const data$1 = "<h1>Citywide Celebration This Weekend</h1><p>Join us at <a href='https://www.google.com/' target='_blank'>Fairweather Park</a> at 7:00 pm on Saturday for barbeque, fireworks and an electric light parade.</p><hr><blockquote>Be there or be square!</blockquote>";
const alertDefaults$1 = {
  data: data$1
};
const alertSeparateDefaults$1 = [
  {
    id: 1,
    content: "<h1>Road Construction Alert</h1><p>Due to the ongoing road construction on Main St., traffic will be rerouted through Pine Ave starting from June 15. We apologize for any inconvenience and appreciate your patience.</p><hr>Contact the city engineer's office with any questions <hr>123-456-7890",
    image: {
      url: "https://d2kzwze52p8717.cloudfront.net/city-streets.jpg",
      alt_text: "Construction work on Main St."
    },
    status: "published",
    style: "light_box",
    display_location: "homepage"
  },
  {
    id: 2,
    content: "<h1>Community Clean-Up Day</h1><p>Join us this Saturday for a community clean-up of River Park. Volunteers are needed from 8:00 am to 12:00 pm. Let's keep our city beautiful together!</p><hr>To volunteer, please call <hr>123-456-7890",
    image: {
      url: "https://d2kzwze52p8717.cloudfront.net/youth_program.jpeg",
      alt_text: "Community cleaning River Park"
    },
    status: "published",
    style: "light_box",
    display_location: "homepage"
  },
  {
    id: 3,
    content: "<h1>Annual City Festival</h1><p>Don't miss our annual City Festival from July 10th to 12th! Enjoy food, music, and games right in the heart of our downtown. It's fun for the whole family!</p><hr>More details? Call <hr>123-456-7890",
    status: "published",
    style: "banner",
    display_location: "homepage"
  },
  {
    id: 4,
    content: "<h1>Water Restriction Notice</h1><p>Please note that water use restrictions are in effect throughout July due to expected drought conditions. Lawn watering is limited to evenings and mornings. Thank you for your cooperation.</p><hr>For more info, please contact <hr>123-456-7890",
    status: "published",
    style: "banner",
    display_location: "homepage"
  }
];
const menu$1 = [
  [
    {
      type: "SchoolsMenuOrg",
      name: "Some City Thing",
      link: "http://randomCityDomain/"
    },
    {
      type: "SchoolsMenuHeader",
      name: "Departments",
      children: [
        {
          type: "SchoolsMenuOrg",
          name: "Public Works",
          link: "http://randomCityDomain/o/public-works"
        },
        {
          type: "SchoolsMenuOrg",
          name: "Employment",
          link: "http://randomCityDomain/o/employment"
        },
        {
          type: "SchoolsMenuOrg",
          name: "Residents"
        }
      ]
    }
  ],
  [
    {
      type: "SchoolsMenuHeader",
      name: "Businesses",
      children: [
        {
          type: "SchoolsMenuOrg",
          name: "Permits",
          link: "http://someOtherRandomDomain/"
        },
        {
          type: "SchoolsMenuOrg",
          name: "Payments",
          link: "http://someOtherRandomDomain/"
        },
        {
          type: "SchoolsMenuOrg",
          name: "Forms and Applications",
          link: "http://someOtherRandomDomain/"
        },
        {
          type: "SchoolsMenuOrg",
          name: "Planning and Development",
          link: "http://someOtherRandomDomain/"
        }
      ]
    }
  ],
  [
    {
      type: "SchoolsMenuHeader",
      name: "Government",
      children: [
        {
          type: "SchoolsMenuOrg",
          name: "Board of Directors",
          link: "http://someOtherRandomDomain/"
        },
        {
          type: "SchoolsMenuOrg",
          name: "District Courts",
          link: "http://someOtherRandomDomain/"
        },
        {
          type: "SchoolsMenuOrg",
          name: "Community Programs",
          link: "http://someOtherRandomDomain/"
        },
        {
          type: "SchoolsMenuOrg",
          name: "Fire Department",
          link: "http://someOtherRandomDomain/"
        }
      ]
    }
  ],
  [
    {
      url: "https://d2kzwze52p8717.cloudfront.net/honeysuckle-logo.jpg",
      type: "SchoolsMenuImage",
      caption: "Honeysuckle Logo",
      display: "actual-size",
      alt_text: "Honeysuckle Logo",
      asset_id: 206,
      link_url: "",
      set_ratio: 1,
      cropped_width: {},
      cropped_height: {},
      action_on_click: "no_action",
      image_alignment: "center",
      preferred_width: null,
      preferred_height: null,
      caption_alignment: "center",
      open_link_in_new_tab: false
    }
  ]
];
const orgMenuDefaults$1 = {
  menu: menu$1
};
const info$1 = {
  alert_text_color: {
    hex: "#20713B"
  },
  alert_link_color: {
    hex: "#0F0F0F"
  },
  alert_bg_color: {
    hex: "#FFFFFF"
  },
  alert_lightbox_overlay: {
    hex: "#20713B"
  },
  school_name: "Honeysuckle Township",
  school_tag_line: "Welcome to Honeysuckle!",
  customHeader: false
};
const language$1 = "en";
const logo$1 = {
  url: "https://d2kzwze52p8717.cloudfront.net/honeysuckle-logo.jpg"
};
const watermark$1 = {
  url: "https://d2kzwze52p8717.cloudfront.net/honeysuckle-logo.jpg"
};
const active_theme$1 = {
  content: {
    menu: {
      options: {
        style: "light",
        version: "M4",
        bg_color: {
          hex: "#FFFFFF"
        },
        icon_color: {
          a: 1,
          hex: "#20713B",
          hsl: {
            a: 1,
            h: 192.9281767955801,
            l: 1,
            s: 0
          },
          hsv: {
            a: 1,
            h: 192.9281767955801,
            s: 0,
            v: 1
          },
          hex8: "#20713BFF",
          rgba: {
            a: 1,
            b: 255,
            g: 255,
            r: 255
          },
          source: "hsva"
        },
        text_color: {
          a: 1,
          hex: "#20713B",
          hsl: {
            a: 1,
            h: 0,
            l: 1,
            s: 0
          },
          hsv: {
            a: 1,
            h: 0,
            s: 0,
            v: 1
          },
          hex8: "##20713BFF",
          rgba: {
            a: 1,
            b: 255,
            g: 255,
            r: 255
          },
          source: "hsva"
        },
        l2_bg_color: {
          hex: "#fff"
        },
        heading_color: {
          hex: "#fff"
        },
        icon_bg_color: {
          a: 1,
          hex: "#20713B",
          hsl: {
            a: 1,
            h: 192.9281767955801,
            l: 0.4294117647058823,
            s: 0.8264840182648403
          },
          hsv: {
            a: 1,
            h: 192.9281767955801,
            s: 0.905,
            v: 0.7843137254901961
          },
          hex8: "#20713BFF",
          rgba: {
            a: 1,
            b: 200,
            g: 161,
            r: 19
          },
          source: "hex"
        },
        l1_text_color: {
          hex: "#fff"
        },
        l2_text_color: {
          hex: "#20713B"
        },
        sticky_header: true,
        icon_text_color: {
          a: 1,
          hex: "#FFFFFF",
          hsl: {
            a: 1,
            h: 0,
            l: 1,
            s: 0
          },
          hsv: {
            a: 1,
            h: 0,
            s: 0,
            v: 1
          },
          hex8: "#FFFFFFFF",
          rgba: {
            a: 1,
            b: 255,
            g: 255,
            r: 255
          },
          source: "hsva"
        },
        text_hover_color: {
          a: 1,
          hex: "#FFFFFF",
          hsl: {
            a: 1,
            h: 0,
            l: 1,
            s: 0
          },
          hsv: {
            a: 1,
            h: 0,
            s: 0,
            v: 1
          },
          hex8: "#FFFFFFFF",
          rgba: {
            a: 1,
            b: 255,
            g: 255,
            r: 255
          },
          source: "hsva"
        },
        l1_text_hover_color: {
          hex: "#fff"
        },
        l2_text_hover_color: {
          hex: "#20713B"
        }
      }
    }
  }
};
const globalSettingDefaults$1 = {
  info: info$1,
  language: language$1,
  logo: logo$1,
  watermark: watermark$1,
  active_theme: active_theme$1
};
const utilityLinkDefaults$1 = [
  {
    name: "Police Department",
    link: "/o/police"
  },
  {
    name: "Fire Department",
    link: "/o/fire"
  },
  {
    name: "City Hall",
    link: "/o/city-hall"
  },
  {
    name: "Mayor's Office",
    link: "/o/mayor"
  },
  {
    name: "Transportation",
    link: "/o/transportation"
  }
];
const description$1 = "This is not just a test file. It's used to set up Theme Preview data for CMS Public homepages. Please do not edit it unless you are explicitly required to.";
const gallery$1 = {
  slides: [
    {
      url: "https://d2kzwze52p8717.cloudfront.net/central-park.jpg",
      title: "<h1>Welcome to Honeysuckle!</h1>",
      content: "",
      index: 0,
      alt_text: "dsd",
      sizes: {
        px600: "https://d2kzwze52p8717.cloudfront.net/central-park.jpg?id=px600",
        px960: "https://d2kzwze52p8717.cloudfront.net/central-park.jpg?id=px960"
      }
    },
    {
      url: "https://d2kzwze52p8717.cloudfront.net/satellite-view.jpg",
      title: "<h1>Welcome to Honeysuckle!</h1>",
      content: "",
      index: 1,
      alt_text: "dssd",
      sizes: {
        px600: "https://d2kzwze52p8717.cloudfront.net/satellite-view.jpg?id=px600",
        px960: "https://d2kzwze52p8717.cloudfront.net/satellite-view.jpg?id=px960"
      }
    },
    {
      url: "https://d2kzwze52p8717.cloudfront.net/city-streets.jpg",
      title: "<h1>Welcome to Honeysuckle!</h1>",
      content: "",
      index: 3,
      alt_text: "dsdsd",
      sizes: {
        px600: "https://d2kzwze52p8717.cloudfront.net/city-streets.jpg?id=px600",
        px960: "https://d2kzwze52p8717.cloudfront.net/city-streets.jpg?id=px960"
      }
    }
  ],
  widget: {
    body: "Get your application started online today.",
    link: {
      href: "https://www.google.com/",
      name: "",
      target: ""
    }
  }
};
const events$1 = {
  background_image: {
    url: "https://d2kzwze52p8717.cloudfront.net/events_background.jpeg"
  },
  display_tags: false,
  preview_id: {
    component_header: "Events",
    component_header_top: "Latest",
    selected_sections: [],
    see_all_link: {
      href: "/events",
      name: "See All Events",
      target: "_self"
    }
  },
  customSections: [
    1,
    2
  ]
};
const news$1 = {
  preview_id: {
    component_header: "News",
    component_header_top: "Latest",
    see_all_link: {
      href: "/news",
      name: "See All News",
      target: "_self"
    }
  }
};
const live_feed$1 = {
  preview_id: {
    component_header: "Live Feed",
    component_header_top: "Latest",
    see_all_link: {
      href: "",
      name: "See All Posts",
      target: "_self"
    }
  }
};
const stats$1 = {
  preview_id: {
    content: [
      {
        name: "people meeting",
        path: '<path fill-rule="evenodd" clip-rule="evenodd" d="M46.2244 18.8153L34.6573 14.2932V6.71484H29.34V12.2989L15.6466 6.9816C14.7168 6.58274 13.6523 6.84948 12.8546 7.51259L0.888706 18.1498C-0.175778 19.0796 -0.307881 20.8097 0.621966 21.8716C1.2851 22.4051 1.95066 22.6694 2.74838 22.6694H4.07707V41.2838H12.0543V25.3293H20.0316V41.2838H43.9633V24.0006H45.292C46.3565 24.0006 47.4184 23.335 47.8173 22.273C48.3508 20.9419 47.6852 19.3464 46.2243 18.8154L46.2244 18.8153ZM38.646 25.3292V29.3178H33.3287V25.3292H38.646ZM25.3489 25.3292H30.6662V29.3178H25.3489V25.3292ZM25.3489 35.9664V31.9778H30.6662V35.9664H25.3489ZM38.646 35.9664H33.3287V31.9778H38.646V35.9664Z" />',
        snippet: "At the heart of Honeysuckle is a community that's diverse, vibrant, and welcoming. From our annual summer festival to our weekly farmers markets, there's always something happening here. Our residents take pride in our rich history and are deeply involved in shaping the town's future",
        headline: "Our community",
        view_box: "0 0 48 48",
        icon: "<svg viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg'><path d='M12.0005 12.748C12.0005 15.2341 9.98681 17.2479 7.50064 17.2479C5.01727 17.2479 3.00073 15.2341 3.00073 12.748C3.00073 10.2618 5.01727 8.24805 7.50064 8.24805C9.98681 8.24805 12.0005 10.2618 12.0005 12.748Z'></path><path d='M45.0018 12.748C45.0018 15.2341 42.9852 17.2479 40.5019 17.2479C38.0157 17.2479 36.002 15.2341 36.002 12.748C36.002 10.2618 38.0157 8.24805 40.5019 8.24805C42.9852 8.24805 45.0018 10.2618 45.0018 12.748Z'></path><path d='M40.5019 20.248C39.1519 20.248 37.951 20.698 36.7529 21.2971L24.0041 28.7979L11.2554 21.2971C10.0516 20.698 8.85077 20.248 7.5008 20.248C3.30185 20.248 0 23.547 0 27.7488V39.7495H14.9987V30.4488L22.4995 34.9487C22.8005 35.0977 22.9495 35.2496 23.2505 35.2496C23.5514 35.2496 23.7005 35.3987 24.0014 35.3987C24.3024 35.3987 24.4514 35.3987 24.7524 35.2496C25.0533 35.2496 25.2023 35.1006 25.5033 34.9487L33.0041 30.4488L33.0013 39.7467H48V27.746C48 23.547 44.701 20.248 40.5021 20.248H40.5019Z'></path></svg>"
      },
      {
        name: "leaf",
        path: '<path fill-rule="evenodd" clip-rule="evenodd" d="M40.954 36.0013C35.5822 29.6225 28.0296 22.5734 22.661 17.7083C22.3243 17.3715 22.1575 17.038 22.1575 16.5345C22.1575 15.5275 22.8278 14.8572 23.8348 14.8572C24.1715 14.8572 24.675 15.024 25.0086 15.1939H25.1753C32.7279 22.0763 38.77 27.9484 43.1348 32.9834C43.4716 32.3132 43.8051 31.6397 44.1419 30.9694C44.1419 30.9694 44.1419 30.8026 44.3086 30.6327C44.4754 30.1292 44.6454 29.4589 44.8121 28.9554C44.8121 28.7886 44.9789 28.6187 44.9789 28.4519C45.1457 27.9484 45.1457 27.4449 45.3157 26.9414C45.3157 26.7746 45.3157 26.6047 45.4824 26.2711C45.3157 25.5945 45.3157 24.7543 45.3157 24.084C45.3157 10.9928 31.5542 4.11049 18.463 3.94373C6.5456 3.77694 0 0.585938 0 0.585938C0 0.585938 1.67728 17.7052 5.20183 27.2718C9.23304 38.1822 16.6157 42.547 26.8559 42.547C27.5262 42.547 28.1996 42.547 28.8699 42.3802H29.0367C29.5402 42.3802 30.2105 42.2135 30.714 42.0435H30.8808C32.0545 41.7068 33.2315 41.3732 34.4053 40.8697C35.4123 40.3662 36.4193 39.8627 37.4263 39.1925C40.7841 43.0538 42.9649 46.0748 42.9649 47.4153H48C47.8332 44.8947 44.9821 40.533 40.954 36.0014L40.954 36.0013Z" />',
        snippet: "Honeysuckle is a leader in environmental sustainability. With numerous parks and green initiatives, we are committed to preserving our natural resources for generations to come.",
        headline: "Our Commitment to the Environment",
        view_box: "0 0 48 48",
        icon: "<svg viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg'><path d='M40.954 36.0013C35.5822 29.6225 28.0296 22.5734 22.661 17.7083C22.3243 17.3715 22.1575 17.038 22.1575 16.5345C22.1575 15.5275 22.8278 14.8572 23.8348 14.8572C24.1715 14.8572 24.675 15.024 25.0086 15.1939H25.1753C32.7279 22.0763 38.77 27.9484 43.1348 32.9834C43.4716 32.3132 43.8051 31.6397 44.1419 30.9694C44.1419 30.9694 44.1419 30.8026 44.3086 30.6327C44.4754 30.1292 44.6454 29.4589 44.8121 28.9554C44.8121 28.7886 44.9789 28.6187 44.9789 28.4519C45.1457 27.9484 45.1457 27.4449 45.3157 26.9414C45.3157 26.7746 45.3157 26.6047 45.4824 26.2711C45.3157 25.5945 45.3157 24.7543 45.3157 24.084C45.3157 10.9928 31.5542 4.11049 18.463 3.94373C6.5456 3.77694 0 0.585938 0 0.585938C0 0.585938 1.67728 17.7052 5.20183 27.2718C9.23304 38.1822 16.6157 42.547 26.8559 42.547C27.5262 42.547 28.1996 42.547 28.8699 42.3802H29.0367C29.5402 42.3802 30.2105 42.2135 30.714 42.0435H30.8808C32.0545 41.7068 33.2315 41.3732 34.4053 40.8697C35.4123 40.3662 36.4193 39.8627 37.4263 39.1925C40.7841 43.0538 42.9649 46.0748 42.9649 47.4153H48C47.8332 44.8947 44.9821 40.533 40.954 36.0014L40.954 36.0013Z'></path></svg>"
      },
      {
        name: "education",
        path: '<path fill-rule="evenodd" clip-rule="evenodd" d="M11.2933 38.1178H13.6944L7.90481 48H14.3985L20.1881 38.1178H27.5289L33.3185 48H39.8122L34.0226 38.1178H36.7069C39.108 38.1178 40.9425 36.2833 40.9425 33.8822V5.64658C40.9425 2.82193 39.3886 0 24.0001 0C8.61158 0 7.05762 2.82464 7.05762 5.64658V33.8822C7.05762 36.2833 8.89215 38.1178 11.2932 38.1178H11.2933ZM35.296 35.2958C33.742 35.2958 32.4714 34.0251 32.4714 32.4712C32.4714 30.9172 33.742 29.6465 35.296 29.6465C36.85 29.6465 38.1207 30.9172 38.1207 32.4712C38.118 34.0251 36.8473 35.2958 35.296 35.2958ZM19.7645 4.23283H28.2358C29.0829 4.23283 29.6467 4.7967 29.6467 5.6438C29.6467 6.4909 29.0829 7.05477 28.2358 7.05477H19.7645C18.9174 7.05477 18.3536 6.4909 18.3536 5.6438C18.3536 4.79932 18.9174 4.23283 19.7645 4.23283ZM9.88233 15.5287C9.88233 13.1276 11.7169 11.2931 14.1179 11.2931H33.8823C36.2834 11.2931 38.1179 13.1276 38.1179 15.5287V21.1753C38.1179 23.4334 36.2834 25.4109 33.8823 25.4109H14.1179C11.7169 25.4109 9.88233 23.4334 9.88233 21.1753V15.5287ZM12.7043 29.6465C14.2583 29.6465 15.529 30.9172 15.529 32.4712C15.529 34.0251 14.2583 35.2958 12.7043 35.2958C11.1504 35.2958 9.87969 34.0251 9.87969 32.4712C9.88234 30.9172 11.153 29.6465 12.7043 29.6465Z" />',
        snippet: "Our strong school system and public libraries form the backbone of our commitment to education. We believe that a good education is the foundation for a strong community.",
        headline: "Education and Learning",
        view_box: "0 0 48 48",
        icon: "<svg viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg'><path d='M35.9061 44.8493H35.1765C34.7512 44.364 34.5928 43.7568 34.7205 43.0075C34.9336 41.772 35.814 40.7467 36.2335 40.5979L36.2272 40.5864C36.8229 40.3718 37.266 39.7943 37.266 39.1127L37.2962 6.78552C37.2962 5.91911 36.5973 5.21303 35.7468 5.20727C35.7468 5.20727 29.2758 5.20151 27.5022 5.18855C27.508 3.66502 27.5133 1.57605 27.5133 1.57605C27.5133 0.938121 27.1432 0.366918 26.5595 0.121636C25.9773 -0.124125 25.3144 0.0107557 24.8651 0.451878L14.0377 11.3177C12.1364 13.2286 10.6359 16.8397 10.6296 19.5555L10.5447 42.1708C10.5389 45.3345 13.0781 47.9261 16.2202 47.939L35.9004 48C36.7562 48 37.4551 47.2934 37.4551 46.4333V46.428C37.4546 45.5544 36.7687 44.855 35.9061 44.8493ZM34.1795 8.35176C34.1795 11.0484 34.1555 34.8378 34.1498 37.5403H16.4142L27.52 28.1303L27.497 8.33928C28.505 8.34505 33.2445 8.35176 34.1795 8.35176ZM13.6556 42.1771C13.6556 42.1771 13.6613 40.8753 13.6613 40.6848H32.2355C31.9682 41.256 31.7555 41.8579 31.6523 42.4665C31.5064 43.3075 31.5794 44.0937 31.7671 44.8368L16.2308 44.7873C14.81 44.7873 13.6556 43.6205 13.6556 42.1771Z'></path></svg>"
      },
      {
        name: "shield",
        path: '<path fill-rule="evenodd" clip-rule="evenodd" d="M45.3325 30.6665H14.8C14.6675 30.399 14.5325 29.8665 14.8 29.334C15.2 28.134 16.5325 27.2016 18.8 26.6665L43.0675 23.999C44.4 23.8665 45.3351 22.6665 45.3351 21.3315V9.33148C45.3351 7.86396 44.1351 6.66396 42.6675 6.66396L9.86755 6.66646L9.33254 3.46646C9.06754 2.26646 8.00006 1.33398 6.66752 1.33398H2.66752C1.2 1.33398 0 2.53398 0 4.0015C0 5.46902 1.2 6.66902 2.66752 6.66902H4.53504L9.46752 31.3365V31.469C10 34.1366 12 35.869 14.2675 35.869L45.3325 35.8665C46.8 35.8665 48 34.6665 48 33.199C48 31.734 46.8 30.6665 45.3325 30.6665L45.3325 30.6665ZM18.6675 21.334V12.0016H24V20.6691L18.6675 21.334ZM26.6675 11.999H32V19.8665L26.6675 20.399V11.999ZM40 18.934L34.6675 19.4665V11.999H40V18.934ZM16 11.999V21.8665C14.9325 22.2665 14 22.6665 13.2 23.199L11.0675 11.999H16Z" />',
        snippet: "Public safety is our top priority. Our dedicated police and fire departments work tirelessly to ensure that Honeysuckle remains a safe place for all its residents.",
        headline: "Public Safety",
        view_box: "0 0 48 48",
        icon: "<svg viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg'><path d='M36.0015 5.99928C29.8503 5.99928 24.0001 0 24.0001 0C24.0001 0 18.1499 5.99928 11.9987 5.99928C6.14842 5.99928 2.99829 1.4991 2.99829 1.4991V29.9993C2.99829 43.6489 14.9997 38.9996 24.0001 48C33.0004 38.9996 45.0019 43.6489 45.0019 29.9993V1.4991C45.0019 1.4991 41.8518 5.99928 36.0015 5.99928ZM33.1496 36.0014C30.4495 36.9015 27.2993 38.1025 24.1492 40.2006L24.0001 40.0516V24H9.0005V11.7004C9.90054 11.8495 10.9496 12.0014 12.0016 12.0014C16.6508 12.0014 21.0019 9.75131 24.003 7.80219L24.0002 24H38.9998V29.9992C38.9998 34.0494 38.4008 34.2013 33.1496 36.0013L33.1496 36.0014Z'></path></svg>"
      }
    ],
    snippet: true,
    headline: true,
    slider: true,
    stats_header: "Fun Facts",
    component_header: "Why Us"
  }
};
const header$1 = {
  links: [
    {
      name: "Students",
      link: ""
    },
    {
      name: "Parents",
      link: ""
    },
    {
      name: "Admissions",
      link: ""
    },
    {
      name: "Grades",
      link: ""
    },
    {
      name: "Bus Routes",
      link: ""
    }
  ],
  icon_links: [
    {
      name: "facebook",
      link: "#",
      opens_in_new_tab: false,
      icon: "<svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'><path fill-rule='evenodd' clip-rule='evenodd' d='M11.1413 4.64124C12.0321 3.75044 13.2403 3.25 14.5001 3.25H16.9001C17.3143 3.25 17.6501 3.58579 17.6501 4V7.2C17.6501 7.61421 17.3143 7.95 16.9001 7.95H14.5001C14.4868 7.95 14.4741 7.95527 14.4647 7.96464C14.4554 7.97402 14.4501 7.98674 14.4501 8V9.65H16.9001C17.131 9.65 17.3491 9.7564 17.4913 9.93844C17.6334 10.1205 17.6837 10.3578 17.6277 10.5819L16.8277 13.7819C16.7442 14.1158 16.4442 14.35 16.1001 14.35H14.4501V20C14.4501 20.4142 14.1143 20.75 13.7001 20.75H10.5001C10.0859 20.75 9.7501 20.4142 9.7501 20V14.35H8.1001C7.68588 14.35 7.3501 14.0142 7.3501 13.6V10.4C7.3501 9.98579 7.68588 9.65 8.1001 9.65H9.7501V8C9.7501 6.74022 10.2505 5.53204 11.1413 4.64124ZM14.5001 4.75C13.6381 4.75 12.8115 5.09241 12.202 5.7019C11.5925 6.3114 11.2501 7.13805 11.2501 8V10.4C11.2501 10.8142 10.9143 11.15 10.5001 11.15H8.8501V12.85H10.5001C10.9143 12.85 11.2501 13.1858 11.2501 13.6V19.25H12.9501V13.6C12.9501 13.1858 13.2859 12.85 13.7001 12.85H15.5145L15.9395 11.15H13.7001C13.2859 11.15 12.9501 10.8142 12.9501 10.4V8C12.9501 7.58891 13.1134 7.19467 13.4041 6.90398C13.6948 6.6133 14.089 6.45 14.5001 6.45H16.1501V4.75H14.5001Z' /></svg>",
      icon_id: 1
    },
    {
      name: "X",
      link: "#",
      opens_in_new_tab: false,
      icon: "<svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'><path fill-rule='evenodd' clip-rule='evenodd' d='M4.89876 3.89999C4.01359 3.89999 3.49096 4.89227 3.99166 5.62222L9.43281 13.5546L4.01032 19.8371C3.58312 20.332 3.93474 21.1 4.58856 21.1C4.81064 21.1 5.02171 21.0033 5.16681 20.8352L10.3263 14.8572L14.2808 20.6222C14.486 20.9213 14.8253 21.1 15.1879 21.1H18.1375C19.0226 21.1 19.5453 20.1077 19.0446 19.3778L13.4562 11.2308L18.6936 5.16264C19.1207 4.66779 18.7691 3.89999 18.1154 3.89999C17.8934 3.89999 17.6824 3.99661 17.5373 4.16469L12.5627 9.92825L8.7554 4.37777C8.55027 4.07872 8.21093 3.89999 7.8483 3.89999H4.89876ZM15.1919 19.0924L5.8798 5.51666H7.10218C7.39889 5.51666 7.67653 5.6629 7.84436 5.90757L17.1564 19.4833H15.934C15.6373 19.4833 15.3597 19.3371 15.1919 19.0924Z' /></svg>",
      icon_id: 2
    },
    {
      name: "instagram",
      link: "#",
      opens_in_new_tab: false,
      icon: "<svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'><path fill-rule='evenodd' clip-rule='evenodd' d='M8 4.75C6.20507 4.75 4.75 6.20507 4.75 8V16C4.75 17.7949 6.20507 19.25 8 19.25H16C17.7949 19.25 19.25 17.7949 19.25 16V8C19.25 6.20507 17.7949 4.75 16 4.75H8ZM3.25 8C3.25 5.37665 5.37665 3.25 8 3.25H16C18.6234 3.25 20.75 5.37665 20.75 8V16C20.75 18.6234 18.6234 20.75 16 20.75H8C5.37665 20.75 3.25 18.6234 3.25 16V8ZM15.65 7.6C15.65 7.18579 15.9858 6.85 16.4 6.85H16.408C16.8222 6.85 17.158 7.18579 17.158 7.6C17.158 8.01421 16.8222 8.35 16.408 8.35H16.4C15.9858 8.35 15.65 8.01421 15.65 7.6ZM12.394 9.54189C11.8842 9.4663 11.3636 9.55337 10.9062 9.79071C10.4488 10.0281 10.0779 10.4036 9.84619 10.8639C9.6145 11.3242 9.53386 11.8458 9.61573 12.3546C9.6976 12.8634 9.93781 13.3334 10.3022 13.6978C10.6666 14.0622 11.1366 14.3024 11.6454 14.3843C12.1542 14.4661 12.6758 14.3855 13.1361 14.1538C13.5964 13.9221 13.9719 13.5512 14.2093 13.0938C14.4466 12.6364 14.5337 12.1158 14.4581 11.606C14.381 11.086 14.1387 10.6047 13.767 10.233C13.3953 9.86128 12.914 9.61899 12.394 9.54189ZM10.2154 8.45928C10.9528 8.07662 11.7922 7.93624 12.614 8.05811C13.4523 8.18242 14.2284 8.57306 14.8277 9.17232C15.4269 9.77157 15.8176 10.5477 15.9419 11.386C16.0638 12.2078 15.9234 13.0472 15.5407 13.7846C15.1581 14.5221 14.5526 15.1201 13.8105 15.4937C13.0684 15.8672 12.2274 15.9972 11.4071 15.8652C10.5868 15.7332 9.82903 15.3459 9.24154 14.7585C8.65406 14.171 8.26677 13.4132 8.13478 12.5929C8.00279 11.7726 8.1328 10.9316 8.50633 10.1895C8.87987 9.44738 9.4779 8.84193 10.2154 8.45928Z' /></svg>",
      icon_id: 3
    },
    {
      name: "linkedIn",
      link: "#",
      opens_in_new_tab: false,
      icon: "<svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'><path fill-rule='evenodd' clip-rule='evenodd' d='M5.2 4.75C4.66872 4.75 4.25 5.17484 4.25 5.68421C4.25 6.19358 4.66872 6.61842 5.2 6.61842C5.73128 6.61842 6.15 6.19358 6.15 5.68421C6.15 5.17484 5.73128 4.75 5.2 4.75ZM2.75 5.68421C2.75 4.33325 3.85352 3.25 5.2 3.25C6.54648 3.25 7.65 4.33325 7.65 5.68421C7.65 7.03517 6.54648 8.11842 5.2 8.11842C3.85352 8.11842 2.75 7.03517 2.75 5.68421ZM15.4 9.80263C14.2441 9.80263 13.1369 10.2576 12.3216 11.0653C11.5066 11.8728 11.05 12.9664 11.05 14.1053V19.25H12.95V14.1053C12.95 13.4574 13.2098 12.8375 13.6701 12.3815C14.1301 11.9258 14.7525 11.6711 15.4 11.6711C16.0475 11.6711 16.6699 11.9258 17.1299 12.3815C17.5902 12.8375 17.85 13.4574 17.85 14.1053V19.25H19.75V14.1053C19.75 12.9664 19.2934 11.8728 18.4784 11.0653C17.6631 10.2576 16.5559 9.80263 15.4 9.80263ZM11.2659 9.99971C12.3635 8.91229 13.8507 8.30263 15.4 8.30263C16.9493 8.30263 18.4365 8.91229 19.5341 9.99971C20.6319 11.0874 21.25 12.564 21.25 14.1053V20C21.25 20.4142 20.9142 20.75 20.5 20.75H17.1C16.6858 20.75 16.35 20.4142 16.35 20V14.1053C16.35 13.8598 16.2516 13.6229 16.0742 13.4471C15.8966 13.2712 15.6542 13.1711 15.4 13.1711C15.1458 13.1711 14.9034 13.2712 14.7258 13.4471C14.5484 13.6229 14.45 13.8598 14.45 14.1053V20C14.45 20.4142 14.1142 20.75 13.7 20.75H10.3C9.88579 20.75 9.55 20.4142 9.55 20V14.1053C9.55 12.564 10.1681 11.0874 11.2659 9.99971ZM2.75 9.89474C2.75 9.48052 3.08579 9.14474 3.5 9.14474H6.9C7.31421 9.14474 7.65 9.48052 7.65 9.89474V20C7.65 20.4142 7.31421 20.75 6.9 20.75H3.5C3.08579 20.75 2.75 20.4142 2.75 20V9.89474ZM4.25 10.6447V19.25H6.15V10.6447H4.25Z' /></svg>",
      icon_id: 4
    },
    {
      name: "threads",
      link: "#",
      opens_in_new_tab: false,
      icon: "<svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M15.8286 11.4157C15.7597 11.3827 15.6897 11.3509 15.6188 11.3204C15.4953 9.04485 14.2519 7.74208 12.164 7.72875C12.1546 7.72869 12.1451 7.72869 12.1357 7.72869C10.8869 7.72869 9.84828 8.26174 9.20902 9.23173L10.3573 10.0194C10.8348 9.29486 11.5843 9.1404 12.1362 9.1404C12.1426 9.1404 12.149 9.1404 12.1553 9.14046C12.8428 9.14484 13.3615 9.34472 13.6973 9.7345C13.9416 10.0183 14.105 10.4104 14.1859 10.9053C13.5764 10.8017 12.9173 10.7699 12.2126 10.8103C10.2276 10.9246 8.95145 12.0823 9.03715 13.691C9.08065 14.507 9.48716 15.209 10.1818 15.6676C10.7691 16.0553 11.5254 16.2448 12.3115 16.2019C13.3497 16.145 14.1641 15.7489 14.7323 15.0247C15.1638 14.4747 15.4367 13.7619 15.5572 12.8638C16.0519 13.1624 16.4186 13.5553 16.6211 14.0277C16.9654 14.8306 16.9855 16.15 15.9089 17.2257C14.9657 18.168 13.8319 18.5757 12.1183 18.5883C10.2175 18.5742 8.78 17.9646 7.84536 16.7764C6.97015 15.6638 6.51783 14.0568 6.50095 12C6.51783 9.94315 6.97015 8.33613 7.84536 7.22356C8.78 6.03541 10.2175 5.42583 12.1183 5.41171C14.0329 5.42594 15.4954 6.03845 16.4659 7.23233C16.9417 7.8178 17.3004 8.55407 17.5369 9.41253L18.8825 9.05352C18.5959 7.99685 18.1448 7.08631 17.5309 6.33117C16.2869 4.80056 14.4674 4.01626 12.123 4H12.1136C9.77399 4.01621 7.97486 4.80348 6.76621 6.33994C5.69068 7.7072 5.13589 9.60964 5.11725 11.9944L5.11719 12L5.11725 12.0056C5.13589 14.3903 5.69068 16.2928 6.76621 17.6601C7.97486 19.1965 9.77399 19.9838 12.1136 20H12.123C14.203 19.9856 15.6692 19.441 16.877 18.2343C18.4573 16.6555 18.4097 14.6766 17.8889 13.4618C17.5152 12.5906 16.8028 11.883 15.8286 11.4157ZM12.2372 14.7923C11.3672 14.8413 10.4634 14.4508 10.4188 13.6143C10.3858 12.9942 10.8602 12.3022 12.2906 12.2197C12.4544 12.2103 12.6152 12.2057 12.7731 12.2057C13.2927 12.2057 13.7788 12.2561 14.2207 12.3528C14.0559 14.4113 13.089 14.7455 12.2372 14.7923Z'  /></svg>",
      icon_id: 5
    }
  ]
};
const footer$1 = {
  logo: {
    url: "https://d2kzwze52p8717.cloudfront.net/honeysuckle-logo.jpg",
    type: "FooterLogo",
    caption: "",
    display: "actual-size",
    alt_text: "Logo",
    asset_id: null,
    link_url: "",
    set_ratio: 1,
    cropped_width: null,
    cropped_height: null,
    action_on_click: "no_action",
    image_alignment: "left",
    preferred_width: null,
    preferred_height: null,
    caption_alignment: "center",
    open_link_in_new_tab: false
  },
  columns: [
    {
      items: [],
      header: "Find Us",
      hasHeader: true,
      showSchools: false
    },
    {
      items: [
        {
          url: "http://apptegy.com",
          type: "FooterLink",
          mailto: false,
          content: "Garbage & Recycling",
          email_address: "",
          opens_in_new_tab: true
        }
      ],
      header: "Services",
      hasHeader: true,
      showSchools: true
    },
    {
      items: [
        {
          url: "http://apptegy.com",
          type: "FooterLink",
          mailto: false,
          content: "Restaurants & Dining",
          email_address: "",
          opens_in_new_tab: true
        },
        {
          url: "http://apptegy.com",
          type: "FooterLink",
          mailto: false,
          content: "Entertainment & Night Life",
          email_address: "",
          opens_in_new_tab: true
        },
        {
          url: "http://apptegy.com",
          type: "FooterLink",
          mailto: false,
          content: "Area Schools",
          email_address: "",
          opens_in_new_tab: true
        },
        {
          url: "http://apptegy.com",
          type: "FooterLink",
          mailto: false,
          content: "Outdoors & Recreation",
          email_address: "",
          opens_in_new_tab: true
        }
      ],
      header: "Visit Us",
      hasHeader: true,
      showSchools: false
    },
    {
      items: [
        {
          url: "http://apptegy.com",
          type: "FooterLink",
          mailto: false,
          content: "Directions to Our Offices",
          email_address: "",
          opens_in_new_tab: true
        },
        {
          url: "http://apptegy.com",
          type: "FooterLink",
          mailto: false,
          content: "Paying Bills Online",
          email_address: "",
          opens_in_new_tab: true
        },
        {
          url: "http://apptegy.com",
          type: "FooterLink",
          mailto: false,
          content: "Green Initiatives",
          email_address: "",
          opens_in_new_tab: true
        }
      ],
      header: "FAQs",
      hasHeader: true,
      showSchools: false
    }
  ],
  hasLogo: true,
  hasSocial: true,
  hasApps: true,
  twitter: "https://twitter.com/test",
  youtube: "https://youtube.com/test",
  facebook: "https://facebook.com/test",
  instagram: "https://instagram.com/test",
  additionalText: "",
  hasAdditionalText: false,
  additionalTextAlignment: "left",
  organization_info: {
    zip: "72205",
    city: "Little Rock",
    name: "Honeysuckle Township",
    state: "Arkansas",
    address: "123 Magnolia Lane",
    phone_number: "113-123-1233",
    fax_number: "113-123-4535",
    email: "info@honeysuckletown.com"
  }
};
const programs$1 = {
  preview_id: {
    content: [
      {
        link: {
          name: "More about...",
          url: "#",
          opens_in_new_tab: false
        },
        image: {
          url: "https://d2kzwze52p8717.cloudfront.net/public_works.jpg",
          alt_text: "Alt text for image"
        },
        headline: "We make a difference",
        title: "Department of Public Works",
        description: "We ensure that the town's infrastructure, from roads to public buildings, is maintained, safe, and efficient. Our team is responsible for maintaining and improving the municipality's facilities, roads, and public spaces."
      },
      {
        link: {
          name: "More about...",
          url: "#",
          opens_in_new_tab: false
        },
        image: {
          url: "https://d2kzwze52p8717.cloudfront.net/park.jpg",
          alt_text: "Alt text for image"
        },
        headline: "We discover new ways",
        title: "Parks and Recreation",
        description: "Our mission is to enhance the quality of life in Honeysuckle by providing the best possible recreational facilities, open green spaces, and programs for its citizens."
      },
      {
        link: {
          name: "More about...",
          url: "#",
          opens_in_new_tab: false
        },
        image: {
          url: "https://d2kzwze52p8717.cloudfront.net/city-streets.jpg",
          alt_text: "Alt text for image"
        },
        headline: "We are creative",
        title: "Community Development",
        description: "We oversee planning, zoning, and building in the municipality. Our team works diligently to promote sustainable growth and development that enhances the quality of life for our residents."
      },
      {
        link: {
          name: "More about...",
          url: "#",
          opens_in_new_tab: false
        },
        image: {
          url: "https://d2kzwze52p8717.cloudfront.net/police.jpeg",
          alt_text: "Alt text for image"
        },
        headline: "We make a difference",
        title: "Police Department",
        description: "Our goal is to ensure public safety through proactive law enforcement and strong community partnerships. We're dedicated to maintaining the peace and safety of all residents."
      },
      {
        link: {
          name: "More about...",
          url: "#",
          opens_in_new_tab: false
        },
        image: {
          url: "https://d2kzwze52p8717.cloudfront.net/fire.jpg",
          alt_text: "Alt text for image"
        },
        headline: "We make a difference",
        title: "Fire Department",
        description: "We provide rapid, professional, humanitarian services essential to the health, safety, and wellbeing of the community. We serve with dedication and pride."
      },
      {
        link: {
          name: "More about...",
          url: "#",
          opens_in_new_tab: false
        },
        image: {
          url: "https://d2kzwze52p8717.cloudfront.net/library.jpg",
          alt_text: "Alt text for image"
        },
        headline: "We explore new worlds",
        title: "Honeysuckle Public Library",
        description: "We strive to inspire lifelong learning, advance knowledge, and strengthen our community. Come explore our extensive collection of books, digital resources, and community programs."
      },
      {
        link: {
          name: "More about...",
          url: "#",
          opens_in_new_tab: false
        },
        image: {
          url: "https://d2kzwze52p8717.cloudfront.net/budget.jpeg",
          alt_text: "Alt text for image"
        },
        headline: "We make a difference",
        title: "Department of Finance",
        description: "We take pride in our meticulous approach to financial management. With transparency, integrity, and a commitment to excellence, we safeguard and optimize the city's financial resources."
      },
      {
        link: {
          name: "More about...",
          url: "#",
          opens_in_new_tab: false
        },
        image: {
          url: "https://d2kzwze52p8717.cloudfront.net/environmental.jpeg",
          alt_text: "Alt text for image"
        },
        headline: "We make a difference",
        title: "Environmental Services",
        description: "We are passionate about creating a cleaner, greener, and more sustainable future for our community. Our dedicated team is leading the way in waste reduction and recycling initiatives."
      }
    ],
    num_columns: 4,
    read_more_link: true,
    has_header: true,
    has_snippet: true,
    component_header: "Departments",
    component_header_top: "Choose from our",
    component_header_description: "To meet the needs of students, families can choose between one of our variety of programs and activities",
    details_on_hover: true,
    see_all: true,
    slider: true,
    see_all_link: {
      url: "/programs",
      name: "See All Programs",
      opens_in_new_tab: true
    }
  }
};
const our_schools$1 = {
  preview_id: {
    content: [
      {
        box: "Department of Public Works",
        icon: "<svg viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg'><g clip-path='url(#clip0_1638_10452)'><path d='M47.7189 6.63857L42.1581 12.1994L36.896 11.1481L35.8448 5.88602L41.4056 0.325221C38.3983 -0.427331 35.0922 0.325221 32.6881 2.57999C29.9824 5.28571 29.3821 9.49365 30.8843 12.8026L12.8462 30.8407C9.54012 29.1863 5.3293 29.7894 2.62357 32.6445C0.21945 35.0486 -0.533101 38.3576 0.368806 41.362L5.92961 35.8012L11.1917 36.8525L12.243 42.1145L6.68216 47.6754C9.68948 48.4279 12.9955 47.6754 15.3996 45.4206C18.1054 42.7149 18.7057 38.5069 17.2034 35.198L35.2416 17.1599C38.5476 18.8143 42.7584 18.2111 45.4642 15.356C47.7189 12.9519 48.4687 9.643 47.7189 6.63857Z'></path></g><defs><clipPath id='clip0_1638_10452'><rect width='48' height='48'></rect></clipPath></defs></svg>",
        image: {
          url: "https://d2kzwze52p8717.cloudfront.net/public_works.jpg",
          alt_text: "Alt text for image"
        },
        link: "http://apptegy.com"
      },
      {
        box: "Police Department",
        icon: "<svg viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg'><path d='M36.0015 5.99928C29.8503 5.99928 24.0001 0 24.0001 0C24.0001 0 18.1499 5.99928 11.9987 5.99928C6.14842 5.99928 2.99829 1.4991 2.99829 1.4991V29.9993C2.99829 43.6489 14.9997 38.9996 24.0001 48C33.0004 38.9996 45.0019 43.6489 45.0019 29.9993V1.4991C45.0019 1.4991 41.8518 5.99928 36.0015 5.99928ZM33.1496 36.0014C30.4495 36.9015 27.2993 38.1025 24.1492 40.2006L24.0001 40.0516V24H9.0005V11.7004C9.90054 11.8495 10.9496 12.0014 12.0016 12.0014C16.6508 12.0014 21.0019 9.75131 24.003 7.80219L24.0002 24H38.9998V29.9992C38.9998 34.0494 38.4008 34.2013 33.1496 36.0013L33.1496 36.0014Z'></path></svg>",
        image: {
          url: "https://d2kzwze52p8717.cloudfront.net/police.jpeg",
          alt_text: "Alt text for image"
        },
        link: "http://apptegy.com"
      },
      {
        box: "Honeysuckle Public Library",
        icon: "<svg viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg'><path d='M11.3332 21.3333H14.0001V40.0001H17.9999V24.0002H21.9998V40.0001H25.9996V24.0002H30V40.0001H33.9998V21.3333H36.6667C37.403 21.3333 38.0001 20.7367 38.0001 20.0003C38.0001 19.5554 37.7798 19.1642 37.4452 18.9223L37.4462 18.9194L37.427 18.9064C37.4155 18.8987 37.4035 18.8915 37.392 18.8839L24.6667 11.7098V9.60833C27.0163 10.7843 28.9507 8.75825 32.0001 9.97697V5.33344C28.9502 4.11472 27.0158 6.14032 24.6667 4.9648V4.66672C24.6667 4.29808 24.3681 4 23.9999 4C23.6318 4 23.3332 4.29808 23.3332 4.66672V11.7098L10.6079 18.8834C10.5964 18.8911 10.5844 18.8983 10.5729 18.9059L10.5542 18.9189L10.5546 18.9218C10.2201 19.1637 10.0002 19.5549 10.0002 19.9999C9.99976 20.7367 10.5969 21.3333 11.3332 21.3333Z'></path><path d='M12.6666 41.334L9.99976 44.0004H38.0001L35.3332 41.334H12.6666Z'></path><path d='M35.3333 22.666V39.9993H35.8853L36.2755 40.39L38.9424 43.0569L39.8851 43.9996H48V22.666H35.3333ZM40.667 36.6657H38.0001V32.6659H40.667V36.6657ZM40.667 29.9995H38.0001V25.9996H40.667V29.9995ZM45.3331 36.6657H42.6662V32.6659H45.3331V36.6657ZM45.3331 29.9995H42.6662V25.9996H45.3331V29.9995Z'></path><path d='M12.1147 40.0008H12.6667V22.668H0V44.0011H8.11441L9.05713 43.0584L11.724 40.3915L12.1147 40.0008ZM5.33329 36.6672H2.66688V32.6673H5.33377V36.6672H5.33329ZM5.33329 30.0009H2.66688V26.0011H5.33377V30.0009H5.33329ZM9.99986 36.6672H7.33297V32.6673H9.99986V36.6672ZM9.99986 30.0009H7.33297V26.0011H9.99986V30.0009Z'></path></svg>",
        image: {
          url: "https://d2kzwze52p8717.cloudfront.net/library.jpg",
          alt_text: "Alt text for image"
        },
        link: "http://apptegy.com"
      },
      {
        box: "Parks and Recreation",
        icon: "<svg viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg'><g clip-path='url(#clip0_1638_10312)'><path d='M36.2143 8.72322C38.4468 8.72322 40.255 6.90882 40.255 4.67586C40.255 2.44289 38.4473 0.632812 36.2143 0.632812C33.9809 0.632812 32.1655 2.44241 32.1655 4.67538C32.166 6.90882 33.9804 8.72322 36.2143 8.72322Z'></path><path d='M22.2897 11.7271L15.9969 18.9924C15.6269 19.4527 15.0595 19.7368 14.4264 19.7368C13.2984 19.7368 12.3907 18.8263 12.3907 17.7031C12.3907 17.0944 12.6542 16.5511 13.0771 16.1781L19.86 8.36516C20.2358 7.91684 20.7974 7.6274 21.4305 7.6274L31.2509 7.625C31.9742 7.625 32.6189 7.91492 33.097 8.37428L39.36 14.6354L44.5483 9.45524C44.9126 9.14708 45.3845 8.96276 45.8986 8.96276C47.0626 8.96276 48 9.90644 48 11.0647C48 11.573 47.8267 12.0324 47.5282 12.3952L41.2704 18.7005C39.3725 20.596 37.8432 18.9866 37.8432 18.9866L34.0051 15.1284L28.0037 22.0677L33.503 27.5661C33.503 27.5661 34.6613 28.6423 33.9979 30.7845L30.9168 44.5183C30.6725 45.7126 29.6155 46.6077 28.356 46.6077C26.9102 46.6077 25.7405 45.4375 25.7405 43.9922C25.7405 43.7652 25.7645 43.5439 25.8245 43.3356L28.3555 32.0661L22.1107 25.9937L16.7371 31.9845C16.7371 31.9845 15.8664 33.0602 13.5614 32.9757L2.66396 32.994C1.4462 33.0175 0.341239 32.1828 0.0671584 30.9492C-0.255882 29.5404 0.617239 28.1604 2.02508 27.8474C2.24636 27.7956 2.46668 27.7783 2.6822 27.7841L12.0561 27.8114L25.9142 11.7439L22.2897 11.7271Z'></path><path d='M42.4819 47.368C45.2667 47.368 47.5243 45.1104 47.5243 42.3256C47.5243 39.5408 45.2667 37.2832 42.4819 37.2832C39.697 37.2832 37.4395 39.5408 37.4395 42.3256C37.4395 45.1104 39.697 47.368 42.4819 47.368Z'></path></g><defs><clipPath id='clip0_1638_10312'><rect width='48' height='48'></rect></clipPath></defs></svg>",
        image: {
          url: "https://d2kzwze52p8717.cloudfront.net/park.jpg",
          alt_text: "Alt text for image"
        },
        link: "http://apptegy.com"
      },
      {
        box: "Community Development",
        icon: "<svg viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg'><path d='M12.0005 12.748C12.0005 15.2341 9.98681 17.2479 7.50064 17.2479C5.01727 17.2479 3.00073 15.2341 3.00073 12.748C3.00073 10.2618 5.01727 8.24805 7.50064 8.24805C9.98681 8.24805 12.0005 10.2618 12.0005 12.748Z'></path><path d='M45.0018 12.748C45.0018 15.2341 42.9852 17.2479 40.5019 17.2479C38.0157 17.2479 36.002 15.2341 36.002 12.748C36.002 10.2618 38.0157 8.24805 40.5019 8.24805C42.9852 8.24805 45.0018 10.2618 45.0018 12.748Z'></path><path d='M40.5019 20.248C39.1519 20.248 37.951 20.698 36.7529 21.2971L24.0041 28.7979L11.2554 21.2971C10.0516 20.698 8.85077 20.248 7.5008 20.248C3.30185 20.248 0 23.547 0 27.7488V39.7495H14.9987V30.4488L22.4995 34.9487C22.8005 35.0977 22.9495 35.2496 23.2505 35.2496C23.5514 35.2496 23.7005 35.3987 24.0014 35.3987C24.3024 35.3987 24.4514 35.3987 24.7524 35.2496C25.0533 35.2496 25.2023 35.1006 25.5033 34.9487L33.0041 30.4488L33.0013 39.7467H48V27.746C48 23.547 44.701 20.248 40.5021 20.248H40.5019Z'></path></svg>",
        image: {
          url: "https://d2kzwze52p8717.cloudfront.net/city-streets.jpg",
          alt_text: "Alt text for image"
        },
        link: "http://apptegy.com"
      }
    ],
    has_description: true,
    component_header: "Our City",
    component_header_top: "This Is",
    component_header_description: "Our mission is to enhance the quality of life in Honeysuckle by providing the best possible recreational facilities, open green spaces, and programs for its citizens."
  }
};
const spotlights$1 = {
  preview_id: {
    show_slider: true,
    show_name: true,
    show_icons: true,
    show_tab_labels: true,
    component_header: "Spotlight",
    component_header_top: "View our",
    content: [
      {
        id: 11223,
        author_id: 22334,
        quote: "Every day is different in Honeysuckle! The sense of community here is truly heartwarming.",
        author: "Sarah Thompson, Honeysuckle Police",
        image: {
          url: "https://d2kzwze52p8717.cloudfront.net/sarah.jpeg",
          alt_text: "alt_text"
        },
        link: {
          name: "Apptegy",
          href: "http://apptegy.com",
          target: "_blank"
        }
      },
      {
        id: 11224,
        author_id: 22335,
        quote: "Working at the Parks and Recreation Department is fulfilling. We get to create beautiful spaces for everyone to enjoy.",
        author: "James Peterson, Parks and Recreation",
        image: {
          url: "https://d2kzwze52p8717.cloudfront.net/james.jpeg",
          alt_text: "alt_text"
        },
        link: {
          name: "Apptegy",
          href: "http://apptegy.com",
          target: "_blank"
        }
      },
      {
        id: 11225,
        author_id: 22336,
        quote: "The library is not just about books. It's about community, it's about connection, it's about exploration.",
        author: "Molly Patel, Honeysuckle Public Library",
        image: {
          url: "https://d2kzwze52p8717.cloudfront.net/molly.jpeg",
          alt_text: "alt_text"
        },
        link: {
          name: "Apptegy",
          href: "http://apptegy.com",
          target: "_blank"
        }
      },
      {
        id: 11226,
        author_id: 22337,
        quote: "I'm proud to serve a community that values sustainability. Our recycling program is a testament to that commitment.",
        author: "Sophia Martinez, Department of Public Works",
        image: {
          url: "https://d2kzwze52p8717.cloudfront.net/sophia.jpg",
          alt_text: "alt_text"
        },
        link: {
          name: "Apptegy",
          href: "http://apptegy.com",
          target: "_blank"
        }
      }
    ],
    nested_content: [
      {
        cards: [
          {
            icon: "<svg data-name='Layer 1' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 48 48.1'><path d='M48 30.9657C48 32.6177 46.654 33.9618 45 33.9618C43.346 33.9618 42 32.6177 42 30.9657C42 29.6647 42.839 28.5667 44 28.1528V15.7347L36.959 19.8908C36.974 19.9578 37 20.0208 37 20.0918V36.0747C37 36.6117 36.575 37.0407 36.044 37.0647C34.595 37.7947 29.741 39.9557 23 39.9557C16.259 39.9557 11.404 37.7947 9.956 37.0647C9.425 37.0407 9 36.6117 9 36.0747V20.0918C9 20.0208 9.026 19.9578 9.041 19.8908L0.491 14.8438C0.186 14.6648 0 14.3367 0 13.9837C0 13.6317 0.186 13.3037 0.491 13.1247L22.492 0.13875C22.807 -0.04625 23.195 -0.04625 23.51 0.13875L45.51 13.1247C45.913 13.1847 46 13.4688 46 13.9587V13.9808C46 13.9818 46.001 13.9827 46.001 13.9837C46.001 13.9857 46 13.9867 46 13.9878V28.1528C47.162 28.5667 48 29.6647 48 30.9657ZM35 35.3498V21.0478L23.51 27.8298C23.352 27.9217 23.177 27.9688 23.001 27.9688C22.825 27.9688 22.649 27.9217 22.492 27.8298L11 21.0468V35.3498C12.452 36.0518 16.951 37.9577 23 37.9577C29.048 37.9577 33.548 36.0518 35 35.3498ZM23.001 2.15875L2.966 13.9837L23.001 25.8098L43.035 13.9837L23.001 2.15875ZM45.419 30.0658C45.397 30.0678 45.386 30.0818 45.362 30.0818C45.224 30.0818 45.07 30.0458 44.916 29.9838C44.405 30.0288 44 30.4447 44 30.9657C44 31.5157 44.448 31.9648 45 31.9648C45.552 31.9648 46 31.5157 46 30.9657C46 30.5658 45.76 30.2248 45.419 30.0658Z'/></svg>",
            image: {
              url: "https://d2kzwze52p8717.cloudfront.net/sarah.jpeg",
              alt_text: "alt_text"
            },
            name: "Sarah Thompson",
            role: "Honeysuckle Police",
            snippet: "Every day is different in Honeysuckle! The sense of community here is truly heartwarming."
          },
          {
            icon: "<svg data-name='Layer 1' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 48 48.1'><path d='M48 30.9657C48 32.6177 46.654 33.9618 45 33.9618C43.346 33.9618 42 32.6177 42 30.9657C42 29.6647 42.839 28.5667 44 28.1528V15.7347L36.959 19.8908C36.974 19.9578 37 20.0208 37 20.0918V36.0747C37 36.6117 36.575 37.0407 36.044 37.0647C34.595 37.7947 29.741 39.9557 23 39.9557C16.259 39.9557 11.404 37.7947 9.956 37.0647C9.425 37.0407 9 36.6117 9 36.0747V20.0918C9 20.0208 9.026 19.9578 9.041 19.8908L0.491 14.8438C0.186 14.6648 0 14.3367 0 13.9837C0 13.6317 0.186 13.3037 0.491 13.1247L22.492 0.13875C22.807 -0.04625 23.195 -0.04625 23.51 0.13875L45.51 13.1247C45.913 13.1847 46 13.4688 46 13.9587V13.9808C46 13.9818 46.001 13.9827 46.001 13.9837C46.001 13.9857 46 13.9867 46 13.9878V28.1528C47.162 28.5667 48 29.6647 48 30.9657ZM35 35.3498V21.0478L23.51 27.8298C23.352 27.9217 23.177 27.9688 23.001 27.9688C22.825 27.9688 22.649 27.9217 22.492 27.8298L11 21.0468V35.3498C12.452 36.0518 16.951 37.9577 23 37.9577C29.048 37.9577 33.548 36.0518 35 35.3498ZM23.001 2.15875L2.966 13.9837L23.001 25.8098L43.035 13.9837L23.001 2.15875ZM45.419 30.0658C45.397 30.0678 45.386 30.0818 45.362 30.0818C45.224 30.0818 45.07 30.0458 44.916 29.9838C44.405 30.0288 44 30.4447 44 30.9657C44 31.5157 44.448 31.9648 45 31.9648C45.552 31.9648 46 31.5157 46 30.9657C46 30.5658 45.76 30.2248 45.419 30.0658Z'/></svg>",
            image: {
              url: "https://d2kzwze52p8717.cloudfront.net/james.jpeg",
              alt_text: "alt_text"
            },
            name: "James Peterson",
            role: "Parks and Recreation",
            snippet: "Working at the Parks and Recreation Department is fulfilling. We get to create beautiful spaces for everyone to enjoy."
          },
          {
            icon: "<svg data-name='Layer 1' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 48 48.1'><path d='M48 30.9657C48 32.6177 46.654 33.9618 45 33.9618C43.346 33.9618 42 32.6177 42 30.9657C42 29.6647 42.839 28.5667 44 28.1528V15.7347L36.959 19.8908C36.974 19.9578 37 20.0208 37 20.0918V36.0747C37 36.6117 36.575 37.0407 36.044 37.0647C34.595 37.7947 29.741 39.9557 23 39.9557C16.259 39.9557 11.404 37.7947 9.956 37.0647C9.425 37.0407 9 36.6117 9 36.0747V20.0918C9 20.0208 9.026 19.9578 9.041 19.8908L0.491 14.8438C0.186 14.6648 0 14.3367 0 13.9837C0 13.6317 0.186 13.3037 0.491 13.1247L22.492 0.13875C22.807 -0.04625 23.195 -0.04625 23.51 0.13875L45.51 13.1247C45.913 13.1847 46 13.4688 46 13.9587V13.9808C46 13.9818 46.001 13.9827 46.001 13.9837C46.001 13.9857 46 13.9867 46 13.9878V28.1528C47.162 28.5667 48 29.6647 48 30.9657ZM35 35.3498V21.0478L23.51 27.8298C23.352 27.9217 23.177 27.9688 23.001 27.9688C22.825 27.9688 22.649 27.9217 22.492 27.8298L11 21.0468V35.3498C12.452 36.0518 16.951 37.9577 23 37.9577C29.048 37.9577 33.548 36.0518 35 35.3498ZM23.001 2.15875L2.966 13.9837L23.001 25.8098L43.035 13.9837L23.001 2.15875ZM45.419 30.0658C45.397 30.0678 45.386 30.0818 45.362 30.0818C45.224 30.0818 45.07 30.0458 44.916 29.9838C44.405 30.0288 44 30.4447 44 30.9657C44 31.5157 44.448 31.9648 45 31.9648C45.552 31.9648 46 31.5157 46 30.9657C46 30.5658 45.76 30.2248 45.419 30.0658Z'/></svg>",
            image: {
              url: "https://d2kzwze52p8717.cloudfront.net/molly.jpeg",
              alt_text: "alt_text"
            },
            name: "Molly Patel",
            role: "Honeysuckle Public Library",
            snippet: "The library is not just about books. It's about community, it's about connection, it's about exploration."
          },
          {
            icon: "<svg data-name='Layer 1' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 48 48.1'><path d='M48 30.9657C48 32.6177 46.654 33.9618 45 33.9618C43.346 33.9618 42 32.6177 42 30.9657C42 29.6647 42.839 28.5667 44 28.1528V15.7347L36.959 19.8908C36.974 19.9578 37 20.0208 37 20.0918V36.0747C37 36.6117 36.575 37.0407 36.044 37.0647C34.595 37.7947 29.741 39.9557 23 39.9557C16.259 39.9557 11.404 37.7947 9.956 37.0647C9.425 37.0407 9 36.6117 9 36.0747V20.0918C9 20.0208 9.026 19.9578 9.041 19.8908L0.491 14.8438C0.186 14.6648 0 14.3367 0 13.9837C0 13.6317 0.186 13.3037 0.491 13.1247L22.492 0.13875C22.807 -0.04625 23.195 -0.04625 23.51 0.13875L45.51 13.1247C45.913 13.1847 46 13.4688 46 13.9587V13.9808C46 13.9818 46.001 13.9827 46.001 13.9837C46.001 13.9857 46 13.9867 46 13.9878V28.1528C47.162 28.5667 48 29.6647 48 30.9657ZM35 35.3498V21.0478L23.51 27.8298C23.352 27.9217 23.177 27.9688 23.001 27.9688C22.825 27.9688 22.649 27.9217 22.492 27.8298L11 21.0468V35.3498C12.452 36.0518 16.951 37.9577 23 37.9577C29.048 37.9577 33.548 36.0518 35 35.3498ZM23.001 2.15875L2.966 13.9837L23.001 25.8098L43.035 13.9837L23.001 2.15875ZM45.419 30.0658C45.397 30.0678 45.386 30.0818 45.362 30.0818C45.224 30.0818 45.07 30.0458 44.916 29.9838C44.405 30.0288 44 30.4447 44 30.9657C44 31.5157 44.448 31.9648 45 31.9648C45.552 31.9648 46 31.5157 46 30.9657C46 30.5658 45.76 30.2248 45.419 30.0658Z'/></svg>",
            image: {
              url: "https://d2kzwze52p8717.cloudfront.net/sophia.jpg",
              alt_text: "alt_text"
            },
            name: "Sophia Martinez",
            role: "Department of Public Works",
            snippet: "I'm proud to serve a community that values sustainability. Our recycling program is a testament to that commitment."
          },
          {
            icon: "<svg data-name='Layer 1' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 48 48.1'><path d='M48 30.9657C48 32.6177 46.654 33.9618 45 33.9618C43.346 33.9618 42 32.6177 42 30.9657C42 29.6647 42.839 28.5667 44 28.1528V15.7347L36.959 19.8908C36.974 19.9578 37 20.0208 37 20.0918V36.0747C37 36.6117 36.575 37.0407 36.044 37.0647C34.595 37.7947 29.741 39.9557 23 39.9557C16.259 39.9557 11.404 37.7947 9.956 37.0647C9.425 37.0407 9 36.6117 9 36.0747V20.0918C9 20.0208 9.026 19.9578 9.041 19.8908L0.491 14.8438C0.186 14.6648 0 14.3367 0 13.9837C0 13.6317 0.186 13.3037 0.491 13.1247L22.492 0.13875C22.807 -0.04625 23.195 -0.04625 23.51 0.13875L45.51 13.1247C45.913 13.1847 46 13.4688 46 13.9587V13.9808C46 13.9818 46.001 13.9827 46.001 13.9837C46.001 13.9857 46 13.9867 46 13.9878V28.1528C47.162 28.5667 48 29.6647 48 30.9657ZM35 35.3498V21.0478L23.51 27.8298C23.352 27.9217 23.177 27.9688 23.001 27.9688C22.825 27.9688 22.649 27.9217 22.492 27.8298L11 21.0468V35.3498C12.452 36.0518 16.951 37.9577 23 37.9577C29.048 37.9577 33.548 36.0518 35 35.3498ZM23.001 2.15875L2.966 13.9837L23.001 25.8098L43.035 13.9837L23.001 2.15875ZM45.419 30.0658C45.397 30.0678 45.386 30.0818 45.362 30.0818C45.224 30.0818 45.07 30.0458 44.916 29.9838C44.405 30.0288 44 30.4447 44 30.9657C44 31.5157 44.448 31.9648 45 31.9648C45.552 31.9648 46 31.5157 46 30.9657C46 30.5658 45.76 30.2248 45.419 30.0658Z'/></svg>",
            image: {
              url: "https://d2kzwze52p8717.cloudfront.net/sarah.jpeg",
              alt_text: "alt_text"
            },
            name: "Sarah Thompson",
            role: "Honeysuckle Police",
            snippet: "Every day is different in Honeysuckle! The sense of community here is truly heartwarming."
          },
          {
            icon: "<svg data-name='Layer 1' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 48 48.1'><path d='M48 30.9657C48 32.6177 46.654 33.9618 45 33.9618C43.346 33.9618 42 32.6177 42 30.9657C42 29.6647 42.839 28.5667 44 28.1528V15.7347L36.959 19.8908C36.974 19.9578 37 20.0208 37 20.0918V36.0747C37 36.6117 36.575 37.0407 36.044 37.0647C34.595 37.7947 29.741 39.9557 23 39.9557C16.259 39.9557 11.404 37.7947 9.956 37.0647C9.425 37.0407 9 36.6117 9 36.0747V20.0918C9 20.0208 9.026 19.9578 9.041 19.8908L0.491 14.8438C0.186 14.6648 0 14.3367 0 13.9837C0 13.6317 0.186 13.3037 0.491 13.1247L22.492 0.13875C22.807 -0.04625 23.195 -0.04625 23.51 0.13875L45.51 13.1247C45.913 13.1847 46 13.4688 46 13.9587V13.9808C46 13.9818 46.001 13.9827 46.001 13.9837C46.001 13.9857 46 13.9867 46 13.9878V28.1528C47.162 28.5667 48 29.6647 48 30.9657ZM35 35.3498V21.0478L23.51 27.8298C23.352 27.9217 23.177 27.9688 23.001 27.9688C22.825 27.9688 22.649 27.9217 22.492 27.8298L11 21.0468V35.3498C12.452 36.0518 16.951 37.9577 23 37.9577C29.048 37.9577 33.548 36.0518 35 35.3498ZM23.001 2.15875L2.966 13.9837L23.001 25.8098L43.035 13.9837L23.001 2.15875ZM45.419 30.0658C45.397 30.0678 45.386 30.0818 45.362 30.0818C45.224 30.0818 45.07 30.0458 44.916 29.9838C44.405 30.0288 44 30.4447 44 30.9657C44 31.5157 44.448 31.9648 45 31.9648C45.552 31.9648 46 31.5157 46 30.9657C46 30.5658 45.76 30.2248 45.419 30.0658Z'/></svg>",
            image: {
              url: "https://d2kzwze52p8717.cloudfront.net/james.jpeg",
              alt_text: "alt_text"
            },
            name: "James Peterson",
            role: "Parks and Recreation",
            snippet: "Working at the Parks and Recreation Department is fulfilling. We get to create beautiful spaces for everyone to enjoy."
          },
          {
            icon: "<svg data-name='Layer 1' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 48 48.1'><path d='M48 30.9657C48 32.6177 46.654 33.9618 45 33.9618C43.346 33.9618 42 32.6177 42 30.9657C42 29.6647 42.839 28.5667 44 28.1528V15.7347L36.959 19.8908C36.974 19.9578 37 20.0208 37 20.0918V36.0747C37 36.6117 36.575 37.0407 36.044 37.0647C34.595 37.7947 29.741 39.9557 23 39.9557C16.259 39.9557 11.404 37.7947 9.956 37.0647C9.425 37.0407 9 36.6117 9 36.0747V20.0918C9 20.0208 9.026 19.9578 9.041 19.8908L0.491 14.8438C0.186 14.6648 0 14.3367 0 13.9837C0 13.6317 0.186 13.3037 0.491 13.1247L22.492 0.13875C22.807 -0.04625 23.195 -0.04625 23.51 0.13875L45.51 13.1247C45.913 13.1847 46 13.4688 46 13.9587V13.9808C46 13.9818 46.001 13.9827 46.001 13.9837C46.001 13.9857 46 13.9867 46 13.9878V28.1528C47.162 28.5667 48 29.6647 48 30.9657ZM35 35.3498V21.0478L23.51 27.8298C23.352 27.9217 23.177 27.9688 23.001 27.9688C22.825 27.9688 22.649 27.9217 22.492 27.8298L11 21.0468V35.3498C12.452 36.0518 16.951 37.9577 23 37.9577C29.048 37.9577 33.548 36.0518 35 35.3498ZM23.001 2.15875L2.966 13.9837L23.001 25.8098L43.035 13.9837L23.001 2.15875ZM45.419 30.0658C45.397 30.0678 45.386 30.0818 45.362 30.0818C45.224 30.0818 45.07 30.0458 44.916 29.9838C44.405 30.0288 44 30.4447 44 30.9657C44 31.5157 44.448 31.9648 45 31.9648C45.552 31.9648 46 31.5157 46 30.9657C46 30.5658 45.76 30.2248 45.419 30.0658Z'/></svg>",
            image: {
              url: "https://d2kzwze52p8717.cloudfront.net/molly.jpeg",
              alt_text: "alt_text"
            },
            name: "Molly Patel",
            role: "Honeysuckle Public Library",
            snippet: "The library is not just about books. It's about community, it's about connection, it's about exploration."
          },
          {
            icon: "<svg data-name='Layer 1' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 48 48.1'><path d='M48 30.9657C48 32.6177 46.654 33.9618 45 33.9618C43.346 33.9618 42 32.6177 42 30.9657C42 29.6647 42.839 28.5667 44 28.1528V15.7347L36.959 19.8908C36.974 19.9578 37 20.0208 37 20.0918V36.0747C37 36.6117 36.575 37.0407 36.044 37.0647C34.595 37.7947 29.741 39.9557 23 39.9557C16.259 39.9557 11.404 37.7947 9.956 37.0647C9.425 37.0407 9 36.6117 9 36.0747V20.0918C9 20.0208 9.026 19.9578 9.041 19.8908L0.491 14.8438C0.186 14.6648 0 14.3367 0 13.9837C0 13.6317 0.186 13.3037 0.491 13.1247L22.492 0.13875C22.807 -0.04625 23.195 -0.04625 23.51 0.13875L45.51 13.1247C45.913 13.1847 46 13.4688 46 13.9587V13.9808C46 13.9818 46.001 13.9827 46.001 13.9837C46.001 13.9857 46 13.9867 46 13.9878V28.1528C47.162 28.5667 48 29.6647 48 30.9657ZM35 35.3498V21.0478L23.51 27.8298C23.352 27.9217 23.177 27.9688 23.001 27.9688C22.825 27.9688 22.649 27.9217 22.492 27.8298L11 21.0468V35.3498C12.452 36.0518 16.951 37.9577 23 37.9577C29.048 37.9577 33.548 36.0518 35 35.3498ZM23.001 2.15875L2.966 13.9837L23.001 25.8098L43.035 13.9837L23.001 2.15875ZM45.419 30.0658C45.397 30.0678 45.386 30.0818 45.362 30.0818C45.224 30.0818 45.07 30.0458 44.916 29.9838C44.405 30.0288 44 30.4447 44 30.9657C44 31.5157 44.448 31.9648 45 31.9648C45.552 31.9648 46 31.5157 46 30.9657C46 30.5658 45.76 30.2248 45.419 30.0658Z'/></svg>",
            image: {
              url: "https://d2kzwze52p8717.cloudfront.net/sophia.jpg",
              alt_text: "alt_text"
            },
            name: "Sophia Martinez",
            role: "Department of Public Works",
            snippet: "I'm proud to serve a community that values sustainability. Our recycling program is a testament to that commitment."
          }
        ],
        icon: "<svg data-name='Layer 1' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 48 48.1'><path d='M48 30.9657C48 32.6177 46.654 33.9618 45 33.9618C43.346 33.9618 42 32.6177 42 30.9657C42 29.6647 42.839 28.5667 44 28.1528V15.7347L36.959 19.8908C36.974 19.9578 37 20.0208 37 20.0918V36.0747C37 36.6117 36.575 37.0407 36.044 37.0647C34.595 37.7947 29.741 39.9557 23 39.9557C16.259 39.9557 11.404 37.7947 9.956 37.0647C9.425 37.0407 9 36.6117 9 36.0747V20.0918C9 20.0208 9.026 19.9578 9.041 19.8908L0.491 14.8438C0.186 14.6648 0 14.3367 0 13.9837C0 13.6317 0.186 13.3037 0.491 13.1247L22.492 0.13875C22.807 -0.04625 23.195 -0.04625 23.51 0.13875L45.51 13.1247C45.913 13.1847 46 13.4688 46 13.9587V13.9808C46 13.9818 46.001 13.9827 46.001 13.9837C46.001 13.9857 46 13.9867 46 13.9878V28.1528C47.162 28.5667 48 29.6647 48 30.9657ZM35 35.3498V21.0478L23.51 27.8298C23.352 27.9217 23.177 27.9688 23.001 27.9688C22.825 27.9688 22.649 27.9217 22.492 27.8298L11 21.0468V35.3498C12.452 36.0518 16.951 37.9577 23 37.9577C29.048 37.9577 33.548 36.0518 35 35.3498ZM23.001 2.15875L2.966 13.9837L23.001 25.8098L43.035 13.9837L23.001 2.15875ZM45.419 30.0658C45.397 30.0678 45.386 30.0818 45.362 30.0818C45.224 30.0818 45.07 30.0458 44.916 29.9838C44.405 30.0288 44 30.4447 44 30.9657C44 31.5157 44.448 31.9648 45 31.9648C45.552 31.9648 46 31.5157 46 30.9657C46 30.5658 45.76 30.2248 45.419 30.0658Z'/></svg>",
        label: "Departments",
        show_image_icons: true,
        show_headline: true,
        show_snippet: true
      },
      {
        cards: [
          {
            icon: "<svg data-name='Layer 1' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 48 48.1'><path d='M48 30.9657C48 32.6177 46.654 33.9618 45 33.9618C43.346 33.9618 42 32.6177 42 30.9657C42 29.6647 42.839 28.5667 44 28.1528V15.7347L36.959 19.8908C36.974 19.9578 37 20.0208 37 20.0918V36.0747C37 36.6117 36.575 37.0407 36.044 37.0647C34.595 37.7947 29.741 39.9557 23 39.9557C16.259 39.9557 11.404 37.7947 9.956 37.0647C9.425 37.0407 9 36.6117 9 36.0747V20.0918C9 20.0208 9.026 19.9578 9.041 19.8908L0.491 14.8438C0.186 14.6648 0 14.3367 0 13.9837C0 13.6317 0.186 13.3037 0.491 13.1247L22.492 0.13875C22.807 -0.04625 23.195 -0.04625 23.51 0.13875L45.51 13.1247C45.913 13.1847 46 13.4688 46 13.9587V13.9808C46 13.9818 46.001 13.9827 46.001 13.9837C46.001 13.9857 46 13.9867 46 13.9878V28.1528C47.162 28.5667 48 29.6647 48 30.9657ZM35 35.3498V21.0478L23.51 27.8298C23.352 27.9217 23.177 27.9688 23.001 27.9688C22.825 27.9688 22.649 27.9217 22.492 27.8298L11 21.0468V35.3498C12.452 36.0518 16.951 37.9577 23 37.9577C29.048 37.9577 33.548 36.0518 35 35.3498ZM23.001 2.15875L2.966 13.9837L23.001 25.8098L43.035 13.9837L23.001 2.15875ZM45.419 30.0658C45.397 30.0678 45.386 30.0818 45.362 30.0818C45.224 30.0818 45.07 30.0458 44.916 29.9838C44.405 30.0288 44 30.4447 44 30.9657C44 31.5157 44.448 31.9648 45 31.9648C45.552 31.9648 46 31.5157 46 30.9657C46 30.5658 45.76 30.2248 45.419 30.0658Z'/></svg>",
            image: {
              url: "https://d2kzwze52p8717.cloudfront.net/james.jpeg",
              alt_text: "alt_text"
            },
            name: "James Peterson",
            role: "Parks and Recreation",
            snippet: "Working at the Parks and Recreation Department is fulfilling. We get to create beautiful spaces for everyone to enjoy."
          },
          {
            icon: "<svg data-name='Layer 1' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 48 48.1'><path d='M48 30.9657C48 32.6177 46.654 33.9618 45 33.9618C43.346 33.9618 42 32.6177 42 30.9657C42 29.6647 42.839 28.5667 44 28.1528V15.7347L36.959 19.8908C36.974 19.9578 37 20.0208 37 20.0918V36.0747C37 36.6117 36.575 37.0407 36.044 37.0647C34.595 37.7947 29.741 39.9557 23 39.9557C16.259 39.9557 11.404 37.7947 9.956 37.0647C9.425 37.0407 9 36.6117 9 36.0747V20.0918C9 20.0208 9.026 19.9578 9.041 19.8908L0.491 14.8438C0.186 14.6648 0 14.3367 0 13.9837C0 13.6317 0.186 13.3037 0.491 13.1247L22.492 0.13875C22.807 -0.04625 23.195 -0.04625 23.51 0.13875L45.51 13.1247C45.913 13.1847 46 13.4688 46 13.9587V13.9808C46 13.9818 46.001 13.9827 46.001 13.9837C46.001 13.9857 46 13.9867 46 13.9878V28.1528C47.162 28.5667 48 29.6647 48 30.9657ZM35 35.3498V21.0478L23.51 27.8298C23.352 27.9217 23.177 27.9688 23.001 27.9688C22.825 27.9688 22.649 27.9217 22.492 27.8298L11 21.0468V35.3498C12.452 36.0518 16.951 37.9577 23 37.9577C29.048 37.9577 33.548 36.0518 35 35.3498ZM23.001 2.15875L2.966 13.9837L23.001 25.8098L43.035 13.9837L23.001 2.15875ZM45.419 30.0658C45.397 30.0678 45.386 30.0818 45.362 30.0818C45.224 30.0818 45.07 30.0458 44.916 29.9838C44.405 30.0288 44 30.4447 44 30.9657C44 31.5157 44.448 31.9648 45 31.9648C45.552 31.9648 46 31.5157 46 30.9657C46 30.5658 45.76 30.2248 45.419 30.0658Z'/></svg>",
            image: {
              url: "https://d2kzwze52p8717.cloudfront.net/molly.jpeg",
              alt_text: "alt_text"
            },
            name: "Molly Patel",
            role: "Honeysuckle Public Library",
            snippet: "The library is not just about books. It's about community, it's about connection, it's about exploration."
          },
          {
            icon: "<svg data-name='Layer 1' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 48 48.1'><path d='M48 30.9657C48 32.6177 46.654 33.9618 45 33.9618C43.346 33.9618 42 32.6177 42 30.9657C42 29.6647 42.839 28.5667 44 28.1528V15.7347L36.959 19.8908C36.974 19.9578 37 20.0208 37 20.0918V36.0747C37 36.6117 36.575 37.0407 36.044 37.0647C34.595 37.7947 29.741 39.9557 23 39.9557C16.259 39.9557 11.404 37.7947 9.956 37.0647C9.425 37.0407 9 36.6117 9 36.0747V20.0918C9 20.0208 9.026 19.9578 9.041 19.8908L0.491 14.8438C0.186 14.6648 0 14.3367 0 13.9837C0 13.6317 0.186 13.3037 0.491 13.1247L22.492 0.13875C22.807 -0.04625 23.195 -0.04625 23.51 0.13875L45.51 13.1247C45.913 13.1847 46 13.4688 46 13.9587V13.9808C46 13.9818 46.001 13.9827 46.001 13.9837C46.001 13.9857 46 13.9867 46 13.9878V28.1528C47.162 28.5667 48 29.6647 48 30.9657ZM35 35.3498V21.0478L23.51 27.8298C23.352 27.9217 23.177 27.9688 23.001 27.9688C22.825 27.9688 22.649 27.9217 22.492 27.8298L11 21.0468V35.3498C12.452 36.0518 16.951 37.9577 23 37.9577C29.048 37.9577 33.548 36.0518 35 35.3498ZM23.001 2.15875L2.966 13.9837L23.001 25.8098L43.035 13.9837L23.001 2.15875ZM45.419 30.0658C45.397 30.0678 45.386 30.0818 45.362 30.0818C45.224 30.0818 45.07 30.0458 44.916 29.9838C44.405 30.0288 44 30.4447 44 30.9657C44 31.5157 44.448 31.9648 45 31.9648C45.552 31.9648 46 31.5157 46 30.9657C46 30.5658 45.76 30.2248 45.419 30.0658Z'/></svg>",
            image: {
              url: "https://d2kzwze52p8717.cloudfront.net/sophia.jpg",
              alt_text: "alt_text"
            },
            name: "Sophia Martinez",
            role: "Department of Public Works",
            snippet: "I'm proud to serve a community that values sustainability. Our recycling program is a testament to that commitment."
          }
        ],
        icon: "<svg data-name='Layer 1' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 48 48.1'><path d='M48 30.9657C48 32.6177 46.654 33.9618 45 33.9618C43.346 33.9618 42 32.6177 42 30.9657C42 29.6647 42.839 28.5667 44 28.1528V15.7347L36.959 19.8908C36.974 19.9578 37 20.0208 37 20.0918V36.0747C37 36.6117 36.575 37.0407 36.044 37.0647C34.595 37.7947 29.741 39.9557 23 39.9557C16.259 39.9557 11.404 37.7947 9.956 37.0647C9.425 37.0407 9 36.6117 9 36.0747V20.0918C9 20.0208 9.026 19.9578 9.041 19.8908L0.491 14.8438C0.186 14.6648 0 14.3367 0 13.9837C0 13.6317 0.186 13.3037 0.491 13.1247L22.492 0.13875C22.807 -0.04625 23.195 -0.04625 23.51 0.13875L45.51 13.1247C45.913 13.1847 46 13.4688 46 13.9587V13.9808C46 13.9818 46.001 13.9827 46.001 13.9837C46.001 13.9857 46 13.9867 46 13.9878V28.1528C47.162 28.5667 48 29.6647 48 30.9657ZM35 35.3498V21.0478L23.51 27.8298C23.352 27.9217 23.177 27.9688 23.001 27.9688C22.825 27.9688 22.649 27.9217 22.492 27.8298L11 21.0468V35.3498C12.452 36.0518 16.951 37.9577 23 37.9577C29.048 37.9577 33.548 36.0518 35 35.3498ZM23.001 2.15875L2.966 13.9837L23.001 25.8098L43.035 13.9837L23.001 2.15875ZM45.419 30.0658C45.397 30.0678 45.386 30.0818 45.362 30.0818C45.224 30.0818 45.07 30.0458 44.916 29.9838C44.405 30.0288 44 30.4447 44 30.9657C44 31.5157 44.448 31.9648 45 31.9648C45.552 31.9648 46 31.5157 46 30.9657C46 30.5658 45.76 30.2248 45.419 30.0658Z'/></svg>",
        label: "Services",
        show_image_icons: true,
        show_headline: true,
        show_snippet: true
      },
      {
        cards: [
          {
            icon: "<svg data-name='Layer 1' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 48 48.1'><path d='M48 30.9657C48 32.6177 46.654 33.9618 45 33.9618C43.346 33.9618 42 32.6177 42 30.9657C42 29.6647 42.839 28.5667 44 28.1528V15.7347L36.959 19.8908C36.974 19.9578 37 20.0208 37 20.0918V36.0747C37 36.6117 36.575 37.0407 36.044 37.0647C34.595 37.7947 29.741 39.9557 23 39.9557C16.259 39.9557 11.404 37.7947 9.956 37.0647C9.425 37.0407 9 36.6117 9 36.0747V20.0918C9 20.0208 9.026 19.9578 9.041 19.8908L0.491 14.8438C0.186 14.6648 0 14.3367 0 13.9837C0 13.6317 0.186 13.3037 0.491 13.1247L22.492 0.13875C22.807 -0.04625 23.195 -0.04625 23.51 0.13875L45.51 13.1247C45.913 13.1847 46 13.4688 46 13.9587V13.9808C46 13.9818 46.001 13.9827 46.001 13.9837C46.001 13.9857 46 13.9867 46 13.9878V28.1528C47.162 28.5667 48 29.6647 48 30.9657ZM35 35.3498V21.0478L23.51 27.8298C23.352 27.9217 23.177 27.9688 23.001 27.9688C22.825 27.9688 22.649 27.9217 22.492 27.8298L11 21.0468V35.3498C12.452 36.0518 16.951 37.9577 23 37.9577C29.048 37.9577 33.548 36.0518 35 35.3498ZM23.001 2.15875L2.966 13.9837L23.001 25.8098L43.035 13.9837L23.001 2.15875ZM45.419 30.0658C45.397 30.0678 45.386 30.0818 45.362 30.0818C45.224 30.0818 45.07 30.0458 44.916 29.9838C44.405 30.0288 44 30.4447 44 30.9657C44 31.5157 44.448 31.9648 45 31.9648C45.552 31.9648 46 31.5157 46 30.9657C46 30.5658 45.76 30.2248 45.419 30.0658Z'/></svg>",
            image: {
              url: "https://d2kzwze52p8717.cloudfront.net/sarah.jpeg",
              alt_text: "alt_text"
            },
            name: "Sarah Thompson",
            role: "Honeysuckle Police",
            snippet: "Every day is different in Honeysuckle! The sense of community here is truly heartwarming."
          },
          {
            icon: "<svg data-name='Layer 1' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 48 48.1'><path d='M48 30.9657C48 32.6177 46.654 33.9618 45 33.9618C43.346 33.9618 42 32.6177 42 30.9657C42 29.6647 42.839 28.5667 44 28.1528V15.7347L36.959 19.8908C36.974 19.9578 37 20.0208 37 20.0918V36.0747C37 36.6117 36.575 37.0407 36.044 37.0647C34.595 37.7947 29.741 39.9557 23 39.9557C16.259 39.9557 11.404 37.7947 9.956 37.0647C9.425 37.0407 9 36.6117 9 36.0747V20.0918C9 20.0208 9.026 19.9578 9.041 19.8908L0.491 14.8438C0.186 14.6648 0 14.3367 0 13.9837C0 13.6317 0.186 13.3037 0.491 13.1247L22.492 0.13875C22.807 -0.04625 23.195 -0.04625 23.51 0.13875L45.51 13.1247C45.913 13.1847 46 13.4688 46 13.9587V13.9808C46 13.9818 46.001 13.9827 46.001 13.9837C46.001 13.9857 46 13.9867 46 13.9878V28.1528C47.162 28.5667 48 29.6647 48 30.9657ZM35 35.3498V21.0478L23.51 27.8298C23.352 27.9217 23.177 27.9688 23.001 27.9688C22.825 27.9688 22.649 27.9217 22.492 27.8298L11 21.0468V35.3498C12.452 36.0518 16.951 37.9577 23 37.9577C29.048 37.9577 33.548 36.0518 35 35.3498ZM23.001 2.15875L2.966 13.9837L23.001 25.8098L43.035 13.9837L23.001 2.15875ZM45.419 30.0658C45.397 30.0678 45.386 30.0818 45.362 30.0818C45.224 30.0818 45.07 30.0458 44.916 29.9838C44.405 30.0288 44 30.4447 44 30.9657C44 31.5157 44.448 31.9648 45 31.9648C45.552 31.9648 46 31.5157 46 30.9657C46 30.5658 45.76 30.2248 45.419 30.0658Z'/></svg>",
            image: {
              url: "https://d2kzwze52p8717.cloudfront.net/james.jpeg",
              alt_text: "alt_text"
            },
            name: "James Peterson",
            role: "Parks and Recreation",
            snippet: "Working at the Parks and Recreation Department is fulfilling. We get to create beautiful spaces for everyone to enjoy."
          },
          {
            icon: "<svg data-name='Layer 1' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 48 48.1'><path d='M48 30.9657C48 32.6177 46.654 33.9618 45 33.9618C43.346 33.9618 42 32.6177 42 30.9657C42 29.6647 42.839 28.5667 44 28.1528V15.7347L36.959 19.8908C36.974 19.9578 37 20.0208 37 20.0918V36.0747C37 36.6117 36.575 37.0407 36.044 37.0647C34.595 37.7947 29.741 39.9557 23 39.9557C16.259 39.9557 11.404 37.7947 9.956 37.0647C9.425 37.0407 9 36.6117 9 36.0747V20.0918C9 20.0208 9.026 19.9578 9.041 19.8908L0.491 14.8438C0.186 14.6648 0 14.3367 0 13.9837C0 13.6317 0.186 13.3037 0.491 13.1247L22.492 0.13875C22.807 -0.04625 23.195 -0.04625 23.51 0.13875L45.51 13.1247C45.913 13.1847 46 13.4688 46 13.9587V13.9808C46 13.9818 46.001 13.9827 46.001 13.9837C46.001 13.9857 46 13.9867 46 13.9878V28.1528C47.162 28.5667 48 29.6647 48 30.9657ZM35 35.3498V21.0478L23.51 27.8298C23.352 27.9217 23.177 27.9688 23.001 27.9688C22.825 27.9688 22.649 27.9217 22.492 27.8298L11 21.0468V35.3498C12.452 36.0518 16.951 37.9577 23 37.9577C29.048 37.9577 33.548 36.0518 35 35.3498ZM23.001 2.15875L2.966 13.9837L23.001 25.8098L43.035 13.9837L23.001 2.15875ZM45.419 30.0658C45.397 30.0678 45.386 30.0818 45.362 30.0818C45.224 30.0818 45.07 30.0458 44.916 29.9838C44.405 30.0288 44 30.4447 44 30.9657C44 31.5157 44.448 31.9648 45 31.9648C45.552 31.9648 46 31.5157 46 30.9657C46 30.5658 45.76 30.2248 45.419 30.0658Z'/></svg>",
            image: {
              url: "https://d2kzwze52p8717.cloudfront.net/molly.jpeg",
              alt_text: "alt_text"
            },
            name: "Molly Patel",
            role: "Honeysuckle Public Library",
            snippet: "The library is not just about books. It's about community, it's about connection, it's about exploration."
          },
          {
            icon: "<svg data-name='Layer 1' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 48 48.1'><path d='M48 30.9657C48 32.6177 46.654 33.9618 45 33.9618C43.346 33.9618 42 32.6177 42 30.9657C42 29.6647 42.839 28.5667 44 28.1528V15.7347L36.959 19.8908C36.974 19.9578 37 20.0208 37 20.0918V36.0747C37 36.6117 36.575 37.0407 36.044 37.0647C34.595 37.7947 29.741 39.9557 23 39.9557C16.259 39.9557 11.404 37.7947 9.956 37.0647C9.425 37.0407 9 36.6117 9 36.0747V20.0918C9 20.0208 9.026 19.9578 9.041 19.8908L0.491 14.8438C0.186 14.6648 0 14.3367 0 13.9837C0 13.6317 0.186 13.3037 0.491 13.1247L22.492 0.13875C22.807 -0.04625 23.195 -0.04625 23.51 0.13875L45.51 13.1247C45.913 13.1847 46 13.4688 46 13.9587V13.9808C46 13.9818 46.001 13.9827 46.001 13.9837C46.001 13.9857 46 13.9867 46 13.9878V28.1528C47.162 28.5667 48 29.6647 48 30.9657ZM35 35.3498V21.0478L23.51 27.8298C23.352 27.9217 23.177 27.9688 23.001 27.9688C22.825 27.9688 22.649 27.9217 22.492 27.8298L11 21.0468V35.3498C12.452 36.0518 16.951 37.9577 23 37.9577C29.048 37.9577 33.548 36.0518 35 35.3498ZM23.001 2.15875L2.966 13.9837L23.001 25.8098L43.035 13.9837L23.001 2.15875ZM45.419 30.0658C45.397 30.0678 45.386 30.0818 45.362 30.0818C45.224 30.0818 45.07 30.0458 44.916 29.9838C44.405 30.0288 44 30.4447 44 30.9657C44 31.5157 44.448 31.9648 45 31.9648C45.552 31.9648 46 31.5157 46 30.9657C46 30.5658 45.76 30.2248 45.419 30.0658Z'/></svg>",
            image: {
              url: "https://d2kzwze52p8717.cloudfront.net/sophia.jpg",
              alt_text: "alt_text"
            },
            name: "Sophia Martinez",
            role: "Department of Public Works",
            snippet: "I'm proud to serve a community that values sustainability. Our recycling program is a testament to that commitment."
          },
          {
            icon: "<svg data-name='Layer 1' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 48 48.1'><path d='M48 30.9657C48 32.6177 46.654 33.9618 45 33.9618C43.346 33.9618 42 32.6177 42 30.9657C42 29.6647 42.839 28.5667 44 28.1528V15.7347L36.959 19.8908C36.974 19.9578 37 20.0208 37 20.0918V36.0747C37 36.6117 36.575 37.0407 36.044 37.0647C34.595 37.7947 29.741 39.9557 23 39.9557C16.259 39.9557 11.404 37.7947 9.956 37.0647C9.425 37.0407 9 36.6117 9 36.0747V20.0918C9 20.0208 9.026 19.9578 9.041 19.8908L0.491 14.8438C0.186 14.6648 0 14.3367 0 13.9837C0 13.6317 0.186 13.3037 0.491 13.1247L22.492 0.13875C22.807 -0.04625 23.195 -0.04625 23.51 0.13875L45.51 13.1247C45.913 13.1847 46 13.4688 46 13.9587V13.9808C46 13.9818 46.001 13.9827 46.001 13.9837C46.001 13.9857 46 13.9867 46 13.9878V28.1528C47.162 28.5667 48 29.6647 48 30.9657ZM35 35.3498V21.0478L23.51 27.8298C23.352 27.9217 23.177 27.9688 23.001 27.9688C22.825 27.9688 22.649 27.9217 22.492 27.8298L11 21.0468V35.3498C12.452 36.0518 16.951 37.9577 23 37.9577C29.048 37.9577 33.548 36.0518 35 35.3498ZM23.001 2.15875L2.966 13.9837L23.001 25.8098L43.035 13.9837L23.001 2.15875ZM45.419 30.0658C45.397 30.0678 45.386 30.0818 45.362 30.0818C45.224 30.0818 45.07 30.0458 44.916 29.9838C44.405 30.0288 44 30.4447 44 30.9657C44 31.5157 44.448 31.9648 45 31.9648C45.552 31.9648 46 31.5157 46 30.9657C46 30.5658 45.76 30.2248 45.419 30.0658Z'/></svg>",
            image: {
              url: "https://d2kzwze52p8717.cloudfront.net/sarah.jpeg",
              alt_text: "alt_text"
            },
            name: "Sarah Thompson",
            role: "Honeysuckle Police",
            snippet: "Every day is different in Honeysuckle! The sense of community here is truly heartwarming."
          }
        ],
        icon: "<svg data-name='Layer 1' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 48 48.1'><path d='M48 30.9657C48 32.6177 46.654 33.9618 45 33.9618C43.346 33.9618 42 32.6177 42 30.9657C42 29.6647 42.839 28.5667 44 28.1528V15.7347L36.959 19.8908C36.974 19.9578 37 20.0208 37 20.0918V36.0747C37 36.6117 36.575 37.0407 36.044 37.0647C34.595 37.7947 29.741 39.9557 23 39.9557C16.259 39.9557 11.404 37.7947 9.956 37.0647C9.425 37.0407 9 36.6117 9 36.0747V20.0918C9 20.0208 9.026 19.9578 9.041 19.8908L0.491 14.8438C0.186 14.6648 0 14.3367 0 13.9837C0 13.6317 0.186 13.3037 0.491 13.1247L22.492 0.13875C22.807 -0.04625 23.195 -0.04625 23.51 0.13875L45.51 13.1247C45.913 13.1847 46 13.4688 46 13.9587V13.9808C46 13.9818 46.001 13.9827 46.001 13.9837C46.001 13.9857 46 13.9867 46 13.9878V28.1528C47.162 28.5667 48 29.6647 48 30.9657ZM35 35.3498V21.0478L23.51 27.8298C23.352 27.9217 23.177 27.9688 23.001 27.9688C22.825 27.9688 22.649 27.9217 22.492 27.8298L11 21.0468V35.3498C12.452 36.0518 16.951 37.9577 23 37.9577C29.048 37.9577 33.548 36.0518 35 35.3498ZM23.001 2.15875L2.966 13.9837L23.001 25.8098L43.035 13.9837L23.001 2.15875ZM45.419 30.0658C45.397 30.0678 45.386 30.0818 45.362 30.0818C45.224 30.0818 45.07 30.0458 44.916 29.9838C44.405 30.0288 44 30.4447 44 30.9657C44 31.5157 44.448 31.9648 45 31.9648C45.552 31.9648 46 31.5157 46 30.9657C46 30.5658 45.76 30.2248 45.419 30.0658Z'/></svg>",
        label: "Community",
        show_image_icons: true,
        show_headline: true,
        show_snippet: true
      }
    ]
  }
};
const buttons$1 = {
  preview_id: {
    content: [
      {
        link: "#",
        title: "About Us",
        mailto: false,
        ipAddress: false,
        opens_in_new_tab: false,
        icon: '<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48.01 46"><path d="M31.0612 35.1518C28.9435 34.0214 30.0739 31.9037 31.0612 30.9164C32.3318 29.6458 33.8857 25.2701 33.8857 25.2701C36.4269 24.1398 36.7102 22.3054 36.9907 21.0347C38.1211 17.3632 35.2966 16.7994 35.2966 16.7994C35.2966 16.7994 37.5546 10.7296 35.7201 6.07066C33.3192 0.000863567 23.5778 -2.25981 21.8837 3.38916C10.3079 0.845296 12.7061 16.7967 12.7061 16.7967C12.7061 16.7967 9.88164 17.3605 11.012 21.032C11.2952 22.3026 11.5758 24.1371 14.117 25.2674C14.117 25.2674 15.6709 29.6431 16.9415 30.9137C17.9288 31.901 19.0592 34.0187 16.9415 35.149C12.7061 37.407 0 37.9735 0 47.8552H48C48.0026 37.9735 35.2966 37.4097 31.0612 35.1518Z" transform="translate(0.02 -1)"></path></svg>'
      },
      {
        link: "#",
        title: "Pay a Bill",
        mailto: false,
        ipAddress: false,
        opens_in_new_tab: false,
        icon: '<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 36"><path d="M47,34H45V8.6A2.52,2.52,0,0,0,42.4,6H5.5A2.56,2.56,0,0,0,3,8.6V34H1a.94.94,0,0,0-1,1v4.5A2.48,2.48,0,0,0,2.5,42h43A2.48,2.48,0,0,0,48,39.5V35A.94.94,0,0,0,47,34ZM5,8.6A.56.56,0,0,1,5.5,8H42.4a.65.65,0,0,1,.6.6V34H30.1a.94.94,0,0,0-1,1v1H19V35a.94.94,0,0,0-1-1H5ZM45.5,40H2.5a.64.64,0,0,1-.5-.5V36H17v1a.94.94,0,0,0,1,1H30a.94.94,0,0,0,1-1V36H46v3.5A.64.64,0,0,1,45.5,40Z" transform="translate(0 -6)"></path><path d="M32.2,26.4H29a1,1,0,0,0,0,2h2.2V30a1,1,0,1,0,2,0V28.3a4.1,4.1,0,0,0,3.2-4.1A4.16,4.16,0,0,0,32.2,20a2.2,2.2,0,0,1,0-4.4h3.2a1,1,0,0,0,0-2H33.2V12a1,1,0,0,0-2,0v1.7A4.1,4.1,0,0,0,28,17.8,4.16,4.16,0,0,0,32.2,22a2.22,2.22,0,0,1,2.2,2.2A2.16,2.16,0,0,1,32.2,26.4Z" transform="translate(0 -6)"></path></svg>'
      },
      {
        link: "#",
        title: "Community",
        mailto: false,
        ipAddress: false,
        opens_in_new_tab: false,
        icon: "<svg id='Layer_1' data-name='Layer 1' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 48 48'><path d='M40.5019 20.248C39.1519 20.248 37.951 20.698 36.7529 21.2971L24.0041 28.7979L11.2554 21.2971C10.0516 20.698 8.85077 20.248 7.5008 20.248C3.30185 20.248 0 23.547 0 27.7488V39.7495H14.9987V30.4488L22.4995 34.9487C22.8005 35.0977 22.9495 35.2496 23.2505 35.2496C23.5514 35.2496 23.7005 35.3987 24.0014 35.3987C24.3024 35.3987 24.4514 35.3987 24.7524 35.2496C25.0533 35.2496 25.2023 35.1006 25.5033 34.9487L33.0041 30.4488L33.0013 39.7467H48V27.746C48 23.547 44.701 20.248 40.5021 20.248H40.5019Z' transform='translate(0 0)'/></svg>"
      },
      {
        link: "#",
        title: "Forms & Submissions",
        mailto: false,
        ipAddress: false,
        opens_in_new_tab: false,
        icon: "<svg id='Layer_1' data-name='Layer 1' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 48 48'><path d='M42,36a6.06,6.06,0,0,0-3.5,1.1l-9.6-9.6a6.07,6.07,0,0,0-1.7-8.6l3.2-7.1a7.72,7.72,0,0,0,1.5.2,5.89,5.89,0,0,0,6-6,6,6,0,0,0-12,0,6,6,0,0,0,2.6,5l-3.3,7.2A3.73,3.73,0,0,0,24,18a6,6,0,0,0-6,6,6.93,6.93,0,0,0,.3,2l-7.6,4.3A6,6,0,1,0,12,34a6.93,6.93,0,0,0-.3-2l7.6-4.3A6,6,0,0,0,24,30a6.06,6.06,0,0,0,3.5-1.1l9.6,9.6A6,6,0,1,0,42,36ZM32,2a4,4,0,1,1-4,4A4,4,0,0,1,32,2ZM6,38a4,4,0,1,1,4-4A4,4,0,0,1,6,38ZM20,24a4,4,0,0,1,4-4,3.19,3.19,0,0,1,1.4.3h.1A4,4,0,0,1,27.9,24a3.86,3.86,0,0,1-1.1,2.7l-.1.1-.1.1A3.47,3.47,0,0,1,24,28,4,4,0,0,1,20,24ZM42,46a4,4,0,0,1-4-4,3.86,3.86,0,0,1,1.1-2.7l.1-.1.1-.1A3.86,3.86,0,0,1,42,38a4,4,0,0,1,0,8Z' transform='translate(0 0)'/></svg>"
      },
      {
        link: "#",
        title: "Directory",
        mailto: false,
        ipAddress: false,
        opens_in_new_tab: false,
        icon: "<svg id='Layer_1' data-name='Layer 1' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 48 48'><path d='M24,0A24,24,0,1,0,48,24,24.07,24.07,0,0,0,24,0ZM43,35H35.1A33.45,33.45,0,0,0,37,25h9A21.63,21.63,0,0,1,43,35ZM25.6,45.9H25v-9h7.1A28.08,28.08,0,0,1,25.6,45.9Zm-3.2,0A28.68,28.68,0,0,1,15.8,37H23v9A1.27,1.27,0,0,1,22.4,45.9ZM5,35A21.63,21.63,0,0,1,2,25h9a30.6,30.6,0,0,0,1.9,10ZM5,13h7.9A33.45,33.45,0,0,0,11,23H2A21.63,21.63,0,0,1,5,13ZM22.4,2.1H23v9H15.9A28.08,28.08,0,0,1,22.4,2.1Zm3.2,0A28.68,28.68,0,0,1,32.2,11H25V2A1.27,1.27,0,0,1,25.6,2.1ZM33,13a30.17,30.17,0,0,1,2,10H25V13ZM23,13V23H13a30.17,30.17,0,0,1,2-10ZM13,25H23V35H15A30.17,30.17,0,0,1,13,25ZM25,35V25H35a30.17,30.17,0,0,1-2,10ZM37,23a30.6,30.6,0,0,0-1.9-10H43a21.53,21.53,0,0,1,2.9,10Zm4.7-12H34.3a29.48,29.48,0,0,0-5.4-8.4A21.28,21.28,0,0,1,41.7,11ZM19.1,2.6A29.48,29.48,0,0,0,13.7,11H6.3A21.28,21.28,0,0,1,19.1,2.6ZM6.3,37h7.4a29.48,29.48,0,0,0,5.4,8.4A21.28,21.28,0,0,1,6.3,37Zm22.6,8.4A28.74,28.74,0,0,0,34.3,37h7.4A21.28,21.28,0,0,1,28.9,45.4Z'/></svg>"
      }
    ],
    icons_active: true
  }
};
const parallax$1 = {
  preview_id: {
    background_image: {
      url: "https://d2kzwze52p8717.cloudfront.net/canopy-path.jpg"
    }
  }
};
const video$1 = {
  preview_id: {
    component_header_top: "View our",
    headline: "Videos",
    show_headline: true,
    videos: [
      {
        id: 1,
        position: 1,
        order: 1,
        url: "https://www.youtube.com/watch?v=4AmdMPrgiYU",
        alt_text: "Community Video 1",
        title: "Community Video 1",
        description: "Consectetur adipiscing elit. Maecenas vel enim non dui venenatis vulputate commodo a magna. Pellentesque sed venenatis erat, eget consequat orci. In lacinia mollis ante. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas vel enim non dui venenatis vulputate commodo a magna. Pellentesque sed venenatis erat, eget consequat orci. In lacinia mollis ante.",
        type: "youtube"
      },
      {
        id: 2,
        position: 2,
        order: 2,
        url: "https://www.youtube.com/watch?v=gHiiH1i8KeA",
        alt_text: "Community Video 2",
        title: "Community Video 2",
        description: "Adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.",
        type: "youtube"
      },
      {
        position: 3,
        url: "https://www.youtube.com/watch?v=yV4g9bwq0Ss",
        alt_text: "Video 3",
        title: "Video 3",
        description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.",
        type: "youtube"
      }
    ]
  }
};
const about$1 = {
  preview_id: {
    component_header: "Our City",
    component_header_top: "This Is",
    component_text: "<p>I am honored to serve as your Mayor and be part of this vibrant and diverse community. As we continue to grow and face new challenges, it's essential that we work together to make our city an even better place to live, work, and raise families.</p><br><p>Our city is a tapestry of cultures, ideas, and dreams. We are committed to fostering an inclusive and welcoming environment where everyone can thrive. From improving our infrastructure and public services to promoting local businesses and green initiatives, we are dedicated to enhancing your quality of life.</p><br><p><strong>Mayor Phil Jacobson</strong></p>",
    has_image: true,
    has_accent_logo: true,
    has_header: true,
    image: {
      url: "https://apptegy-cms-theme-preview-images.s3.us-east-2.amazonaws.com/superintendent.jpeg",
      alt_text: ""
    },
    links: [
      {
        href: "#",
        title: "City Services",
        target: "_self",
        icon: "<svg id='Layer_1' data-name='Layer 1' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 48.08 41.95'><path d='M1,21H7V37H4.1a1,1,0,1,0,0,2H43.9a1,1,0,1,0,0-2H41V21h6a1.2,1.2,0,0,0,1-.7.84.84,0,0,0-.4-1.1l-23-16a1.08,1.08,0,0,0-1.1,0l-23,16a1,1,0,0,0-.4,1.1A1,1,0,0,0,1,21Zm8,0h6V37H9Zm14,0V37H17V21Zm8,0V37H25V21Zm8,16H33V21h6ZM24,5.2,43.8,19H4.2Z' transform='translate(0 -3.05)'/><path d='M47,43H1a1,1,0,0,0,0,2H47a1,1,0,0,0,0-2Z' transform='translate(0 -3.05)'/></svg>"
      },
      {
        href: "#",
        title: "Visitors' Guide",
        target: "_self",
        icon: "<svg id='Layer_1' data-name='Layer 1' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 48 46.05'><path d='M.5,14.9l23,12a1.3,1.3,0,0,0,1,0l23-12a1.06,1.06,0,0,0,0-1.8l-23-12a.75.75,0,0,0-.9,0l-23,12A1,1,0,0,0,0,14,1.05,1.05,0,0,0,.5,14.9ZM24,3.1,44.8,14,24,24.9,3.2,14Z' transform='translate(0 -0.95)'/><path d='M47.4,22.6l-3-1.5a1,1,0,0,0-.9,1.7l1.3.6L24,34.9,3.2,23.5l1.3-.6a.88.88,0,0,0,.4-1.3.88.88,0,0,0-1.3-.4l-3,1.5a.76.76,0,0,0-.6.8,1.05,1.05,0,0,0,.5.9l23,12.5a1.3,1.3,0,0,0,1,0l23-12.5a1.05,1.05,0,0,0,.5-.9A1,1,0,0,0,47.4,22.6Z' transform='translate(0 -0.95)'/><path d='M47.4,32.6l-3-1.5a1,1,0,0,0-.9,1.7l1.3.6L24,44.9,3.2,33.5l1.3-.6a.88.88,0,0,0,.4-1.3.88.88,0,0,0-1.3-.4l-3,1.5a.76.76,0,0,0-.6.8,1.05,1.05,0,0,0,.5.9l23,12.5a1.3,1.3,0,0,0,1,0l23-12.5a1.05,1.05,0,0,0,.5-.9A1,1,0,0,0,47.4,32.6Z' transform='translate(0 -0.95)'/></svg>"
      },
      {
        href: "#",
        title: "City Initiatives",
        target: "_self",
        icon: "<svg id='Layer_1' data-name='Layer 1' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 47.92 46.04'><path d='M47.1,1.4A2.32,2.32,0,0,0,45.3,1L24,4.7,2.6,1a2.21,2.21,0,0,0-1.9.6A2.36,2.36,0,0,0,0,3.2V40.9a3.07,3.07,0,0,0,2.3,2.8L23.8,47H24l21.6-3.3a3,3,0,0,0,2.3-2.8V3.2A1.84,1.84,0,0,0,47.1,1.4ZM32,5.3,40,4V15.1l-3.4-2.6a1.07,1.07,0,0,0-1.4.1L32,16.4ZM2,40.9V3.2c0-.1,0-.1.1-.1s.1-.1.2-.1L23,6.5V44.8L2.7,41.7A1.12,1.12,0,0,1,2,40.9Zm44,0a1.12,1.12,0,0,1-.7.8L25,44.8V6.5l5-.9V19a1,1,0,0,0,.7.9c.1,0,.2.1.3.1a.91.91,0,0,0,.8-.4l4.4-5.2,4.2,3.3a1.07,1.07,0,0,0,1.1.1,1.15,1.15,0,0,0,.6-.9V3.6L45.7,3h.2a.35.35,0,0,1,.1.2Z' transform='translate(0 -0.96)'/></svg>"
      },
      {
        href: "#",
        title: "Resident Resources",
        target: "_self",
        icon: "<svg id='Layer_1' data-name='Layer 1' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 48 48'><path d='M30,6A6,6,0,0,0,18,6,6,6,0,0,0,30,6Zm-6,4a4,4,0,1,1,4-4A4,4,0,0,1,24,10Z'/><path d='M24,12A10,10,0,0,0,14,22v9a.94.94,0,0,0,1,1h3.1L20,47.1a1.06,1.06,0,0,0,1,.9h6a1.06,1.06,0,0,0,1-.9L29.9,32H33a.94.94,0,0,0,1-1V21.9A10,10,0,0,0,24,12Zm8,18H28.7c-.1,0-.1.1-.2.1l-.1.1c-.1,0-.1.1-.1.2a.35.35,0,0,0-.1.2c0,.1,0,.1-.1.2v.1L26.1,46H21.9L20,30.9v-.1c0-.1,0-.1-.1-.2a.1.1,0,0,0-.1-.1c0-.1-.1-.1-.1-.2l-.1-.1c-.1,0-.1-.1-.2-.1H16.1V22a8,8,0,0,1,16,0v8Z'/><path d='M45,9A6,6,0,0,0,33,9,6,6,0,0,0,45,9Zm-6,4a4,4,0,1,1,4-4A4,4,0,0,1,39,13Z'/><path d='M48,25.6C48,19.2,44.5,15,39,15a1,1,0,0,0,0,2c5.2,0,7,4.4,7,8.6V31H43.7c-.1,0-.1,0-.2.1s-.1.1-.2.1l-.1.1a.35.35,0,0,0-.1.2c0,.1-.1.1-.1.2v.1L41.2,43H36.9L36,36.9a1,1,0,0,0-1.9.3l1,7a1.06,1.06,0,0,0,1,.9h6a1.08,1.08,0,0,0,1-.8L44.8,33H47a.94.94,0,0,0,1-1V25.6Z'/><path d='M15,9A5.89,5.89,0,0,0,9,3,5.89,5.89,0,0,0,3,9a5.89,5.89,0,0,0,6,6A5.89,5.89,0,0,0,15,9ZM9,13a4,4,0,1,1,4-4A4,4,0,0,1,9,13Z'/><path d='M13.1,36a.89.89,0,0,0-1.1.8L11.1,43H6.8L5,31.8v-.1c0-.1,0-.1-.1-.2s-.1-.1-.1-.2l-.1-.1c-.1,0-.1-.1-.2-.1a.1.1,0,0,1-.1-.1H2V25.5C2,21.4,3.8,17,9,17a1,1,0,0,0,0-2c-5.5,0-9,4.2-9,10.6V32a.94.94,0,0,0,1,1H3.2L5,44.2A1.08,1.08,0,0,0,6,45h6a1.06,1.06,0,0,0,1-.9l1-7A1,1,0,0,0,13.1,36Z'/></svg>"
      },
      {
        href: "#",
        title: "Sustainability",
        target: "_self",
        icon: "<svg id='Layer_1' data-name='Layer 1' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 48 32'><path d='M9,30H19a2.15,2.15,0,0,0,2-2V26.7c0-.1-.1-.1-.1-.2s-.1-.1-.1-.2-.1-.1-.2-.1l-.1-.1-3-1.5A7.08,7.08,0,0,0,18,22h0V18.8c0-.1,0-.1-.1-.2h0C17.5,17,15.6,16,14,16s-3.5,1-3.9,2.6h0c0,.1,0,.1-.1.2V22h0a6,6,0,0,0,.6,2.6l-3,1.5-.1.1c-.1,0-.1.1-.2.1a.35.35,0,0,0-.1.2c0,.1-.1.1-.1.2V28A2,2,0,0,0,9,30Zm5-12c.9,0,1.9.6,2,1.1V22h0a3.37,3.37,0,0,1-.8,2.3.1.1,0,0,1-.1.1l-.1.1v.1c0,.1,0,.1-.1.2v.4c0,.1,0,.1.1.2s.1.1.1.2.1.1.1.2v.1a.1.1,0,0,1,.1.1l.1.1,3.4,1.7V28H9v-.4l3.4-1.7a7961314590657.33,7961314590657.33,0,0,0,.2-.2v-.1a.35.35,0,0,0,.1-.2c0-.1.1-.1.1-.2s0-.1.1-.2v-.4c0-.1,0-.1-.1-.2v-.1l-.1-.1a.1.1,0,0,0-.1-.1,4.09,4.09,0,0,1-.8-2.3h0V18.9A3.76,3.76,0,0,1,14,18Z' transform='translate(0 -8)'/><path d='M47,8H1A.94.94,0,0,0,0,9V39a.94.94,0,0,0,1,1H47a.94.94,0,0,0,1-1V9A.94.94,0,0,0,47,8ZM46,38H39V36a1,1,0,0,0-2,0v2H11V36a.94.94,0,0,0-1-1,.94.94,0,0,0-1,1v2H2V10H46Z' transform='translate(0 -8)'/><path d='M27,18H40a1,1,0,0,0,0-2H27a1,1,0,0,0,0,2Z' transform='translate(0 -8)'/><path d='M27,24H40a1,1,0,0,0,0-2H27a1,1,0,0,0,0,2Z' transform='translate(0 -8)'/><path d='M26.9,30h7a1,1,0,0,0,0-2h-7a1,1,0,0,0,0,2Z' transform='translate(0 -8)'/></svg>"
      },
      {
        href: "#",
        title: "Contact Us",
        target: "_self",
        icon: "<svg id='Layer_1' data-name='Layer 1' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 47.9 48'><path d='M29.8,25.1A4.1,4.1,0,0,0,34,20.9V4.2A4.1,4.1,0,0,0,29.8,0H4.2A4.1,4.1,0,0,0,0,4.2V32a1.2,1.2,0,0,0,.7,1H1a1.23,1.23,0,0,0,.8-.4l5-7.5ZM2,24V4.2A2.1,2.1,0,0,1,4.2,2H29.8A2.1,2.1,0,0,1,32,4.2V20.9a2.1,2.1,0,0,1-2.2,2.2H6.8a1,1,0,0,0-1.2.3L2,28.7Z'/><path d='M43.8,15H39a1,1,0,0,0,0,2h4.8A2.1,2.1,0,0,1,46,19.2V43.7l-3.4-5a1.38,1.38,0,0,0-.3-.4.91.91,0,0,0-1.1-.2h-23A2.1,2.1,0,0,1,16,35.9V30a1,1,0,0,0-2,0v5.9a4.1,4.1,0,0,0,4.2,4.2H41.1l5,7.5a.91.91,0,0,0,.8.4h.3a1,1,0,0,0,.7-1V19.2A4,4,0,0,0,43.8,15Z'/></svg>"
      }
    ]
  }
};
const floating_nav$1 = {
  buttons: [
    {
      url: "#",
      title: "City Services",
      mailto: false,
      email_address: "",
      opens_in_new_tab: false,
      icon: "<svg id='Layer_1' data-name='Layer 1' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 48 48'><path d='M41.6009 25.5995V14.4006C41.6009 11.3616 39.522 8.96158 36.8009 8.16056V3.19858L35.202 1.59961L33.603 3.19858V8.15756C30.882 8.79656 28.803 11.3586 28.803 14.3976V28.7976H22.404V33.5976H16.005V22.3986L3.20402 12.7986V25.5996H0V46.3986H48V25.5996L41.6009 25.5995Z' transform='translate(-4 -3)'/></svg>"
    },
    {
      url: "#",
      title: "Visitor's Guide",
      mailto: false,
      email_address: "",
      opens_in_new_tab: false,
      icon: "<svg id='Layer_1' data-name='Layer 1' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 48 48'><path d='M39.9996 22.4004C39.9996 24.5332 36.8018 24.5332 36.8018 22.4004C36.8018 20.2676 39.9996 20.2676 39.9996 22.4004Z'/><path d='M35.1998 3.20117L12.8002 8.00086L0 3.20117V39.9998L12.8002 44.7995L35.1998 39.9998L48 44.7995V8.00086L35.1998 3.20117ZM28.8012 34.8791L19.2018 36.958V13.1185L28.8012 11.0396V34.8791ZM38.4006 31.9993C38.4006 31.9993 33.6009 25.1208 33.6009 22.3999C33.6009 19.6791 35.6798 17.6003 38.4006 17.6003C41.1215 17.6003 43.2003 19.6791 43.2003 22.3999C43.2003 25.1178 38.4006 31.9993 38.4006 31.9993Z'/></svg>"
    },
    {
      url: "#",
      title: "City Initiatives",
      mailto: false,
      email_address: "",
      opens_in_new_tab: false,
      icon: "<svg id='Layer_1' data-name='Layer 1' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 48 48'><path d='M24.0001 11.2949C17.7873 11.2949 12.7048 16.3774 12.7048 22.5902C12.7048 25.1314 13.5519 27.3893 14.9628 29.2265C14.9628 29.2265 15.3863 29.7903 15.5266 29.9333C16.7972 31.4872 19.9023 35.8628 19.9023 39.5344H28.373C28.373 35.8628 31.4781 31.4872 32.7487 29.9333C32.889 29.793 33.3125 29.2265 33.3125 29.2265C34.7234 27.3921 35.5705 24.9911 35.5705 22.5902C35.2952 16.3774 30.2128 11.2949 24.0001 11.2949H24.0001Z'/><path d='M19.7646 42.3535H28.2354V47.9998H19.7646V42.3535Z'><path d='M1.41235 21.1777H9.8831V24.0022H1.41235V21.1777Z'/><path d='M38.1172 21.1777H46.5879V24.0022H38.1172V21.1777Z'/><path d='M38.9906 5.61719L40.9865 7.6131L34.9962 13.6035L33.0002 11.6076L38.9906 5.61719Z'/><path d='M22.5891 0H25.4136V8.47075H22.5891V0Z'/><path d='M9.02521 5.60352L15.0156 11.5939L13.0197 13.5898L7.0293 7.59943L9.02521 5.60352Z'/></svg>"
    },
    {
      url: "#",
      title: "Resident Resources",
      mailto: false,
      email_address: "",
      opens_in_new_tab: false,
      icon: "<svg id='Layer_1' data-name='Layer 1' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 48 48'><path d='M46.2244 18.8153L34.6573 14.2932V6.71484H29.34V12.2989L15.6466 6.9816C14.7168 6.58274 13.6523 6.84948 12.8546 7.51259L0.888706 18.1498C-0.175778 19.0796 -0.307881 20.8097 0.621966 21.8716C1.2851 22.4051 1.95066 22.6694 2.74838 22.6694H4.07707V41.2838H12.0543V25.3293H20.0316V41.2838H43.9633V24.0006H45.292C46.3565 24.0006 47.4184 23.335 47.8173 22.273C48.3508 20.9419 47.6852 19.3464 46.2243 18.8154L46.2244 18.8153ZM38.646 25.3292V29.3178H33.3287V25.3292H38.646ZM25.3489 25.3292H30.6662V29.3178H25.3489V25.3292ZM25.3489 35.9664V31.9778H30.6662V35.9664H25.3489ZM38.646 35.9664H33.3287V31.9778H38.646V35.9664Z'/></svg>"
    },
    {
      url: "#",
      title: "Contact Us",
      mailto: false,
      email_address: "",
      opens_in_new_tab: false,
      icon: "<svg id='Layer_1' data-name='Layer 1' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 48 48'><path d='M32.4708 0H15.5293C13.1284 0 11.2939 1.83443 11.2939 4.23537V43.7646C11.2939 46.0226 13.1284 48 15.5293 48H32.4708C34.8718 48 36.7062 46.0226 36.7062 43.7646V4.23537C36.7062 1.83707 34.8718 0 32.4708 0ZM24.0001 46.5891C22.4462 46.5891 21.1756 45.3185 21.1756 43.7646C21.1756 42.2108 22.4462 40.9401 24.0001 40.9401C25.5539 40.9401 26.8246 42.2108 26.8246 43.7646C26.8246 45.3185 25.5539 46.5891 24.0001 46.5891ZM33.8817 39.532H14.1184V7.05986H33.8844L33.8817 39.532Z' transform='translate(0 0)'/></svg>"
    }
  ],
  is_fixed: true,
  shape: "rounded"
};
const sticky_footer$1 = {
  show_pill_button: true,
  show_social_icons: true,
  show_only_on_homepage: true,
  pill_button: {
    title: "Pay Utility Bills",
    link: "",
    opens_in_new_tab: false
  },
  icon_buttons: [
    {
      title: "City Services",
      link: "",
      opens_in_new_tab: false,
      icon: "<svg data-name='Layer 1' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 48.08 41.95'><path d='M1,21H7V37H4.1a1,1,0,1,0,0,2H43.9a1,1,0,1,0,0-2H41V21h6a1.2,1.2,0,0,0,1-.7.84.84,0,0,0-.4-1.1l-23-16a1.08,1.08,0,0,0-1.1,0l-23,16a1,1,0,0,0-.4,1.1A1,1,0,0,0,1,21Zm8,0h6V37H9Zm14,0V37H17V21Zm8,0V37H25V21Zm8,16H33V21h6ZM24,5.2,43.8,19H4.2Z' transform='translate(0 -3.05)'/><path d='M47,43H1a1,1,0,0,0,0,2H47a1,1,0,0,0,0-2Z' transform='translate(0 -3.05)'/></svg>",
      icon_id: 34
    },
    {
      icon: "<svg data-name='Layer 1' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 48 46.05'><path d='M.5,14.9l23,12a1.3,1.3,0,0,0,1,0l23-12a1.06,1.06,0,0,0,0-1.8l-23-12a.75.75,0,0,0-.9,0l-23,12A1,1,0,0,0,0,14,1.05,1.05,0,0,0,.5,14.9ZM24,3.1,44.8,14,24,24.9,3.2,14Z' transform='translate(0 -0.95)'/><path d='M47.4,22.6l-3-1.5a1,1,0,0,0-.9,1.7l1.3.6L24,34.9,3.2,23.5l1.3-.6a.88.88,0,0,0,.4-1.3.88.88,0,0,0-1.3-.4l-3,1.5a.76.76,0,0,0-.6.8,1.05,1.05,0,0,0,.5.9l23,12.5a1.3,1.3,0,0,0,1,0l23-12.5a1.05,1.05,0,0,0,.5-.9A1,1,0,0,0,47.4,22.6Z' transform='translate(0 -0.95)'/><path d='M47.4,32.6l-3-1.5a1,1,0,0,0-.9,1.7l1.3.6L24,44.9,3.2,33.5l1.3-.6a.88.88,0,0,0,.4-1.3.88.88,0,0,0-1.3-.4l-3,1.5a.76.76,0,0,0-.6.8,1.05,1.05,0,0,0,.5.9l23,12.5a1.3,1.3,0,0,0,1,0l23-12.5a1.05,1.05,0,0,0,.5-.9A1,1,0,0,0,47.4,32.6Z' transform='translate(0 -0.95)'/></svg>",
      link: "",
      title: "Visitors' Guide",
      icon_id: 106,
      opens_in_new_tab: false
    },
    {
      icon: "<svg data-name='Layer 1' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 47.92 46.04'><path d='M47.1,1.4A2.32,2.32,0,0,0,45.3,1L24,4.7,2.6,1a2.21,2.21,0,0,0-1.9.6A2.36,2.36,0,0,0,0,3.2V40.9a3.07,3.07,0,0,0,2.3,2.8L23.8,47H24l21.6-3.3a3,3,0,0,0,2.3-2.8V3.2A1.84,1.84,0,0,0,47.1,1.4ZM32,5.3,40,4V15.1l-3.4-2.6a1.07,1.07,0,0,0-1.4.1L32,16.4ZM2,40.9V3.2c0-.1,0-.1.1-.1s.1-.1.2-.1L23,6.5V44.8L2.7,41.7A1.12,1.12,0,0,1,2,40.9Zm44,0a1.12,1.12,0,0,1-.7.8L25,44.8V6.5l5-.9V19a1,1,0,0,0,.7.9c.1,0,.2.1.3.1a.91.91,0,0,0,.8-.4l4.4-5.2,4.2,3.3a1.07,1.07,0,0,0,1.1.1,1.15,1.15,0,0,0,.6-.9V3.6L45.7,3h.2a.35.35,0,0,1,.1.2Z' transform='translate(0 -0.96)'/></svg>",
      link: "",
      title: "City Initiatives",
      icon_id: 128,
      opens_in_new_tab: false
    },
    {
      icon: "<svg data-name='Layer 1' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 48 48'><path d='M30,6A6,6,0,0,0,18,6,6,6,0,0,0,30,6Zm-6,4a4,4,0,1,1,4-4A4,4,0,0,1,24,10Z'/><path d='M24,12A10,10,0,0,0,14,22v9a.94.94,0,0,0,1,1h3.1L20,47.1a1.06,1.06,0,0,0,1,.9h6a1.06,1.06,0,0,0,1-.9L29.9,32H33a.94.94,0,0,0,1-1V21.9A10,10,0,0,0,24,12Zm8,18H28.7c-.1,0-.1.1-.2.1l-.1.1c-.1,0-.1.1-.1.2a.35.35,0,0,0-.1.2c0,.1,0,.1-.1.2v.1L26.1,46H21.9L20,30.9v-.1c0-.1,0-.1-.1-.2a.1.1,0,0,0-.1-.1c0-.1-.1-.1-.1-.2l-.1-.1c-.1,0-.1-.1-.2-.1H16.1V22a8,8,0,0,1,16,0v8Z'/><path d='M45,9A6,6,0,0,0,33,9,6,6,0,0,0,45,9Zm-6,4a4,4,0,1,1,4-4A4,4,0,0,1,39,13Z'/><path d='M48,25.6C48,19.2,44.5,15,39,15a1,1,0,0,0,0,2c5.2,0,7,4.4,7,8.6V31H43.7c-.1,0-.1,0-.2.1s-.1.1-.2.1l-.1.1a.35.35,0,0,0-.1.2c0,.1-.1.1-.1.2v.1L41.2,43H36.9L36,36.9a1,1,0,0,0-1.9.3l1,7a1.06,1.06,0,0,0,1,.9h6a1.08,1.08,0,0,0,1-.8L44.8,33H47a.94.94,0,0,0,1-1V25.6Z'/><path d='M15,9A5.89,5.89,0,0,0,9,3,5.89,5.89,0,0,0,3,9a5.89,5.89,0,0,0,6,6A5.89,5.89,0,0,0,15,9ZM9,13a4,4,0,1,1,4-4A4,4,0,0,1,9,13Z'/><path d='M13.1,36a.89.89,0,0,0-1.1.8L11.1,43H6.8L5,31.8v-.1c0-.1,0-.1-.1-.2s-.1-.1-.1-.2l-.1-.1c-.1,0-.1-.1-.2-.1a.1.1,0,0,1-.1-.1H2V25.5C2,21.4,3.8,17,9,17a1,1,0,0,0,0-2c-5.5,0-9,4.2-9,10.6V32a.94.94,0,0,0,1,1H3.2L5,44.2A1.08,1.08,0,0,0,6,45h6a1.06,1.06,0,0,0,1-.9l1-7A1,1,0,0,0,13.1,36Z'/></svg>",
      link: "",
      title: "Resident Resources",
      icon_id: 45,
      opens_in_new_tab: false
    },
    {
      title: "Contact Us",
      link: "",
      opens_in_new_tab: false,
      icon: "<svg data-name='Layer 1' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 47.9 48'><path d='M29.8,25.1A4.1,4.1,0,0,0,34,20.9V4.2A4.1,4.1,0,0,0,29.8,0H4.2A4.1,4.1,0,0,0,0,4.2V32a1.2,1.2,0,0,0,.7,1H1a1.23,1.23,0,0,0,.8-.4l5-7.5ZM2,24V4.2A2.1,2.1,0,0,1,4.2,2H29.8A2.1,2.1,0,0,1,32,4.2V20.9a2.1,2.1,0,0,1-2.2,2.2H6.8a1,1,0,0,0-1.2.3L2,28.7Z'/><path d='M43.8,15H39a1,1,0,0,0,0,2h4.8A2.1,2.1,0,0,1,46,19.2V43.7l-3.4-5a1.38,1.38,0,0,0-.3-.4.91.91,0,0,0-1.1-.2h-23A2.1,2.1,0,0,1,16,35.9V30a1,1,0,0,0-2,0v5.9a4.1,4.1,0,0,0,4.2,4.2H41.1l5,7.5a.91.91,0,0,0,.8.4h.3a1,1,0,0,0,.7-1V19.2A4,4,0,0,0,43.8,15Z'/></svg>",
      icon_id: 24
    }
  ],
  icon_links: [
    {
      title: "Facebook",
      link: "#",
      opens_in_new_tab: false
    },
    {
      title: "X",
      link: "#",
      opens_in_new_tab: false
    },
    {
      title: "Instagram",
      link: "#",
      opens_in_new_tab: false
    },
    {
      title: "Youtube",
      link: "#",
      opens_in_new_tab: false
    }
  ]
};
const timeline$1 = {
  preview_id: {
    show_component_header: true,
    show_slider_controls: true,
    show_scroll_text: true,
    auto_scroll: false,
    hide_component: false,
    component_header: "From Small Beginnings to Big Dreams: Our Story of Success",
    scroll_text: "Where Every Journey Starts with a Single Step",
    items: [
      {
        id: 1,
        year: "2020",
        title: "Item 1",
        description: "Department of Public Works",
        image: {
          url: "https://d2kzwze52p8717.cloudfront.net/public_works.jpg",
          alt_text: "alt_text"
        }
      },
      {
        id: 2,
        year: "2021",
        title: "Item 2",
        description: "Parks and Recreation",
        image: {
          url: "https://d2kzwze52p8717.cloudfront.net/park.jpg",
          alt_text: "alt_text"
        }
      },
      {
        id: 3,
        year: "2022",
        title: "Item 3",
        description: "Community Development",
        image: {
          url: "https://d2kzwze52p8717.cloudfront.net/city-streets.jpg",
          alt_text: "alt_text"
        }
      },
      {
        id: 4,
        year: "2023",
        title: "Item 4",
        description: "Police Department",
        image: {
          url: "https://d2kzwze52p8717.cloudfront.net/police.jpeg",
          alt_text: "alt_text"
        }
      },
      {
        id: 5,
        year: "2024",
        title: "Item 5",
        description: "Fire Department",
        image: {
          url: "https://d2kzwze52p8717.cloudfront.net/fire.jpg",
          alt_text: "alt_text"
        }
      }
    ]
  }
};
const custom_component$1 = {
  preview_id: {
    textarea: {
      "cms-textarea": {
        text: "Community\nTransparency\nProgress"
      }
    },
    input: {
      "cms-input": {
        text: "Building a Better City Together"
      }
    },
    image: {
      "cms-image": {
        alt_text: "city park",
        url: "https://d2kzwze52p8717.cloudfront.net/canopy-path.jpg"
      }
    },
    loop: {
      "cms-loop": [
        {
          input: {
            "cms-input": {
              text: "Building a Better City Together"
            }
          },
          textarea: {
            "cms-textarea": {
              text: "Community\nTransparency\nProgress"
            }
          },
          rich_textarea: {
            "cms-rich_textarea": {
              text: "<p>Our mission is to serve the citizens of our city with integrity, transparency, and a commitment to sustainable growth. We strive to foster a vibrant community by prioritizing public safety, infrastructure development, and environmental stewardship.</p><p><strong>Jane Smith, Mayor</strong></p>"
            }
          },
          image: {
            "cms-image": {
              alt_text: "city park",
              url: "https://d2kzwze52p8717.cloudfront.net/canopy-path.jpg"
            }
          },
          icon: {
            "cms-icon": {
              icon: '<svg width="100%" height="100%" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><title>Placeholder for cms-icon</title><path fill-rule="evenodd" clip-rule="evenodd" d="M7.99998 0C12.4183 0 16.0001 3.58178 16.0001 8.00008C16.0001 12.4181 12.4183 15.9999 7.99998 15.9999C3.58176 15.9999 0 12.4181 0 8.00008C0 3.58178 3.58176 0 7.99998 0Z"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M10.8144 6.07292L7.94646 10.8265C7.80032 10.9837 7.59753 11.0287 7.4095 10.9844C7.22147 11.0287 7.0188 10.9837 6.87266 10.8265L5.1731 9.00103C4.9449 8.75609 4.9449 8.35895 5.1731 8.11376C5.40118 7.86883 5.77105 7.86883 5.99924 8.11376L7.34782 9.56223L9.9882 5.18566C10.2164 4.94072 10.5863 4.94072 10.8144 5.18566C11.0425 5.43059 11.0425 5.82799 10.8144 6.07292Z" fill="white"></path></svg>'
            }
          }
        }
      ]
    },
    rich_textarea: {
      "cms-rich_textarea": {
        text: "<p>Our mission is to serve the citizens of our city with integrity, transparency, and a commitment to sustainable growth. We strive to foster a vibrant community by prioritizing public safety, infrastructure development, and environmental stewardship.</p><p><strong>Jane Smith, Mayor</strong></p>"
      }
    },
    icon: {
      "cms-icon": {
        icon: '<svg width="100%" height="100%" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><title>Placeholder for cms-icon</title><path fill-rule="evenodd" clip-rule="evenodd" d="M7.99998 0C12.4183 0 16.0001 3.58178 16.0001 8.00008C16.0001 12.4181 12.4183 15.9999 7.99998 15.9999C3.58176 15.9999 0 12.4181 0 8.00008C0 3.58178 3.58176 0 7.99998 0Z"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M10.8144 6.07292L7.94646 10.8265C7.80032 10.9837 7.59753 11.0287 7.4095 10.9844C7.22147 11.0287 7.0188 10.9837 6.87266 10.8265L5.1731 9.00103C4.9449 8.75609 4.9449 8.35895 5.1731 8.11376C5.40118 7.86883 5.77105 7.86883 5.99924 8.11376L7.34782 9.56223L9.9882 5.18566C10.2164 4.94072 10.5863 4.94072 10.8144 5.18566C11.0425 5.43059 11.0425 5.82799 10.8144 6.07292Z" fill="white"></path></svg>'
      }
    }
  }
};
const editableHomepageComponents$1 = {
  description: description$1,
  gallery: gallery$1,
  events: events$1,
  news: news$1,
  live_feed: live_feed$1,
  stats: stats$1,
  header: header$1,
  footer: footer$1,
  programs: programs$1,
  our_schools: our_schools$1,
  spotlights: spotlights$1,
  buttons: buttons$1,
  parallax: parallax$1,
  video: video$1,
  about: about$1,
  floating_nav: floating_nav$1,
  sticky_footer: sticky_footer$1,
  timeline: timeline$1,
  custom_component: custom_component$1
};
const orgDefaults$1 = [
  {
    alias: "publicworks",
    name: "Public Works",
    path_prefix: "",
    primary: true
  },
  {
    alias: "parks",
    name: "Parks and Recreation",
    path_prefix: "",
    primary: false
  },
  {
    alias: "police",
    name: "Police Department",
    path_prefix: "",
    primary: false
  },
  {
    alias: "fire",
    name: "Fire Department",
    path_prefix: "",
    primary: false
  }
];
const siteMenuDefaults$1 = [
  {
    id: 2,
    name: "About Us",
    slug: "about-us",
    type: "header",
    position: 0,
    status: "published",
    hidden: false,
    published_at: "2019-10-08T20:58:04.395-05:00",
    children: [
      {
        id: 21,
        name: "Mayor's Office",
        slug: "mayors-office",
        type: "page",
        position: 0,
        status: "published",
        hidden: false,
        published_at: "2019-10-08T20:58:06.726-05:00",
        children: []
      },
      {
        id: 22,
        name: "City Council",
        slug: "city-council",
        type: "page",
        position: 0,
        status: "published",
        hidden: false,
        published_at: "2019-10-08T20:58:06.726-05:00",
        children: []
      },
      {
        id: 23,
        name: "City Departments",
        slug: "city-departments",
        type: "page",
        position: 0,
        status: "published",
        hidden: false,
        published_at: "2019-10-08T20:58:06.726-05:00",
        children: []
      },
      {
        id: 24,
        name: "History",
        slug: "history",
        type: "page",
        position: 0,
        status: "published",
        hidden: false,
        published_at: "2019-10-08T20:58:06.726-05:00",
        children: []
      },
      {
        id: 25,
        name: "Mission and Values",
        slug: "mission and values",
        type: "page",
        position: 0,
        status: "published",
        hidden: false,
        published_at: "2019-10-08T20:58:06.726-05:00",
        children: []
      }
    ]
  },
  {
    id: 3,
    name: "Services",
    slug: "services",
    type: "header",
    position: 1,
    status: "published",
    hidden: false,
    published_at: "2019-10-08T20:58:08.501-05:00",
    children: [
      {
        id: 31,
        name: "Public Safety",
        slug: "public-safety",
        type: "page",
        position: 0,
        status: "published",
        hidden: false,
        published_at: "2019-10-08T20:58:09.831-05:00",
        children: [
          {
            id: 311,
            name: "Police Department",
            slug: "pd",
            type: "page",
            position: 0,
            status: "published",
            hidden: false,
            published_at: "2019-10-08T21:00:20.036-05:00",
            children: []
          },
          {
            id: 312,
            name: "Fire Department",
            slug: "fire",
            type: "page",
            position: 0,
            status: "published",
            hidden: false,
            published_at: "2019-10-08T21:00:20.036-05:00",
            children: []
          },
          {
            id: 313,
            name: "Emergency Services",
            slug: "emergency",
            type: "page",
            position: 0,
            status: "published",
            hidden: false,
            published_at: "2019-10-08T21:00:20.036-05:00",
            children: []
          }
        ]
      },
      {
        id: 32,
        name: "Public Works",
        slug: "public-works",
        type: "page",
        position: 0,
        status: "published",
        hidden: false,
        published_at: "2019-10-08T20:58:09.831-05:00",
        children: [
          {
            id: 321,
            name: "Streets and Roads",
            slug: "streets",
            type: "page",
            position: 0,
            status: "published",
            hidden: false,
            published_at: "2019-10-08T21:00:20.036-05:00",
            children: []
          },
          {
            id: 322,
            name: "Parks and Recreation",
            slug: "parks",
            type: "page",
            position: 0,
            status: "published",
            hidden: false,
            published_at: "2019-10-08T21:00:20.036-05:00",
            children: []
          },
          {
            id: 323,
            name: "Waste Management",
            slug: "waste",
            type: "page",
            position: 0,
            status: "published",
            hidden: false,
            published_at: "2019-10-08T21:00:20.036-05:00",
            children: []
          }
        ]
      },
      {
        id: 33,
        name: "Utilities",
        slug: "utilities",
        type: "page",
        position: 0,
        status: "published",
        hidden: false,
        published_at: "2019-10-08T20:58:09.831-05:00",
        children: [
          {
            id: 331,
            name: "Water and Sewer",
            slug: "water-and-sewer",
            type: "page",
            position: 0,
            status: "published",
            hidden: false,
            published_at: "2019-10-08T21:00:20.036-05:00",
            children: []
          },
          {
            id: 332,
            name: "Electric",
            slug: "electric",
            type: "page",
            position: 0,
            status: "published",
            hidden: false,
            published_at: "2019-10-08T21:00:20.036-05:00",
            children: []
          },
          {
            id: 333,
            name: "Gas",
            slug: "gas",
            type: "page",
            position: 0,
            status: "published",
            hidden: false,
            published_at: "2019-10-08T21:00:20.036-05:00",
            children: []
          }
        ]
      }
    ]
  },
  {
    id: 4,
    name: "Residents",
    slug: "residents",
    type: "header",
    position: 2,
    status: "published",
    hidden: false,
    published_at: "2019-10-08T20:58:14.226-05:00",
    children: [
      {
        id: 41,
        name: "Resident Resources",
        slug: "resources",
        type: "page",
        position: 0,
        status: "published",
        hidden: false,
        published_at: "2019-10-08T20:58:16.857-05:00",
        children: []
      },
      {
        id: 42,
        name: "Education",
        slug: "education",
        type: "page",
        position: 0,
        status: "published",
        hidden: false,
        published_at: "2019-10-08T20:58:16.857-05:00",
        children: []
      },
      {
        id: 43,
        name: "Healthcare",
        slug: "health",
        type: "page",
        position: 0,
        status: "published",
        hidden: false,
        published_at: "2019-10-08T20:58:16.857-05:00",
        children: []
      },
      {
        id: 44,
        name: "Housing",
        slug: "housing",
        type: "page",
        position: 0,
        status: "published",
        hidden: false,
        published_at: "2019-10-08T20:58:16.857-05:00",
        children: []
      },
      {
        id: 45,
        name: "Public Transportation",
        slug: "transportation",
        type: "page",
        position: 0,
        status: "published",
        hidden: false,
        published_at: "2019-10-08T20:58:16.857-05:00",
        children: []
      },
      {
        id: 46,
        name: "Community Events",
        slug: "events",
        type: "page",
        position: 0,
        status: "published",
        hidden: false,
        published_at: "2019-10-08T20:58:16.857-05:00",
        children: []
      }
    ]
  },
  {
    id: 5,
    name: "Visitors",
    slug: "visitors",
    type: "link",
    mailto: true,
    email_address: "city@city.com",
    position: 9,
    opens_in_new_tab: false,
    status: "published",
    hidden: false,
    published_at: "2021-05-12T13:04:50.667-05:00",
    children: [
      {
        id: 51,
        name: "Attractions",
        slug: "attractions",
        type: "page",
        position: 0,
        status: "published",
        hidden: false,
        published_at: "2019-10-08T20:58:16.857-05:00",
        children: []
      },
      {
        id: 52,
        name: "Accomodations",
        slug: "accomodations",
        type: "page",
        position: 0,
        status: "published",
        hidden: false,
        published_at: "2019-10-08T20:58:16.857-05:00",
        children: []
      },
      {
        id: 53,
        name: "Events and Festivals",
        slug: "festivals",
        type: "page",
        position: 0,
        status: "published",
        hidden: false,
        published_at: "2019-10-08T20:58:16.857-05:00",
        children: []
      },
      {
        id: 54,
        name: "Maps and Directions",
        slug: "maps",
        type: "page",
        position: 0,
        status: "published",
        hidden: false,
        published_at: "2019-10-08T20:58:16.857-05:00",
        children: []
      }
    ]
  },
  {
    id: 6,
    name: "News and Updates",
    slug: null,
    type: "link",
    mailto: false,
    ipAddress: true,
    url: "127.0.0.1",
    position: 9,
    opens_in_new_tab: false,
    status: "published",
    hidden: false,
    published_at: "2021-05-12T13:04:50.667-05:00",
    children: [
      {
        id: 61,
        name: "Newsletters",
        slug: "newsletters",
        type: "page",
        position: 0,
        status: "published",
        hidden: false,
        published_at: "2019-10-08T20:58:16.857-05:00",
        children: []
      },
      {
        id: 62,
        name: "Announcements",
        slug: "announcements",
        type: "page",
        position: 0,
        status: "published",
        hidden: false,
        published_at: "2019-10-08T20:58:16.857-05:00",
        children: []
      },
      {
        id: 63,
        name: "Events Calendar",
        slug: "calendar",
        type: "page",
        position: 0,
        status: "published",
        hidden: false,
        published_at: "2019-10-08T20:58:16.857-05:00",
        children: []
      },
      {
        id: 64,
        name: "Public Notices",
        slug: "notices",
        type: "page",
        position: 0,
        status: "published",
        hidden: false,
        published_at: "2019-10-08T20:58:16.857-05:00",
        children: []
      }
    ]
  },
  {
    id: 7,
    name: "Contact Us",
    slug: null,
    type: "link",
    mailto: false,
    ipAddress: true,
    url: "127.0.0.1",
    position: 9,
    opens_in_new_tab: false,
    status: "published",
    hidden: false,
    published_at: "2021-05-12T13:04:50.667-05:00",
    children: [
      {
        id: 71,
        name: "City Hall Contacts",
        slug: "city-hall",
        type: "page",
        position: 0,
        status: "published",
        hidden: false,
        published_at: "2019-10-08T20:58:16.857-05:00",
        children: []
      },
      {
        id: 72,
        name: "Department Directory",
        slug: "directory",
        type: "page",
        position: 0,
        status: "published",
        hidden: false,
        published_at: "2019-10-08T20:58:16.857-05:00",
        children: []
      },
      {
        id: 73,
        name: "Report a Problem",
        slug: "problem",
        type: "page",
        position: 0,
        status: "published",
        hidden: false,
        published_at: "2019-10-08T20:58:16.857-05:00",
        children: []
      },
      {
        id: 74,
        name: "Feedback and Suggestions",
        slug: "suggestions",
        type: "page",
        position: 0,
        status: "published",
        hidden: false,
        published_at: "2019-10-08T20:58:16.857-05:00",
        children: []
      }
    ]
  },
  {
    id: 8,
    name: "Online Services",
    slug: null,
    type: "link",
    mailto: false,
    ipAddress: true,
    url: "127.0.0.1",
    position: 9,
    opens_in_new_tab: false,
    status: "published",
    hidden: false,
    published_at: "2021-05-12T13:04:50.667-05:00",
    children: [
      {
        id: 81,
        name: "Pay Utility Bills",
        slug: "bills",
        type: "page",
        position: 0,
        status: "published",
        hidden: false,
        published_at: "2019-10-08T20:58:16.857-05:00",
        children: []
      },
      {
        id: 82,
        name: "Apply for Permits",
        slug: "permits",
        type: "page",
        position: 0,
        status: "published",
        hidden: false,
        published_at: "2019-10-08T20:58:16.857-05:00",
        children: []
      },
      {
        id: 83,
        name: "Report Issues",
        slug: "issues",
        type: "page",
        position: 0,
        status: "published",
        hidden: false,
        published_at: "2019-10-08T20:58:16.857-05:00",
        children: []
      },
      {
        id: 84,
        name: "Online Forms",
        slug: "forms",
        type: "page",
        position: 0,
        status: "published",
        hidden: false,
        published_at: "2019-10-08T20:58:16.857-05:00",
        children: []
      },
      {
        id: 85,
        name: "Register for Programs",
        slug: "programs",
        type: "page",
        position: 0,
        status: "published",
        hidden: false,
        published_at: "2019-10-08T20:58:16.857-05:00",
        children: []
      }
    ]
  },
  {
    id: 9,
    name: "FAQs",
    slug: null,
    type: "link",
    mailto: false,
    ipAddress: true,
    url: "127.0.0.1",
    position: 9,
    opens_in_new_tab: false,
    status: "published",
    hidden: false,
    published_at: "2021-05-12T13:04:50.667-05:00",
    children: [
      {
        id: 91,
        name: "Frequently Asked Questions",
        slug: "faqs",
        type: "page",
        position: 0,
        status: "published",
        hidden: false,
        published_at: "2019-10-08T20:58:16.857-05:00",
        children: []
      },
      {
        id: 92,
        name: "How-To Guides",
        slug: "how-to",
        type: "page",
        position: 0,
        status: "published",
        hidden: false,
        published_at: "2019-10-08T20:58:16.857-05:00",
        children: []
      }
    ]
  }
];
const staticMenuLinkDefaults$1 = [
  {
    id: 1,
    config_id: 1,
    menu_icon_id: 1,
    name: "Visitor Information",
    url: "/info",
    opens_in_new_tab: false,
    position: 0,
    created_at: "2020-03-17T23:08:05.850-05:00",
    updated_at: "2020-03-17T23:08:05.850-05:00",
    icon: '<svg data-v-ea34907a="" xmlns="http://www.w3.org/2000/svg" viewBox="-6 0 174.53 173.95" class="svg_icon"><title>Live Feed Icon</title><path fill="#000" d="M106.9,112.13a5.2,5.2,0,0,1-5.16-4.65A43.18,43.18,0,0,0,89,80.93,43.39,43.39,0,0,0,62.44,68.18,5.2,5.2,0,0,1,57.8,63v-.1a5.21,5.21,0,0,1,5.68-5.18c23.2,2.1,45.91,21.36,48.69,48.72a5.18,5.18,0,0,1-5.18,5.66Z"></path><path fill="##000" d="M63.86,76.54a35.46,35.46,0,0,1,29.55,29.8,5.2,5.2,0,0,1-5.19,5.85h0A5.22,5.22,0,0,1,83,107.72,24.91,24.91,0,0,0,62.24,86.87a5.22,5.22,0,0,1-4.44-5.16h0A5.25,5.25,0,0,1,63.86,76.54Z"></path><path fill="##000" d="M65.26,112.06a7.29,7.29,0,0,1-7.35-7.39,7.35,7.35,0,0,1,14.7.09A7.27,7.27,0,0,1,65.26,112.06Z"></path></svg>'
  },
  {
    id: 2,
    config_id: 1,
    menu_icon_id: 2,
    name: "Eat Local",
    url: "/local",
    opens_in_new_tab: false,
    position: 1,
    created_at: "2020-03-17T23:08:05.856-05:00",
    updated_at: "2020-03-17T23:08:05.856-05:00",
    icon: '<svg data-v-ea34907a="" xmlns="http://www.w3.org/2000/svg" viewBox="-1 0 174.53 173.95" class="svg_icon"><title>Dining Icon</title><path fill="#000" d="M113.5,52.93c-.09-1.85-.14-3.7-.26-5.55-.07-1.08-.5-2-1.77-1.89s-1.49.92-1.44,2c.07,1.69.14,3.38.21,5.06.14,2.93.27,5.86.42,8.84a2.37,2.37,0,0,1-2.36,2.48h0a2.36,2.36,0,0,1-2.36-2.23c-.21-3.77-.59-11-.73-14.11-.05-1.18-.39-2.12-1.77-2s-1.52,1.07-1.46,2.15c.12,2.23.34,9.57.42,13.75A2.36,2.36,0,0,1,100,63.8h-.21a2.36,2.36,0,0,1-2.36-2.46c.16-3.56.46-10.07.65-13.64.06-1.15-.17-2.15-1.54-2.21s-1.61.86-1.66,2-.7,13.81-.7,13.81c.06,1.3-.14,2.56-1.85,2.66a2.22,2.22,0,0,1-2.24-2.36c.14-3.56.43-10.19.6-13.68.06-1.17-.06-2.32-1.54-2.39s-1.67,1-1.72,2.24c-.16,3.54-1.15,19.21-.9,23.48.32,5.61,3,10,8.38,12.23a2.31,2.31,0,0,1,1.67,2.61q-.07,22.65,0,45.3a3.84,3.84,0,0,0,3.75,3c1.7,0,3.8-1.54,3.8-3l-.06-44.16c0-2,.11-3.48,2.48-4,4.28-1,7.67-8,7.65-13.09C114.21,64.33,113.76,58.63,113.5,52.93Z"></path><path fill="#000" d="M71.19,41.45C66.48,48.71,61.54,59,60.5,68.75,59.83,75,60.84,80.93,64.79,86a6,6,0,0,1,1.29,3.67c.07,12.87.1,25.73,0,38.6,0,3,.9,6.06,3.66,6.06,3.93,0,3.87-3.85,3.88-5.53.06-24.95,0-72.2,0-86.6A1.32,1.32,0,0,0,71.19,41.45Z"></path></svg>'
  },
  {
    id: 3,
    config_id: 1,
    menu_icon_id: 3,
    name: "Press Releases",
    url: "/press-releases",
    opens_in_new_tab: false,
    position: 2,
    created_at: "2020-03-17T23:08:05.860-05:00",
    updated_at: "2020-03-17T23:08:05.860-05:00",
    icon: '<svg data-v-ea34907a="" xmlns="http://www.w3.org/2000/svg" viewBox="-4 0 174.53 173.95" class="svg_icon"><title>News Icon</title><path fill="#000" d="M116.27,64.15v45.64a5.75,5.75,0,0,1-5.75,5.75H53.59a5.75,5.75,0,0,1-5.75-5.75V64.15a5.75,5.75,0,0,1,5.75-5.75h56.93A5.75,5.75,0,0,1,116.27,64.15ZM58.08,73.89h46.16A1.73,1.73,0,0,0,106,72.16V68.33a1.73,1.73,0,0,0-1.73-1.73H58.08a1.73,1.73,0,0,0-1.73,1.73v3.83A1.73,1.73,0,0,0,58.08,73.89ZM75.46,91.1H58.09a1.73,1.73,0,0,0-1.73,1.73v13.52a1.73,1.73,0,0,0,1.73,1.73H75.46a1.73,1.73,0,0,0,1.73-1.73V92.84A1.73,1.73,0,0,0,75.46,91.1ZM97.87,77.23H58.08A1.73,1.73,0,0,0,56.35,79v4.22a1.73,1.73,0,0,0,1.73,1.73H97.87a1.73,1.73,0,0,0,1.73-1.73V79A1.73,1.73,0,0,0,97.87,77.23Zm6,13.88H85.07a1.73,1.73,0,0,0-1.73,1.73v.72a1.73,1.73,0,0,0,1.73,1.73h18.81a1.73,1.73,0,0,0,1.73-1.73v-.72A1.73,1.73,0,0,0,103.88,91.12ZM85,108.42h18.83a1.73,1.73,0,0,0,1.73-1.73v-.28a1.73,1.73,0,0,0-1.73-1.73H85a1.73,1.73,0,0,0-1.73,1.73v.28A1.73,1.73,0,0,0,85,108.42Zm18.83-10.17H85.07A1.73,1.73,0,0,0,83.34,100h0a1.73,1.73,0,0,0,1.73,1.73h18.81a1.73,1.73,0,0,0,1.73-1.73h0A1.73,1.73,0,0,0,103.88,98.25Z"></path><path fill="##000" d="M119.11,109.49V70.14a1,1,0,0,1,1-1h5.68a1,1,0,0,1,.95,1.11l-6.08,39.32A.75.75,0,0,1,119.11,109.49Z"></path></svg>'
  },
  {
    id: 4,
    config_id: 1,
    menu_icon_id: 4,
    name: "Volunteer",
    url: "/volunteer",
    opens_in_new_tab: false,
    position: 1,
    created_at: "2020-03-17T23:08:05.856-05:00",
    updated_at: "2020-03-17T23:08:05.856-05:00",
    icon: '<svg data-v-ea34907a="" xmlns="http://www.w3.org/2000/svg" viewBox="6 0 174.53 173.95" class="svg_icon"><title>Staff Icon</title><path fill="#000" d="M95.73,116.2c-4.69,0-9.37,0-14.06,0a12.73,12.73,0,0,1-1.95-.16,3.31,3.31,0,0,1-3-3,13.62,13.62,0,0,1-.17-2c0-3.35,0-6.71,0-10.06a9.89,9.89,0,0,1,4.27-8.62c1.21-.89,2.46-1.72,3.75-2.5a2.82,2.82,0,0,1,3.49.28c1.61,1.38,3.14,2.87,4.69,4.32.62.58,1.17,1.25,1.82,1.78a1.66,1.66,0,0,0,2.33,0,13.62,13.62,0,0,0,1.25-1.15c1.48-1.44,2.91-2.95,4.44-4.33,1.88-1.69,2.82-1.73,5-.47a18.47,18.47,0,0,1,4.78,3.65,9.42,9.42,0,0,1,2.46,6.44c0,3.72,0,7.44,0,11.16a8.55,8.55,0,0,1-.2,1.77c-.42,1.91-1.75,2.84-4.15,2.87s-4.77,0-7.16,0Z"></path><path fill="#000" d="M107.82,71.47A17.33,17.33,0,0,1,104.66,82a11.41,11.41,0,0,1-6.47,4.7,9.7,9.7,0,0,1-9.48-2.61,15.62,15.62,0,0,1-4.9-11.74,18.63,18.63,0,0,1,.84-6.88,11.72,11.72,0,0,1,11.82-7.7,11.6,11.6,0,0,1,10.76,9.08A45,45,0,0,1,107.82,71.47Z"></path><path fill="#000" d="M71.81,113.61c-.13.11-.15.14-.17.14-3.49,0-7,0-10.47-.1-2.4-.1-3.52-1.2-3.62-3.55a52.37,52.37,0,0,1,.15-8A9.79,9.79,0,0,1,63,94.62a3.39,3.39,0,0,1,3-.17A10.39,10.39,0,0,1,69.6,96.9a8.45,8.45,0,0,1,2.1,2.3,8,8,0,0,1,.11,2.95q0,5.28,0,10.57Z"></path><path fill="#000" d="M119.7,113.78c0-.38,0-.66,0-.94,0-4.32,0-8.63,0-13a1.6,1.6,0,0,1,.55-1.34c1.15-1,2.25-2.08,3.4-3.08a6.18,6.18,0,0,1,1.24-.74,3.93,3.93,0,0,1,4.39.33A10.51,10.51,0,0,1,134,104q0,2.68,0,5.37a8.44,8.44,0,0,1-.19,1.69,3.18,3.18,0,0,1-3.08,2.59c-1.38.11-2.78.13-4.17.14C124.33,113.8,122.09,113.78,119.7,113.78Z"></path><path fill="#000" d="M79.07,79.57a21.73,21.73,0,0,1-.3,3.75c-.81,3.25-3.09,5.1-6.24,5.95a3.19,3.19,0,0,1-1.67-.06c-3-.9-6.34-3.53-6.19-8.06A35,35,0,0,1,65,75.39a7,7,0,0,1,13.77.39A35.33,35.33,0,0,1,79.07,79.57Z"></path><path fill="#000" d="M112.46,79.52a30.93,30.93,0,0,1,.34-4,7.13,7.13,0,0,1,7-5.66A6.91,6.91,0,0,1,126.67,76a30.61,30.61,0,0,1,0,7c-.34,2.89-3.31,5.67-6.18,6.2a3.93,3.93,0,0,1-1.76-.05c-3.08-.91-6.42-3.77-6.18-8.06,0-.54,0-1.08,0-1.62Z"></path></svg>'
  },
  {
    id: 5,
    config_id: 1,
    menu_icon_id: 5,
    name: "Come Work With Us",
    url: "/work-with-us",
    opens_in_new_tab: false,
    position: 2,
    created_at: "2020-03-17T23:08:05.860-05:00",
    updated_at: "2020-03-17T23:08:05.860-05:00",
    icon: '<svg data-v-ea34907a="" xmlns="http://www.w3.org/2000/svg" viewBox="6 0 174.53 173.95" class="svg_icon"><title>Documents Icon</title><path fill="#000" d="M112.57,119.07H70.31a1,1,0,0,1-.45-.1c-1.79-.86-3-2.12-3-4.32q0-26.56,0-53.12a4.18,4.18,0,0,1,4.34-4.39c1,0,2.05,0,3.15,0a1,1,0,0,0,1-1.07c-.11-2.37.65-4.24,3-5.26a1.09,1.09,0,0,1,.42-.08h30.31a1,1,0,0,1,.74.32c.38.41.75.82,1.15,1.19,3.51,3.21,7,6.38,10.53,9.61a2.41,2.41,0,0,1,.79,1.53q.06,20.92,0,41.84a5.32,5.32,0,0,1-5.33,5.32H117a1,1,0,0,0-1,1,19.59,19.59,0,0,0,0,2.2,4.76,4.76,0,0,1-3,5.26A1.07,1.07,0,0,1,112.57,119.07Zm-32.8-63v49.09a1,1,0,0,0,1,1H117a1,1,0,0,0,1-1V66.65a1,1,0,0,0-1-1h-9.63a1,1,0,0,1-1-1V56.05a1,1,0,0,0-1-1H80.79A1,1,0,0,0,79.77,56.05Zm31.9,55.48a1,1,0,0,0-1-1h-.6c-9.79,0-19.58-.1-29.37.05-3.46.05-5.35-2.09-5.32-5.26.12-14.1.05-28.21.05-42.32v-.48a1,1,0,0,0-1-1H72.23a1,1,0,0,0-1,1V113.7a1,1,0,0,0,1,1h38.42a1,1,0,0,0,1-1Z"></path><rect fill="##000" x="84.03" y="74.32" width="29.77" height="4.09" rx="2.05" ry="2.05"></rect><rect fill="##000" x="84.06" y="82.82" width="29.72" height="4.1" rx="2.05" ry="2.05"></rect><rect fill="##000" x="84.05" y="91.37" width="29.71" height="4.11" rx="2.06" ry="2.06"></rect><rect fill="##000" x="84.03" y="61.5" width="18.02" height="4.1" rx="2.05" ry="2.05"></rect></svg>'
  }
];
const slides$1 = [
  {
    url: "https://d2kzwze52p8717.cloudfront.net/neighborhood-flyover.mp4",
    title: "<h1>Welcome to Honeysuckle</h1>",
    index: 0,
    content: "<p>2Users will be able to add short description besides the headline. They will not be have formatting options for this and the number of characters should be truncated.</p>",
    alt_text: "video gallery demo"
  }
];
const videoGalleryDefaults$1 = {
  slides: slides$1
};
const athleticsPreviewContent$1 = [
  {
    id: 1,
    away_score: "",
    away_team: "",
    home_score: "",
    home_team: "Home Team Name",
    title: "Township Charity Match",
    place: "",
    address: "425 Main St, North Little Rock, AR 72114, USA",
    city_state: "",
    state: "",
    zip: "",
    formatted_date: "2019-03-12 09:43:00",
    day: "12",
    month: "MAR",
    year: "2019",
    time: "9:43 AM",
    latitude: "34.75793",
    longitude: "-92.267876",
    versus: false,
    multi_line: false,
    filter_name: "Golf"
  },
  {
    id: 2,
    away_score: "",
    away_team: "Away Team Name",
    home_score: "",
    home_team: "Honeysuckle Home Team",
    title: "Township Charity Match",
    place: "",
    address: "425 Main St, North Little Rock, AR 72114, USA",
    city_state: "",
    state: "",
    zip: "",
    formatted_date: "2019-03-12 09:43:00",
    day: "12",
    month: "MAR",
    year: "2019",
    time: "9:43 AM",
    latitude: "34.75793",
    longitude: "-92.267876",
    versus: true,
    multi_line: false,
    filter_name: "Football"
  },
  {
    id: 3,
    away_score: "",
    away_team: "Away Team Name",
    home_score: "",
    home_team: "Honeysuckle Home Team",
    title: "Township Charity Match",
    place: "",
    address: "425 Main St, North Little Rock, AR 72114, USA",
    city_state: "",
    state: "",
    zip: "",
    formatted_date: "2019-03-12 09:43:00",
    day: "12",
    month: "MAR",
    year: "2019",
    time: "9:43 AM",
    latitude: "34.75793",
    longitude: "-92.267876",
    versus: true,
    multi_line: false,
    filter_name: "Soccer"
  },
  {
    id: 4,
    away_score: "",
    away_team: "Greenville Greenies",
    home_score: "",
    home_team: "Honeysuckle Home Team",
    title: "Township Charity Match",
    place: "",
    address: "425 Main St, North Little Rock, AR 72114, USA",
    city_state: "",
    state: "",
    zip: "",
    formatted_date: "2019-03-12 09:43:00",
    day: "12",
    month: "MAR",
    year: "2019",
    time: "9:43 AM",
    latitude: "34.75793",
    longitude: "-92.267876",
    versus: true,
    multi_line: false,
    filter_name: "Soccer"
  }
];
const eventsPreviewContent$1 = [
  {
    id: 55667,
    title: "Park Opening Ceremony",
    venue: "Honeysuckle Green Park",
    address: "",
    city_state: "",
    state: "",
    zip: "",
    description: "",
    start_at: "2023-07-18T10:00:00.000-05:00",
    end_at: "2023-07-18T01:00:00.000-05:00",
    all_day: false,
    start: "Jul 18 at 10:00 AM",
    end: "Jul 18 at 1:00 PM",
    day: "18",
    month: "JUL",
    year: "2023",
    time: " 10:00 AM",
    filter_name: "All",
    filter_color: "#888888",
    formatted_date: "JUL 18 10:00 AM - 1:00 PM",
    cms_formatted_date: "Jul 18 from 10:00 AM to 1:00 PM",
    formatted_start: "2023-07-18 10:00:00",
    formatted_end: "2023-07-18 13:00:00",
    latitude: "",
    longitude: "",
    sectionDisplayName: "Daytime Events",
    custom_section_id: 3
  },
  {
    id: 55668,
    title: "Recycling Program Kick-off",
    venue: "Town Hall",
    address: "",
    city_state: "",
    state: "",
    zip: "",
    description: "",
    start_at: "2023-07-20T09:00:00.000-05:00",
    end_at: "2023-07-20T12:00:00.000-05:00",
    all_day: true,
    start: "Jul 20 at 09:00 AM",
    end: "Jul 20 at 12:00 PM",
    day: "20",
    month: "JUL",
    year: "2023",
    time: "9:00 AM",
    filter_name: "All",
    filter_color: "#888888",
    formatted_date: "JUL 20 9:00 AM - 12:00 PM",
    cms_formatted_date: "Jul 20 from 9:00 AM to 12:00 PM",
    formatted_start: "2023-07-20 09:00:00",
    formatted_end: "2023-07-20 12:00:00",
    latitude: "",
    longitude: "",
    sectionDisplayName: "All Day Events",
    custom_section_id: 4
  },
  {
    id: 55669,
    title: "Summer Youth Program Orientation",
    venue: "Honeysuckle Community Center",
    address: "",
    city_state: "",
    state: "",
    zip: "",
    description: "",
    start_at: "2023-07-22T17:00:00.000-05:00",
    end_at: "2023-07-22T19:00:00.000-05:00",
    all_day: false,
    start: "Jul 22 at 05:00 PM",
    end: "Jul 22 at 07:00 PM",
    day: "22",
    month: "JUL",
    year: "2023",
    time: "5:00 PM",
    filter_name: "All",
    filter_color: "#888888",
    formatted_date: "JUL 22 5:00 PM - 7:00 PM",
    cms_formatted_date: "Jul 22 from 5:00 PM to 7:00 PM",
    formatted_start: "2023-07-22 17:00:00",
    formatted_end: "2023-07-22 19:00:00",
    latitude: "",
    longitude: "",
    sectionDisplayName: "Daytime Events",
    custom_section_id: 3
  },
  {
    id: 55670,
    title: "Annual Budget Information Session",
    venue: "Town Hall",
    address: "",
    city_state: "",
    state: "",
    zip: "",
    description: "",
    start_at: "2023-07-25T19:00:00.000-05:00",
    end_at: "2023-07-25T21:00:00.000-05:00",
    all_day: true,
    start: "Jul 25 at 7:00 PM",
    end: "Jul 25 at 9:00 PM",
    day: "25",
    month: "JUL",
    year: "2023",
    time: "7:00 PM",
    filter_name: "All",
    filter_color: "#888888",
    formatted_date: "JUL 25",
    cms_formatted_date: "Jul 25 from 7:00 PM to 9:00 PM",
    formatted_start: "2023-07-25 19:00:00",
    formatted_end: "2023-07-25 21:00:00",
    latitude: "",
    longitude: "",
    sectionDisplayName: "Daytime Events",
    custom_section_id: 3
  },
  {
    id: 55671,
    title: "Streetlight Upgrade Community Meeting",
    venue: "Town Hall",
    address: "",
    city_state: "",
    state: "",
    zip: "",
    description: "",
    start_at: "2023-07-27T18:00:00.000-05:00",
    end_at: "2023-07-27T20:00:00.000-05:00",
    all_day: false,
    start: "Jul 27 at 6:00 PM",
    end: "Jul 27 at 8:00 PM",
    day: "27",
    month: "JUL",
    year: "2023",
    time: "6:00 PM",
    filter_name: "All",
    filter_color: "#888888",
    formatted_date: "JUL 27 6:00 PM - 8:00 PM",
    cms_formatted_date: "Jul 27 from 6:00 PM to 8:00 PM",
    formatted_start: "2023-07-27 18:00:00",
    formatted_end: "2023-07-27 20:00:00",
    latitude: "",
    longitude: "",
    sectionDisplayName: "Daytime Events",
    custom_section_id: 3
  },
  {
    id: 55672,
    title: "Art Exhibit Opening Reception",
    venue: "Honeysuckle Community Center",
    address: "",
    city_state: "",
    state: "",
    zip: "",
    description: "",
    start_at: "2023-07-29T04:00:00.000-05:00",
    end_at: "2023-07-29T06:00:00.000-05:00",
    all_day: false,
    start: "Jul 29 at 4:00 PM",
    end: "Jul 29 at 6:00 PM",
    day: "29",
    month: "JUL",
    year: "2023",
    time: "4:00 PM",
    filter_name: "All",
    filter_color: "#888888",
    formatted_date: "JUL 29 4:00 PM - 6:00 PM",
    cms_formatted_date: "Jul 29 from 4:00 PM to 6:00 PM",
    formatted_start: "2023-07-29 04:00:00",
    formatted_end: "2023-07-29 06:00:00",
    latitude: "",
    longitude: "",
    sectionDisplayName: "All Day Events",
    custom_section_id: 4
  }
];
const liveFeedPreviewContent$1 = [
  {
    id: 44556,
    status: "Celebrating the completion of Honeysuckle Green Park! Let's get outdoors and enjoy this wonderful new space! 🌳☀️ #HoneysuckleGreen",
    author: "Honeysuckle Township",
    author_id: 26212,
    moderator_id: null,
    author_name: "Honeysuckle Township",
    time_ago: "1 minute ago",
    avatar: "https://d2kzwze52p8717.cloudfront.net/honeysuckle-logo.jpg",
    approved: true,
    filter_name: "All",
    filter_color: "#888888",
    formatted_date: "2019-10-08 11:08:24",
    time: "2019-10-08T11:08:24.520-05:00",
    image_large: "",
    to_twitter: false,
    to_facebook: false,
    to_live_feed: true,
    to_push_notifications: false,
    detected_urls: [],
    expanded_urls: [],
    jid: null,
    live_feed_images: [
      {
        alt_text: "livefeed image 1",
        id: 277784,
        url: "https://d2kzwze52p8717.cloudfront.net/park.jpg"
      },
      {
        alt_text: "livefeed image 2",
        id: 277785,
        url: "https://d2kzwze52p8717.cloudfront.net/library.jpg"
      },
      {
        alt_text: "livefeed image 3",
        id: 277786,
        url: "https://d2kzwze52p8717.cloudfront.net/recycling.jpeg"
      },
      {
        alt_text: "livefeed image 4",
        id: 277787,
        url: "https://d2kzwze52p8717.cloudfront.net/youth_program.jpeg"
      }
    ]
  },
  {
    id: 44557,
    status: "Let's make recycling a community effort! Participate in our new recycling program, conveniently available at designated collection points throughout Honeysuckle. Together, we can preserve our environment, reduce waste, and keep our beloved community clean and sustainable for generations to come.",
    author: "Honeysuckle Township",
    author_id: 26212,
    moderator_id: null,
    author_name: "Honeysuckle Township",
    time_ago: "1 minute ago",
    avatar: "https://d2kzwze52p8717.cloudfront.net/honeysuckle-logo.jpg",
    approved: true,
    filter_name: "All",
    filter_color: "#888888",
    formatted_date: "2019-10-08 11:08:13",
    time: "2019-10-08T11:08:13.624-05:00",
    image_large: "",
    to_twitter: false,
    to_facebook: false,
    to_live_feed: true,
    to_push_notifications: false,
    detected_urls: [],
    expanded_urls: [],
    jid: null,
    live_feed_images: [
      {
        alt_text: "the city image",
        id: 277783,
        url: "https://d2kzwze52p8717.cloudfront.net/city-streets.jpg"
      }
    ]
  },
  {
    id: 44558,
    status: "Congratulations to the members of the senior class as they prepare for graduation and life beyond high school.",
    author: "Honeysuckle Township",
    author_id: 26212,
    moderator_id: null,
    author_name: "Honeysuckle Township",
    time_ago: "2 minutes ago",
    avatar: "https://d2kzwze52p8717.cloudfront.net/honeysuckle-logo.jpg",
    approved: true,
    filter_name: "All",
    filter_color: "#888888",
    formatted_date: "2019-10-08 11:07:47",
    time: "2019-10-08T11:07:47.715-05:00",
    image_large: "",
    to_twitter: false,
    to_facebook: false,
    to_live_feed: true,
    to_push_notifications: false,
    detected_urls: [],
    expanded_urls: [],
    jid: null,
    live_feed_images: [
      {
        alt_text: "livefeed image 1",
        id: 277784,
        url: "https://d2kzwze52p8717.cloudfront.net/youth_program.jpeg"
      },
      {
        alt_text: "livefeed image 2",
        id: 277785,
        url: "https://d2kzwze52p8717.cloudfront.net/art-show.jpg"
      },
      {
        alt_text: "livefeed image 3",
        id: 277786,
        url: "https://d2kzwze52p8717.cloudfront.net/satellite-view.jpg"
      },
      {
        alt_text: "livefeed image 4",
        id: 277787,
        url: "https://d2kzwze52p8717.cloudfront.net/library.jpg"
      },
      {
        alt_text: "livefeed image 5",
        id: 277788,
        url: "https://d2kzwze52p8717.cloudfront.net/central-park.jpg"
      }
    ]
  },
  {
    id: 44559,
    status: "Have you signed up for our Summer Youth Program yet? Don't miss the chance to make new friends and learn new skills! #HoneysuckleYouth",
    author: "Honeysuckle Township",
    author_id: 26212,
    moderator_id: null,
    author_name: "Honeysuckle Township",
    time_ago: "5 minutes ago",
    avatar: "https://d2kzwze52p8717.cloudfront.net/honeysuckle-logo.jpg",
    approved: true,
    filter_name: "All",
    filter_color: "#888888",
    formatted_date: "2019-10-08 11:07:36",
    time: "2019-10-08T11:07:36.674-05:00",
    image_large: "",
    to_twitter: false,
    to_facebook: false,
    to_live_feed: true,
    to_push_notifications: false,
    detected_urls: [],
    expanded_urls: [],
    jid: null,
    live_feed_images: [
      {
        alt_text: "livefeed image 5",
        id: 277788,
        url: "https://d2kzwze52p8717.cloudfront.net/central-park.jpg"
      }
    ]
  },
  {
    id: 44560,
    status: "Safety first! Our Streetlight Upgrade Initiative begins next week, as we strive to enhance visibility and promote a secure environment for all residents. We apologize in advance for any inconvenience caused during the process and appreciate your understanding as we work diligently to complete the upgrade swiftly and efficiently.",
    author: "Honeysuckle Township",
    author_id: 26212,
    moderator_id: null,
    author_name: "Honeysuckle Township",
    time_ago: "1 day ago",
    avatar: "https://d2kzwze52p8717.cloudfront.net/honeysuckle-logo.jpg",
    approved: true,
    filter_name: "All",
    filter_color: "#888888",
    formatted_date: "2019-10-08 11:06:52",
    time: "2019-10-08T11:06:52.050-05:00",
    image_large: "",
    to_twitter: false,
    to_facebook: false,
    to_live_feed: true,
    to_push_notifications: false,
    detected_urls: [],
    expanded_urls: [],
    jid: null,
    live_feed_images: [
      {
        alt_text: "livefeed image 5",
        id: 277788,
        url: "https://d2kzwze52p8717.cloudfront.net/central-park.jpg"
      }
    ]
  },
  {
    id: 44561,
    status: "Have a love for art? Visit our Community Center, a vibrant hub where you can immerse yourself in the creativity and talent of local artists. Discover captivating paintings, sculptures, and other artistic expressions that reflect the unique spirit of our community.",
    author: "Honeysuckle Township",
    author_id: 26212,
    moderator_id: null,
    author_name: "Honeysuckle Township",
    time_ago: "2 days ago",
    avatar: "https://d2kzwze52p8717.cloudfront.net/honeysuckle-logo.jpg",
    approved: true,
    filter_name: "All",
    filter_color: "#888888",
    formatted_date: "2019-10-08 11:08:24",
    time: "2019-10-08T11:08:24.520-05:00",
    image_large: "",
    to_twitter: false,
    to_facebook: false,
    to_live_feed: true,
    to_push_notifications: false,
    detected_urls: [],
    expanded_urls: [],
    jid: null,
    live_feed_images: []
  }
];
const newsPreviewContent$1 = [
  {
    id: 44556,
    jid: null,
    author_id: 26212,
    title: "Celebrating the completion of Honeysuckle Green Park!",
    content: "Celebrating the completion of Honeysuckle Green Park! Let's get outdoors and enjoy this wonderful new space! 🌳☀️ #HoneysuckleGreen",
    content_text: "Celebrating the completion of Honeysuckle Green Park! Let's get outdoors and enjoy this wonderful new ...",
    snippet: "Let's get outdoors and enjoy this wonderful new space! 🌳☀️ #HoneysuckleGreen",
    published_at: "2019-10-08T11:08:24.520-05:00",
    publish_date: " 8 Oct",
    day: "08",
    month: "OCT",
    year: "2019",
    time_ago: "1 minute ago",
    author: "Honeysuckle Township",
    filter_name: "All",
    filter_color: "#888888",
    link: "",
    caption: "",
    author_avatar: "https://d2kzwze52p8717.cloudfront.net/honeysuckle-logo.jpg",
    cover_image: "https://d2kzwze52p8717.cloudfront.net/park.jpg",
    approved: true,
    to_facebook: false,
    to_twitter: false
  },
  {
    id: 44557,
    jid: null,
    author_id: 26212,
    title: "Let's make recycling a community effort!",
    content: "Let's make recycling a community effort! Participate in our new recycling program, conveniently available at designated collection points throughout Honeysuckle. Together, we can preserve our environment, reduce waste, and keep our beloved community clean and sustainable for generations to come.",
    content_text: "Participate in our new recycling program, conveniently available at designated collection points throughout Honeysuckle ...",
    snippet: "Let's make recycling a community effort! Participate in our new recycling program, conveniently available at designated collection points throughout Honeysuckle. Together, we can preserve our environment, reduce waste, and keep our beloved community clean and sustainable for generations to come.",
    published_at: "2019-10-08T11:08:24.520-05:00",
    publish_date: " 8 Oct",
    day: "08",
    month: "OCT",
    year: "2019",
    time_ago: "1 minute ago",
    author: "Honeysuckle Township",
    filter_name: "All",
    filter_color: "#888888",
    link: "",
    caption: "",
    author_avatar: "https://d2kzwze52p8717.cloudfront.net/honeysuckle-logo.jpg",
    cover_image: "https://d2kzwze52p8717.cloudfront.net/recycling.jpeg",
    approved: true,
    to_facebook: false,
    to_twitter: false
  },
  {
    id: 44558,
    jid: null,
    author_id: 26212,
    title: "Congratulations to our graduating seniors",
    content: "It's time to prepare for graduation and life beyond high school. Honeysuckle Township is proud to call you our own.",
    content_text: "It's time to prepare for graduation and life beyond high school. Honeysuckle Township...",
    snippet: "It's time to prepare for graduation and life beyond high school. Honeysuckle Township is proud to call you our own.",
    published_at: "2019-10-08T11:08:24.520-05:00",
    publish_date: " 8 Oct",
    day: "08",
    month: "OCT",
    year: "2019",
    time_ago: "1 minute ago",
    author: "Honeysuckle Township",
    filter_name: "All",
    filter_color: "#888888",
    link: "",
    caption: "",
    author_avatar: "https://d2kzwze52p8717.cloudfront.net/honeysuckle-logo.jpg",
    cover_image: "https://d2kzwze52p8717.cloudfront.net/library.jpg",
    approved: true,
    to_facebook: false,
    to_twitter: false
  },
  {
    id: 44559,
    jid: null,
    author_id: 26212,
    title: "Have you signed up for our Summer Youth Program yet?",
    content: "Don't miss the chance to make new friends and learn new skills! #HoneysuckleYouth",
    content_text: "Don't miss the chance to make new friends and learn...",
    snippet: "Don't miss the chance to make new friends and learn new skills! #HoneysuckleYouth",
    published_at: "2019-10-08T11:08:24.520-05:00",
    publish_date: " 8 Oct",
    day: "08",
    month: "OCT",
    year: "2019",
    time_ago: "1 minute ago",
    author: "Honeysuckle Township",
    filter_name: "All",
    filter_color: "#888888",
    link: "",
    caption: "",
    author_avatar: "https://d2kzwze52p8717.cloudfront.net/honeysuckle-logo.jpg",
    cover_image: "https://d2kzwze52p8717.cloudfront.net/youth_program.jpeg",
    approved: true,
    to_facebook: false,
    to_twitter: false
  },
  {
    id: 44560,
    jid: null,
    author_id: 26212,
    title: "Have a love for art?",
    content: "Visit our Community Center, a vibrant hub where you can immerse yourself in the creativity and talent of local artists. Discover captivating paintings, sculptures, and other artistic expressions that reflect the unique spirit of our community.",
    content_text: "Visit our Community Center, a vibrant hub where you can immerse yourself...",
    snippet: "Visit our Community Center, a vibrant hub where you can immerse yourself in the creativity and talent of local artists. Discover captivating paintings, sculptures, and other artistic expressions that reflect the unique spirit of our community.",
    published_at: "2019-10-08T11:08:24.520-05:00",
    publish_date: " 8 Oct",
    day: "08",
    month: "OCT",
    year: "2019",
    time_ago: "1 minute ago",
    author: "Honeysuckle Township",
    filter_name: "All",
    filter_color: "#888888",
    link: "",
    caption: "",
    author_avatar: "https://d2kzwze52p8717.cloudfront.net/honeysuckle-logo.jpg",
    cover_image: "https://d2kzwze52p8717.cloudfront.net/art-show.jpg",
    approved: true,
    to_facebook: false,
    to_twitter: false
  },
  {
    id: 44561,
    jid: null,
    author_id: 26212,
    title: "Safety first!",
    content: "Our Streetlight Upgrade Initiative begins next week, as we strive to enhance visibility and promote a secure environment for all residents. We apologize in advance for any inconvenience caused during the process and appreciate your understanding as we work diligently to complete the upgrade swiftly and efficiently.",
    content_text: "Our Streetlight Upgrade Initiative begins next week, as we strive to enhance visibility...",
    snippet: "Our Streetlight Upgrade Initiative begins next week, as we strive to enhance visibility and promote a secure environment for all residents. We apologize in advance for any inconvenience caused during the process and appreciate your understanding as we work diligently to complete the upgrade swiftly and efficiently.",
    published_at: "2019-10-08T11:08:24.520-05:00",
    publish_date: " 8 Oct",
    day: "08",
    month: "OCT",
    year: "2019",
    time_ago: "1 minute ago",
    author: "Honeysuckle Township",
    filter_name: "All",
    filter_color: "#888888",
    link: "",
    caption: "",
    author_avatar: "https://d2kzwze52p8717.cloudfront.net/honeysuckle-logo.jpg",
    cover_image: "https://d2kzwze52p8717.cloudfront.net/satellite-view.jpg",
    approved: true,
    to_facebook: false,
    to_twitter: false
  }
];
const version$1 = "M4";
const style$1 = "light";
const bg_color$1 = {
  hex: "#13A1C8"
};
const text_color$1 = {
  hex: "#FFFFFF"
};
const text_hover_color$1 = {
  hex: "#13A1C8"
};
const heading_color$1 = {
  hex: "#fff"
};
const more_bg_color$1 = {
  hex: "#FFFFFF"
};
const more_text_color$1 = {
  hex: "#13A1C8"
};
const dropdown_bg_color$1 = {
  hex: "#FFFFFF"
};
const dropdown_text_color$1 = {
  hex: "#333333"
};
const explore_menu_text_color$1 = {
  hex: "#FFFFFF"
};
const explore_menu_bg_color$1 = {
  hex: "#333333"
};
const schools_menu_bg_color$1 = {
  hex: "#333333"
};
const schools_menu_text_color$1 = {
  hex: "#FFFFFF"
};
const icon_color$1 = {
  hex: "#0E315C"
};
const icon_bg_color$1 = {
  hex: "#13A1C8"
};
const icon_text_color$1 = {
  hex: "#F31556"
};
const icon_text_hover_color$1 = {
  hex: "#fff"
};
const navigation_icon_bg_color$1 = {
  hex: "#0D4C8F"
};
const l2_bg_color$1 = {
  hex: "#fff"
};
const l1_text_color$1 = {
  hex: "#fff"
};
const l2_text_color$1 = {
  hex: "#13A1C8"
};
const l1_text_hover_color$1 = {
  hex: "#fff"
};
const l2_text_hover_color$1 = {
  hex: "#13A1C8"
};
const search_icon_color$1 = {
  hex: "#fff"
};
const translations$1 = {
  title: "Menu"
};
const menu_titles$1 = true;
const link_icon$1 = "arrow-2";
const menuOptionDefaults$2 = {
  version: version$1,
  style: style$1,
  bg_color: bg_color$1,
  text_color: text_color$1,
  text_hover_color: text_hover_color$1,
  heading_color: heading_color$1,
  more_bg_color: more_bg_color$1,
  more_text_color: more_text_color$1,
  dropdown_bg_color: dropdown_bg_color$1,
  dropdown_text_color: dropdown_text_color$1,
  explore_menu_text_color: explore_menu_text_color$1,
  explore_menu_bg_color: explore_menu_bg_color$1,
  schools_menu_bg_color: schools_menu_bg_color$1,
  schools_menu_text_color: schools_menu_text_color$1,
  icon_color: icon_color$1,
  icon_bg_color: icon_bg_color$1,
  icon_text_color: icon_text_color$1,
  icon_text_hover_color: icon_text_hover_color$1,
  navigation_icon_bg_color: navigation_icon_bg_color$1,
  l2_bg_color: l2_bg_color$1,
  l1_text_color: l1_text_color$1,
  l2_text_color: l2_text_color$1,
  l1_text_hover_color: l1_text_hover_color$1,
  l2_text_hover_color: l2_text_hover_color$1,
  search_icon_color: search_icon_color$1,
  translations: translations$1,
  menu_titles: menu_titles$1,
  link_icon: link_icon$1
};
const languageDefaults$2 = [
  {
    code: "en",
    language: "English"
  },
  {
    code: "fr",
    language: "French"
  },
  {
    code: "es",
    language: "Spanish"
  }
];
const content$3 = [
  {
    snippet: "residents with diverse backgrounds and cultures",
    headline: "150,000"
  },
  {
    snippet: "parks and green spaces spanning 500 acres",
    headline: "20"
  },
  {
    snippet: "major highways and serviced by two railway stations",
    headline: "3"
  },
  {
    snippet: "businesses call Honeysuckle home",
    headline: "5000+"
  },
  {
    snippet: "community events annually",
    headline: "100"
  },
  {
    snippet: "ranked as the safest municipalities in the state",
    headline: "#1"
  }
];
const snippet$5 = true;
const headline$5 = true;
const slider$3 = true;
const stats_header$3 = "About Us";
const component_header$7 = "At the heart of Honeysuckle is a community that's diverse, vibrant, and welcoming";
const component_header_top$7 = "This is";
const municipalityStats2 = {
  content: content$3,
  snippet: snippet$5,
  headline: headline$5,
  slider: slider$3,
  stats_header: stats_header$3,
  component_header: component_header$7,
  component_header_top: component_header_top$7
};
const content$2 = [
  {
    name: "people meeting",
    snippet: "residents with diverse backgrounds and cultures",
    headline: "150,000",
    icon: "<svg viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg'><path d='M12.0005 12.748C12.0005 15.2341 9.98681 17.2479 7.50064 17.2479C5.01727 17.2479 3.00073 15.2341 3.00073 12.748C3.00073 10.2618 5.01727 8.24805 7.50064 8.24805C9.98681 8.24805 12.0005 10.2618 12.0005 12.748Z'></path><path d='M45.0018 12.748C45.0018 15.2341 42.9852 17.2479 40.5019 17.2479C38.0157 17.2479 36.002 15.2341 36.002 12.748C36.002 10.2618 38.0157 8.24805 40.5019 8.24805C42.9852 8.24805 45.0018 10.2618 45.0018 12.748Z'></path><path d='M40.5019 20.248C39.1519 20.248 37.951 20.698 36.7529 21.2971L24.0041 28.7979L11.2554 21.2971C10.0516 20.698 8.85077 20.248 7.5008 20.248C3.30185 20.248 0 23.547 0 27.7488V39.7495H14.9987V30.4488L22.4995 34.9487C22.8005 35.0977 22.9495 35.2496 23.2505 35.2496C23.5514 35.2496 23.7005 35.3987 24.0014 35.3987C24.3024 35.3987 24.4514 35.3987 24.7524 35.2496C25.0533 35.2496 25.2023 35.1006 25.5033 34.9487L33.0041 30.4488L33.0013 39.7467H48V27.746C48 23.547 44.701 20.248 40.5021 20.248H40.5019Z'></path></svg>",
    bg_color: "var(--card-bg-color)",
    color: "var(--color)"
  },
  {
    snippet: "major highways and serviced by two railway stations",
    headline: "3",
    bg_image: {
      url: "https://d2kzwze52p8717.cloudfront.net/canopy-path.jpg",
      alt_text: "landscape"
    }
  },
  {
    name: "public safety",
    snippet: "ranked as the safest municipalities in the state",
    headline: "#1",
    icon: "<svg viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg'><path d='M36.0015 5.99928C29.8503 5.99928 24.0001 0 24.0001 0C24.0001 0 18.1499 5.99928 11.9987 5.99928C6.14842 5.99928 2.99829 1.4991 2.99829 1.4991V29.9993C2.99829 43.6489 14.9997 38.9996 24.0001 48C33.0004 38.9996 45.0019 43.6489 45.0019 29.9993V1.4991C45.0019 1.4991 41.8518 5.99928 36.0015 5.99928ZM33.1496 36.0014C30.4495 36.9015 27.2993 38.1025 24.1492 40.2006L24.0001 40.0516V24H9.0005V11.7004C9.90054 11.8495 10.9496 12.0014 12.0016 12.0014C16.6508 12.0014 21.0019 9.75131 24.003 7.80219L24.0002 24H38.9998V29.9992C38.9998 34.0494 38.4008 34.2013 33.1496 36.0013L33.1496 36.0014Z'></path></svg>",
    bg_color: "var(--card-2-bg-color)",
    color: "var(--color2)"
  },
  {
    snippet: "businesses call Honeysuckle home",
    headline: "5000+",
    bg_image: {
      url: "https://d2kzwze52p8717.cloudfront.net/city-streets.jpg",
      alt_text: "landscape"
    }
  },
  {
    name: "leaf",
    snippet: "parks and green spaces spanning 500 acres",
    headline: "20",
    icon: "<svg viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg'><path d='M40.954 36.0013C35.5822 29.6225 28.0296 22.5734 22.661 17.7083C22.3243 17.3715 22.1575 17.038 22.1575 16.5345C22.1575 15.5275 22.8278 14.8572 23.8348 14.8572C24.1715 14.8572 24.675 15.024 25.0086 15.1939H25.1753C32.7279 22.0763 38.77 27.9484 43.1348 32.9834C43.4716 32.3132 43.8051 31.6397 44.1419 30.9694C44.1419 30.9694 44.1419 30.8026 44.3086 30.6327C44.4754 30.1292 44.6454 29.4589 44.8121 28.9554C44.8121 28.7886 44.9789 28.6187 44.9789 28.4519C45.1457 27.9484 45.1457 27.4449 45.3157 26.9414C45.3157 26.7746 45.3157 26.6047 45.4824 26.2711C45.3157 25.5945 45.3157 24.7543 45.3157 24.084C45.3157 10.9928 31.5542 4.11049 18.463 3.94373C6.5456 3.77694 0 0.585938 0 0.585938C0 0.585938 1.67728 17.7052 5.20183 27.2718C9.23304 38.1822 16.6157 42.547 26.8559 42.547C27.5262 42.547 28.1996 42.547 28.8699 42.3802H29.0367C29.5402 42.3802 30.2105 42.2135 30.714 42.0435H30.8808C32.0545 41.7068 33.2315 41.3732 34.4053 40.8697C35.4123 40.3662 36.4193 39.8627 37.4263 39.1925C40.7841 43.0538 42.9649 46.0748 42.9649 47.4153H48C47.8332 44.8947 44.9821 40.533 40.954 36.0014L40.954 36.0013Z'></path></svg>",
    bg_color: "var(--card-3-bg-color)",
    color: "var(--color-3)"
  },
  {
    snippet: "community events annually",
    headline: "100",
    bg_image: {
      url: "https://d2kzwze52p8717.cloudfront.net/youth_program.jpeg",
      alt_text: "landscape"
    }
  }
];
const snippet$4 = true;
const headline$4 = true;
const slider$2 = true;
const stats_header$2 = "About Us";
const component_header$6 = "About Us";
const component_header_top$6 = "This is";
const municipalityStats3 = {
  content: content$2,
  snippet: snippet$4,
  headline: headline$4,
  slider: slider$2,
  stats_header: stats_header$2,
  component_header: component_header$6,
  component_header_top: component_header_top$6
};
const nested_content$1 = [
  {
    top_stats: {
      headline: "20",
      snippet: "parks and green spaces over 500 acres"
    },
    bottom_stats: {
      headline: "#1",
      snippet: "safest municipality in the state"
    },
    left_image: {
      url: "https://d2kzwze52p8717.cloudfront.net/canopy-path.jpg",
      alt_text: "parks"
    },
    right_image: {
      url: "https://d2kzwze52p8717.cloudfront.net/police.jpeg",
      alt_text: "safety"
    }
  },
  {
    top_stats: {
      headline: "3",
      snippet: "major highways serviced by two railway stations"
    },
    bottom_stats: {
      headline: "150,000",
      snippet: "residents with diverse backgrounds"
    },
    left_image: {
      url: "https://d2kzwze52p8717.cloudfront.net/city-streets.jpg",
      alt_text: "streets"
    },
    right_image: {
      url: "https://d2kzwze52p8717.cloudfront.net/youth_program.jpeg",
      alt_text: "residents"
    }
  },
  {
    top_stats: {
      headline: "1",
      snippet: "commitment to improving our parks"
    },
    bottom_stats: {
      headline: "15",
      snippet: "municipal departments to serve residents"
    },
    left_image: {
      url: "https://d2kzwze52p8717.cloudfront.net/central-park.jpg",
      alt_text: "landscape"
    },
    right_image: {
      url: "https://d2kzwze52p8717.cloudfront.net/public_works.jpg",
      alt_text: "public works"
    }
  },
  {
    top_stats: {
      headline: "5000+",
      snippet: "businesses call Honeysuckle home"
    },
    bottom_stats: {
      headline: "100",
      snippet: "community events annually"
    },
    left_image: {
      url: "https://d2kzwze52p8717.cloudfront.net/satellite-view.jpg",
      alt_text: "satellite-view"
    },
    right_image: {
      url: "https://d2kzwze52p8717.cloudfront.net/fire.jpg",
      alt_text: "fire department"
    }
  }
];
const headline$3 = true;
const snippet$3 = true;
const component_header$5 = "About the Honeysuckle Community";
const component_header_top$5 = "This is";
const municipalityStats4 = {
  nested_content: nested_content$1,
  headline: headline$3,
  snippet: snippet$3,
  component_header: component_header$5,
  component_header_top: component_header_top$5
};
const component_header$4 = "Building A Better City Together";
const component_header_top$4 = "We Are";
const component_text$1 = "<p>Our city is a tapestry of cultures, ideas, and dreams. We are committed to fostering an inclusive and welcoming environment where everyone can thrive. From improving our infrastructure and public services to promoting local businesses and green initiatives, we are dedicated to enhancing your quality of life.</p><br><p><strong>Mayor Phil Jacobson</strong></p>";
const links$1 = [
  {
    href: "#",
    top_title: "",
    title: "Community",
    image: {
      url: "https://public-apptegy-assets.s3.us-east-2.amazonaws.com/apptegy-cms-theme-preview-images/community.jpeg",
      alt_text: ""
    }
  },
  {
    href: "#",
    top_title: "Resident",
    title: "Artists",
    image: {
      url: "https://public-apptegy-assets.s3.us-east-2.amazonaws.com/apptegy-cms-theme-preview-images/art.jpeg",
      alt_text: ""
    }
  },
  {
    href: "#",
    top_title: "Local",
    title: "Farmers",
    target: "_self",
    icon: "<svg data-name='Layer 1' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 47.92 46.04'><path d='M47.1,1.4A2.32,2.32,0,0,0,45.3,1L24,4.7,2.6,1a2.21,2.21,0,0,0-1.9.6A2.36,2.36,0,0,0,0,3.2V40.9a3.07,3.07,0,0,0,2.3,2.8L23.8,47H24l21.6-3.3a3,3,0,0,0,2.3-2.8V3.2A1.84,1.84,0,0,0,47.1,1.4ZM32,5.3,40,4V15.1l-3.4-2.6a1.07,1.07,0,0,0-1.4.1L32,16.4ZM2,40.9V3.2c0-.1,0-.1.1-.1s.1-.1.2-.1L23,6.5V44.8L2.7,41.7A1.12,1.12,0,0,1,2,40.9Zm44,0a1.12,1.12,0,0,1-.7.8L25,44.8V6.5l5-.9V19a1,1,0,0,0,.7.9c.1,0,.2.1.3.1a.91.91,0,0,0,.8-.4l4.4-5.2,4.2,3.3a1.07,1.07,0,0,0,1.1.1,1.15,1.15,0,0,0,.6-.9V3.6L45.7,3h.2a.35.35,0,0,1,.1.2Z' transform='translate(0 -0.96)'/></svg>",
    image: {
      url: "https://public-apptegy-assets.s3.us-east-2.amazonaws.com/apptegy-cms-theme-preview-images/flower.jpeg",
      alt_text: ""
    }
  },
  {
    href: "#",
    top_title: "Educational",
    title: "Programming",
    image: {
      url: "https://public-apptegy-assets.s3.us-east-2.amazonaws.com/apptegy-cms-theme-preview-images/growth.png",
      alt_text: ""
    }
  },
  {
    href: "#",
    top_title: "Volunteer",
    title: "In the Community",
    image: {
      url: "https://public-apptegy-assets.s3.us-east-2.amazonaws.com/apptegy-cms-theme-preview-images/friends.png",
      alt_text: ""
    }
  }
];
const municipalityAbout3 = {
  component_header: component_header$4,
  component_header_top: component_header_top$4,
  component_text: component_text$1,
  links: links$1
};
const municipalityHomepageDefaults = {
  alertDefaults: alertDefaults$1,
  alertSeparateDefaults: alertSeparateDefaults$1,
  orgMenuDefaults: orgMenuDefaults$1,
  globalSettingDefaults: globalSettingDefaults$1,
  utilityLinkDefaults: utilityLinkDefaults$1,
  editableHomepageComponents: editableHomepageComponents$1,
  orgDefaults: orgDefaults$1,
  siteMenuDefaults: siteMenuDefaults$1,
  staticMenuLinkDefaults: staticMenuLinkDefaults$1,
  videoGalleryDefaults: videoGalleryDefaults$1,
  menuOptionDefaults: menuOptionDefaults$2,
  languageDefaults: languageDefaults$2,
  aboutPreviewContent: {
    AboutV1: editableHomepageComponents$1.about.preview_id,
    AboutV2: editableHomepageComponents$1.about.preview_id,
    AboutV3: municipalityAbout3
  },
  statsPreviewContent: {
    S1: editableHomepageComponents$1.stats.preview_id,
    S2: municipalityStats2,
    S3: municipalityStats3,
    S4: municipalityStats4
  }
};
const municipalityMediaPreviewContent = {
  athleticsPreviewContent: athleticsPreviewContent$1,
  eventsPreviewContent: eventsPreviewContent$1,
  liveFeedPreviewContent: liveFeedPreviewContent$1,
  newsPreviewContent: newsPreviewContent$1
};
const data = "<h1>School Closing Early</h1><p>Icy roads are expected during dismissal today, so to ensure the safety of our students, teachers and bus drivers, we will be dismissing students at 1:00 pm today. Please plan accordingly.</p><hr>Contact the front office with any questions <hr>214-545-0098";
const alertDefaults = {
  data
};
const alertSeparateDefaults = [
  {
    id: 1,
    content: "<h1>School Closing Early</h1><p>Icy roads are expected during dismissal today, so to ensure the safety of our students, teachers and bus drivers, we will be dismissing students at 1:00 pm today. Please plan accordingly.</p><hr>Contact the front office with any questions <hr>123-456-7890",
    image: {
      url: "https://public-apptegy-assets.s3.us-east-2.amazonaws.com/apptegy-cms-theme-preview-images/graduation.jpeg",
      alt_text: "example alt text"
    },
    status: "published",
    style: "light_box",
    display_location: "homepage"
  },
  {
    id: 2,
    content: "<h1>Parent-Teacher Conference</h1><p>We invite all parents to join us for the upcoming parent-teacher conferences next Thursday from 4:00 pm to 7:00 pm. This is a great opportunity to discuss your child's progress with their teachers.</p><hr>For scheduling appointments, please call <hr>123-456-7890",
    image: {
      url: "https://public-apptegy-assets.s3.us-east-2.amazonaws.com/apptegy-cms-theme-preview-images/robotics.jpeg",
      alt_text: "example alt text"
    },
    status: "published",
    style: "light_box",
    display_location: "homepage"
  },
  {
    id: 3,
    content: "<h1>Book Fair Next Week</h1><p>Our school library will host a book fair from Monday to Wednesday next week during school hours. A portion of the proceeds will go towards new library resources. We hope to see you there!</p><hr>Questions? Contact <hr>123-456-7890",
    status: "published",
    style: "banner",
    display_location: "homepage"
  },
  {
    id: 4,
    content: "<h1>Annual Science Fair</h1><p>Join us for our annual Science Fair on March 15th! Students will be presenting their projects in the school gymnasium from 9:00 am to 3:00 pm. Come and see the innovative projects our students have been working on.</p><hr>For more information, please contact <hr>123-456-7890",
    status: "published",
    style: "banner",
    display_location: "homepage"
  }
];
const menu = [
  [
    {
      type: "SchoolsMenuOrg",
      name: "School District",
      link: "#"
    },
    {
      type: "SchoolsMenuHeader",
      name: "High Schools",
      children: [
        {
          type: "SchoolsMenuOrg",
          name: "Bella High School",
          link: "#"
        },
        {
          type: "SchoolsMenuOrg",
          name: "Northside High School",
          link: "#"
        },
        {
          type: "SchoolsMenuOrg",
          name: "No-Link High School"
        }
      ]
    }
  ],
  [
    {
      type: "SchoolsMenuHeader",
      name: "Middle Schools",
      children: [
        {
          type: "SchoolsMenuOrg",
          name: "Bella Middle School",
          link: "#"
        },
        {
          type: "SchoolsMenuOrg",
          name: "Northside Intermediate",
          link: "#"
        },
        {
          type: "SchoolsMenuOrg",
          name: "Parkway Middle School",
          link: "#"
        },
        {
          type: "SchoolsMenuOrg",
          name: "Bohr Science Magnet",
          link: "#"
        }
      ]
    }
  ],
  [
    {
      type: "SchoolsMenuHeader",
      name: "Elementary Schools",
      children: [
        {
          type: "SchoolsMenuOrg",
          name: "Bella Elementary School",
          link: "#"
        },
        {
          type: "SchoolsMenuOrg",
          name: "Northside Elementary",
          link: "#"
        },
        {
          type: "SchoolsMenuOrg",
          name: "Parkway Elementary",
          link: "#"
        },
        {
          type: "SchoolsMenuOrg",
          name: "Eastside Elementary",
          link: "#"
        },
        {
          type: "SchoolsMenuOrg",
          name: "Southside Elementary",
          link: "#"
        },
        {
          type: "SchoolsMenuOrg",
          name: "Burnside Elementary",
          link: "#"
        },
        {
          type: "SchoolsMenuOrg",
          name: "Gibbs Magnet School",
          link: "#"
        }
      ]
    }
  ],
  [
    {
      url: "https://d2kzwze52p8717.cloudfront.net/youth_program.jpeg",
      type: "SchoolsMenuImage",
      caption: "Girl walking up steps to school",
      display: "actual-size",
      alt_text: "Girl walking up steps to school",
      asset_id: 206,
      link_url: "",
      set_ratio: 1,
      cropped_width: {},
      cropped_height: {},
      action_on_click: "no_action",
      image_alignment: "center",
      preferred_width: null,
      preferred_height: null,
      caption_alignment: "center",
      open_link_in_new_tab: false
    }
  ]
];
const orgMenuDefaults = {
  menu
};
const info = {
  alert_text_color: {
    hex: "#FFFFFF"
  },
  alert_link_color: {
    hex: "#004490"
  },
  alert_bg_color: {
    hex: "#CC314B"
  },
  alert_lightbox_overlay: {
    hex: "#000000"
  },
  school_name: "Poly University",
  school_tag_line: "foobar, fizzbuzz",
  customHeader: false
};
const language = "en";
const logo = {
  url: "https://cms-v2-assets-qa.apptegy.net/uploads/1271/logo/19/rover.png"
};
const watermark = {
  url: "https://cms-v2-assets-qa.apptegy.net/uploads/1271/logo/19/rover.png"
};
const active_theme = {
  content: {
    menu: {
      options: {
        style: "light",
        version: "M1",
        bg_color: {
          hex: "#13A1C8"
        },
        icon_color: {
          a: 1,
          hex: "#FFFFFF",
          hsl: {
            a: 1,
            h: 192.9281767955801,
            l: 1,
            s: 0
          },
          hsv: {
            a: 1,
            h: 192.9281767955801,
            s: 0,
            v: 1
          },
          hex8: "#FFFFFFFF",
          rgba: {
            a: 1,
            b: 255,
            g: 255,
            r: 255
          },
          source: "hsva"
        },
        text_color: {
          a: 1,
          hex: "#FFFFFF",
          hsl: {
            a: 1,
            h: 0,
            l: 1,
            s: 0
          },
          hsv: {
            a: 1,
            h: 0,
            s: 0,
            v: 1
          },
          hex8: "#FFFFFFFF",
          rgba: {
            a: 1,
            b: 255,
            g: 255,
            r: 255
          },
          source: "hsva"
        },
        l2_bg_color: {
          hex: "#fff"
        },
        heading_color: {
          hex: "#fff"
        },
        icon_bg_color: {
          a: 1,
          hex: "#13A1C8",
          hsl: {
            a: 1,
            h: 192.9281767955801,
            l: 0.4294117647058823,
            s: 0.8264840182648403
          },
          hsv: {
            a: 1,
            h: 192.9281767955801,
            s: 0.905,
            v: 0.7843137254901961
          },
          hex8: "#13A1C8FF",
          rgba: {
            a: 1,
            b: 200,
            g: 161,
            r: 19
          },
          source: "hex"
        },
        l1_text_color: {
          hex: "#fff"
        },
        l2_text_color: {
          hex: "#13A1C8"
        },
        sticky_header: true,
        icon_text_color: {
          a: 1,
          hex: "#FFFFFF",
          hsl: {
            a: 1,
            h: 0,
            l: 1,
            s: 0
          },
          hsv: {
            a: 1,
            h: 0,
            s: 0,
            v: 1
          },
          hex8: "#FFFFFFFF",
          rgba: {
            a: 1,
            b: 255,
            g: 255,
            r: 255
          },
          source: "hsva"
        },
        text_hover_color: {
          a: 1,
          hex: "#FFFFFF",
          hsl: {
            a: 1,
            h: 0,
            l: 1,
            s: 0
          },
          hsv: {
            a: 1,
            h: 0,
            s: 0,
            v: 1
          },
          hex8: "#FFFFFFFF",
          rgba: {
            a: 1,
            b: 255,
            g: 255,
            r: 255
          },
          source: "hsva"
        },
        l1_text_hover_color: {
          hex: "#fff"
        },
        l2_text_hover_color: {
          hex: "#13A1C8"
        }
      }
    }
  }
};
const globalSettingDefaults = {
  info,
  language,
  logo,
  watermark,
  active_theme
};
const utilityLinkDefaults = [
  {
    name: "Students",
    link: "/o/middleschool"
  },
  {
    name: "Parents",
    link: "/o/middleschool"
  },
  {
    name: "Admissions",
    link: "/o/middleschool"
  },
  {
    name: "Grade",
    link: "/o/middleschool"
  },
  {
    name: "Bus Routes",
    link: "/o/middleschool"
  }
];
const description = "This is not just a test file. It's used to set up Theme Preview data for CMS Public homepages. Please do not edit it unless you are explicitly required to.";
const gallery = {
  slides: [
    {
      url: "https://d2kzwze52p8717.cloudfront.net/gallery_01.png?id=1",
      title: "<h1>Welcome to Our School</h1>",
      content: "<p></p>",
      alt_text: "dssd",
      sizes: {
        px600: "https://d2kzwze52p8717.cloudfront.net/gallery_01.png?id=px600",
        px960: "https://d2kzwze52p8717.cloudfront.net/gallery_01.png?id=px960"
      }
    },
    {
      url: "https://d2kzwze52p8717.cloudfront.net/gallery.png?id=2",
      title: "<h1>Welcome to Our School</h1>",
      content: "<p>Users will be able to add short description besides the headline.</p>",
      alt_text: "dds"
    },
    {
      url: "https://d2kzwze52p8717.cloudfront.net/computer_science.png?id=3",
      title: "<h1>Welcome to Our School</h1>",
      content: "<p></p>",
      alt_text: "dsd"
    },
    {
      url: "https://d2kzwze52p8717.cloudfront.net/arts.png?id=4",
      title: "<h1>Welcome to Our School</h1>",
      content: "<p>Everyone is welcome</p>",
      alt_text: "dsdsd"
    }
  ],
  widget: {
    body: "Get your application started online today.",
    link: {
      href: "https://www.google.com/",
      name: "",
      target: ""
    }
  }
};
const events = {
  background_image: {
    url: "https://d2kzwze52p8717.cloudfront.net/events_background.jpeg"
  },
  display_tags: true,
  preview_id: {
    component_header: "Events",
    component_header_top: "Latest",
    selected_sections: [],
    see_all_link: {
      href: "/events",
      name: "See All Events",
      target: "_self"
    }
  },
  customSections: [
    1,
    2
  ]
};
const athletics = {
  preview_id: {
    component_header: "Athletics",
    component_header_top: "Latest",
    see_all_link: {
      href: "",
      name: "See All Events",
      target: "_self"
    }
  }
};
const news = {
  preview_id: {
    component_header: "News",
    component_header_top: "Latest",
    see_all_link: {
      href: "/news",
      name: "See All News",
      target: "_self"
    }
  }
};
const live_feed = {
  preview_id: {
    component_header: "Live Feed",
    component_header_top: "Latest",
    see_all_link: {
      href: "",
      name: "See All Posts",
      target: "_self"
    }
  }
};
const stats = {
  preview_id: {
    content: [
      {
        name: "graduation cap",
        path: '<path fill-rule="evenodd" clip-rule="evenodd" d="M48 30.9657C48 32.6177 46.654 33.9618 45 33.9618C43.346 33.9618 42 32.6177 42 30.9657C42 29.6647 42.839 28.5667 44 28.1528V15.7347L36.959 19.8908C36.974 19.9578 37 20.0208 37 20.0918V36.0747C37 36.6117 36.575 37.0407 36.044 37.0647C34.595 37.7947 29.741 39.9557 23 39.9557C16.259 39.9557 11.404 37.7947 9.956 37.0647C9.425 37.0407 9 36.6117 9 36.0747V20.0918C9 20.0208 9.026 19.9578 9.041 19.8908L0.491 14.8438C0.186 14.6648 0 14.3367 0 13.9837C0 13.6317 0.186 13.3037 0.491 13.1247L22.492 0.13875C22.807 -0.04625 23.195 -0.04625 23.51 0.13875L45.51 13.1247C45.913 13.1847 46 13.4688 46 13.9587V13.9808C46 13.9818 46.001 13.9827 46.001 13.9837C46.001 13.9857 46 13.9867 46 13.9878V28.1528C47.162 28.5667 48 29.6647 48 30.9657ZM35 35.3498V21.0478L23.51 27.8298C23.352 27.9217 23.177 27.9688 23.001 27.9688C22.825 27.9688 22.649 27.9217 22.492 27.8298L11 21.0468V35.3498C12.452 36.0518 16.951 37.9577 23 37.9577C29.048 37.9577 33.548 36.0518 35 35.3498ZM23.001 2.15875L2.966 13.9837L23.001 25.8098L43.035 13.9837L23.001 2.15875ZM45.419 30.0658C45.397 30.0678 45.386 30.0818 45.362 30.0818C45.224 30.0818 45.07 30.0458 44.916 29.9838C44.405 30.0288 44 30.4447 44 30.9657C44 31.5157 44.448 31.9648 45 31.9648C45.552 31.9648 46 31.5157 46 30.9657C46 30.5658 45.76 30.2248 45.419 30.0658Z" />',
        snippet: "All of our middle schools offer the same rigorous curriculum and provide scholars with an excellent education.",
        headline: "87% graduation rate",
        view_box: "0 0 48 48"
      },
      {
        name: "school bag",
        path: '<path fill-rule="evenodd" clip-rule="evenodd" d="M45.467 44H2.533C1.137 44 0 42.849 0 41.435V10.564C0 9.15 1.137 8 2.533 8H15V4.067C15 1.824 16.884 0 19.2 0H28.8C31.116 0 33 1.824 33 4.067V8H45.467C46.863 8 48 9.15 48 10.564V41.435C48 42.849 46.863 44 45.467 44ZM2 41.435C2 41.741 2.244 42 2.533 42H23V23H17V24.143C17 26.27 15.206 28 13 28C11.95 28 10.955 27.603 10.196 26.883C9.424 26.142 9 25.169 9 24.143V23H2V41.435ZM15 24.143V20.001H11V24.143C11 24.62 11.205 25.08 11.577 25.437C11.953 25.793 12.473 26 13 26C14.103 26 15 25.167 15 24.143ZM31 4.067C31 2.927 30.013 2 28.8 2H19.2C17.987 2 17 2.927 17 4.067V8H31V4.067ZM46 10.564C46 10.259 45.756 10 45.467 10H2.533C2.239 10 2 10.254 2 10.564V21H9V19C9 18.448 9.447 18 10 18H16C16.553 18 17 18.448 17 19V21H31V19C31 18.448 31.447 18 32 18H38C38.553 18 39 18.448 39 19V21H46V10.564ZM37 20.001H33V24.143C33 24.62 33.205 25.08 33.577 25.437C33.953 25.793 34.473 26 35 26C36.102 26 37 25.167 37 24.143V20.001ZM46 23H39V24.143C39 26.27 37.206 28 35 28C33.95 28 32.955 27.603 32.196 26.883C31.424 26.142 31 25.169 31 24.143V23H25V42H45.467C45.756 42 46 41.741 46 41.435V23Z" />',
        snippet: "More than 79% of faculty members have advanced degrees and teachers have an average of 10 years' experience.",
        headline: "It's the staff that make all the difference to the quality of education.",
        view_box: "0 0 48 48"
      },
      {
        name: "trophy",
        path: '<path fill-rule="evenodd" clip-rule="evenodd" d="M39 14.331V20.888C39 20.907 38.99 20.924 38.989 20.943C38.99 20.962 39 20.979 39 20.998C39 28.933 32.805 35.43 25 35.948V45.999H35C35.553 45.999 36 46.446 36 46.998C36 47.55 35.553 47.999 35 47.999H13C12.447 47.999 12 47.55 12 46.998C12 46.446 12.447 45.999 13 45.999H23V35.948C15.195 35.43 9 28.933 9 20.998C9 20.979 9.01 20.962 9.011 20.943C9.01 20.924 9 20.907 9 20.888V14.331C3.932 14.331 0 8.77705 0 3.99805C0 3.44605 0.447 2.99905 1 2.99905H9V0.998047C9 0.446047 9.447 -0.00195312 10 -0.00195312H38C38.553 -0.00195312 39 0.446047 39 0.998047V2.99905H47C47.553 2.99905 48 3.44605 48 3.99805C48 8.77705 44.068 14.331 39 14.331ZM9 4.99905H2.069C2.549 8.53205 5.46 12.332 9 12.332V4.99905ZM37 20.888V1.99905H11V20.888C11 20.907 10.99 20.924 10.989 20.943C10.99 20.962 11 20.979 11 20.998C11 28.167 16.832 33.998 24 33.998C31.168 33.998 37 28.167 37 20.998C37 20.979 37.01 20.962 37.011 20.943C37.01 20.924 37 20.907 37 20.888ZM39 4.99905V12.332C42.54 12.332 45.451 8.53205 45.931 4.99905H39ZM27 25.998H21C20.447 25.998 20 25.551 20 24.999C20 24.447 20.447 23.998 21 23.998H23V13.413L20.707 15.706C20.316 16.096 19.684 16.096 19.293 15.706C18.902 15.315 18.902 14.682 19.293 14.292L23.293 10.292C23.579 10.004 24.009 9.92005 24.383 10.075C24.757 10.23 25 10.594 25 10.999V23.998H27C27.553 23.998 28 24.447 28 24.999C28 25.551 27.553 25.998 27 25.998Z" />',
        snippet: "Learning is disciplined based, and the curriculum changes to reflect the latest best practices in education.",
        headline: " Our educational experience begins with academics.",
        view_box: "0 0 48 48"
      },
      {
        snippet: "Offering a professional environment in classes taught by working professionals, there are 30 distinct areas of study to choose from.",
        headline: "Comprehensive arts programs for K-12 District-wide",
        icon: "<svg id='Layer_1' data-name='Layer 1' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 48 48.1'><path d='M31.9,18.7h0c-.1-.2-.1-.3-.2-.4h0l-12-12h0c-.1-.1-.2-.1-.3-.2h-.1A.37.37,0,0,1,19,6H2A2,2,0,0,0,0,8V46a2.15,2.15,0,0,0,2,2H30a2,2,0,0,0,2-2V18.9C32,18.8,32,18.8,31.9,18.7ZM20,9.4,28.6,18H20ZM2,46V8H18V19a.94.94,0,0,0,1,1H30V46Z' transform='translate(0 0.1)'/><path d='M48,12.9a.37.37,0,0,0-.1-.3v-.1c0-.1-.1-.2-.2-.3h0L35.7.2h0c-.1-.1-.2-.1-.3-.2h-.1A.37.37,0,0,1,35-.1H18c-1.2,0-2,.6-2,1.5V2a1,1,0,0,0,2,0H34V13a.94.94,0,0,0,1,1H46V40H36a1,1,0,0,0,0,2H46a2,2,0,0,0,2-2V12.9ZM36,12V3.4L44.6,12Z' transform='translate(0 0.1)'/></svg>"
      }
    ],
    snippet: true,
    headline: true,
    slider: true,
    stats_header: "About Us",
    component_header: "About Us",
    component_header_top: "This is"
  }
};
const header = {
  links: [
    {
      name: "Students",
      link: ""
    },
    {
      name: "Parents",
      link: ""
    },
    {
      name: "Admissions",
      link: ""
    },
    {
      name: "Grades",
      link: ""
    },
    {
      name: "Bus Routes",
      link: ""
    }
  ],
  icon_links: [
    {
      name: "facebook",
      link: "#",
      opens_in_new_tab: false,
      icon: "<svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'><path fill-rule='evenodd' clip-rule='evenodd' d='M11.1413 4.64124C12.0321 3.75044 13.2403 3.25 14.5001 3.25H16.9001C17.3143 3.25 17.6501 3.58579 17.6501 4V7.2C17.6501 7.61421 17.3143 7.95 16.9001 7.95H14.5001C14.4868 7.95 14.4741 7.95527 14.4647 7.96464C14.4554 7.97402 14.4501 7.98674 14.4501 8V9.65H16.9001C17.131 9.65 17.3491 9.7564 17.4913 9.93844C17.6334 10.1205 17.6837 10.3578 17.6277 10.5819L16.8277 13.7819C16.7442 14.1158 16.4442 14.35 16.1001 14.35H14.4501V20C14.4501 20.4142 14.1143 20.75 13.7001 20.75H10.5001C10.0859 20.75 9.7501 20.4142 9.7501 20V14.35H8.1001C7.68588 14.35 7.3501 14.0142 7.3501 13.6V10.4C7.3501 9.98579 7.68588 9.65 8.1001 9.65H9.7501V8C9.7501 6.74022 10.2505 5.53204 11.1413 4.64124ZM14.5001 4.75C13.6381 4.75 12.8115 5.09241 12.202 5.7019C11.5925 6.3114 11.2501 7.13805 11.2501 8V10.4C11.2501 10.8142 10.9143 11.15 10.5001 11.15H8.8501V12.85H10.5001C10.9143 12.85 11.2501 13.1858 11.2501 13.6V19.25H12.9501V13.6C12.9501 13.1858 13.2859 12.85 13.7001 12.85H15.5145L15.9395 11.15H13.7001C13.2859 11.15 12.9501 10.8142 12.9501 10.4V8C12.9501 7.58891 13.1134 7.19467 13.4041 6.90398C13.6948 6.6133 14.089 6.45 14.5001 6.45H16.1501V4.75H14.5001Z' /></svg>",
      icon_id: 1
    },
    {
      name: "X",
      link: "#",
      opens_in_new_tab: false,
      icon: "<svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'><path fill-rule='evenodd' clip-rule='evenodd' d='M4.89876 3.89999C4.01359 3.89999 3.49096 4.89227 3.99166 5.62222L9.43281 13.5546L4.01032 19.8371C3.58312 20.332 3.93474 21.1 4.58856 21.1C4.81064 21.1 5.02171 21.0033 5.16681 20.8352L10.3263 14.8572L14.2808 20.6222C14.486 20.9213 14.8253 21.1 15.1879 21.1H18.1375C19.0226 21.1 19.5453 20.1077 19.0446 19.3778L13.4562 11.2308L18.6936 5.16264C19.1207 4.66779 18.7691 3.89999 18.1154 3.89999C17.8934 3.89999 17.6824 3.99661 17.5373 4.16469L12.5627 9.92825L8.7554 4.37777C8.55027 4.07872 8.21093 3.89999 7.8483 3.89999H4.89876ZM15.1919 19.0924L5.8798 5.51666H7.10218C7.39889 5.51666 7.67653 5.6629 7.84436 5.90757L17.1564 19.4833H15.934C15.6373 19.4833 15.3597 19.3371 15.1919 19.0924Z' /></svg>",
      icon_id: 2
    },
    {
      name: "instagram",
      link: "#",
      opens_in_new_tab: false,
      icon: "<svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'><path fill-rule='evenodd' clip-rule='evenodd' d='M8 4.75C6.20507 4.75 4.75 6.20507 4.75 8V16C4.75 17.7949 6.20507 19.25 8 19.25H16C17.7949 19.25 19.25 17.7949 19.25 16V8C19.25 6.20507 17.7949 4.75 16 4.75H8ZM3.25 8C3.25 5.37665 5.37665 3.25 8 3.25H16C18.6234 3.25 20.75 5.37665 20.75 8V16C20.75 18.6234 18.6234 20.75 16 20.75H8C5.37665 20.75 3.25 18.6234 3.25 16V8ZM15.65 7.6C15.65 7.18579 15.9858 6.85 16.4 6.85H16.408C16.8222 6.85 17.158 7.18579 17.158 7.6C17.158 8.01421 16.8222 8.35 16.408 8.35H16.4C15.9858 8.35 15.65 8.01421 15.65 7.6ZM12.394 9.54189C11.8842 9.4663 11.3636 9.55337 10.9062 9.79071C10.4488 10.0281 10.0779 10.4036 9.84619 10.8639C9.6145 11.3242 9.53386 11.8458 9.61573 12.3546C9.6976 12.8634 9.93781 13.3334 10.3022 13.6978C10.6666 14.0622 11.1366 14.3024 11.6454 14.3843C12.1542 14.4661 12.6758 14.3855 13.1361 14.1538C13.5964 13.9221 13.9719 13.5512 14.2093 13.0938C14.4466 12.6364 14.5337 12.1158 14.4581 11.606C14.381 11.086 14.1387 10.6047 13.767 10.233C13.3953 9.86128 12.914 9.61899 12.394 9.54189ZM10.2154 8.45928C10.9528 8.07662 11.7922 7.93624 12.614 8.05811C13.4523 8.18242 14.2284 8.57306 14.8277 9.17232C15.4269 9.77157 15.8176 10.5477 15.9419 11.386C16.0638 12.2078 15.9234 13.0472 15.5407 13.7846C15.1581 14.5221 14.5526 15.1201 13.8105 15.4937C13.0684 15.8672 12.2274 15.9972 11.4071 15.8652C10.5868 15.7332 9.82903 15.3459 9.24154 14.7585C8.65406 14.171 8.26677 13.4132 8.13478 12.5929C8.00279 11.7726 8.1328 10.9316 8.50633 10.1895C8.87987 9.44738 9.4779 8.84193 10.2154 8.45928Z' /></svg>",
      icon_id: 3
    },
    {
      name: "linkedIn",
      link: "#",
      opens_in_new_tab: false,
      icon: "<svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'><path fill-rule='evenodd' clip-rule='evenodd' d='M5.2 4.75C4.66872 4.75 4.25 5.17484 4.25 5.68421C4.25 6.19358 4.66872 6.61842 5.2 6.61842C5.73128 6.61842 6.15 6.19358 6.15 5.68421C6.15 5.17484 5.73128 4.75 5.2 4.75ZM2.75 5.68421C2.75 4.33325 3.85352 3.25 5.2 3.25C6.54648 3.25 7.65 4.33325 7.65 5.68421C7.65 7.03517 6.54648 8.11842 5.2 8.11842C3.85352 8.11842 2.75 7.03517 2.75 5.68421ZM15.4 9.80263C14.2441 9.80263 13.1369 10.2576 12.3216 11.0653C11.5066 11.8728 11.05 12.9664 11.05 14.1053V19.25H12.95V14.1053C12.95 13.4574 13.2098 12.8375 13.6701 12.3815C14.1301 11.9258 14.7525 11.6711 15.4 11.6711C16.0475 11.6711 16.6699 11.9258 17.1299 12.3815C17.5902 12.8375 17.85 13.4574 17.85 14.1053V19.25H19.75V14.1053C19.75 12.9664 19.2934 11.8728 18.4784 11.0653C17.6631 10.2576 16.5559 9.80263 15.4 9.80263ZM11.2659 9.99971C12.3635 8.91229 13.8507 8.30263 15.4 8.30263C16.9493 8.30263 18.4365 8.91229 19.5341 9.99971C20.6319 11.0874 21.25 12.564 21.25 14.1053V20C21.25 20.4142 20.9142 20.75 20.5 20.75H17.1C16.6858 20.75 16.35 20.4142 16.35 20V14.1053C16.35 13.8598 16.2516 13.6229 16.0742 13.4471C15.8966 13.2712 15.6542 13.1711 15.4 13.1711C15.1458 13.1711 14.9034 13.2712 14.7258 13.4471C14.5484 13.6229 14.45 13.8598 14.45 14.1053V20C14.45 20.4142 14.1142 20.75 13.7 20.75H10.3C9.88579 20.75 9.55 20.4142 9.55 20V14.1053C9.55 12.564 10.1681 11.0874 11.2659 9.99971ZM2.75 9.89474C2.75 9.48052 3.08579 9.14474 3.5 9.14474H6.9C7.31421 9.14474 7.65 9.48052 7.65 9.89474V20C7.65 20.4142 7.31421 20.75 6.9 20.75H3.5C3.08579 20.75 2.75 20.4142 2.75 20V9.89474ZM4.25 10.6447V19.25H6.15V10.6447H4.25Z' /></svg>",
      icon_id: 4
    },
    {
      name: "threads",
      link: "#",
      opens_in_new_tab: false,
      icon: "<svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M15.8286 11.4157C15.7597 11.3827 15.6897 11.3509 15.6188 11.3204C15.4953 9.04485 14.2519 7.74208 12.164 7.72875C12.1546 7.72869 12.1451 7.72869 12.1357 7.72869C10.8869 7.72869 9.84828 8.26174 9.20902 9.23173L10.3573 10.0194C10.8348 9.29486 11.5843 9.1404 12.1362 9.1404C12.1426 9.1404 12.149 9.1404 12.1553 9.14046C12.8428 9.14484 13.3615 9.34472 13.6973 9.7345C13.9416 10.0183 14.105 10.4104 14.1859 10.9053C13.5764 10.8017 12.9173 10.7699 12.2126 10.8103C10.2276 10.9246 8.95145 12.0823 9.03715 13.691C9.08065 14.507 9.48716 15.209 10.1818 15.6676C10.7691 16.0553 11.5254 16.2448 12.3115 16.2019C13.3497 16.145 14.1641 15.7489 14.7323 15.0247C15.1638 14.4747 15.4367 13.7619 15.5572 12.8638C16.0519 13.1624 16.4186 13.5553 16.6211 14.0277C16.9654 14.8306 16.9855 16.15 15.9089 17.2257C14.9657 18.168 13.8319 18.5757 12.1183 18.5883C10.2175 18.5742 8.78 17.9646 7.84536 16.7764C6.97015 15.6638 6.51783 14.0568 6.50095 12C6.51783 9.94315 6.97015 8.33613 7.84536 7.22356C8.78 6.03541 10.2175 5.42583 12.1183 5.41171C14.0329 5.42594 15.4954 6.03845 16.4659 7.23233C16.9417 7.8178 17.3004 8.55407 17.5369 9.41253L18.8825 9.05352C18.5959 7.99685 18.1448 7.08631 17.5309 6.33117C16.2869 4.80056 14.4674 4.01626 12.123 4H12.1136C9.77399 4.01621 7.97486 4.80348 6.76621 6.33994C5.69068 7.7072 5.13589 9.60964 5.11725 11.9944L5.11719 12L5.11725 12.0056C5.13589 14.3903 5.69068 16.2928 6.76621 17.6601C7.97486 19.1965 9.77399 19.9838 12.1136 20H12.123C14.203 19.9856 15.6692 19.441 16.877 18.2343C18.4573 16.6555 18.4097 14.6766 17.8889 13.4618C17.5152 12.5906 16.8028 11.883 15.8286 11.4157ZM12.2372 14.7923C11.3672 14.8413 10.4634 14.4508 10.4188 13.6143C10.3858 12.9942 10.8602 12.3022 12.2906 12.2197C12.4544 12.2103 12.6152 12.2057 12.7731 12.2057C13.2927 12.2057 13.7788 12.2561 14.2207 12.3528C14.0559 14.4113 13.089 14.7455 12.2372 14.7923Z'  /></svg>",
      icon_id: 5
    }
  ]
};
const footer = {
  logo: {
    url: null,
    type: "FooterLogo",
    caption: "",
    display: "actual-size",
    alt_text: "Logo",
    asset_id: null,
    link_url: "",
    set_ratio: 1,
    cropped_width: null,
    cropped_height: null,
    action_on_click: "no_action",
    image_alignment: "left",
    preferred_width: null,
    preferred_height: null,
    caption_alignment: "center",
    open_link_in_new_tab: false
  },
  columns: [
    {
      items: [],
      header: "Find Us",
      hasHeader: true,
      showSchools: true
    },
    {
      items: [],
      header: "Schools",
      hasHeader: true,
      showSchools: true
    },
    {
      items: [
        {
          content: "School Calendar",
          email_address: "",
          mailto: false,
          opens_in_new_tab: false,
          type: "FooterLink",
          url: "#"
        },
        {
          content: "Home Access Center",
          email_address: "",
          mailto: false,
          opens_in_new_tab: false,
          type: "FooterLink",
          url: "#"
        },
        {
          content: "Campus Information",
          email_address: "",
          mailto: false,
          opens_in_new_tab: false,
          type: "FooterLink",
          url: "#"
        },
        {
          content: "Handbook Policies",
          email_address: "",
          mailto: false,
          opens_in_new_tab: false,
          type: "FooterLink",
          url: "#"
        },
        {
          content: "Required Documents",
          email_address: "",
          mailto: false,
          opens_in_new_tab: false,
          type: "FooterLink",
          url: "#"
        }
      ],
      header: "Quick Links",
      hasHeader: true,
      showSchools: true
    },
    {
      items: [
        {
          content: "Live Feed",
          email_address: "",
          mailto: false,
          opens_in_new_tab: false,
          type: "FooterLink",
          url: "#"
        },
        {
          content: "Faculty and Staff",
          email_address: "",
          mailto: false,
          opens_in_new_tab: false,
          type: "FooterLink",
          url: "#"
        },
        {
          content: "News",
          email_address: "",
          mailto: false,
          opens_in_new_tab: false,
          type: "FooterLink",
          url: "#"
        },
        {
          content: "Events",
          email_address: "",
          mailto: false,
          opens_in_new_tab: false,
          type: "FooterLink",
          url: "#"
        },
        {
          content: "Documents",
          email_address: "",
          mailto: false,
          opens_in_new_tab: false,
          type: "FooterLink",
          url: "#"
        }
      ],
      header: "Menu",
      hasHeader: true,
      showSchools: true
    }
  ],
  hasLogo: true,
  hasSocial: true,
  hasApps: true,
  twitter: "https://twitter.com/test",
  youtube: "https://youtube.com/test",
  facebook: "https://facebook.com/test",
  instagram: "https://instagram.com/test",
  additionalText: "",
  hasAdditionalText: false,
  organization_info: {
    zip: "",
    city: "",
    name: "",
    state: "",
    address: ""
  }
};
const programs = {
  preview_id: {
    content: [
      {
        link: {},
        image: {
          url: "https://d2kzwze52p8717.cloudfront.net/arts.png",
          alt_text: "Alt text for image"
        },
        title: "Arts",
        headline: "We are creative",
        description: "This is how the programs section looks on hover. More information can be added here..."
      },
      {
        link: {},
        image: {
          url: "https://d2kzwze52p8717.cloudfront.net/athletics.png",
          alt_text: "Alt text for image"
        },
        title: "Athletics",
        headline: "We make a difference",
        description: "This is how the programs section looks on hover. More information can be added here..."
      },
      {
        link: {},
        image: {
          url: "https://d2kzwze52p8717.cloudfront.net/health.png",
          alt_text: "Alt text for image"
        },
        title: "Health",
        headline: "We discover new ways",
        description: "This is how the programs section looks on hover. More information can be added here..."
      },
      {
        link: {},
        image: {
          url: "https://d2kzwze52p8717.cloudfront.net/education.png",
          alt_text: "Alt text for image"
        },
        title: "Education",
        headline: "We explore new worlds",
        description: "This is how the programs section looks on hover. More information can be added here..."
      },
      {
        link: {},
        image: {
          url: "https://d2kzwze52p8717.cloudfront.net/computer_science.png",
          alt_text: "Alt text for image"
        },
        title: "Computer Science",
        headline: "We are creative",
        description: "This is how the programs section looks on hover. More information can be added here..."
      },
      {
        link: {},
        image: {
          url: "https://d2kzwze52p8717.cloudfront.net/business.png",
          alt_text: "Alt text for image"
        },
        title: "Business",
        headline: "We make a difference",
        description: "This is how the programs section looks on hover. More information can be added here..."
      },
      {
        link: {},
        image: {
          url: "https://d2kzwze52p8717.cloudfront.net/journalism.png",
          alt_text: "Alt text for image"
        },
        title: "Journalism",
        headline: "We discover new ways",
        description: "This is how the programs section looks on hover. More information can be added here..."
      },
      {
        link: {},
        image: {
          url: "https://d2kzwze52p8717.cloudfront.net/law.png",
          alt_text: "Alt text for image"
        },
        title: "Law",
        headline: "We explore new worlds",
        description: "This is how the programs section looks on hover. More information can be added here..."
      }
    ],
    num_columns: 4,
    read_more_link: true,
    has_header: true,
    has_snippet: true,
    component_header: "Programs",
    component_header_top: "Choose from our",
    component_header_description: "To meet the needs of students, families can choose between one of our variety of programs and activities",
    details_on_hover: true,
    see_all: true,
    slider: true,
    see_all_link: {
      url: "/programs",
      name: "See All Programs",
      opens_in_new_tab: true
    }
  }
};
const our_schools = {
  preview_id: {
    content: [
      {
        box: "Pre-K",
        icon: "<svg viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg'><path d='M0 21.7947C0 21.8383 0.0048 21.8801 0.00624 21.9233V21.666C0.0048 21.7087 0 21.751 0 21.7947Z'></path><path d='M14.4595 19.5275C15.3797 19.5275 16.1256 18.7815 16.1256 17.8614C16.1256 16.9412 15.3797 16.1953 14.4595 16.1953C13.5394 16.1953 12.7935 16.9412 12.7935 17.8614C12.7935 18.7815 13.5394 19.5275 14.4595 19.5275Z'></path><path d='M32.8373 26.1663C33.733 25.9561 34.2883 25.0594 34.0786 24.1628C33.8693 23.2681 32.9722 22.7117 32.077 22.921C31.1813 23.1313 30.6245 24.0284 30.8343 24.9231C31.0445 25.8193 31.9407 26.3761 32.8373 26.1663Z'></path><path d='M43.333 38.3328C41.1298 38.3328 38.4893 35.8478 35.6942 33.217C35.389 32.9299 35.0798 32.6395 34.7678 32.3477L33.8174 28.2898C33.5923 27.3264 32.629 26.7302 31.668 26.9554C30.8904 27.1373 30.36 27.8006 30.2995 28.5562C27.5126 26.5214 24.3787 24.9998 20.6664 24.9998V9L9.99984 3L0 9V24.9998V30.3331V45H2.00016V42.3331H8.66736V45H10.6675V42.3331H18.6677V45H20.6678V30.3331V29.0002C25.3795 29.0002 29.2301 32.6246 32.9539 36.1296C36.3437 39.3202 39.5443 42.3336 43.3339 42.3336H44.0011V45H46.0008V42.3331H48V38.3328H43.333ZM8.66688 41.0002H2.00016V38.3328H8.66736V41.0002H8.66688ZM8.66688 36.9998H2.00016V34.333H8.66736V36.9998H8.66688ZM8.66688 33H2.00016V30.3331H8.66736V33H8.66688ZM18.6667 24.9998H16.6142L15.8198 21.6086C15.5947 20.6458 14.6323 20.0491 13.6704 20.2752C12.708 20.5003 12.1104 21.4627 12.336 22.4251L12.9389 24.9998H2.00016V10.333H18.6672V24.9998H18.6667Z'></path></svg>",
        image: {
          url: "https://d2kzwze52p8717.cloudfront.net/arts.png",
          alt_text: "Alt text for image"
        },
        link: {}
      },
      {
        box: "Elementary",
        icon: "<svg viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg'><path d='M9.88157 8.46963C9.88157 12.2365 4.23267 12.2365 4.23267 8.46963C4.23267 4.70544 9.88157 4.70544 9.88157 8.46963Z'></path><path d='M28.2342 9.88372C28.2342 13.6479 22.5879 13.6479 22.5879 9.88372C22.5879 6.11688 28.2342 6.11688 28.2342 9.88372Z'></path><path d='M44.4688 20.4719C44.4688 23.2937 40.2334 23.2937 40.2334 20.4719C40.2334 17.6474 44.4688 17.6474 44.4688 20.4719Z'></path><path d='M9.88163 12.7051H4.23537C1.83443 12.7051 0 14.5395 0 16.9405V25.4112H2.82449V42.3527H5.64897V29.6466H8.47346V42.3527H11.2979L11.2927 25.4112H14.1171V16.9405C14.1171 14.5421 12.2801 12.7051 9.88176 12.7051H9.88163Z'></path><path d='M32.4694 32.4715L29.6449 17.6477C29.3616 15.6703 27.5272 14.1191 25.4095 14.1191C23.2918 14.1191 21.5977 15.673 21.1741 17.6477L18.3523 32.4715H21.1768V42.3532H24.0013V32.4715H26.8231V42.3532H29.6476V32.4715H32.4694Z'></path><path d='M43.7647 24H40.9402C38.5393 24 36.7048 25.8344 36.7048 28.2354V32.4707H39.5293V42.3524H45.1756V32.4707H48.0001V28.2354C48.0001 25.8344 46.163 24 43.7647 24Z'></path></svg>",
        image: {
          url: "https://d2kzwze52p8717.cloudfront.net/athletics.png",
          alt_text: "Alt text for image"
        },
        link: {
          href: "http://apptegy.com",
          name: "Apptegy",
          target: "_self"
        }
      },
      {
        box: "Middle School",
        icon: "<svg viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg'><path d='M35.9061 44.8493H35.1765C34.7512 44.364 34.5928 43.7568 34.7205 43.0075C34.9336 41.772 35.814 40.7467 36.2335 40.5979L36.2272 40.5864C36.8229 40.3718 37.266 39.7943 37.266 39.1127L37.2962 6.78552C37.2962 5.91911 36.5973 5.21303 35.7468 5.20727C35.7468 5.20727 29.2758 5.20151 27.5022 5.18855C27.508 3.66502 27.5133 1.57605 27.5133 1.57605C27.5133 0.938121 27.1432 0.366918 26.5595 0.121636C25.9773 -0.124125 25.3144 0.0107557 24.8651 0.451878L14.0377 11.3177C12.1364 13.2286 10.6359 16.8397 10.6296 19.5555L10.5447 42.1708C10.5389 45.3345 13.0781 47.9261 16.2202 47.939L35.9004 48C36.7562 48 37.4551 47.2934 37.4551 46.4333V46.428C37.4546 45.5544 36.7687 44.855 35.9061 44.8493ZM34.1795 8.35176C34.1795 11.0484 34.1555 34.8378 34.1498 37.5403H16.4142L27.52 28.1303L27.497 8.33928C28.505 8.34505 33.2445 8.35176 34.1795 8.35176ZM13.6556 42.1771C13.6556 42.1771 13.6613 40.8753 13.6613 40.6848H32.2355C31.9682 41.256 31.7555 41.8579 31.6523 42.4665C31.5064 43.3075 31.5794 44.0937 31.7671 44.8368L16.2308 44.7873C14.81 44.7873 13.6556 43.6205 13.6556 42.1771Z'></path></svg>",
        image: {
          url: "https://d2kzwze52p8717.cloudfront.net/health.png",
          alt_text: "Alt text for image"
        },
        link: {
          href: "http://apptegy.com",
          name: "Apptegy",
          target: "_self"
        }
      },
      {
        box: "High School",
        icon: "<svg viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg'><path d='M11.3332 21.3333H14.0001V40.0001H17.9999V24.0002H21.9998V40.0001H25.9996V24.0002H30V40.0001H33.9998V21.3333H36.6667C37.403 21.3333 38.0001 20.7367 38.0001 20.0003C38.0001 19.5554 37.7798 19.1642 37.4452 18.9223L37.4462 18.9194L37.427 18.9064C37.4155 18.8987 37.4035 18.8915 37.392 18.8839L24.6667 11.7098V9.60833C27.0163 10.7843 28.9507 8.75825 32.0001 9.97697V5.33344C28.9502 4.11472 27.0158 6.14032 24.6667 4.9648V4.66672C24.6667 4.29808 24.3681 4 23.9999 4C23.6318 4 23.3332 4.29808 23.3332 4.66672V11.7098L10.6079 18.8834C10.5964 18.8911 10.5844 18.8983 10.5729 18.9059L10.5542 18.9189L10.5546 18.9218C10.2201 19.1637 10.0002 19.5549 10.0002 19.9999C9.99976 20.7367 10.5969 21.3333 11.3332 21.3333Z'></path><path d='M12.6666 41.334L9.99976 44.0004H38.0001L35.3332 41.334H12.6666Z'></path><path d='M35.3333 22.666V39.9993H35.8853L36.2755 40.39L38.9424 43.0569L39.8851 43.9996H48V22.666H35.3333ZM40.667 36.6657H38.0001V32.6659H40.667V36.6657ZM40.667 29.9995H38.0001V25.9996H40.667V29.9995ZM45.3331 36.6657H42.6662V32.6659H45.3331V36.6657ZM45.3331 29.9995H42.6662V25.9996H45.3331V29.9995Z'></path><path d='M12.1147 40.0008H12.6667V22.668H0V44.0011H8.11441L9.05713 43.0584L11.724 40.3915L12.1147 40.0008ZM5.33329 36.6672H2.66688V32.6673H5.33377V36.6672H5.33329ZM5.33329 30.0009H2.66688V26.0011H5.33377V30.0009H5.33329ZM9.99986 36.6672H7.33297V32.6673H9.99986V36.6672ZM9.99986 30.0009H7.33297V26.0011H9.99986V30.0009Z'></path></svg>",
        image: {
          url: "https://d2kzwze52p8717.cloudfront.net/education.png",
          alt_text: "Alt text for image"
        },
        link: {
          href: "http://apptegy.com",
          name: "Apptegy",
          target: "_self"
        }
      },
      {
        box: "Steam",
        icon: "<svg viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg'><path d='M36.2057 24C37.9876 21.5316 39.0855 18.3767 39.0855 15.0855C39.0855 6.72127 32.3669 0 24 0C15.6358 0 8.91455 6.71863 8.91455 15.0855C8.91455 18.3767 10.0125 21.5316 11.7943 24L11.9306 24.1363C12.2057 24.5477 12.6172 24.9591 12.8897 25.3705C14.8104 27.7026 18.513 32.7756 18.513 37.0259H29.4845C29.4845 32.7756 33.1871 27.7 35.1078 25.3705C35.5192 24.9591 35.7944 24.5477 36.0669 24.1363C36.0669 24.1388 36.2057 24 36.2057 24H36.2057Z'></path><path d='M18.5156 39.7715H29.4871V42.515H18.5156V39.7715Z'></path><path d='M18.5156 45.2559H29.4871V47.9994H18.5156V45.2559Z'></path></svg>",
        image: {
          url: "https://d2kzwze52p8717.cloudfront.net/computer_science.png",
          alt_text: "Alt text for image"
        },
        link: {
          href: "http://apptegy.com",
          name: "Apptegy",
          target: "_self"
        }
      }
    ],
    has_description: true,
    component_header: "Our Schools",
    component_header_top: "These Are",
    component_header_description: "We are a dynamic and innovative school with a strong commitment to teaching, learning and research."
  }
};
const spotlights = {
  preview_id: {
    show_slider: true,
    show_name: true,
    show_icons: true,
    show_tab_labels: true,
    component_header: "Spotlight",
    component_header_top: "View our",
    content: [
      {
        id: 97314,
        author_id: 26213,
        quote: "Several students earned recognition at the recent Young Artist Association Spring Competition and Convention. The Young Artist Association is a statewide organization of high school students that offers students a unique opportunity.",
        author: "Edgar M.",
        role: "Student",
        image: {
          url: "https://d2kzwze52p8717.cloudfront.net/spotlight/face-1.jpg",
          alt_text: "alt_text"
        },
        link: {
          name: "Apptegy",
          href: "http://apptegy.com",
          target: "_blank"
        }
      },
      {
        id: 97315,
        author_id: 26214,
        quote: "Several students earned recognition at the recent Young Artist Association Spring Competition and Convention. The Young Artist Association is a statewide organization of high school students that offers students a unique opportunity.",
        author: "Nina Mercado",
        role: "Student",
        image: {
          url: "https://d2kzwze52p8717.cloudfront.net/spotlight/face-2.jpg",
          alt_text: "alt_text"
        },
        link: {
          name: "Apptegy",
          href: "http://apptegy.com",
          target: "_blank"
        }
      },
      {
        id: 97316,
        author_id: 26215,
        quote: "Several students earned recognition at the recent Young Artist Association Spring Competition and Convention. The Young Artist Association is a statewide organization of high school students that offers students a unique opportunity.",
        author: "Ussama Azam",
        role: "Student",
        image: {
          url: "https://d2kzwze52p8717.cloudfront.net/spotlight/face-3.jpg",
          alt_text: "alt_text"
        },
        link: {
          name: "Apptegy",
          href: "http://apptegy.com",
          target: "_blank"
        }
      },
      {
        id: 97317,
        author_id: 26212,
        quote: "Several students from the Arkansas School for Mathematics, Sciences and the Arts earned recognition at the recent Arkansas Young Artist Association Spring Competition. Sciences and the Arts and the Lakeside School District are offering their students a unique.",
        author: "Sir Sam Sung 3",
        role: "Student",
        image: {
          url: "https://d2kzwze52p8717.cloudfront.net/gallery.png",
          alt_text: "alt_text"
        },
        link: {
          name: "Apptegy",
          href: "http://apptegy.com",
          target: "_blank"
        }
      },
      {
        id: 97318,
        author_id: 26212,
        quote: "Several students from the Arkansas School for Mathematics, Sciences and the Arts earned recognition at the recent Arkansas Young Artist Association Spring Competition. Sciences and the Arts and the Lakeside School District are offering their students a unique.",
        author: "Sir Sam Sung 4",
        role: "Student",
        image: {
          url: "https://d2kzwze52p8717.cloudfront.net/gallery.png",
          alt_text: "alt_text"
        },
        link: {
          name: "Apptegy",
          href: "http://apptegy.com",
          target: "_blank"
        }
      },
      {
        id: 97319,
        author_id: 26214,
        quote: "Several students earned recognition at the recent Young Artist Association Spring Competition and Convention. The Young Artist Association is a statewide organization of high school students that offers students a unique opportunity.",
        author: "Edgar M. A.",
        role: "Student",
        image: {
          url: "https://d2kzwze52p8717.cloudfront.net/spotlight/face-1.jpg",
          alt_text: "alt_text"
        },
        link: {
          name: "Apptegy",
          href: "http://apptegy.com",
          target: "_blank"
        }
      }
    ],
    nested_content: [
      {
        cards: [
          {
            icon: "<svg data-name='Layer 1' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 48 48.1'><path d='M48 30.9657C48 32.6177 46.654 33.9618 45 33.9618C43.346 33.9618 42 32.6177 42 30.9657C42 29.6647 42.839 28.5667 44 28.1528V15.7347L36.959 19.8908C36.974 19.9578 37 20.0208 37 20.0918V36.0747C37 36.6117 36.575 37.0407 36.044 37.0647C34.595 37.7947 29.741 39.9557 23 39.9557C16.259 39.9557 11.404 37.7947 9.956 37.0647C9.425 37.0407 9 36.6117 9 36.0747V20.0918C9 20.0208 9.026 19.9578 9.041 19.8908L0.491 14.8438C0.186 14.6648 0 14.3367 0 13.9837C0 13.6317 0.186 13.3037 0.491 13.1247L22.492 0.13875C22.807 -0.04625 23.195 -0.04625 23.51 0.13875L45.51 13.1247C45.913 13.1847 46 13.4688 46 13.9587V13.9808C46 13.9818 46.001 13.9827 46.001 13.9837C46.001 13.9857 46 13.9867 46 13.9878V28.1528C47.162 28.5667 48 29.6647 48 30.9657ZM35 35.3498V21.0478L23.51 27.8298C23.352 27.9217 23.177 27.9688 23.001 27.9688C22.825 27.9688 22.649 27.9217 22.492 27.8298L11 21.0468V35.3498C12.452 36.0518 16.951 37.9577 23 37.9577C29.048 37.9577 33.548 36.0518 35 35.3498ZM23.001 2.15875L2.966 13.9837L23.001 25.8098L43.035 13.9837L23.001 2.15875ZM45.419 30.0658C45.397 30.0678 45.386 30.0818 45.362 30.0818C45.224 30.0818 45.07 30.0458 44.916 29.9838C44.405 30.0288 44 30.4447 44 30.9657C44 31.5157 44.448 31.9648 45 31.9648C45.552 31.9648 46 31.5157 46 30.9657C46 30.5658 45.76 30.2248 45.419 30.0658Z'/></svg>",
            image: {
              url: "https://d2kzwze52p8717.cloudfront.net/spotlight/face-1.jpg",
              alt_text: "alt_text"
            },
            name: "Edgar M.",
            role: "Student",
            snippet: "Several students from the Arkansas School for Mathematics, Sciences and the Arts earned recognition at the recent Arkansas Young Artist Association Spring Competition. Sciences and the Arts and the Lakeside School District are offering their students a unique."
          },
          {
            icon: "<svg data-name='Layer 1' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 48 48.1'><path d='M48 30.9657C48 32.6177 46.654 33.9618 45 33.9618C43.346 33.9618 42 32.6177 42 30.9657C42 29.6647 42.839 28.5667 44 28.1528V15.7347L36.959 19.8908C36.974 19.9578 37 20.0208 37 20.0918V36.0747C37 36.6117 36.575 37.0407 36.044 37.0647C34.595 37.7947 29.741 39.9557 23 39.9557C16.259 39.9557 11.404 37.7947 9.956 37.0647C9.425 37.0407 9 36.6117 9 36.0747V20.0918C9 20.0208 9.026 19.9578 9.041 19.8908L0.491 14.8438C0.186 14.6648 0 14.3367 0 13.9837C0 13.6317 0.186 13.3037 0.491 13.1247L22.492 0.13875C22.807 -0.04625 23.195 -0.04625 23.51 0.13875L45.51 13.1247C45.913 13.1847 46 13.4688 46 13.9587V13.9808C46 13.9818 46.001 13.9827 46.001 13.9837C46.001 13.9857 46 13.9867 46 13.9878V28.1528C47.162 28.5667 48 29.6647 48 30.9657ZM35 35.3498V21.0478L23.51 27.8298C23.352 27.9217 23.177 27.9688 23.001 27.9688C22.825 27.9688 22.649 27.9217 22.492 27.8298L11 21.0468V35.3498C12.452 36.0518 16.951 37.9577 23 37.9577C29.048 37.9577 33.548 36.0518 35 35.3498ZM23.001 2.15875L2.966 13.9837L23.001 25.8098L43.035 13.9837L23.001 2.15875ZM45.419 30.0658C45.397 30.0678 45.386 30.0818 45.362 30.0818C45.224 30.0818 45.07 30.0458 44.916 29.9838C44.405 30.0288 44 30.4447 44 30.9657C44 31.5157 44.448 31.9648 45 31.9648C45.552 31.9648 46 31.5157 46 30.9657C46 30.5658 45.76 30.2248 45.419 30.0658Z'/></svg>",
            image: {
              url: "https://d2kzwze52p8717.cloudfront.net/spotlight/face-2.jpg",
              alt_text: "alt_text"
            },
            name: "Nina Mercado",
            role: "student",
            snippet: "Several students from the Arkansas School for Mathematics, Sciences and the Arts earned recognition at the recent Arkansas Young Artist Association Spring Competition. Sciences and the Arts and the Lakeside School District are offering their students a unique."
          },
          {
            icon: "<svg data-name='Layer 1' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 48 48.1'><path d='M48 30.9657C48 32.6177 46.654 33.9618 45 33.9618C43.346 33.9618 42 32.6177 42 30.9657C42 29.6647 42.839 28.5667 44 28.1528V15.7347L36.959 19.8908C36.974 19.9578 37 20.0208 37 20.0918V36.0747C37 36.6117 36.575 37.0407 36.044 37.0647C34.595 37.7947 29.741 39.9557 23 39.9557C16.259 39.9557 11.404 37.7947 9.956 37.0647C9.425 37.0407 9 36.6117 9 36.0747V20.0918C9 20.0208 9.026 19.9578 9.041 19.8908L0.491 14.8438C0.186 14.6648 0 14.3367 0 13.9837C0 13.6317 0.186 13.3037 0.491 13.1247L22.492 0.13875C22.807 -0.04625 23.195 -0.04625 23.51 0.13875L45.51 13.1247C45.913 13.1847 46 13.4688 46 13.9587V13.9808C46 13.9818 46.001 13.9827 46.001 13.9837C46.001 13.9857 46 13.9867 46 13.9878V28.1528C47.162 28.5667 48 29.6647 48 30.9657ZM35 35.3498V21.0478L23.51 27.8298C23.352 27.9217 23.177 27.9688 23.001 27.9688C22.825 27.9688 22.649 27.9217 22.492 27.8298L11 21.0468V35.3498C12.452 36.0518 16.951 37.9577 23 37.9577C29.048 37.9577 33.548 36.0518 35 35.3498ZM23.001 2.15875L2.966 13.9837L23.001 25.8098L43.035 13.9837L23.001 2.15875ZM45.419 30.0658C45.397 30.0678 45.386 30.0818 45.362 30.0818C45.224 30.0818 45.07 30.0458 44.916 29.9838C44.405 30.0288 44 30.4447 44 30.9657C44 31.5157 44.448 31.9648 45 31.9648C45.552 31.9648 46 31.5157 46 30.9657C46 30.5658 45.76 30.2248 45.419 30.0658Z'/></svg>",
            image: {
              url: "https://d2kzwze52p8717.cloudfront.net/spotlight/face-3.jpg",
              alt_text: "alt_text"
            },
            name: "Ussama Azam",
            role: "Student",
            snippet: "Several students from the Arkansas School for Mathematics, Sciences and the Arts earned recognition at the recent Arkansas Young Artist Association Spring Competition. Sciences and the Arts and the Lakeside School District are offering their students a unique."
          },
          {
            icon: "<svg data-name='Layer 1' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 48 48.1'><path d='M48 30.9657C48 32.6177 46.654 33.9618 45 33.9618C43.346 33.9618 42 32.6177 42 30.9657C42 29.6647 42.839 28.5667 44 28.1528V15.7347L36.959 19.8908C36.974 19.9578 37 20.0208 37 20.0918V36.0747C37 36.6117 36.575 37.0407 36.044 37.0647C34.595 37.7947 29.741 39.9557 23 39.9557C16.259 39.9557 11.404 37.7947 9.956 37.0647C9.425 37.0407 9 36.6117 9 36.0747V20.0918C9 20.0208 9.026 19.9578 9.041 19.8908L0.491 14.8438C0.186 14.6648 0 14.3367 0 13.9837C0 13.6317 0.186 13.3037 0.491 13.1247L22.492 0.13875C22.807 -0.04625 23.195 -0.04625 23.51 0.13875L45.51 13.1247C45.913 13.1847 46 13.4688 46 13.9587V13.9808C46 13.9818 46.001 13.9827 46.001 13.9837C46.001 13.9857 46 13.9867 46 13.9878V28.1528C47.162 28.5667 48 29.6647 48 30.9657ZM35 35.3498V21.0478L23.51 27.8298C23.352 27.9217 23.177 27.9688 23.001 27.9688C22.825 27.9688 22.649 27.9217 22.492 27.8298L11 21.0468V35.3498C12.452 36.0518 16.951 37.9577 23 37.9577C29.048 37.9577 33.548 36.0518 35 35.3498ZM23.001 2.15875L2.966 13.9837L23.001 25.8098L43.035 13.9837L23.001 2.15875ZM45.419 30.0658C45.397 30.0678 45.386 30.0818 45.362 30.0818C45.224 30.0818 45.07 30.0458 44.916 29.9838C44.405 30.0288 44 30.4447 44 30.9657C44 31.5157 44.448 31.9648 45 31.9648C45.552 31.9648 46 31.5157 46 30.9657C46 30.5658 45.76 30.2248 45.419 30.0658Z'/></svg>",
            image: {
              url: "https://d2kzwze52p8717.cloudfront.net/spotlight/face-1.jpg",
              alt_text: "alt_text"
            },
            name: "Edgar M.",
            role: "Student",
            snippet: "Several students from the Arkansas School for Mathematics, Sciences and the Arts earned recognition at the recent Arkansas Young Artist Association Spring Competition. Sciences and the Arts and the Lakeside School District are offering their students a unique."
          },
          {
            icon: "<svg data-name='Layer 1' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 48 48.1'><path d='M48 30.9657C48 32.6177 46.654 33.9618 45 33.9618C43.346 33.9618 42 32.6177 42 30.9657C42 29.6647 42.839 28.5667 44 28.1528V15.7347L36.959 19.8908C36.974 19.9578 37 20.0208 37 20.0918V36.0747C37 36.6117 36.575 37.0407 36.044 37.0647C34.595 37.7947 29.741 39.9557 23 39.9557C16.259 39.9557 11.404 37.7947 9.956 37.0647C9.425 37.0407 9 36.6117 9 36.0747V20.0918C9 20.0208 9.026 19.9578 9.041 19.8908L0.491 14.8438C0.186 14.6648 0 14.3367 0 13.9837C0 13.6317 0.186 13.3037 0.491 13.1247L22.492 0.13875C22.807 -0.04625 23.195 -0.04625 23.51 0.13875L45.51 13.1247C45.913 13.1847 46 13.4688 46 13.9587V13.9808C46 13.9818 46.001 13.9827 46.001 13.9837C46.001 13.9857 46 13.9867 46 13.9878V28.1528C47.162 28.5667 48 29.6647 48 30.9657ZM35 35.3498V21.0478L23.51 27.8298C23.352 27.9217 23.177 27.9688 23.001 27.9688C22.825 27.9688 22.649 27.9217 22.492 27.8298L11 21.0468V35.3498C12.452 36.0518 16.951 37.9577 23 37.9577C29.048 37.9577 33.548 36.0518 35 35.3498ZM23.001 2.15875L2.966 13.9837L23.001 25.8098L43.035 13.9837L23.001 2.15875ZM45.419 30.0658C45.397 30.0678 45.386 30.0818 45.362 30.0818C45.224 30.0818 45.07 30.0458 44.916 29.9838C44.405 30.0288 44 30.4447 44 30.9657C44 31.5157 44.448 31.9648 45 31.9648C45.552 31.9648 46 31.5157 46 30.9657C46 30.5658 45.76 30.2248 45.419 30.0658Z'/></svg>",
            image: {
              url: "https://d2kzwze52p8717.cloudfront.net/spotlight/face-2.jpg",
              alt_text: "alt_text"
            },
            name: "Nina Mercado",
            role: "Student",
            snippet: "Several students from the Arkansas School for Mathematics, Sciences and the Arts earned recognition at the recent Arkansas Young Artist Association Spring Competition. Sciences and the Arts and the Lakeside School District are offering their students a unique."
          },
          {
            icon: "<svg data-name='Layer 1' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 48 48.1'><path d='M48 30.9657C48 32.6177 46.654 33.9618 45 33.9618C43.346 33.9618 42 32.6177 42 30.9657C42 29.6647 42.839 28.5667 44 28.1528V15.7347L36.959 19.8908C36.974 19.9578 37 20.0208 37 20.0918V36.0747C37 36.6117 36.575 37.0407 36.044 37.0647C34.595 37.7947 29.741 39.9557 23 39.9557C16.259 39.9557 11.404 37.7947 9.956 37.0647C9.425 37.0407 9 36.6117 9 36.0747V20.0918C9 20.0208 9.026 19.9578 9.041 19.8908L0.491 14.8438C0.186 14.6648 0 14.3367 0 13.9837C0 13.6317 0.186 13.3037 0.491 13.1247L22.492 0.13875C22.807 -0.04625 23.195 -0.04625 23.51 0.13875L45.51 13.1247C45.913 13.1847 46 13.4688 46 13.9587V13.9808C46 13.9818 46.001 13.9827 46.001 13.9837C46.001 13.9857 46 13.9867 46 13.9878V28.1528C47.162 28.5667 48 29.6647 48 30.9657ZM35 35.3498V21.0478L23.51 27.8298C23.352 27.9217 23.177 27.9688 23.001 27.9688C22.825 27.9688 22.649 27.9217 22.492 27.8298L11 21.0468V35.3498C12.452 36.0518 16.951 37.9577 23 37.9577C29.048 37.9577 33.548 36.0518 35 35.3498ZM23.001 2.15875L2.966 13.9837L23.001 25.8098L43.035 13.9837L23.001 2.15875ZM45.419 30.0658C45.397 30.0678 45.386 30.0818 45.362 30.0818C45.224 30.0818 45.07 30.0458 44.916 29.9838C44.405 30.0288 44 30.4447 44 30.9657C44 31.5157 44.448 31.9648 45 31.9648C45.552 31.9648 46 31.5157 46 30.9657C46 30.5658 45.76 30.2248 45.419 30.0658Z'/></svg>",
            image: {
              url: "https://d2kzwze52p8717.cloudfront.net/spotlight/face-3.jpg",
              alt_text: "alt_text"
            },
            name: "Ussama Azam",
            role: "Student",
            snippet: "Several students from the Arkansas School for Mathematics, Sciences and the Arts earned recognition at the recent Arkansas Young Artist Association Spring Competition. Sciences and the Arts and the Lakeside School District are offering their students a unique."
          }
        ],
        icon: "<svg data-name='Layer 1' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 48 48.1'><path d='M48 30.9657C48 32.6177 46.654 33.9618 45 33.9618C43.346 33.9618 42 32.6177 42 30.9657C42 29.6647 42.839 28.5667 44 28.1528V15.7347L36.959 19.8908C36.974 19.9578 37 20.0208 37 20.0918V36.0747C37 36.6117 36.575 37.0407 36.044 37.0647C34.595 37.7947 29.741 39.9557 23 39.9557C16.259 39.9557 11.404 37.7947 9.956 37.0647C9.425 37.0407 9 36.6117 9 36.0747V20.0918C9 20.0208 9.026 19.9578 9.041 19.8908L0.491 14.8438C0.186 14.6648 0 14.3367 0 13.9837C0 13.6317 0.186 13.3037 0.491 13.1247L22.492 0.13875C22.807 -0.04625 23.195 -0.04625 23.51 0.13875L45.51 13.1247C45.913 13.1847 46 13.4688 46 13.9587V13.9808C46 13.9818 46.001 13.9827 46.001 13.9837C46.001 13.9857 46 13.9867 46 13.9878V28.1528C47.162 28.5667 48 29.6647 48 30.9657ZM35 35.3498V21.0478L23.51 27.8298C23.352 27.9217 23.177 27.9688 23.001 27.9688C22.825 27.9688 22.649 27.9217 22.492 27.8298L11 21.0468V35.3498C12.452 36.0518 16.951 37.9577 23 37.9577C29.048 37.9577 33.548 36.0518 35 35.3498ZM23.001 2.15875L2.966 13.9837L23.001 25.8098L43.035 13.9837L23.001 2.15875ZM45.419 30.0658C45.397 30.0678 45.386 30.0818 45.362 30.0818C45.224 30.0818 45.07 30.0458 44.916 29.9838C44.405 30.0288 44 30.4447 44 30.9657C44 31.5157 44.448 31.9648 45 31.9648C45.552 31.9648 46 31.5157 46 30.9657C46 30.5658 45.76 30.2248 45.419 30.0658Z'/></svg>",
        label: "Our Alumni",
        show_image_icons: true,
        show_headline: true,
        show_snippet: true
      },
      {
        cards: [
          {
            icon: "<svg data-name='Layer 1' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 48 48.1'><path d='M48 30.9657C48 32.6177 46.654 33.9618 45 33.9618C43.346 33.9618 42 32.6177 42 30.9657C42 29.6647 42.839 28.5667 44 28.1528V15.7347L36.959 19.8908C36.974 19.9578 37 20.0208 37 20.0918V36.0747C37 36.6117 36.575 37.0407 36.044 37.0647C34.595 37.7947 29.741 39.9557 23 39.9557C16.259 39.9557 11.404 37.7947 9.956 37.0647C9.425 37.0407 9 36.6117 9 36.0747V20.0918C9 20.0208 9.026 19.9578 9.041 19.8908L0.491 14.8438C0.186 14.6648 0 14.3367 0 13.9837C0 13.6317 0.186 13.3037 0.491 13.1247L22.492 0.13875C22.807 -0.04625 23.195 -0.04625 23.51 0.13875L45.51 13.1247C45.913 13.1847 46 13.4688 46 13.9587V13.9808C46 13.9818 46.001 13.9827 46.001 13.9837C46.001 13.9857 46 13.9867 46 13.9878V28.1528C47.162 28.5667 48 29.6647 48 30.9657ZM35 35.3498V21.0478L23.51 27.8298C23.352 27.9217 23.177 27.9688 23.001 27.9688C22.825 27.9688 22.649 27.9217 22.492 27.8298L11 21.0468V35.3498C12.452 36.0518 16.951 37.9577 23 37.9577C29.048 37.9577 33.548 36.0518 35 35.3498ZM23.001 2.15875L2.966 13.9837L23.001 25.8098L43.035 13.9837L23.001 2.15875ZM45.419 30.0658C45.397 30.0678 45.386 30.0818 45.362 30.0818C45.224 30.0818 45.07 30.0458 44.916 29.9838C44.405 30.0288 44 30.4447 44 30.9657C44 31.5157 44.448 31.9648 45 31.9648C45.552 31.9648 46 31.5157 46 30.9657C46 30.5658 45.76 30.2248 45.419 30.0658Z'/></svg>",
            image: {
              url: "https://d2kzwze52p8717.cloudfront.net/spotlight/face-1.jpg",
              alt_text: "alt_text"
            },
            name: "Edgar M.",
            role: "Teacher",
            snippet: "Several students from the Arkansas School for Mathematics, Sciences and the Arts earned recognition at the recent Arkansas Young Artist Association Spring Competition. Sciences and the Arts and the Lakeside School District are offering their students a unique."
          },
          {
            icon: "<svg data-name='Layer 1' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 48 48.1'><path d='M48 30.9657C48 32.6177 46.654 33.9618 45 33.9618C43.346 33.9618 42 32.6177 42 30.9657C42 29.6647 42.839 28.5667 44 28.1528V15.7347L36.959 19.8908C36.974 19.9578 37 20.0208 37 20.0918V36.0747C37 36.6117 36.575 37.0407 36.044 37.0647C34.595 37.7947 29.741 39.9557 23 39.9557C16.259 39.9557 11.404 37.7947 9.956 37.0647C9.425 37.0407 9 36.6117 9 36.0747V20.0918C9 20.0208 9.026 19.9578 9.041 19.8908L0.491 14.8438C0.186 14.6648 0 14.3367 0 13.9837C0 13.6317 0.186 13.3037 0.491 13.1247L22.492 0.13875C22.807 -0.04625 23.195 -0.04625 23.51 0.13875L45.51 13.1247C45.913 13.1847 46 13.4688 46 13.9587V13.9808C46 13.9818 46.001 13.9827 46.001 13.9837C46.001 13.9857 46 13.9867 46 13.9878V28.1528C47.162 28.5667 48 29.6647 48 30.9657ZM35 35.3498V21.0478L23.51 27.8298C23.352 27.9217 23.177 27.9688 23.001 27.9688C22.825 27.9688 22.649 27.9217 22.492 27.8298L11 21.0468V35.3498C12.452 36.0518 16.951 37.9577 23 37.9577C29.048 37.9577 33.548 36.0518 35 35.3498ZM23.001 2.15875L2.966 13.9837L23.001 25.8098L43.035 13.9837L23.001 2.15875ZM45.419 30.0658C45.397 30.0678 45.386 30.0818 45.362 30.0818C45.224 30.0818 45.07 30.0458 44.916 29.9838C44.405 30.0288 44 30.4447 44 30.9657C44 31.5157 44.448 31.9648 45 31.9648C45.552 31.9648 46 31.5157 46 30.9657C46 30.5658 45.76 30.2248 45.419 30.0658Z'/></svg>",
            image: {
              url: "https://d2kzwze52p8717.cloudfront.net/spotlight/face-2.jpg",
              alt_text: "alt_text"
            },
            name: "Nina Mercado",
            role: "Teacher",
            snippet: "Several students from the Arkansas School for Mathematics, Sciences and the Arts earned recognition at the recent Arkansas Young Artist Association Spring Competition. Sciences and the Arts and the Lakeside School District are offering their students a unique."
          },
          {
            icon: "<svg data-name='Layer 1' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 48 48.1'><path d='M48 30.9657C48 32.6177 46.654 33.9618 45 33.9618C43.346 33.9618 42 32.6177 42 30.9657C42 29.6647 42.839 28.5667 44 28.1528V15.7347L36.959 19.8908C36.974 19.9578 37 20.0208 37 20.0918V36.0747C37 36.6117 36.575 37.0407 36.044 37.0647C34.595 37.7947 29.741 39.9557 23 39.9557C16.259 39.9557 11.404 37.7947 9.956 37.0647C9.425 37.0407 9 36.6117 9 36.0747V20.0918C9 20.0208 9.026 19.9578 9.041 19.8908L0.491 14.8438C0.186 14.6648 0 14.3367 0 13.9837C0 13.6317 0.186 13.3037 0.491 13.1247L22.492 0.13875C22.807 -0.04625 23.195 -0.04625 23.51 0.13875L45.51 13.1247C45.913 13.1847 46 13.4688 46 13.9587V13.9808C46 13.9818 46.001 13.9827 46.001 13.9837C46.001 13.9857 46 13.9867 46 13.9878V28.1528C47.162 28.5667 48 29.6647 48 30.9657ZM35 35.3498V21.0478L23.51 27.8298C23.352 27.9217 23.177 27.9688 23.001 27.9688C22.825 27.9688 22.649 27.9217 22.492 27.8298L11 21.0468V35.3498C12.452 36.0518 16.951 37.9577 23 37.9577C29.048 37.9577 33.548 36.0518 35 35.3498ZM23.001 2.15875L2.966 13.9837L23.001 25.8098L43.035 13.9837L23.001 2.15875ZM45.419 30.0658C45.397 30.0678 45.386 30.0818 45.362 30.0818C45.224 30.0818 45.07 30.0458 44.916 29.9838C44.405 30.0288 44 30.4447 44 30.9657C44 31.5157 44.448 31.9648 45 31.9648C45.552 31.9648 46 31.5157 46 30.9657C46 30.5658 45.76 30.2248 45.419 30.0658Z'/></svg>",
            image: {
              url: "https://d2kzwze52p8717.cloudfront.net/spotlight/face-3.jpg",
              alt_text: "alt_text"
            },
            name: "Ussama Azam",
            role: "Teacher",
            snippet: "Several students from the Arkansas School for Mathematics, Sciences and the Arts earned recognition at the recent Arkansas Young Artist Association Spring Competition. Sciences and the Arts and the Lakeside School District are offering their students a unique."
          }
        ],
        icon: "<svg data-name='Layer 1' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 48 48.1'><path d='M48 30.9657C48 32.6177 46.654 33.9618 45 33.9618C43.346 33.9618 42 32.6177 42 30.9657C42 29.6647 42.839 28.5667 44 28.1528V15.7347L36.959 19.8908C36.974 19.9578 37 20.0208 37 20.0918V36.0747C37 36.6117 36.575 37.0407 36.044 37.0647C34.595 37.7947 29.741 39.9557 23 39.9557C16.259 39.9557 11.404 37.7947 9.956 37.0647C9.425 37.0407 9 36.6117 9 36.0747V20.0918C9 20.0208 9.026 19.9578 9.041 19.8908L0.491 14.8438C0.186 14.6648 0 14.3367 0 13.9837C0 13.6317 0.186 13.3037 0.491 13.1247L22.492 0.13875C22.807 -0.04625 23.195 -0.04625 23.51 0.13875L45.51 13.1247C45.913 13.1847 46 13.4688 46 13.9587V13.9808C46 13.9818 46.001 13.9827 46.001 13.9837C46.001 13.9857 46 13.9867 46 13.9878V28.1528C47.162 28.5667 48 29.6647 48 30.9657ZM35 35.3498V21.0478L23.51 27.8298C23.352 27.9217 23.177 27.9688 23.001 27.9688C22.825 27.9688 22.649 27.9217 22.492 27.8298L11 21.0468V35.3498C12.452 36.0518 16.951 37.9577 23 37.9577C29.048 37.9577 33.548 36.0518 35 35.3498ZM23.001 2.15875L2.966 13.9837L23.001 25.8098L43.035 13.9837L23.001 2.15875ZM45.419 30.0658C45.397 30.0678 45.386 30.0818 45.362 30.0818C45.224 30.0818 45.07 30.0458 44.916 29.9838C44.405 30.0288 44 30.4447 44 30.9657C44 31.5157 44.448 31.9648 45 31.9648C45.552 31.9648 46 31.5157 46 30.9657C46 30.5658 45.76 30.2248 45.419 30.0658Z'/></svg>",
        label: "Our Teachers",
        show_image_icons: true,
        show_headline: true,
        show_snippet: true
      },
      {
        cards: [
          {
            icon: "<svg data-name='Layer 1' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 48 48.1'><path d='M48 30.9657C48 32.6177 46.654 33.9618 45 33.9618C43.346 33.9618 42 32.6177 42 30.9657C42 29.6647 42.839 28.5667 44 28.1528V15.7347L36.959 19.8908C36.974 19.9578 37 20.0208 37 20.0918V36.0747C37 36.6117 36.575 37.0407 36.044 37.0647C34.595 37.7947 29.741 39.9557 23 39.9557C16.259 39.9557 11.404 37.7947 9.956 37.0647C9.425 37.0407 9 36.6117 9 36.0747V20.0918C9 20.0208 9.026 19.9578 9.041 19.8908L0.491 14.8438C0.186 14.6648 0 14.3367 0 13.9837C0 13.6317 0.186 13.3037 0.491 13.1247L22.492 0.13875C22.807 -0.04625 23.195 -0.04625 23.51 0.13875L45.51 13.1247C45.913 13.1847 46 13.4688 46 13.9587V13.9808C46 13.9818 46.001 13.9827 46.001 13.9837C46.001 13.9857 46 13.9867 46 13.9878V28.1528C47.162 28.5667 48 29.6647 48 30.9657ZM35 35.3498V21.0478L23.51 27.8298C23.352 27.9217 23.177 27.9688 23.001 27.9688C22.825 27.9688 22.649 27.9217 22.492 27.8298L11 21.0468V35.3498C12.452 36.0518 16.951 37.9577 23 37.9577C29.048 37.9577 33.548 36.0518 35 35.3498ZM23.001 2.15875L2.966 13.9837L23.001 25.8098L43.035 13.9837L23.001 2.15875ZM45.419 30.0658C45.397 30.0678 45.386 30.0818 45.362 30.0818C45.224 30.0818 45.07 30.0458 44.916 29.9838C44.405 30.0288 44 30.4447 44 30.9657C44 31.5157 44.448 31.9648 45 31.9648C45.552 31.9648 46 31.5157 46 30.9657C46 30.5658 45.76 30.2248 45.419 30.0658Z'/></svg>",
            image: {
              url: "https://d2kzwze52p8717.cloudfront.net/spotlight/face-1.jpg",
              alt_text: "alt_text"
            },
            name: "Edgar M.",
            role: "Parent",
            snippet: "Several students from the Arkansas School for Mathematics, Sciences and the Arts earned recognition at the recent Arkansas Young Artist Association Spring Competition. Sciences and the Arts and the Lakeside School District are offering their students a unique."
          },
          {
            icon: "<svg data-name='Layer 1' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 48 48.1'><path d='M48 30.9657C48 32.6177 46.654 33.9618 45 33.9618C43.346 33.9618 42 32.6177 42 30.9657C42 29.6647 42.839 28.5667 44 28.1528V15.7347L36.959 19.8908C36.974 19.9578 37 20.0208 37 20.0918V36.0747C37 36.6117 36.575 37.0407 36.044 37.0647C34.595 37.7947 29.741 39.9557 23 39.9557C16.259 39.9557 11.404 37.7947 9.956 37.0647C9.425 37.0407 9 36.6117 9 36.0747V20.0918C9 20.0208 9.026 19.9578 9.041 19.8908L0.491 14.8438C0.186 14.6648 0 14.3367 0 13.9837C0 13.6317 0.186 13.3037 0.491 13.1247L22.492 0.13875C22.807 -0.04625 23.195 -0.04625 23.51 0.13875L45.51 13.1247C45.913 13.1847 46 13.4688 46 13.9587V13.9808C46 13.9818 46.001 13.9827 46.001 13.9837C46.001 13.9857 46 13.9867 46 13.9878V28.1528C47.162 28.5667 48 29.6647 48 30.9657ZM35 35.3498V21.0478L23.51 27.8298C23.352 27.9217 23.177 27.9688 23.001 27.9688C22.825 27.9688 22.649 27.9217 22.492 27.8298L11 21.0468V35.3498C12.452 36.0518 16.951 37.9577 23 37.9577C29.048 37.9577 33.548 36.0518 35 35.3498ZM23.001 2.15875L2.966 13.9837L23.001 25.8098L43.035 13.9837L23.001 2.15875ZM45.419 30.0658C45.397 30.0678 45.386 30.0818 45.362 30.0818C45.224 30.0818 45.07 30.0458 44.916 29.9838C44.405 30.0288 44 30.4447 44 30.9657C44 31.5157 44.448 31.9648 45 31.9648C45.552 31.9648 46 31.5157 46 30.9657C46 30.5658 45.76 30.2248 45.419 30.0658Z'/></svg>",
            image: {
              url: "https://d2kzwze52p8717.cloudfront.net/spotlight/face-2.jpg",
              alt_text: "alt_text"
            },
            name: "Nina Mercado",
            role: "Parent",
            snippet: "Several students from the Arkansas School for Mathematics, Sciences and the Arts earned recognition at the recent Arkansas Young Artist Association Spring Competition. Sciences and the Arts and the Lakeside School District are offering their students a unique."
          },
          {
            icon: "<svg data-name='Layer 1' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 48 48.1'><path d='M48 30.9657C48 32.6177 46.654 33.9618 45 33.9618C43.346 33.9618 42 32.6177 42 30.9657C42 29.6647 42.839 28.5667 44 28.1528V15.7347L36.959 19.8908C36.974 19.9578 37 20.0208 37 20.0918V36.0747C37 36.6117 36.575 37.0407 36.044 37.0647C34.595 37.7947 29.741 39.9557 23 39.9557C16.259 39.9557 11.404 37.7947 9.956 37.0647C9.425 37.0407 9 36.6117 9 36.0747V20.0918C9 20.0208 9.026 19.9578 9.041 19.8908L0.491 14.8438C0.186 14.6648 0 14.3367 0 13.9837C0 13.6317 0.186 13.3037 0.491 13.1247L22.492 0.13875C22.807 -0.04625 23.195 -0.04625 23.51 0.13875L45.51 13.1247C45.913 13.1847 46 13.4688 46 13.9587V13.9808C46 13.9818 46.001 13.9827 46.001 13.9837C46.001 13.9857 46 13.9867 46 13.9878V28.1528C47.162 28.5667 48 29.6647 48 30.9657ZM35 35.3498V21.0478L23.51 27.8298C23.352 27.9217 23.177 27.9688 23.001 27.9688C22.825 27.9688 22.649 27.9217 22.492 27.8298L11 21.0468V35.3498C12.452 36.0518 16.951 37.9577 23 37.9577C29.048 37.9577 33.548 36.0518 35 35.3498ZM23.001 2.15875L2.966 13.9837L23.001 25.8098L43.035 13.9837L23.001 2.15875ZM45.419 30.0658C45.397 30.0678 45.386 30.0818 45.362 30.0818C45.224 30.0818 45.07 30.0458 44.916 29.9838C44.405 30.0288 44 30.4447 44 30.9657C44 31.5157 44.448 31.9648 45 31.9648C45.552 31.9648 46 31.5157 46 30.9657C46 30.5658 45.76 30.2248 45.419 30.0658Z'/></svg>",
            image: {
              url: "https://d2kzwze52p8717.cloudfront.net/spotlight/face-3.jpg",
              alt_text: "alt_text"
            },
            name: "Ussama Azam",
            role: "Parent",
            snippet: "Several students from the Arkansas School for Mathematics, Sciences and the Arts earned recognition at the recent Arkansas Young Artist Association Spring Competition. Sciences and the Arts and the Lakeside School District are offering their students a unique."
          }
        ],
        icon: "<svg data-name='Layer 1' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 48 48.1'><path d='M48 30.9657C48 32.6177 46.654 33.9618 45 33.9618C43.346 33.9618 42 32.6177 42 30.9657C42 29.6647 42.839 28.5667 44 28.1528V15.7347L36.959 19.8908C36.974 19.9578 37 20.0208 37 20.0918V36.0747C37 36.6117 36.575 37.0407 36.044 37.0647C34.595 37.7947 29.741 39.9557 23 39.9557C16.259 39.9557 11.404 37.7947 9.956 37.0647C9.425 37.0407 9 36.6117 9 36.0747V20.0918C9 20.0208 9.026 19.9578 9.041 19.8908L0.491 14.8438C0.186 14.6648 0 14.3367 0 13.9837C0 13.6317 0.186 13.3037 0.491 13.1247L22.492 0.13875C22.807 -0.04625 23.195 -0.04625 23.51 0.13875L45.51 13.1247C45.913 13.1847 46 13.4688 46 13.9587V13.9808C46 13.9818 46.001 13.9827 46.001 13.9837C46.001 13.9857 46 13.9867 46 13.9878V28.1528C47.162 28.5667 48 29.6647 48 30.9657ZM35 35.3498V21.0478L23.51 27.8298C23.352 27.9217 23.177 27.9688 23.001 27.9688C22.825 27.9688 22.649 27.9217 22.492 27.8298L11 21.0468V35.3498C12.452 36.0518 16.951 37.9577 23 37.9577C29.048 37.9577 33.548 36.0518 35 35.3498ZM23.001 2.15875L2.966 13.9837L23.001 25.8098L43.035 13.9837L23.001 2.15875ZM45.419 30.0658C45.397 30.0678 45.386 30.0818 45.362 30.0818C45.224 30.0818 45.07 30.0458 44.916 29.9838C44.405 30.0288 44 30.4447 44 30.9657C44 31.5157 44.448 31.9648 45 31.9648C45.552 31.9648 46 31.5157 46 30.9657C46 30.5658 45.76 30.2248 45.419 30.0658Z'/></svg>",
        label: "Parent Community",
        show_image_icons: true,
        show_headline: true,
        show_snippet: true
      }
    ]
  }
};
const buttons = {
  preview_id: {
    content: [
      {
        link: "#",
        title: "Donate",
        icon: "<svg data-name='Layer 1' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 48.01 46'><path d='M47.7,34.6a4.15,4.15,0,0,0-5.3-2.4h-.1l-6.7,3.4a4.05,4.05,0,0,0-2.3-2.8h-.1L21.2,29H21c-.3,0-7.1-.8-20.3,2.8A1.09,1.09,0,0,0,0,33L2.1,43.2a1.16,1.16,0,0,0,.5.7,2,2,0,0,0,.8.1,62.42,62.42,0,0,1,8.3-2,32.94,32.94,0,0,1,6.6,2.1c1.5.5,2.9,1.1,4.2,1.5A46.9,46.9,0,0,0,32.8,47h0a.9.9,0,0,0,.5-.1l12.2-6.8A4.24,4.24,0,0,0,47.7,34.6Zm-3.1,3.7L32.6,45c-1.2-.1-6.4-.3-9.5-1.3-1.2-.4-2.7-.9-4.1-1.5-3.8-1.4-6.1-2.2-7.3-2.2-1.4,0-5.8,1.2-7.8,1.7L2.2,33.5c11.4-3,17.7-2.6,18.5-2.5l11.8,3.7a2.29,2.29,0,0,1,1.1,2.9,2.19,2.19,0,0,1-1.3,1.2,1.7,1.7,0,0,1-1.4,0h-.1L19.3,35a1,1,0,1,0-.7,1.9L30,40.6a4,4,0,0,0,1.5.3,3.53,3.53,0,0,0,1.4-.3,4.17,4.17,0,0,0,2.4-2.3.6.6,0,0,0,.1-.4L43,34a2.15,2.15,0,0,1,2.7,1.2A2.18,2.18,0,0,1,44.6,38.3Z' transform='translate(0.02 -1)'/><path d='M32,27A13,13,0,1,0,19,14,13,13,0,0,0,32,27ZM32,3A11,11,0,1,1,21,14,11,11,0,0,1,32,3Z' transform='translate(0.02 -1)'/><path d='M32,19H29a1,1,0,0,0,0,2h2v2a1,1,0,0,0,2,0V20.9A4,4,0,0,0,32,13a2,2,0,0,1,0-4h3a.94.94,0,0,0,1-1,.94.94,0,0,0-1-1H33V5a1,1,0,0,0-2,0V7.1A4,4,0,0,0,32,15a2,2,0,0,1,0,4Z' transform='translate(0.02 -1)'/></svg>"
      },
      {
        link: "#",
        title: "Family Resources",
        icon: "<svg data-name='Layer 1' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 39.8 42.1'><path d='M30.7,33.6V27.8h0a6.87,6.87,0,0,0-5-6.6,4.3,4.3,0,1,0-3.8,0,6.87,6.87,0,0,0-5,6.6h0v5.8a.94.94,0,0,0,1,1h1.7l1.2,9.6a1.06,1.06,0,0,0,1,.9h3.9a1.06,1.06,0,0,0,1-.9l1.2-9.6h1.7A1,1,0,0,0,30.7,33.6ZM23.9,15a2.3,2.3,0,1,1-2.3,2.3A2.26,2.26,0,0,1,23.9,15Zm4.8,17.6H26.8c-.1,0-.1.1-.2.1s-.1.1-.2.1l-.1.1a.35.35,0,0,0-.1.2c0,.1,0,.1-.1.2v.1L24.9,43H22.8l-1.2-9.6v-.1c0-.1,0-.1-.1-.2s-.1-.1-.1-.2-.1-.1-.1-.2l-.1-.1c-.1,0-.1-.1-.2-.1H19V27.7h0a4.9,4.9,0,0,1,9.8,0h0v4.9Z' transform='translate(-4 -3)'/><path d='M40.7,9a6,6,0,1,0-12,0,6,6,0,1,0,12,0Zm-6,4a4,4,0,1,1,4-4A4,4,0,0,1,34.7,13Z' transform='translate(-4 -3)'/><path d='M43.7,25.6c0-6.4-3.5-10.6-9-10.6h0a8.61,8.61,0,0,0-5.3,1.7,1.08,1.08,0,0,0-.2,1.4.91.91,0,0,0,.8.4,1.42,1.42,0,0,0,.6-.2A6.29,6.29,0,0,1,34.7,17h0c5.2,0,7,4.4,7,8.6V31H39.4c-.1,0-.1,0-.2.1s-.1.1-.2.1l-.1.1a.35.35,0,0,0-.1.2c0,.1-.1.1-.1.2v.1L36.9,43H32.6l-.9-6.1a1,1,0,0,0-1.9.3l1,7a1.06,1.06,0,0,0,1,.9h6a1.08,1.08,0,0,0,1-.8L40.6,33h2.2a.94.94,0,0,0,1-1V25.7c-.1,0-.1,0-.1-.1Z' transform='translate(-4 -3)'/><path d='M19,9a5.89,5.89,0,0,0-6-6A5.89,5.89,0,0,0,7,9a5.89,5.89,0,0,0,6,6A5.89,5.89,0,0,0,19,9Zm-6,4a4,4,0,1,1,4-4A4,4,0,0,1,13,13Z' transform='translate(-4 -3)'/><path d='M17.1,36a.94.94,0,0,0-1.1.8L15.1,43H10.8L9,31.8v-.1c0-.1,0-.1-.1-.2s-.1-.1-.1-.2l-.1-.1c-.1-.1-.1-.1-.2-.1a.1.1,0,0,1-.1-.1H6V25.5c0-4.2,1.8-8.6,7-8.6a6.29,6.29,0,0,1,4.1,1.3,1.42,1.42,0,0,0,.6.2.91.91,0,0,0,.8-.4,1,1,0,0,0-.2-1.4A9.23,9.23,0,0,0,13,15c-5.5,0-9,4.2-9,10.6V32a.94.94,0,0,0,1,1H7.2L9,44.2a1,1,0,0,0,1,.8h6a1.06,1.06,0,0,0,1-.9l1-7A1,1,0,0,0,17.1,36Z' transform='translate(-4 -3)'/></svg>"
      },
      {
        link: "#",
        title: "Explore Summer Programs",
        icon: "<svg data-name='Layer 1' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 48 48'><path d='M9,17a1.88,1.88,0,0,1,2,1.75A1,1,0,0,1,11,19h2a3.88,3.88,0,0,0-3.76-4H9a3.88,3.88,0,0,0-4,3.76V19H7a1.88,1.88,0,0,1,1.75-2A1,1,0,0,1,9,17Z' transform='translate(0 0)'/><path d='M39,23a1.88,1.88,0,0,1,2,1.75A1,1,0,0,1,41,25h2a4,4,0,0,0-8,0h2a1.88,1.88,0,0,1,1.75-2A1,1,0,0,1,39,23Z' transform='translate(0 0)'/><path d='M32,34h6.7A4.91,4.91,0,0,1,34,37H30a1,1,0,0,0,0,2h4a6.9,6.9,0,0,0,7-5.9.79.79,0,0,0-.2-.8A1.12,1.12,0,0,0,40,32H32a1,1,0,0,0,0,2Z' transform='translate(0 0)'/><path d='M31,22.5V5.8a.91.91,0,0,0-.4-.8A25.29,25.29,0,0,0,.4,5a.91.91,0,0,0-.4.8V22.5C0,31.5,6.8,42,15.5,42S31,31.5,31,22.5ZM15.5,40C9.3,40,2,32.4,2,22.5V6.3A23.67,23.67,0,0,1,15.5,2,24,24,0,0,1,29,6.3V22.5C29,32.4,21.7,40,15.5,40Z' transform='translate(0 0)'/><path d='M23,26H8a1.12,1.12,0,0,0-.8.3,1.19,1.19,0,0,0-.2.8A6.9,6.9,0,0,0,14,33h3a6.83,6.83,0,0,0,7-5.9,1.09,1.09,0,0,0-.2-.8A1.12,1.12,0,0,0,23,26Zm-6,5H14a4.91,4.91,0,0,1-4.7-3H21.6A4.65,4.65,0,0,1,17,31Z' transform='translate(0 0)'/><path d='M47.7,11.3A22.22,22.22,0,0,0,35.1,6a1,1,0,1,0-.2,2A21.74,21.74,0,0,1,46,12.5v16c0,9.9-7.3,17.5-13.6,17.4a11,11,0,0,1-7.3-3.1,1,1,0,0,0-1.3,1.5A13,13,0,0,0,32.5,48C41.2,48,48,37.5,48,28.5V12A.89.89,0,0,0,47.7,11.3Z' transform='translate(0 0)'/><path d='M22,15a3.88,3.88,0,0,0-4,3.76V19h2a1.88,1.88,0,0,1,1.75-2A1,1,0,0,1,22,17a1.88,1.88,0,0,1,2,1.75A1,1,0,0,1,24,19h2a3.88,3.88,0,0,0-3.76-4Z' transform='translate(0 0)'/></svg>"
      },
      {
        link: "#",
        title: "Partnerships & Outreach",
        icon: "<svg data-name='Layer 1' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 48 48'><path d='M42,36a6.06,6.06,0,0,0-3.5,1.1l-9.6-9.6a6.07,6.07,0,0,0-1.7-8.6l3.2-7.1a7.72,7.72,0,0,0,1.5.2,5.89,5.89,0,0,0,6-6,6,6,0,0,0-12,0,6,6,0,0,0,2.6,5l-3.3,7.2A3.73,3.73,0,0,0,24,18a6,6,0,0,0-6,6,6.93,6.93,0,0,0,.3,2l-7.6,4.3A6,6,0,1,0,12,34a6.93,6.93,0,0,0-.3-2l7.6-4.3A6,6,0,0,0,24,30a6.06,6.06,0,0,0,3.5-1.1l9.6,9.6A6,6,0,1,0,42,36ZM32,2a4,4,0,1,1-4,4A4,4,0,0,1,32,2ZM6,38a4,4,0,1,1,4-4A4,4,0,0,1,6,38ZM20,24a4,4,0,0,1,4-4,3.19,3.19,0,0,1,1.4.3h.1A4,4,0,0,1,27.9,24a3.86,3.86,0,0,1-1.1,2.7l-.1.1-.1.1A3.47,3.47,0,0,1,24,28,4,4,0,0,1,20,24ZM42,46a4,4,0,0,1-4-4,3.86,3.86,0,0,1,1.1-2.7l.1-.1.1-.1A3.86,3.86,0,0,1,42,38a4,4,0,0,1,0,8Z' transform='translate(0 0)'/></svg>"
      },
      {
        link: "#",
        title: "Diversity and Inclusion",
        icon: "<svg data-name='Layer 1' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 48 48'><path d='M24,0A24,24,0,1,0,48,24,24.07,24.07,0,0,0,24,0ZM43,35H35.1A33.45,33.45,0,0,0,37,25h9A21.63,21.63,0,0,1,43,35ZM25.6,45.9H25v-9h7.1A28.08,28.08,0,0,1,25.6,45.9Zm-3.2,0A28.68,28.68,0,0,1,15.8,37H23v9A1.27,1.27,0,0,1,22.4,45.9ZM5,35A21.63,21.63,0,0,1,2,25h9a30.6,30.6,0,0,0,1.9,10ZM5,13h7.9A33.45,33.45,0,0,0,11,23H2A21.63,21.63,0,0,1,5,13ZM22.4,2.1H23v9H15.9A28.08,28.08,0,0,1,22.4,2.1Zm3.2,0A28.68,28.68,0,0,1,32.2,11H25V2A1.27,1.27,0,0,1,25.6,2.1ZM33,13a30.17,30.17,0,0,1,2,10H25V13ZM23,13V23H13a30.17,30.17,0,0,1,2-10ZM13,25H23V35H15A30.17,30.17,0,0,1,13,25ZM25,35V25H35a30.17,30.17,0,0,1-2,10ZM37,23a30.6,30.6,0,0,0-1.9-10H43a21.53,21.53,0,0,1,2.9,10Zm4.7-12H34.3a29.48,29.48,0,0,0-5.4-8.4A21.28,21.28,0,0,1,41.7,11ZM19.1,2.6A29.48,29.48,0,0,0,13.7,11H6.3A21.28,21.28,0,0,1,19.1,2.6ZM6.3,37h7.4a29.48,29.48,0,0,0,5.4,8.4A21.28,21.28,0,0,1,6.3,37Zm22.6,8.4A28.74,28.74,0,0,0,34.3,37h7.4A21.28,21.28,0,0,1,28.9,45.4Z'/></svg>"
      },
      {
        link: "#",
        title: "Mission and Values",
        icon: "<svg data-name='Layer 1' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 38.02 48'><path d='M39.1,11a4.23,4.23,0,0,0-2,.5V7a3.94,3.94,0,0,0-4-4,3.17,3.17,0,0,0-2,.6,4,4,0,0,0-8,.4v.5a4.23,4.23,0,0,0-2-.5,3.94,3.94,0,0,0-4,4V26.9l-2.8-2.3a7.65,7.65,0,0,0-7.7-.8,2.82,2.82,0,0,0-1.5,2A2.58,2.58,0,0,0,5.8,28c1.5,1.5,4.7,5.1,9.5,12.5A15.54,15.54,0,0,0,29.1,48c8.2,0,14-5.5,14-13.3V15A3.94,3.94,0,0,0,39.1,11Zm2,23.7c0,6.8-4.8,11.3-12,11.3a13.65,13.65,0,0,1-12.2-6.5A86.54,86.54,0,0,0,7.2,26.6a.65.65,0,0,1-.2-.5.66.66,0,0,1,.4-.5,5.53,5.53,0,0,1,5.7.6l4.4,3.6a.1.1,0,0,1,.1.1c.1,0,.1.1.2.1h.6c.1,0,.1,0,.2-.1a.1.1,0,0,0,.1-.1c.1,0,.1-.1.2-.1h0a.1.1,0,0,1,.1-.1c0-.1.1-.1.1-.2V8a2,2,0,0,1,4,0V23a1,1,0,0,0,2,0V9h0V4a1.94,1.94,0,0,1,2-2,2,2,0,0,1,2,2.1V23a1,1,0,0,0,2,0V7a2,2,0,0,1,4,0V24a1,1,0,0,0,2,0V15a2,2,0,0,1,4,0V34.7Z' transform='translate(-5.08)'/><path d='M35.4,29.5a4.41,4.41,0,0,0-6.2,0h0l-.2.3-.3-.3h0a4.41,4.41,0,0,0-6.2,0,4.34,4.34,0,0,0-1.3,3,4.16,4.16,0,0,0,1.3,3h.1l5,5.4a1.68,1.68,0,0,0,1.4.6,1.49,1.49,0,0,0,1.3-.6l5.1-5.5h0a4.23,4.23,0,0,0,1.2-3A3.58,3.58,0,0,0,35.4,29.5ZM29,39.6l-5-5.4a.1.1,0,0,1-.1-.1,2.36,2.36,0,0,1-.7-1.6,2,2,0,0,1,.7-1.6,2.48,2.48,0,0,1,3.4,0l1,1h0c.1.1.1.1.2.1l.1.1c.1,0,.2.1.4.1s.3,0,.4-.1a.1.1,0,0,0,.1-.1c.1,0,.1-.1.2-.1h0l1-1a2.48,2.48,0,0,1,3.4,0,2.36,2.36,0,0,1,.7,1.6,2,2,0,0,1-.7,1.6h0Z' transform='translate(-5.08)'/></svg>"
      },
      {
        link: "#",
        title: "Impact",
        icon: "<svg data-name='Layer 1' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 48 40.05'><path d='M46.4,32.4V18.1a1,1,0,0,0-.9-1l-22-13a.91.91,0,0,0-1,0l-22,13a1.06,1.06,0,0,0,0,1.8l8.5,5V40.1a1.06,1.06,0,0,0,.9,1A30.18,30.18,0,0,0,23,44a30.18,30.18,0,0,0,13.1-2.9,1.06,1.06,0,0,0,.9-1V23.9l7.4-4.4V32A3.1,3.1,0,0,0,42,35a3,3,0,0,0,6,0A3.08,3.08,0,0,0,46.4,32.4ZM35,39.4A28.08,28.08,0,0,1,23,42a28.08,28.08,0,0,1-12-2.6V25.1l11.5,6.8a1.3,1.3,0,0,0,1,0L35,25.1ZM23,29.8,3,18,23,6.2,43,18ZM45,36a.94.94,0,0,1-1-1,1,1,0,0,1,1-1,.6.6,0,0,0,.4.1h0a1.15,1.15,0,0,1,.6.9A.94.94,0,0,1,45,36Z' transform='translate(0 -3.95)'/></svg>"
      },
      {
        link: "#",
        title: "New Student Registration",
        icon: "<svg data-name='Layer 1' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 40 48.04'><path d='M42.8,13.2a4,4,0,0,0-5.6,0v.1h-.1L20.8,29.6a.35.35,0,0,0-.1.2c0,.1-.1.1-.1.2l-2.3,6H10a1,1,0,0,0,0,2h9a.37.37,0,0,0,.3-.1L26,35.4c.1,0,.1-.1.2-.1s.1-.1.2-.1L42.7,18.9v-.1h.1A3.87,3.87,0,0,0,42.8,13.2ZM25.1,33.6l-4.4,1.7,1.7-4.4L35.9,17.4l2.8,2.8ZM41.4,17.4h0c0,.1,0,.1-.1.1l-1.2,1.2-2.8-2.8,1.2-1.2v-.1h.1a1.93,1.93,0,0,1,2.8,0,1.93,1.93,0,0,1,0,2.8Z' transform='translate(-4 0.04)'/><path d='M38.9,29a.94.94,0,0,0-1,1V45.5a.64.64,0,0,1-.5.5H6.5a.64.64,0,0,1-.5-.5V14H17a.94.94,0,0,0,1-1V2H37.5a.64.64,0,0,1,.5.5V7a1,1,0,0,0,2,0V2.5A2.48,2.48,0,0,0,37.5,0H17.2a.81.81,0,0,0-.9.3l-12,12a1.4,1.4,0,0,0-.3.9V45.5A2.48,2.48,0,0,0,6.5,48H37.4a2.48,2.48,0,0,0,2.5-2.5V30A.94.94,0,0,0,38.9,29ZM16,3.4V12H7.4Z' transform='translate(-4 0.04)'/></svg>"
      }
    ],
    icons_active: true
  }
};
const parallax = {
  preview_id: {
    background_image: {
      url: "https://d2kzwze52p8717.cloudfront.net/gallery_01.png"
    }
  }
};
const video = {
  preview_id: {
    component_header_top: "View our",
    headline: "Videos",
    show_headline: true,
    videos: [
      {
        id: 1,
        position: 1,
        order: 1,
        url: "https://www.youtube.com/watch?v=4AmdMPrgiYU",
        alt_text: "Video 1",
        title: "Video 1",
        description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas vel enim non dui venenatis vulputate commodo a magna. Pellentesque sed venenatis erat, eget consequat orci. In lacinia mollis ante. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas vel enim non dui venenatis vulputate commodo a magna. Pellentesque sed venenatis erat, eget consequat orci. In lacinia mollis ante.",
        type: "youtube"
      },
      {
        id: 2,
        position: 2,
        order: 2,
        url: "https://www.youtube.com/watch?v=gHiiH1i8KeA",
        alt_text: "Video 2",
        title: "Video 2",
        description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.",
        type: "youtube"
      },
      {
        position: 3,
        url: "https://www.youtube.com/watch?v=yV4g9bwq0Ss",
        alt_text: "Video 3",
        title: "Video 3",
        description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.",
        type: "youtube"
      }
    ]
  }
};
const about = {
  preview_id: {
    component_header: "About Us",
    component_header_top: "This Is",
    component_text: "<p>Our mission is to develop young men with active and creative minds, a sense of understanding and compassion for others, and the courage to act on their beliefs. We stress the total development of each child: spiritual, moral, intellectual, social, emotional, and physical.</p><p><strong>Rick Ross, Superintendent</strong></p>",
    has_image: true,
    has_accent_logo: true,
    has_header: true,
    image: {
      url: "https://apptegy-cms-theme-preview-images.s3.us-east-2.amazonaws.com/superintendent.jpeg",
      alt_text: ""
    },
    links: [
      {
        href: "#",
        title: "Admissions",
        target: "_self",
        icon: "<svg data-name='Layer 1' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 48.08 41.95'><path d='M1,21H7V37H4.1a1,1,0,1,0,0,2H43.9a1,1,0,1,0,0-2H41V21h6a1.2,1.2,0,0,0,1-.7.84.84,0,0,0-.4-1.1l-23-16a1.08,1.08,0,0,0-1.1,0l-23,16a1,1,0,0,0-.4,1.1A1,1,0,0,0,1,21Zm8,0h6V37H9Zm14,0V37H17V21Zm8,0V37H25V21Zm8,16H33V21h6ZM24,5.2,43.8,19H4.2Z' transform='translate(0 -3.05)'/><path d='M47,43H1a1,1,0,0,0,0,2H47a1,1,0,0,0,0-2Z' transform='translate(0 -3.05)'/></svg>"
      },
      {
        href: "#",
        title: "Programs",
        target: "_self",
        icon: "<svg data-name='Layer 1' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 48 46.05'><path d='M.5,14.9l23,12a1.3,1.3,0,0,0,1,0l23-12a1.06,1.06,0,0,0,0-1.8l-23-12a.75.75,0,0,0-.9,0l-23,12A1,1,0,0,0,0,14,1.05,1.05,0,0,0,.5,14.9ZM24,3.1,44.8,14,24,24.9,3.2,14Z' transform='translate(0 -0.95)'/><path d='M47.4,22.6l-3-1.5a1,1,0,0,0-.9,1.7l1.3.6L24,34.9,3.2,23.5l1.3-.6a.88.88,0,0,0,.4-1.3.88.88,0,0,0-1.3-.4l-3,1.5a.76.76,0,0,0-.6.8,1.05,1.05,0,0,0,.5.9l23,12.5a1.3,1.3,0,0,0,1,0l23-12.5a1.05,1.05,0,0,0,.5-.9A1,1,0,0,0,47.4,22.6Z' transform='translate(0 -0.95)'/><path d='M47.4,32.6l-3-1.5a1,1,0,0,0-.9,1.7l1.3.6L24,44.9,3.2,33.5l1.3-.6a.88.88,0,0,0,.4-1.3.88.88,0,0,0-1.3-.4l-3,1.5a.76.76,0,0,0-.6.8,1.05,1.05,0,0,0,.5.9l23,12.5a1.3,1.3,0,0,0,1,0l23-12.5a1.05,1.05,0,0,0,.5-.9A1,1,0,0,0,47.4,32.6Z' transform='translate(0 -0.95)'/></svg>"
      },
      {
        href: "#",
        title: "Library",
        target: "_self",
        icon: "<svg data-name='Layer 1' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 47.92 46.04'><path d='M47.1,1.4A2.32,2.32,0,0,0,45.3,1L24,4.7,2.6,1a2.21,2.21,0,0,0-1.9.6A2.36,2.36,0,0,0,0,3.2V40.9a3.07,3.07,0,0,0,2.3,2.8L23.8,47H24l21.6-3.3a3,3,0,0,0,2.3-2.8V3.2A1.84,1.84,0,0,0,47.1,1.4ZM32,5.3,40,4V15.1l-3.4-2.6a1.07,1.07,0,0,0-1.4.1L32,16.4ZM2,40.9V3.2c0-.1,0-.1.1-.1s.1-.1.2-.1L23,6.5V44.8L2.7,41.7A1.12,1.12,0,0,1,2,40.9Zm44,0a1.12,1.12,0,0,1-.7.8L25,44.8V6.5l5-.9V19a1,1,0,0,0,.7.9c.1,0,.2.1.3.1a.91.91,0,0,0,.8-.4l4.4-5.2,4.2,3.3a1.07,1.07,0,0,0,1.1.1,1.15,1.15,0,0,0,.6-.9V3.6L45.7,3h.2a.35.35,0,0,1,.1.2Z' transform='translate(0 -0.96)'/></svg>"
      },
      {
        href: "#",
        title: "Classes",
        target: "_self",
        icon: "<svg data-name='Layer 1' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 48 48'><path d='M30,6A6,6,0,0,0,18,6,6,6,0,0,0,30,6Zm-6,4a4,4,0,1,1,4-4A4,4,0,0,1,24,10Z'/><path d='M24,12A10,10,0,0,0,14,22v9a.94.94,0,0,0,1,1h3.1L20,47.1a1.06,1.06,0,0,0,1,.9h6a1.06,1.06,0,0,0,1-.9L29.9,32H33a.94.94,0,0,0,1-1V21.9A10,10,0,0,0,24,12Zm8,18H28.7c-.1,0-.1.1-.2.1l-.1.1c-.1,0-.1.1-.1.2a.35.35,0,0,0-.1.2c0,.1,0,.1-.1.2v.1L26.1,46H21.9L20,30.9v-.1c0-.1,0-.1-.1-.2a.1.1,0,0,0-.1-.1c0-.1-.1-.1-.1-.2l-.1-.1c-.1,0-.1-.1-.2-.1H16.1V22a8,8,0,0,1,16,0v8Z'/><path d='M45,9A6,6,0,0,0,33,9,6,6,0,0,0,45,9Zm-6,4a4,4,0,1,1,4-4A4,4,0,0,1,39,13Z'/><path d='M48,25.6C48,19.2,44.5,15,39,15a1,1,0,0,0,0,2c5.2,0,7,4.4,7,8.6V31H43.7c-.1,0-.1,0-.2.1s-.1.1-.2.1l-.1.1a.35.35,0,0,0-.1.2c0,.1-.1.1-.1.2v.1L41.2,43H36.9L36,36.9a1,1,0,0,0-1.9.3l1,7a1.06,1.06,0,0,0,1,.9h6a1.08,1.08,0,0,0,1-.8L44.8,33H47a.94.94,0,0,0,1-1V25.6Z'/><path d='M15,9A5.89,5.89,0,0,0,9,3,5.89,5.89,0,0,0,3,9a5.89,5.89,0,0,0,6,6A5.89,5.89,0,0,0,15,9ZM9,13a4,4,0,1,1,4-4A4,4,0,0,1,9,13Z'/><path d='M13.1,36a.89.89,0,0,0-1.1.8L11.1,43H6.8L5,31.8v-.1c0-.1,0-.1-.1-.2s-.1-.1-.1-.2l-.1-.1c-.1,0-.1-.1-.2-.1a.1.1,0,0,1-.1-.1H2V25.5C2,21.4,3.8,17,9,17a1,1,0,0,0,0-2c-5.5,0-9,4.2-9,10.6V32a.94.94,0,0,0,1,1H3.2L5,44.2A1.08,1.08,0,0,0,6,45h6a1.06,1.06,0,0,0,1-.9l1-7A1,1,0,0,0,13.1,36Z'/></svg>"
      },
      {
        href: "#",
        title: "Educational Programs",
        target: "_self",
        icon: "<svg data-name='Layer 1' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 48 32'><path d='M9,30H19a2.15,2.15,0,0,0,2-2V26.7c0-.1-.1-.1-.1-.2s-.1-.1-.1-.2-.1-.1-.2-.1l-.1-.1-3-1.5A7.08,7.08,0,0,0,18,22h0V18.8c0-.1,0-.1-.1-.2h0C17.5,17,15.6,16,14,16s-3.5,1-3.9,2.6h0c0,.1,0,.1-.1.2V22h0a6,6,0,0,0,.6,2.6l-3,1.5-.1.1c-.1,0-.1.1-.2.1a.35.35,0,0,0-.1.2c0,.1-.1.1-.1.2V28A2,2,0,0,0,9,30Zm5-12c.9,0,1.9.6,2,1.1V22h0a3.37,3.37,0,0,1-.8,2.3.1.1,0,0,1-.1.1l-.1.1v.1c0,.1,0,.1-.1.2v.4c0,.1,0,.1.1.2s.1.1.1.2.1.1.1.2v.1a.1.1,0,0,1,.1.1l.1.1,3.4,1.7V28H9v-.4l3.4-1.7a7961314590657.33,7961314590657.33,0,0,0,.2-.2v-.1a.35.35,0,0,0,.1-.2c0-.1.1-.1.1-.2s0-.1.1-.2v-.4c0-.1,0-.1-.1-.2v-.1l-.1-.1a.1.1,0,0,0-.1-.1,4.09,4.09,0,0,1-.8-2.3h0V18.9A3.76,3.76,0,0,1,14,18Z' transform='translate(0 -8)'/><path d='M47,8H1A.94.94,0,0,0,0,9V39a.94.94,0,0,0,1,1H47a.94.94,0,0,0,1-1V9A.94.94,0,0,0,47,8ZM46,38H39V36a1,1,0,0,0-2,0v2H11V36a.94.94,0,0,0-1-1,.94.94,0,0,0-1,1v2H2V10H46Z' transform='translate(0 -8)'/><path d='M27,18H40a1,1,0,0,0,0-2H27a1,1,0,0,0,0,2Z' transform='translate(0 -8)'/><path d='M27,24H40a1,1,0,0,0,0-2H27a1,1,0,0,0,0,2Z' transform='translate(0 -8)'/><path d='M26.9,30h7a1,1,0,0,0,0-2h-7a1,1,0,0,0,0,2Z' transform='translate(0 -8)'/></svg>"
      },
      {
        href: "#",
        title: "Principal's Greeting",
        target: "_self",
        icon: "<svg data-name='Layer 1' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 47.9 48'><path d='M29.8,25.1A4.1,4.1,0,0,0,34,20.9V4.2A4.1,4.1,0,0,0,29.8,0H4.2A4.1,4.1,0,0,0,0,4.2V32a1.2,1.2,0,0,0,.7,1H1a1.23,1.23,0,0,0,.8-.4l5-7.5ZM2,24V4.2A2.1,2.1,0,0,1,4.2,2H29.8A2.1,2.1,0,0,1,32,4.2V20.9a2.1,2.1,0,0,1-2.2,2.2H6.8a1,1,0,0,0-1.2.3L2,28.7Z'/><path d='M43.8,15H39a1,1,0,0,0,0,2h4.8A2.1,2.1,0,0,1,46,19.2V43.7l-3.4-5a1.38,1.38,0,0,0-.3-.4.91.91,0,0,0-1.1-.2h-23A2.1,2.1,0,0,1,16,35.9V30a1,1,0,0,0-2,0v5.9a4.1,4.1,0,0,0,4.2,4.2H41.1l5,7.5a.91.91,0,0,0,.8.4h.3a1,1,0,0,0,.7-1V19.2A4,4,0,0,0,43.8,15Z'/></svg>"
      }
    ]
  }
};
const floating_nav = {
  buttons: [
    {
      url: "#",
      title: "Enroll Now",
      mailto: false,
      email_address: "",
      opens_in_new_tab: false,
      icon: "<svg data-name='Layer 1' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 48 48'><path d='M13,18H9a.94.94,0,0,0-1,1v4a.94.94,0,0,0,1,1h4a.94.94,0,0,0,1-1V19A.94.94,0,0,0,13,18Zm-1,4H10V20h2Z'/><path d='M26,18H22a.94.94,0,0,0-1,1v4a.94.94,0,0,0,1,1h4a.94.94,0,0,0,1-1V19A.94.94,0,0,0,26,18Zm-1,4H23V20h2Z'/><path d='M39,18H35a.94.94,0,0,0-1,1v4a.94.94,0,0,0,1,1h4a.94.94,0,0,0,1-1V19A.94.94,0,0,0,39,18Zm-1,4H36V20h2Z'/><path d='M13,30H9a.94.94,0,0,0-1,1v4a.94.94,0,0,0,1,1h4a.94.94,0,0,0,1-1V31A.94.94,0,0,0,13,30Zm-1,4H10V32h2Z'/><path d='M26,30H22a.94.94,0,0,0-1,1v4a.94.94,0,0,0,1,1h4a.94.94,0,0,0,1-1V31A.94.94,0,0,0,26,30Zm-1,4H23V32h2Z'/><path d='M39,30H35a.94.94,0,0,0-1,1v4a.94.94,0,0,0,1,1h4a.94.94,0,0,0,1-1V31A.94.94,0,0,0,39,30Zm-1,4H36V32h2Z'/><path d='M45,6H35V1a1,1,0,0,0-2,0V6H15V1a1,1,0,0,0-2,0V6H3A3,3,0,0,0,0,9V45a3,3,0,0,0,3,3H45a3,3,0,0,0,3-3V9A3,3,0,0,0,45,6Zm1,39a.94.94,0,0,1-1,1H3a.94.94,0,0,1-1-1V9A.94.94,0,0,1,3,8H13v3a1,1,0,0,0,2,0V8H33v3a1,1,0,0,0,2,0V8H45a.94.94,0,0,1,1,1Z'/></svg>"
    },
    {
      url: "#",
      title: "About Us",
      mailto: false,
      email_address: "",
      opens_in_new_tab: false,
      icon: "<svg data-name='Layer 1' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 48 48'><path d='M24,0A24,24,0,1,0,48,24,24,24,0,0,0,24,0Zm0,46A22,22,0,1,1,46,24,22,22,0,0,1,24,46Z'/><path d='M24,32a.94.94,0,0,0,1-.88V13a1,1,0,0,0-2,0V31a.94.94,0,0,0,.88,1Z'/><path d='M24,35a2,2,0,1,1-2,2A2,2,0,0,1,24,35Z'/></svg>"
    },
    {
      url: "#",
      title: "Students & Families",
      mailto: false,
      email_address: "",
      opens_in_new_tab: false,
      icon: "<svg data-name='Layer 1' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 39.8 42.1'><path d='M30.7,33.6V27.8h0a6.87,6.87,0,0,0-5-6.6,4.3,4.3,0,1,0-3.8,0,6.87,6.87,0,0,0-5,6.6h0v5.8a.94.94,0,0,0,1,1h1.7l1.2,9.6a1.06,1.06,0,0,0,1,.9h3.9a1.06,1.06,0,0,0,1-.9l1.2-9.6h1.7A1,1,0,0,0,30.7,33.6ZM23.9,15a2.3,2.3,0,1,1-2.3,2.3A2.26,2.26,0,0,1,23.9,15Zm4.8,17.6H26.8c-.1,0-.1.1-.2.1s-.1.1-.2.1l-.1.1a.35.35,0,0,0-.1.2c0,.1,0,.1-.1.2v.1L24.9,43H22.8l-1.2-9.6v-.1c0-.1,0-.1-.1-.2s-.1-.1-.1-.2-.1-.1-.1-.2l-.1-.1c-.1,0-.1-.1-.2-.1H19V27.7h0a4.9,4.9,0,0,1,9.8,0h0v4.9Z' transform='translate(-4 -3)'/><path d='M40.7,9a6,6,0,1,0-12,0,6,6,0,1,0,12,0Zm-6,4a4,4,0,1,1,4-4A4,4,0,0,1,34.7,13Z' transform='translate(-4 -3)'/><path d='M43.7,25.6c0-6.4-3.5-10.6-9-10.6h0a8.61,8.61,0,0,0-5.3,1.7,1.08,1.08,0,0,0-.2,1.4.91.91,0,0,0,.8.4,1.42,1.42,0,0,0,.6-.2A6.29,6.29,0,0,1,34.7,17h0c5.2,0,7,4.4,7,8.6V31H39.4c-.1,0-.1,0-.2.1s-.1.1-.2.1l-.1.1a.35.35,0,0,0-.1.2c0,.1-.1.1-.1.2v.1L36.9,43H32.6l-.9-6.1a1,1,0,0,0-1.9.3l1,7a1.06,1.06,0,0,0,1,.9h6a1.08,1.08,0,0,0,1-.8L40.6,33h2.2a.94.94,0,0,0,1-1V25.7c-.1,0-.1,0-.1-.1Z' transform='translate(-4 -3)'/><path d='M19,9a5.89,5.89,0,0,0-6-6A5.89,5.89,0,0,0,7,9a5.89,5.89,0,0,0,6,6A5.89,5.89,0,0,0,19,9Zm-6,4a4,4,0,1,1,4-4A4,4,0,0,1,13,13Z' transform='translate(-4 -3)'/><path d='M17.1,36a.94.94,0,0,0-1.1.8L15.1,43H10.8L9,31.8v-.1c0-.1,0-.1-.1-.2s-.1-.1-.1-.2l-.1-.1c-.1-.1-.1-.1-.2-.1a.1.1,0,0,1-.1-.1H6V25.5c0-4.2,1.8-8.6,7-8.6a6.29,6.29,0,0,1,4.1,1.3,1.42,1.42,0,0,0,.6.2.91.91,0,0,0,.8-.4,1,1,0,0,0-.2-1.4A9.23,9.23,0,0,0,13,15c-5.5,0-9,4.2-9,10.6V32a.94.94,0,0,0,1,1H7.2L9,44.2a1,1,0,0,0,1,.8h6a1.06,1.06,0,0,0,1-.9l1-7A1,1,0,0,0,17.1,36Z' transform='translate(-4 -3)'/></svg>"
    },
    {
      url: "#",
      title: "Employees",
      mailto: false,
      email_address: "",
      opens_in_new_tab: false,
      icon: "<svg data-name='Layer 1' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 48 48'><path d='M24,0A24,24,0,1,0,48,24,24.07,24.07,0,0,0,24,0ZM43,35H35.1A33.45,33.45,0,0,0,37,25h9A21.63,21.63,0,0,1,43,35ZM25.6,45.9H25v-9h7.1A28.08,28.08,0,0,1,25.6,45.9Zm-3.2,0A28.68,28.68,0,0,1,15.8,37H23v9A1.27,1.27,0,0,1,22.4,45.9ZM5,35A21.63,21.63,0,0,1,2,25h9a30.6,30.6,0,0,0,1.9,10ZM5,13h7.9A33.45,33.45,0,0,0,11,23H2A21.63,21.63,0,0,1,5,13ZM22.4,2.1H23v9H15.9A28.08,28.08,0,0,1,22.4,2.1Zm3.2,0A28.68,28.68,0,0,1,32.2,11H25V2A1.27,1.27,0,0,1,25.6,2.1ZM33,13a30.17,30.17,0,0,1,2,10H25V13ZM23,13V23H13a30.17,30.17,0,0,1,2-10ZM13,25H23V35H15A30.17,30.17,0,0,1,13,25ZM25,35V25H35a30.17,30.17,0,0,1-2,10ZM37,23a30.6,30.6,0,0,0-1.9-10H43a21.53,21.53,0,0,1,2.9,10Zm4.7-12H34.3a29.48,29.48,0,0,0-5.4-8.4A21.28,21.28,0,0,1,41.7,11ZM19.1,2.6A29.48,29.48,0,0,0,13.7,11H6.3A21.28,21.28,0,0,1,19.1,2.6ZM6.3,37h7.4a29.48,29.48,0,0,0,5.4,8.4A21.28,21.28,0,0,1,6.3,37Zm22.6,8.4A28.74,28.74,0,0,0,34.3,37h7.4A21.28,21.28,0,0,1,28.9,45.4Z'/></svg>"
    },
    {
      url: "#",
      title: "Foundation",
      mailto: false,
      email_address: "",
      opens_in_new_tab: false,
      icon: "<svg data-name='Layer 1' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 48 48'><path d='M42,36a6.06,6.06,0,0,0-3.5,1.1l-9.6-9.6a6.07,6.07,0,0,0-1.7-8.6l3.2-7.1a7.72,7.72,0,0,0,1.5.2,5.89,5.89,0,0,0,6-6,6,6,0,0,0-12,0,6,6,0,0,0,2.6,5l-3.3,7.2A3.73,3.73,0,0,0,24,18a6,6,0,0,0-6,6,6.93,6.93,0,0,0,.3,2l-7.6,4.3A6,6,0,1,0,12,34a6.93,6.93,0,0,0-.3-2l7.6-4.3A6,6,0,0,0,24,30a6.06,6.06,0,0,0,3.5-1.1l9.6,9.6A6,6,0,1,0,42,36ZM32,2a4,4,0,1,1-4,4A4,4,0,0,1,32,2ZM6,38a4,4,0,1,1,4-4A4,4,0,0,1,6,38ZM20,24a4,4,0,0,1,4-4,3.19,3.19,0,0,1,1.4.3h.1A4,4,0,0,1,27.9,24a3.86,3.86,0,0,1-1.1,2.7l-.1.1-.1.1A3.47,3.47,0,0,1,24,28,4,4,0,0,1,20,24ZM42,46a4,4,0,0,1-4-4,3.86,3.86,0,0,1,1.1-2.7l.1-.1.1-.1A3.86,3.86,0,0,1,42,38a4,4,0,0,1,0,8Z' transform='translate(0 0)'/></svg>"
    }
  ],
  is_fixed: true,
  shape: "rounded"
};
const sticky_footer = {
  show_pill_button: true,
  show_social_icons: true,
  show_only_on_homepage: true,
  hide_text_label: "hide",
  show_text_label: "show",
  pill_button: {
    title: "REGISTER",
    link: "",
    opens_in_new_tab: false
  },
  icon_buttons: [
    {
      icon: "<svg data-name='Layer 1' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 48 48'><path d='M24,0A24.07,24.07,0,0,0,0,24V37.8A4.25,4.25,0,0,0,4.3,42H7.7A4.25,4.25,0,0,0,12,37.8c0-.2,0-.3-.1-.4V28.2A4.25,4.25,0,0,0,7.6,24H4.3a3.89,3.89,0,0,0-2.3.7V24a22,22,0,0,1,44,0v.7a4.76,4.76,0,0,0-2.3-.7H40.4a4.25,4.25,0,0,0-4.3,4.2v9.6A4.25,4.25,0,0,0,40.4,42h1.1l-10,4H27V45a.94.94,0,0,0-1-1H22a.94.94,0,0,0-1,1v2a.94.94,0,0,0,1,1h9.7a.6.6,0,0,0,.4-.1l15.3-6.1a1,1,0,0,0,.6-.9V24A24.07,24.07,0,0,0,24,0ZM4.3,26H7.6a2.24,2.24,0,0,1,2.3,2.2v9.6a.6.6,0,0,0,.1.4A2.29,2.29,0,0,1,7.7,40H4.3A2.24,2.24,0,0,1,2,37.8V28.2A2.24,2.24,0,0,1,4.3,26ZM38.1,37.8V28.2A2.24,2.24,0,0,1,40.4,26h3.3A2.24,2.24,0,0,1,46,28.2v9.6A2.24,2.24,0,0,1,43.7,40H40.4A2.24,2.24,0,0,1,38.1,37.8Z'/></svg>",
      link: "",
      title: "ASSISTANCE",
      icon_id: 106,
      opens_in_new_tab: false
    },
    {
      icon: "<svg data-name='Layer 1' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 36 48'><path d='M34,25l-6-.6-.1-.1-2.4-5.5a1.3,1.3,0,0,0-1-.9,1.5,1.5,0,0,0-1.3.7c0,.1-.1.1-.1.2l-2.4,5.5c0,.1-.1.1-.2.2l-6,.6h-.1a1.49,1.49,0,0,0-1.1.9,1.25,1.25,0,0,0,.4,1.3l4.5,4.6s.1.2,0,.2l-1.8,6.2a1.34,1.34,0,0,0,.4,1.4,1.21,1.21,0,0,0,1.5-.1l5.8-4,6,4a1.33,1.33,0,0,0,.8.3,1.85,1.85,0,0,0,.7-.2c.2-.1.7-.5.4-1.5L30.2,32v-.3l4.5-4.6a1.44,1.44,0,0,0,.4-1.5A1.22,1.22,0,0,0,34,25Zm-5.1,5.5a2.44,2.44,0,0,0-.6,2.2L29.5,37l-4.3-2.9a2.17,2.17,0,0,0-2.2,0l-4.1,2.8,1.2-4.3a2,2,0,0,0-.6-2.1l-3.6-3.6,4.5-.5a2.16,2.16,0,0,0,1.9-1.3l1.7-4,1.7,4a2.18,2.18,0,0,0,1.8,1.4h0l4.6.5Z' transform='translate(-6)'/><path d='M34,15.1,38.8,1.4a.9.9,0,0,0-.1-1,.91.91,0,0,0-.8-.4H10.3a1.23,1.23,0,0,0-.8.4.74.74,0,0,0-.1.9L14,15.1a18,18,0,1,0,20,0ZM11.7,2H36.5L32.3,14a18.22,18.22,0,0,0-16.6,0ZM24,46A16,16,0,1,1,40,30,16,16,0,0,1,24,46Z' transform='translate(-6)'/></svg>",
      link: "",
      title: "AWARDS",
      icon_id: 128,
      opens_in_new_tab: false
    },
    {
      icon: "<svg data-name='Layer 1' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 42 48'><path d='M40.9,0H7.1A4,4,0,0,0,3,4V42a.94.94,0,0,0,1,1H5v4a.94.94,0,0,0,1,1H16a.94.94,0,0,0,1-1V43H31v4a.94.94,0,0,0,1,1H42a.94.94,0,0,0,1-1V43h1a.94.94,0,0,0,1-1V4A4.1,4.1,0,0,0,40.9,0ZM5,12H43V27H5ZM7.1,2H40.9A2.09,2.09,0,0,1,43,4v6H5V4A2,2,0,0,1,7.1,2ZM15,46H7V43h8Zm26,0H33V43h8ZM5,41V29H43V41Z' transform='translate(-3)'/><path d='M15,7H33a.94.94,0,0,0,1-1,.94.94,0,0,0-1-1H15a.94.94,0,0,0-1,1A.94.94,0,0,0,15,7Z' transform='translate(-3)'/><path d='M36,32a3,3,0,1,0,3,3A2.95,2.95,0,0,0,36,32Zm0,4a1,1,0,1,1,1-1A.94.94,0,0,1,36,36Z' transform='translate(-3)'/><path d='M12,32a3,3,0,1,0,3,3A2.95,2.95,0,0,0,12,32Zm0,4a1,1,0,1,1,1-1A.94.94,0,0,1,12,36Z' transform='translate(-3)'/></svg>",
      link: "",
      title: "TRANSPORTATION",
      icon_id: 45,
      opens_in_new_tab: false
    },
    {
      title: "ANNOUCEMENT",
      link: "",
      opens_in_new_tab: false,
      icon: "<svg data-name='Layer 1' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 48 40.05'><path d='M42,15V5a1.05,1.05,0,0,0-.5-.9.91.91,0,0,0-1,0L26.7,12H3a3,3,0,0,0-3,3V27a3,3,0,0,0,3,3H8V43a.94.94,0,0,0,1,1,.94.94,0,0,0,1-1V30H26.7l13.8,7.9a1.3,1.3,0,0,0,1,0A1.05,1.05,0,0,0,42,37V27a5.89,5.89,0,0,0,6-6A5.89,5.89,0,0,0,42,15ZM3,28a.94.94,0,0,1-1-1V15a.94.94,0,0,1,1-1H8V28Zm37,7.3L27.5,28.2h-.1c-.1,0-.1,0-.2-.1H10V14H27.3c.1,0,.1,0,.2-.1h.1L40,6.7ZM42,25V17a4,4,0,0,1,0,8Z' transform='translate(0 -3.95)'/></svg>",
      icon_id: 24
    },
    {
      title: "BLACKBOARD",
      link: "",
      opens_in_new_tab: false,
      icon: "<svg data-name='Layer 1' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 48 48'><path d='M45,6H25V1a1,1,0,0,0-2,0V6H3A3,3,0,0,0,0,9V35a3,3,0,0,0,3,3H8.9L4.1,46.5a1.11,1.11,0,0,0,.4,1.4A.9.9,0,0,0,5,48a1.19,1.19,0,0,0,.9-.5l5.2-9.2a.37.37,0,0,0,.1-.3H23v7a1,1,0,0,0,2,0V38H36.8a.37.37,0,0,0,.1.3l5.2,9.2a1.05,1.05,0,0,0,.9.5.9.9,0,0,0,.5-.1,1,1,0,0,0,.4-1.4L39.1,38H45a3,3,0,0,0,3-3V9A3,3,0,0,0,45,6ZM3,8H45a.94.94,0,0,1,1,1v3H2V9A.94.94,0,0,1,3,8ZM45,36H3a.94.94,0,0,1-1-1V14H46V35A.94.94,0,0,1,45,36Z'/></svg>",
      icon_id: 34
    }
  ],
  social_media_icons: [
    {
      title: "facebook",
      link: "#",
      opens_in_new_tab: false,
      icon: "<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32' style='enable-background:new 0 0 32 32;' xml:space='preserve'> <path style='fill:#4373B9;' d='M5.3,0h21.3C29.6,0,32,2.4,32,5.3v21.3c0,2.9-2.4,5.3-5.3,5.3H5.3C2.4,32,0,29.6,0,26.7V5.3 C0,2.4,2.4,0,5.3,0z'/> <path style='fill:#FFFFFF;' d='M25.7,19.8l0.8-5.5h-4.8v-3.6c0-1.5,0.7-3,2.8-3h2.2V3c0,0-2-0.4-3.8-0.4c-3.9,0-6.5,2.6-6.5,7.4v4.2 H12v5.5h4.4V32H19h2.7V19.8H25.7z'/> </svg>",
      icon_id: 1
    },
    {
      title: "twitter",
      link: "#",
      opens_in_new_tab: false,
      icon: "<svg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 32 32' style='enable-background:new 0 0 32 32;' xml:space='preserve'> <path style='fill:#439CD6;' d='M5.3,0h21.3C29.6,0,32,2.4,32,5.3v21.3c0,2.9-2.4,5.3-5.3,5.3H5.3C2.4,32,0,29.6,0,26.7V5.3 C0,2.4,2.4,0,5.3,0z'/> <path style='fill:#FFFFFF;' d='M11.7,25.3c8.8,0,13.6-7.2,13.6-13.4c0-0.2,0-0.4,0-0.6c0.9-0.7,1.7-1.5,2.4-2.4 c-0.9,0.4-1.8,0.6-2.7,0.7C25.9,9,26.7,8.1,27,7c-0.9,0.5-2,0.9-3,1.1c-0.7-0.8-1.7-1.3-2.7-1.4c-1-0.2-2.1,0-3,0.5 c-0.9,0.5-1.7,1.3-2.1,2.2c-0.4,0.9-0.5,2-0.3,3c-1.9-0.1-3.8-0.6-5.5-1.4C8.7,10.2,7.2,9,6,7.5c-0.6,1-0.8,2.3-0.5,3.4 c0.3,1.2,1,2.2,2,2.9c-0.8,0-1.5-0.2-2.2-0.6c0,0,0,0,0,0.1c0,1.1,0.4,2.1,1.1,3C7,17.1,8,17.7,9.1,17.9c-0.7,0.2-1.4,0.2-2.2,0.1 c0.3,0.9,0.9,1.8,1.7,2.3c0.8,0.6,1.8,0.9,2.8,0.9c-1.7,1.3-3.8,2-5.9,2c-0.4,0-0.8,0-1.1-0.1C6.5,24.6,9.1,25.3,11.7,25.3'/> </svg>",
      icon_id: 2
    },
    {
      title: "instagram",
      link: "#",
      opens_in_new_tab: false,
      icon: "<svg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 32 32' style='enable-background:new 0 0 32 32;' xml:space='preserve'> <path style='fill:#E02D6A;' d='M5.3,0h21.3C29.6,0,32,2.4,32,5.3v21.3c0,2.9-2.4,5.3-5.3,5.3H5.3C2.4,32,0,29.6,0,26.7V5.3 C0,2.4,2.4,0,5.3,0z'/> <g> <defs> <rect id='SVGID_1_' x='4' y='4' width='24' height='24'/> </defs> <clipPath id='SVGID_00000089557840403914515610000007237598468725314216_'> <use xlink:href='#SVGID_1_'  style='overflow:visible;'/> </clipPath> <g style='clip-path:url(#SVGID_00000089557840403914515610000007237598468725314216_);'> <path style='fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;' d='M21,6H11c-2.8,0-5,2.2-5,5v10c0,2.8,2.2,5,5,5h10 c2.8,0,5-2.2,5-5V11C26,8.2,23.8,6,21,6z M11,4c-3.9,0-7,3.1-7,7v10c0,3.9,3.1,7,7,7h10c3.9,0,7-3.1,7-7V11c0-3.9-3.1-7-7-7H11z M24,9.6c0,0.9-0.7,1.6-1.6,1.6c-0.9,0-1.6-0.7-1.6-1.6c0-0.9,0.7-1.6,1.6-1.6C23.3,8,24,8.7,24,9.6z M20.4,16 c0,2.4-2,4.4-4.4,4.4c-2.4,0-4.4-2-4.4-4.4c0-2.4,2-4.4,4.4-4.4C18.4,11.6,20.4,13.6,20.4,16z M22.4,16c0,3.5-2.9,6.4-6.4,6.4 c-3.5,0-6.4-2.9-6.4-6.4c0-3.5,2.9-6.4,6.4-6.4C19.5,9.6,22.4,12.5,22.4,16z'/> </g> </g> </svg>",
      icon_id: 3
    },
    {
      title: "youtube",
      link: "#",
      opens_in_new_tab: false,
      icon: "<svg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 32 32' style='enable-background:new 0 0 32 32;' xml:space='preserve'> <path style='fill:#ED2224;' d='M5.3,0h21.3C29.6,0,32,2.4,32,5.3v21.3c0,2.9-2.4,5.3-5.3,5.3H5.3C2.4,32,0,29.6,0,26.7V5.3 C0,2.4,2.4,0,5.3,0z'/> <path style='fill:#FFFFFF;' d='M27.5,10.6c-0.1-0.5-0.4-1-0.8-1.3c-0.4-0.4-0.8-0.6-1.3-0.8C23.5,8,16,8,16,8S8.5,8,6.6,8.5 c-0.5,0.1-1,0.4-1.3,0.8c-0.4,0.4-0.6,0.8-0.8,1.3C4,12.5,4,16.4,4,16.4s0,3.9,0.5,5.8c0.3,1,1.1,1.8,2.1,2.1 c1.9,0.5,9.4,0.5,9.4,0.5s7.5,0,9.4-0.5c1-0.3,1.8-1.1,2.1-2.1c0.5-1.9,0.5-5.8,0.5-5.8S28,12.5,27.5,10.6z'/> <polygon style='fill:#ED2224;' points='13.6,20 13.6,12.8 19.8,16.4 '/> </svg>",
      icon_id: 4
    }
  ]
};
const timeline = {
  preview_id: {
    show_component_header: true,
    show_slider_controls: true,
    show_scroll_text: true,
    auto_scroll: false,
    hide_component: false,
    component_header: "From Small Beginnings to Big Dreams: Our School's Story of Success",
    scroll_text: "Where Every Journey Starts with a Single Step",
    items: [
      {
        id: 1,
        year: "2020",
        title: "Building the Foundation",
        description: "Our humble beginnings set the stage for endless possibilities ahead.",
        image: {
          url: "https://d2kzwze52p8717.cloudfront.net/arts.png",
          alt_text: "alt_text"
        }
      },
      {
        id: 1,
        year: "2021",
        title: "Growing Together",
        description: "Every classroom is a hub of creativity and growth, sparking new ideas.",
        image: {
          url: "https://d2kzwze52p8717.cloudfront.net/athletics.png",
          alt_text: "alt_text"
        }
      },
      {
        id: 1,
        year: "2022",
        title: "Lessons for Life",
        description: "We teach skills for life, preparing students for real-world challenges.",
        image: {
          url: "https://d2kzwze52p8717.cloudfront.net/health.png",
          alt_text: "alt_text"
        }
      },
      {
        id: 1,
        year: "2023",
        title: "Our Road to Success",
        description: "Every challenge faced is a lesson learned on our path to achievement.",
        image: {
          url: "https://d2kzwze52p8717.cloudfront.net/education.png",
          alt_text: "alt_text"
        }
      },
      {
        id: 1,
        year: "2024",
        title: "Strong Roots, Big Dreams",
        description: "Together, we build a legacy that empowers generations to come.",
        image: {
          url: "https://d2kzwze52p8717.cloudfront.net/computer_science.png",
          alt_text: "alt_text"
        }
      }
    ]
  }
};
const custom_component = {
  preview_id: {
    textarea: {
      "cms-textarea": {
        text: "Community\nCreativity\nGrowth"
      }
    },
    input: {
      "cms-input": {
        text: "A Story of Passion and Purpose"
      }
    },
    image: {
      "cms-image": {
        alt_text: "students in a classroom",
        url: "https://public-apptegy-assets.s3.us-east-2.amazonaws.com/apptegy-cms-theme-preview-images/students.jpeg"
      }
    },
    loop: {
      "cms-loop": [
        {
          input: {
            "cms-input": {
              text: "A Story of Passion and Purpose"
            }
          },
          textarea: {
            "cms-textarea": {
              text: "Community\nCreativity\nGrowth"
            }
          },
          rich_textarea: {
            "cms-rich_textarea": {
              text: "<p>Our mission is to develop young men with active and creative minds, a sense of understanding and compassion for others, and the courage to act on their beliefs. We stress the total development of each child: spiritual, moral, intellectual, social, emotional, and physical.</p><p><strong>Rick Ross, Superintendent</strong></p>"
            }
          },
          image: {
            "cms-image": {
              alt_text: "students in a classroom",
              url: "https://public-apptegy-assets.s3.us-east-2.amazonaws.com/apptegy-cms-theme-preview-images/students.jpeg"
            }
          },
          icon: {
            "cms-icon": {
              icon: '<svg width="100%" height="100%" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><title>Placeholder for cms-icon</title><path fill-rule="evenodd" clip-rule="evenodd" d="M7.99998 0C12.4183 0 16.0001 3.58178 16.0001 8.00008C16.0001 12.4181 12.4183 15.9999 7.99998 15.9999C3.58176 15.9999 0 12.4181 0 8.00008C0 3.58178 3.58176 0 7.99998 0Z"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M10.8144 6.07292L7.94646 10.8265C7.80032 10.9837 7.59753 11.0287 7.4095 10.9844C7.22147 11.0287 7.0188 10.9837 6.87266 10.8265L5.1731 9.00103C4.9449 8.75609 4.9449 8.35895 5.1731 8.11376C5.40118 7.86883 5.77105 7.86883 5.99924 8.11376L7.34782 9.56223L9.9882 5.18566C10.2164 4.94072 10.5863 4.94072 10.8144 5.18566C11.0425 5.43059 11.0425 5.82799 10.8144 6.07292Z" fill="white"></path></svg>'
            }
          }
        }
      ]
    },
    rich_textarea: {
      "cms-rich_textarea": {
        text: "<p>Our mission is to develop young men with active and creative minds, a sense of understanding and compassion for others, and the courage to act on their beliefs. We stress the total development of each child: spiritual, moral, intellectual, social, emotional, and physical.</p><p><strong>Rick Ross, Superintendent</strong></p>"
      }
    },
    icon: {
      "cms-icon": {
        icon: '<svg width="100%" height="100%" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><title>Placeholder for cms-icon</title><path fill-rule="evenodd" clip-rule="evenodd" d="M7.99998 0C12.4183 0 16.0001 3.58178 16.0001 8.00008C16.0001 12.4181 12.4183 15.9999 7.99998 15.9999C3.58176 15.9999 0 12.4181 0 8.00008C0 3.58178 3.58176 0 7.99998 0Z"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M10.8144 6.07292L7.94646 10.8265C7.80032 10.9837 7.59753 11.0287 7.4095 10.9844C7.22147 11.0287 7.0188 10.9837 6.87266 10.8265L5.1731 9.00103C4.9449 8.75609 4.9449 8.35895 5.1731 8.11376C5.40118 7.86883 5.77105 7.86883 5.99924 8.11376L7.34782 9.56223L9.9882 5.18566C10.2164 4.94072 10.5863 4.94072 10.8144 5.18566C11.0425 5.43059 11.0425 5.82799 10.8144 6.07292Z" fill="white"></path></svg>'
      }
    }
  }
};
const alert_banner = {
  content: "<p>hello world!</p>",
  enabled: true,
  light_box: false,
  display_on_all_pages: true
};
const alert_modal = {
  content: "<p>hello world!</p>",
  enabled: true,
  light_box: true,
  display_on_all_pages: true
};
const editableHomepageComponents = {
  description,
  gallery,
  events,
  athletics,
  news,
  live_feed,
  stats,
  header,
  footer,
  programs,
  our_schools,
  spotlights,
  buttons,
  parallax,
  video,
  about,
  floating_nav,
  sticky_footer,
  timeline,
  custom_component,
  alert_banner,
  alert_modal
};
const orgDefaults = [
  {
    alias: "district",
    name: "District",
    path_prefix: "",
    primary: true
  },
  {
    alias: "highschool",
    name: "High School",
    path_prefix: "",
    primary: false
  },
  {
    alias: "middleschool",
    name: "Middle School",
    path_prefix: "",
    primary: false
  },
  {
    alias: "elementaryschool",
    name: "Elementary School",
    path_prefix: "",
    primary: false
  }
];
const siteMenuDefaults = [
  {
    id: 2,
    name: "Student Resources",
    slug: "student-resources",
    type: "header",
    position: 1,
    status: "published",
    hidden: false,
    published_at: "2019-10-08T20:58:08.501-05:00",
    children: [
      {
        id: 210,
        name: "Resource Guide",
        slug: "resources",
        type: "page",
        position: 1,
        status: "published",
        hidden: false,
        published_at: "2019-10-08T20:58:09.831-05:00",
        children: []
      },
      {
        id: 22,
        name: "Course Guide",
        slug: "course-guide",
        type: "page",
        position: 1,
        status: "published",
        hidden: false,
        published_at: "2019-10-08T20:58:11.688-05:00",
        children: []
      },
      {
        id: 23,
        name: "Calendars",
        slug: "calendars",
        type: "page",
        position: 1,
        status: "published",
        hidden: false,
        published_at: "2019-10-08T20:58:12.950-05:00",
        children: [
          {
            id: 231,
            name: "High School Calendar",
            slug: "high-school-calendar",
            type: "page",
            position: 1,
            status: "published",
            hidden: false,
            published_at: "2019-10-08T21:00:20.036-05:00",
            children: []
          },
          {
            id: 232,
            name: "Middle School Calendar",
            slug: "middle-school-calendar",
            type: "page",
            position: 1,
            status: "published",
            hidden: false,
            published_at: "2019-10-08T21:00:21.335-05:00",
            children: []
          }
        ]
      }
    ]
  },
  {
    id: 3,
    name: "FAQs",
    slug: "faqs",
    type: "page",
    mailto: true,
    email_address: "",
    position: 2,
    opens_in_new_tab: false,
    status: "published",
    hidden: false,
    published_at: "2021-05-12T13:04:50.667-05:00",
    children: [
      {
        id: 31,
        name: "Admissions",
        slug: "admissions",
        type: "page",
        mailto: true,
        email_address: "",
        position: 9,
        opens_in_new_tab: false,
        status: "published",
        hidden: false,
        published_at: "2021-05-12T13:04:50.667-05:00",
        children: [
          {
            id: 311,
            name: "Coming Soon",
            type: "header",
            mailto: true,
            email_address: "",
            position: 9,
            opens_in_new_tab: false,
            status: "published",
            hidden: false,
            published_at: "2021-05-12T13:04:50.667-05:00",
            children: []
          }
        ]
      }
    ]
  },
  {
    id: 4,
    name: "Contact Us",
    type: "link",
    mailto: true,
    email_address: "contact@school.com",
    position: 3,
    opens_in_new_tab: false,
    status: "published",
    hidden: false,
    published_at: "2021-05-12T13:04:50.667-05:00",
    children: []
  },
  {
    id: 5,
    name: "Portal",
    type: "link",
    mailto: false,
    ipAddress: false,
    url: "http://www.apptegy.com",
    position: 4,
    opens_in_new_tab: true,
    status: "published",
    hidden: false,
    published_at: "2021-05-12T13:04:50.667-05:00",
    children: [
      {
        id: 51,
        name: "School IP Address",
        type: "link",
        mailto: false,
        ipAddress: true,
        url: "127.0.0.1",
        position: 4,
        opens_in_new_tab: false,
        status: "published",
        hidden: false,
        published_at: "2021-05-12T13:04:50.667-05:00",
        children: []
      }
    ]
  },
  {
    id: 6,
    name: "Extracurriculars List",
    slug: "extras",
    type: "page",
    mailto: true,
    email_address: "",
    position: 5,
    opens_in_new_tab: false,
    status: "published",
    hidden: false,
    published_at: "2021-05-12T13:04:50.667-05:00",
    children: [
      {
        id: 61,
        name: "All Opportunities - Coming Soon",
        type: "header",
        mailto: true,
        email_address: "",
        position: 5,
        opens_in_new_tab: false,
        status: "published",
        hidden: false,
        published_at: "2021-05-12T13:04:50.667-05:00",
        children: []
      }
    ]
  },
  {
    id: 7,
    name: "Scholarship Info",
    slug: "scholarships",
    opens_in_new_tab: true,
    type: "page",
    position: 6,
    status: "published",
    hidden: false,
    published_at: "2019-10-08T20:58:28.120-05:00",
    children: []
  },
  {
    id: 8,
    name: "Guidance Directory",
    slug: "guidance-directory",
    type: "page",
    position: 7,
    status: "published",
    hidden: false,
    published_at: "2019-10-08T20:58:18.279-05:00",
    children: [
      {
        id: 81,
        name: "Incoming Students",
        slug: "for-other-parents",
        type: "header",
        position: 7,
        status: "published",
        hidden: false,
        published_at: "2019-10-08T20:58:19.686-05:00",
        children: [
          {
            id: 811,
            name: "Parent Resources",
            slug: "parent resources",
            type: "page",
            position: 7,
            status: "published",
            hidden: false,
            published_at: "2019-10-08T20:58:21.622-05:00",
            children: []
          }
        ]
      },
      {
        id: 82,
        name: "Returning Students",
        slug: "returning-students",
        type: "header",
        position: 7,
        status: "published",
        hidden: false,
        published_at: "2019-10-08T20:58:23.939-05:00",
        children: [
          {
            id: 821,
            name: "Parent Resources",
            slug: "parent-resources-upper-class",
            type: "page",
            position: 7,
            status: "published",
            hidden: false,
            published_at: "2019-10-08T20:58:25.410-05:00",
            children: []
          },
          {
            id: 822,
            name: "Student Resources",
            slug: "student-resources-upper-class",
            type: "page",
            position: 1,
            status: "published",
            hidden: false,
            published_at: "2019-10-08T20:58:26.802-05:00",
            children: []
          }
        ]
      }
    ]
  },
  {
    id: 9,
    name: "Study Abroad",
    slug: "other-option-10",
    type: "link",
    url: "https://apptegy.com",
    position: 8,
    status: "published",
    hidden: false,
    published_at: "2019-10-08T20:58:28.120-05:00",
    children: [
      {
        id: 91,
        name: "Host Family Guide",
        slug: "host-family-guide",
        type: "page",
        position: 8,
        status: "published",
        hidden: false,
        published_at: "2019-10-08T20:58:28.120-05:00",
        children: []
      }
    ]
  },
  {
    id: 10,
    name: "Site Information",
    slug: "our-students",
    type: "header",
    position: 9,
    status: "published",
    hidden: false,
    published_at: "2019-10-08T20:58:14.226-05:00",
    children: [
      {
        id: 101,
        name: "Academics",
        slug: "academics",
        type: "page",
        position: 9,
        status: "published",
        hidden: false,
        published_at: "2019-10-08T20:58:16.857-05:00",
        children: []
      },
      {
        id: 102,
        name: "Student Portfolios",
        slug: "portfolio",
        type: "link",
        url: "https://apptegy.com",
        position: 9,
        status: "published",
        hidden: false,
        published_at: "2019-10-08T20:58:16.857-05:00",
        children: []
      }
    ]
  },
  {
    id: 11,
    name: "Testimonials",
    slug: "testimonials",
    type: "header",
    position: 10,
    status: "published",
    opens_in_new_tab: true,
    hidden: false,
    published_at: "2019-10-08T20:58:18.279-05:00",
    children: [
      {
        id: 111,
        name: "Alumni",
        slug: "children-with-grand-children",
        type: "header",
        position: 10,
        status: "published",
        hidden: false,
        published_at: "2019-10-08T20:58:19.686-05:00",
        children: [
          {
            id: 1111,
            name: "Class of 1970 - Coming Soon",
            slug: "seventies",
            type: "header",
            position: 10,
            status: "published",
            opens_in_new_tab: true,
            hidden: false,
            published_at: "2019-10-08T20:58:21.622-05:00",
            children: []
          }
        ]
      }
    ]
  },
  {
    id: 12,
    name: "Internships",
    slug: "Internships",
    type: "header",
    position: 11,
    status: "published",
    hidden: false,
    published_at: "2019-10-08T20:58:18.279-05:00",
    children: [
      {
        id: 121,
        name: "Tech Industries",
        slug: "tech",
        type: "header",
        position: 11,
        status: "published",
        hidden: false,
        published_at: "2019-10-08T20:58:19.686-05:00",
        children: [
          {
            id: 1211,
            name: "Cybersecurity Opportunity Guide",
            slug: "cybersecurity",
            type: "page",
            position: 11,
            status: "published",
            hidden: false,
            published_at: "2019-10-08T20:58:21.622-05:00",
            children: []
          }
        ]
      },
      {
        id: 122,
        name: "Hospitality",
        slug: "hospitality",
        type: "header",
        position: 11,
        status: "published",
        hidden: false,
        published_at: "2019-10-08T20:58:23.939-05:00",
        children: [
          {
            id: 1221,
            name: "Restaurant Opportunity Guide",
            slug: "restaurant-opportunity-guide",
            type: "page",
            position: 11,
            status: "published",
            hidden: false,
            published_at: "2019-10-08T20:58:25.410-05:00",
            children: []
          },
          {
            id: 1222,
            name: "Hotel Internship Application",
            slug: "hotel-internship-link",
            type: "link",
            url: "https://apptegy.com",
            position: 11,
            status: "published",
            hidden: false,
            published_at: "2019-10-08T20:58:26.802-05:00",
            children: []
          }
        ]
      }
    ]
  },
  {
    id: 13,
    name: "Volunteer",
    slug: "other-resources",
    type: "header",
    position: 12,
    status: "published",
    hidden: false,
    published_at: "2019-10-08T20:58:18.279-05:00",
    children: [
      {
        id: 131,
        name: "Service Hour Record",
        slug: "service-hour-record",
        type: "page",
        position: 12,
        status: "published",
        hidden: false,
        published_at: "2019-10-08T20:58:19.686-05:00",
        children: []
      },
      {
        id: 132,
        name: "Upcoming Service Opportunities - Coming Soon",
        slug: "for-other-students",
        type: "header",
        position: 12,
        status: "published",
        hidden: false,
        published_at: "2019-10-08T20:58:23.939-05:00",
        children: []
      }
    ]
  },
  {
    id: 14,
    name: "Virtual Tour - Coming Soon",
    type: "header",
    mailto: true,
    email_address: "",
    position: 13,
    opens_in_new_tab: false,
    status: "published",
    hidden: false,
    published_at: "2021-05-12T13:04:50.667-05:00",
    children: []
  },
  {
    id: 15,
    name: "Test Mail Link",
    type: "link",
    mailto: true,
    email_address: "test@test.com",
    position: 14,
    opens_in_new_tab: false,
    status: "published",
    hidden: false,
    published_at: "2021-05-12T13:04:50.667-05:00",
    children: [
      {
        id: 151,
        name: "Test Mail Header",
        type: "header",
        mailto: false,
        email_address: "",
        position: 14,
        opens_in_new_tab: false,
        status: "published",
        hidden: false,
        published_at: "2021-05-12T13:04:50.667-05:00",
        children: []
      }
    ]
  },
  {
    id: 16,
    name: "Test Mail Page",
    slug: "test-mail-page",
    type: "page",
    mailto: false,
    email_address: "",
    position: 15,
    opens_in_new_tab: false,
    status: "published",
    hidden: false,
    published_at: "2021-05-12T13:04:50.667-05:00",
    children: [
      {
        id: 161,
        name: "Test Mail Link",
        type: "link",
        mailto: true,
        email_address: "test2@test2.com",
        position: 15,
        opens_in_new_tab: false,
        status: "published",
        hidden: false,
        published_at: "2021-05-12T13:04:50.667-05:00",
        children: []
      }
    ]
  },
  {
    id: 17,
    name: "Test Mail Page",
    slug: "test-mail-page-2",
    type: "page",
    mailto: false,
    email_address: "",
    position: 16,
    opens_in_new_tab: false,
    status: "published",
    hidden: false,
    published_at: "2021-05-12T13:04:50.667-05:00",
    children: [
      {
        id: 171,
        name: "Test Mail Page",
        slug: "test-mail-page-3",
        type: "page",
        mailto: false,
        email_address: "",
        position: 16,
        opens_in_new_tab: false,
        status: "published",
        hidden: false,
        published_at: "2021-05-12T13:04:50.667-05:00",
        children: []
      }
    ]
  },
  {
    id: 18,
    name: "Test Mail Page Null",
    slug: null,
    type: "page",
    mailto: false,
    email_address: "",
    position: 17,
    opens_in_new_tab: false,
    status: "published",
    hidden: false,
    published_at: "2021-05-12T13:04:50.667-05:00",
    children: [
      {
        id: 181,
        name: "Test Mail Page",
        slug: "test-mail-page-4",
        type: "page",
        mailto: false,
        email_address: "",
        position: 16,
        opens_in_new_tab: false,
        status: "published",
        hidden: false,
        published_at: "2021-05-12T13:04:50.667-05:00",
        children: [
          {
            id: 1811,
            name: "Test Mail Link",
            type: "link",
            mailto: true,
            email_address: "test3@test3.com",
            position: 16,
            opens_in_new_tab: false,
            status: "published",
            hidden: false,
            published_at: "2021-05-12T13:04:50.667-05:00",
            children: []
          }
        ]
      }
    ]
  },
  {
    id: 19,
    name: "Health Department Site",
    slug: "health-department",
    type: "link",
    mailto: true,
    email_address: "health@department.com",
    position: 18,
    opens_in_new_tab: false,
    status: "published",
    hidden: false,
    published_at: "2021-05-12T13:04:50.667-05:00",
    children: [
      {
        id: 191,
        name: "Vaccination Schedule",
        slug: "vaccination-schedule",
        type: "page",
        mailto: true,
        email_address: "",
        position: 18,
        opens_in_new_tab: false,
        status: "published",
        hidden: false,
        published_at: "2021-05-12T13:04:50.667-05:00",
        children: [
          {
            id: 1911,
            name: "School Nurse Email",
            type: "link",
            mailto: true,
            email_address: "nurse@school.com",
            position: 16,
            opens_in_new_tab: false,
            status: "published",
            hidden: false,
            published_at: "2021-05-12T13:04:50.667-05:00",
            children: []
          }
        ]
      }
    ]
  },
  {
    id: 20,
    name: "Superintendent's Office",
    type: "link",
    mailto: true,
    email_address: "superintendent@school.com",
    position: 19,
    opens_in_new_tab: false,
    status: "published",
    hidden: false,
    published_at: "2021-05-12T13:04:50.667-05:00",
    children: [
      {
        id: 201,
        name: "Mission Statement",
        slug: "mission",
        type: "page",
        mailto: true,
        email_address: "",
        position: 18,
        opens_in_new_tab: false,
        status: "published",
        hidden: false,
        published_at: "2021-05-12T13:04:50.667-05:00",
        children: [
          {
            id: 2011,
            name: "Coming Soon",
            type: "header",
            mailto: true,
            email_address: "",
            position: 16,
            opens_in_new_tab: false,
            status: "published",
            hidden: false,
            published_at: "2021-05-12T13:04:50.667-05:00",
            children: []
          }
        ]
      }
    ]
  },
  {
    id: 21,
    name: "Schedule a School Visit",
    type: "link",
    mailto: true,
    email_address: "visit_us@school.com",
    position: 20,
    opens_in_new_tab: false,
    status: "published",
    hidden: false,
    published_at: "2021-05-12T13:04:50.667-05:00",
    children: [
      {
        id: 211,
        name: "Visiting Our School FAQs",
        slug: "visit-faqs",
        type: "page",
        mailto: true,
        email_address: "",
        position: 20,
        opens_in_new_tab: false,
        status: "published",
        hidden: false,
        published_at: "2021-05-12T13:04:50.667-05:00",
        children: [
          {
            id: 2111,
            name: "Campus Map",
            slug: "map",
            type: "page",
            mailto: true,
            email_address: "",
            position: 20,
            opens_in_new_tab: false,
            status: "published",
            hidden: false,
            published_at: "2021-05-12T13:04:50.667-05:00",
            children: []
          }
        ]
      }
    ]
  }
];
const staticMenuLinkDefaults = [
  {
    id: 1,
    config_id: 1,
    menu_icon_id: 1,
    name: "Athletics",
    url: "/athletics",
    opens_in_new_tab: false,
    position: 0,
    created_at: "2020-03-17T23:08:05.850-05:00",
    updated_at: "2020-03-17T23:08:05.850-05:00",
    icon: '<svg id="Layer_7" data-name="Layer 7" xmlns="http://www.w3.org/2000/svg" width="174.5" height="173.9" viewBox="0 0 174.5 173.9"><title>Hand with Phone</title><path d="M112.9,47.18a5.33,5.33,0,0,1,3.95,2.94,8.15,8.15,0,0,1,.64,3.07c.05,6.32,0,12.64,0,19v1h1.62a4.27,4.27,0,0,1,4.48,4.11c.14,2.65-1.38,4.67-4,4.79-3.25.15-6.52.13-9.77,0a4.1,4.1,0,0,1-3.74-4.46,4.25,4.25,0,0,1,4.05-4.38c1.16-.06,2.32,0,3.54,0V55.78H75.06v9.37l.72-.36c2.47-1.36,4.92-2.77,7.42-4.05a10,10,0,0,1,3.35-1.11c2.63-.29,4.34,1.56,4.2,4.21-.11,2.07-1.37,3.45-2.78,4.67A101.24,101.24,0,0,1,75.76,77.7,1.46,1.46,0,0,0,75,79.13q0,18.33,0,36.67v1h38.73v-2.83h-2.86a4.69,4.69,0,0,1-3.3-1.1,4.75,4.75,0,0,1-1.15-5.07,4.13,4.13,0,0,1,3.93-2.77c3,0,6.06,0,9.08,0a4.18,4.18,0,0,1,4.2,4.29,4.23,4.23,0,0,1-4,4.6c-.66,0-1.33,0-2.07,0,0,1.83,0,3.54,0,5.24a17.51,17.51,0,0,1-.2,3.48,5.28,5.28,0,0,1-5.4,4.14H77.05a5.34,5.34,0,0,1-5.52-4,9.28,9.28,0,0,1-.23-2.23c0-1.74,0-3.45,0-5.27-1.41,0-2.75,0-4.08,0A21.46,21.46,0,0,1,58,113.68a16.86,16.86,0,0,1-10.48-13,28.65,28.65,0,0,1,1.26-16.23,16.07,16.07,0,0,1,7.8-8.79c4.85-2.55,9.55-5.37,14.31-8.11a1.11,1.11,0,0,0,.41-.86c0-4.33,0-8.65,0-13,0-3.83,1.06-5.32,4.64-6.52ZM97.06,121.41a2.67,2.67,0,1,0-2.68,2.66A2.7,2.7,0,0,0,97.06,121.41ZM94.33,52.35h5.5c.46,0,.87-.1.85-.66s-.42-.63-.87-.63H89c-.48,0-.94.08-.93.66s.49.63,1,.63ZM114.89,92.7c-1.53,0-3.06,0-4.58,0a4.19,4.19,0,0,1-4.1-3.63c-.29-2.58.82-4.51,3-5.12a5.36,5.36,0,0,1,1.38-.21c2.87,0,5.74,0,8.61,0a4.26,4.26,0,0,1,4.22,2.94A4.64,4.64,0,0,1,122,91.8a4.39,4.39,0,0,1-2.81.92h-4.27Zm0,10.59c-1.53,0-3,0-4.58,0a4.15,4.15,0,0,1-4.08-3.73c-.27-2.52.9-4.44,3.11-5a3.45,3.45,0,0,1,.91-.13c3.11,0,6.21-.06,9.32,0a4.07,4.07,0,0,1,3.9,3,4.48,4.48,0,0,1-1.56,5.06,9.21,9.21,0,0,1-2.29.84.8.8,0,0,1-.31,0h-4.42Z"/></svg>'
  },
  {
    id: 2,
    config_id: 1,
    menu_icon_id: 3,
    name: "Dining",
    url: "/dining",
    opens_in_new_tab: false,
    position: 1,
    created_at: "2020-03-17T23:08:05.856-05:00",
    updated_at: "2020-03-17T23:08:05.856-05:00",
    icon: '<svg data-v-ea34907a="" xmlns="http://www.w3.org/2000/svg" viewBox="-1 0 174.53 173.95" class="svg_icon"><title>Dining Icon</title><path fill="#000" d="M113.5,52.93c-.09-1.85-.14-3.7-.26-5.55-.07-1.08-.5-2-1.77-1.89s-1.49.92-1.44,2c.07,1.69.14,3.38.21,5.06.14,2.93.27,5.86.42,8.84a2.37,2.37,0,0,1-2.36,2.48h0a2.36,2.36,0,0,1-2.36-2.23c-.21-3.77-.59-11-.73-14.11-.05-1.18-.39-2.12-1.77-2s-1.52,1.07-1.46,2.15c.12,2.23.34,9.57.42,13.75A2.36,2.36,0,0,1,100,63.8h-.21a2.36,2.36,0,0,1-2.36-2.46c.16-3.56.46-10.07.65-13.64.06-1.15-.17-2.15-1.54-2.21s-1.61.86-1.66,2-.7,13.81-.7,13.81c.06,1.3-.14,2.56-1.85,2.66a2.22,2.22,0,0,1-2.24-2.36c.14-3.56.43-10.19.6-13.68.06-1.17-.06-2.32-1.54-2.39s-1.67,1-1.72,2.24c-.16,3.54-1.15,19.21-.9,23.48.32,5.61,3,10,8.38,12.23a2.31,2.31,0,0,1,1.67,2.61q-.07,22.65,0,45.3a3.84,3.84,0,0,0,3.75,3c1.7,0,3.8-1.54,3.8-3l-.06-44.16c0-2,.11-3.48,2.48-4,4.28-1,7.67-8,7.65-13.09C114.21,64.33,113.76,58.63,113.5,52.93Z"></path><path fill="#000" d="M71.19,41.45C66.48,48.71,61.54,59,60.5,68.75,59.83,75,60.84,80.93,64.79,86a6,6,0,0,1,1.29,3.67c.07,12.87.1,25.73,0,38.6,0,3,.9,6.06,3.66,6.06,3.93,0,3.87-3.85,3.88-5.53.06-24.95,0-72.2,0-86.6A1.32,1.32,0,0,0,71.19,41.45Z"></path></svg>'
  },
  {
    id: 3,
    config_id: 1,
    menu_icon_id: 4,
    name: "Documents",
    url: "/documents",
    opens_in_new_tab: false,
    position: 2,
    created_at: "2020-03-17T23:08:05.860-05:00",
    updated_at: "2020-03-17T23:08:05.860-05:00",
    icon: '<svg data-v-ea34907a="" xmlns="http://www.w3.org/2000/svg" viewBox="6 0 174.53 173.95" class="svg_icon"><title>Documents Icon</title><path fill="#000" d="M112.57,119.07H70.31a1,1,0,0,1-.45-.1c-1.79-.86-3-2.12-3-4.32q0-26.56,0-53.12a4.18,4.18,0,0,1,4.34-4.39c1,0,2.05,0,3.15,0a1,1,0,0,0,1-1.07c-.11-2.37.65-4.24,3-5.26a1.09,1.09,0,0,1,.42-.08h30.31a1,1,0,0,1,.74.32c.38.41.75.82,1.15,1.19,3.51,3.21,7,6.38,10.53,9.61a2.41,2.41,0,0,1,.79,1.53q.06,20.92,0,41.84a5.32,5.32,0,0,1-5.33,5.32H117a1,1,0,0,0-1,1,19.59,19.59,0,0,0,0,2.2,4.76,4.76,0,0,1-3,5.26A1.07,1.07,0,0,1,112.57,119.07Zm-32.8-63v49.09a1,1,0,0,0,1,1H117a1,1,0,0,0,1-1V66.65a1,1,0,0,0-1-1h-9.63a1,1,0,0,1-1-1V56.05a1,1,0,0,0-1-1H80.79A1,1,0,0,0,79.77,56.05Zm31.9,55.48a1,1,0,0,0-1-1h-.6c-9.79,0-19.58-.1-29.37.05-3.46.05-5.35-2.09-5.32-5.26.12-14.1.05-28.21.05-42.32v-.48a1,1,0,0,0-1-1H72.23a1,1,0,0,0-1,1V113.7a1,1,0,0,0,1,1h38.42a1,1,0,0,0,1-1Z"></path><rect fill="##000" x="84.03" y="74.32" width="29.77" height="4.09" rx="2.05" ry="2.05"></rect><rect fill="##000" x="84.06" y="82.82" width="29.72" height="4.1" rx="2.05" ry="2.05"></rect><rect fill="##000" x="84.05" y="91.37" width="29.71" height="4.11" rx="2.06" ry="2.06"></rect><rect fill="##000" x="84.03" y="61.5" width="18.02" height="4.1" rx="2.05" ry="2.05"></rect></svg>'
  },
  {
    id: 4,
    config_id: 1,
    menu_icon_id: 7,
    name: "Events",
    url: "/events",
    opens_in_new_tab: false,
    position: 3,
    created_at: "2020-03-17T23:08:05.865-05:00",
    updated_at: "2020-03-17T23:08:05.865-05:00",
    icon: '<svg data-v-ea34907a="" xmlns="http://www.w3.org/2000/svg" viewBox="5 0 174.53 173.95" class="svg_icon"><title>Events Icon</title><path fill="#000" d="M127.15,70.65c0,.51,0,.86,0,1.22,0,13.1-.08,26.19.05,39.29a6.7,6.7,0,0,1-6.87,6.82c-18.21-.09-36.42,0-54.63,0-4.22,0-6.82-2.6-6.82-6.81q0-19.64,0-39.29c0-1.18,0-1.19,1.15-1.19h67.13ZM92.5,93.39c0-3.75-.49-6.39-1.86-8.83a9.55,9.55,0,0,0-16.37-.5,14.19,14.19,0,0,0-2.12,6.67,15.4,15.4,0,0,0,2.45,10.41,9.52,9.52,0,0,0,15.15.33A13.75,13.75,0,0,0,92.5,93.39ZM103,100.9l-.07-.24.76-.59c1.54-1.23,3.13-2.4,4.62-3.7a17.24,17.24,0,0,0,5-6.24,7,7,0,0,0-3.65-9.36,12.52,12.52,0,0,0-7.8-.77,11.48,11.48,0,0,0-6.07,3c-.19.19-.35.71-.24.85.67.82,1.43,1.58,2.17,2.38l.69-.58A9.26,9.26,0,0,1,105,83.41c2.42,0,4.09,1.23,4.49,3.1a4.15,4.15,0,0,1-.75,3.41,21.28,21.28,0,0,1-3.31,3.73c-3,2.47-6.12,4.77-9.19,7.15-.23.18-.58.4-.59.61-.06,1,0,2.06,0,3.06h18.53c0-1,0-1.82,0-2.68s-.2-.92-.91-.92c-3,0-5.92,0-8.88,0Z"></path><path fill="##000" d="M93,65.53H60.09c-1.21,0-1.22,0-1.22-1.22,0-2.06,0-4.13,0-6.19a6.24,6.24,0,0,1,6.31-6.31c3.53,0,7.06,0,10.58,0,.75,0,1,.23,1,1a10.24,10.24,0,0,0,.09,2.5,5,5,0,0,0,9.85-.89c0-.12,0-.24,0-.36,0-2.21,0-2.21,2.28-2.21,3.17,0,6.34,0,9.51,0,.74,0,1,.21,1,1a13.66,13.66,0,0,0,0,1.88,4.94,4.94,0,0,0,9.85-.18c0-.66,0-1.32,0-2,0-.49.2-.69.7-.69,3.8,0,7.59-.06,11.39,0a6.11,6.11,0,0,1,5.71,6c0,2.24,0,4.49,0,6.73,0,.86-.28,1-1.08,1Q109.55,65.52,93,65.53Z"></path><path fill="##000" d="M101.77,50.51c0-1.1,0-2.21,0-3.31a2.6,2.6,0,0,1,2.57-2.75A2.55,2.55,0,0,1,107,47.11c0,2.36.05,4.72,0,7.07a2.51,2.51,0,0,1-2.7,2.59,2.54,2.54,0,0,1-2.53-2.68C101.75,52.9,101.77,51.71,101.77,50.51Z"></path><path fill="#000" d="M79.12,50.57c0-1.19,0-2.39,0-3.58a2.47,2.47,0,0,1,2.54-2.54,2.53,2.53,0,0,1,2.6,2.6q0,3.58,0,7.16a2.48,2.48,0,0,1-2.52,2.56,2.44,2.44,0,0,1-2.62-2.54c0-1.22,0-2.45,0-3.67Z"></path><path fill="##000" d="M88.12,92.31a14.77,14.77,0,0,1-1,5.53,5,5,0,0,1-4.82,3.5,5,5,0,0,1-4.83-3.47,15.3,15.3,0,0,1,0-11,5,5,0,0,1,4.84-3.46,5,5,0,0,1,4.82,3.49,11,11,0,0,1,.65,2.22C88,90.17,88,91.25,88.12,92.31Z"></path></svg>'
  },
  {
    id: 5,
    config_id: 1,
    menu_icon_id: 13,
    name: "Live Feed",
    url: "/live-feed",
    opens_in_new_tab: false,
    position: 4,
    created_at: "2020-03-17T23:08:05.870-05:00",
    updated_at: "2020-03-17T23:08:05.870-05:00",
    icon: '<svg data-v-ea34907a="" xmlns="http://www.w3.org/2000/svg" viewBox="-6 0 174.53 173.95" class="svg_icon"><title>Live Feed Icon</title><path fill="#000" d="M106.9,112.13a5.2,5.2,0,0,1-5.16-4.65A43.18,43.18,0,0,0,89,80.93,43.39,43.39,0,0,0,62.44,68.18,5.2,5.2,0,0,1,57.8,63v-.1a5.21,5.21,0,0,1,5.68-5.18c23.2,2.1,45.91,21.36,48.69,48.72a5.18,5.18,0,0,1-5.18,5.66Z"></path><path fill="##000" d="M63.86,76.54a35.46,35.46,0,0,1,29.55,29.8,5.2,5.2,0,0,1-5.19,5.85h0A5.22,5.22,0,0,1,83,107.72,24.91,24.91,0,0,0,62.24,86.87a5.22,5.22,0,0,1-4.44-5.16h0A5.25,5.25,0,0,1,63.86,76.54Z"></path><path fill="##000" d="M65.26,112.06a7.29,7.29,0,0,1-7.35-7.39,7.35,7.35,0,0,1,14.7.09A7.27,7.27,0,0,1,65.26,112.06Z"></path></svg>'
  },
  {
    id: 6,
    config_id: 1,
    menu_icon_id: 15,
    name: "News",
    url: "/news",
    opens_in_new_tab: false,
    position: 5,
    created_at: "2020-03-17T23:08:05.875-05:00",
    updated_at: "2020-03-17T23:08:05.875-05:00",
    icon: '<svg data-v-ea34907a="" xmlns="http://www.w3.org/2000/svg" viewBox="-4 0 174.53 173.95" class="svg_icon"><title>News Icon</title><path fill="#000" d="M116.27,64.15v45.64a5.75,5.75,0,0,1-5.75,5.75H53.59a5.75,5.75,0,0,1-5.75-5.75V64.15a5.75,5.75,0,0,1,5.75-5.75h56.93A5.75,5.75,0,0,1,116.27,64.15ZM58.08,73.89h46.16A1.73,1.73,0,0,0,106,72.16V68.33a1.73,1.73,0,0,0-1.73-1.73H58.08a1.73,1.73,0,0,0-1.73,1.73v3.83A1.73,1.73,0,0,0,58.08,73.89ZM75.46,91.1H58.09a1.73,1.73,0,0,0-1.73,1.73v13.52a1.73,1.73,0,0,0,1.73,1.73H75.46a1.73,1.73,0,0,0,1.73-1.73V92.84A1.73,1.73,0,0,0,75.46,91.1ZM97.87,77.23H58.08A1.73,1.73,0,0,0,56.35,79v4.22a1.73,1.73,0,0,0,1.73,1.73H97.87a1.73,1.73,0,0,0,1.73-1.73V79A1.73,1.73,0,0,0,97.87,77.23Zm6,13.88H85.07a1.73,1.73,0,0,0-1.73,1.73v.72a1.73,1.73,0,0,0,1.73,1.73h18.81a1.73,1.73,0,0,0,1.73-1.73v-.72A1.73,1.73,0,0,0,103.88,91.12ZM85,108.42h18.83a1.73,1.73,0,0,0,1.73-1.73v-.28a1.73,1.73,0,0,0-1.73-1.73H85a1.73,1.73,0,0,0-1.73,1.73v.28A1.73,1.73,0,0,0,85,108.42Zm18.83-10.17H85.07A1.73,1.73,0,0,0,83.34,100h0a1.73,1.73,0,0,0,1.73,1.73h18.81a1.73,1.73,0,0,0,1.73-1.73h0A1.73,1.73,0,0,0,103.88,98.25Z"></path><path fill="##000" d="M119.11,109.49V70.14a1,1,0,0,1,1-1h5.68a1,1,0,0,1,.95,1.11l-6.08,39.32A.75.75,0,0,1,119.11,109.49Z"></path></svg>'
  },
  {
    id: 7,
    config_id: 1,
    menu_icon_id: 21,
    name: "Staff",
    url: "/staff",
    opens_in_new_tab: false,
    position: 6,
    created_at: "2020-03-17T23:08:05.880-05:00",
    updated_at: "2020-03-17T23:08:05.880-05:00",
    icon: '<svg data-v-ea34907a="" xmlns="http://www.w3.org/2000/svg" viewBox="6 0 174.53 173.95" class="svg_icon"><title>Staff Icon</title><path fill="#000" d="M95.73,116.2c-4.69,0-9.37,0-14.06,0a12.73,12.73,0,0,1-1.95-.16,3.31,3.31,0,0,1-3-3,13.62,13.62,0,0,1-.17-2c0-3.35,0-6.71,0-10.06a9.89,9.89,0,0,1,4.27-8.62c1.21-.89,2.46-1.72,3.75-2.5a2.82,2.82,0,0,1,3.49.28c1.61,1.38,3.14,2.87,4.69,4.32.62.58,1.17,1.25,1.82,1.78a1.66,1.66,0,0,0,2.33,0,13.62,13.62,0,0,0,1.25-1.15c1.48-1.44,2.91-2.95,4.44-4.33,1.88-1.69,2.82-1.73,5-.47a18.47,18.47,0,0,1,4.78,3.65,9.42,9.42,0,0,1,2.46,6.44c0,3.72,0,7.44,0,11.16a8.55,8.55,0,0,1-.2,1.77c-.42,1.91-1.75,2.84-4.15,2.87s-4.77,0-7.16,0Z"></path><path fill="#000" d="M107.82,71.47A17.33,17.33,0,0,1,104.66,82a11.41,11.41,0,0,1-6.47,4.7,9.7,9.7,0,0,1-9.48-2.61,15.62,15.62,0,0,1-4.9-11.74,18.63,18.63,0,0,1,.84-6.88,11.72,11.72,0,0,1,11.82-7.7,11.6,11.6,0,0,1,10.76,9.08A45,45,0,0,1,107.82,71.47Z"></path><path fill="#000" d="M71.81,113.61c-.13.11-.15.14-.17.14-3.49,0-7,0-10.47-.1-2.4-.1-3.52-1.2-3.62-3.55a52.37,52.37,0,0,1,.15-8A9.79,9.79,0,0,1,63,94.62a3.39,3.39,0,0,1,3-.17A10.39,10.39,0,0,1,69.6,96.9a8.45,8.45,0,0,1,2.1,2.3,8,8,0,0,1,.11,2.95q0,5.28,0,10.57Z"></path><path fill="#000" d="M119.7,113.78c0-.38,0-.66,0-.94,0-4.32,0-8.63,0-13a1.6,1.6,0,0,1,.55-1.34c1.15-1,2.25-2.08,3.4-3.08a6.18,6.18,0,0,1,1.24-.74,3.93,3.93,0,0,1,4.39.33A10.51,10.51,0,0,1,134,104q0,2.68,0,5.37a8.44,8.44,0,0,1-.19,1.69,3.18,3.18,0,0,1-3.08,2.59c-1.38.11-2.78.13-4.17.14C124.33,113.8,122.09,113.78,119.7,113.78Z"></path><path fill="#000" d="M79.07,79.57a21.73,21.73,0,0,1-.3,3.75c-.81,3.25-3.09,5.1-6.24,5.95a3.19,3.19,0,0,1-1.67-.06c-3-.9-6.34-3.53-6.19-8.06A35,35,0,0,1,65,75.39a7,7,0,0,1,13.77.39A35.33,35.33,0,0,1,79.07,79.57Z"></path><path fill="#000" d="M112.46,79.52a30.93,30.93,0,0,1,.34-4,7.13,7.13,0,0,1,7-5.66A6.91,6.91,0,0,1,126.67,76a30.61,30.61,0,0,1,0,7c-.34,2.89-3.31,5.67-6.18,6.2a3.93,3.93,0,0,1-1.76-.05c-3.08-.91-6.42-3.77-6.18-8.06,0-.54,0-1.08,0-1.62Z"></path></svg>'
  }
];
const slides = [
  {
    url: "https://d2kzwze52p8717.cloudfront.net/gallery_video.mp4",
    title: "<h1>Welcome to Our School</h1>",
    index: 0,
    content: "<p>2Users will be able to add short description besides the headline.</p>",
    alt_text: "video gallery demo"
  }
];
const videoGalleryDefaults = {
  slides
};
const athleticsPreviewContent = [
  {
    id: 1,
    away_score: "",
    away_team: "",
    home_score: "",
    home_team: "Home Team Name",
    title: "Charity Match",
    place: "",
    address: "425 Main St, North Little Rock, AR 72114, USA",
    city_state: "",
    state: "",
    zip: "",
    formatted_date: "2019-03-12 09:43:00",
    day: "12",
    month: "MAR",
    year: "2019",
    time: "9:43 AM",
    latitude: "34.75793",
    longitude: "-92.267876",
    versus: false,
    multi_line: false,
    filter_name: "Golf"
  },
  {
    id: 2,
    away_score: "",
    away_team: "Away Team Name",
    home_score: "",
    home_team: "Home Team Name",
    title: "Charity Match",
    place: "",
    address: "425 Main St, North Little Rock, AR 72114, USA",
    city_state: "",
    state: "",
    zip: "",
    formatted_date: "2019-03-12 09:43:00",
    day: "12",
    month: "MAR",
    year: "2019",
    time: "9:43 AM",
    latitude: "34.75793",
    longitude: "-92.267876",
    versus: true,
    multi_line: false,
    filter_name: "Football"
  },
  {
    id: 3,
    away_score: "",
    away_team: "Away Team Name",
    home_score: "",
    home_team: "Home Team Name",
    title: "Charity Match",
    place: "",
    address: "425 Main St, North Little Rock, AR 72114, USA",
    city_state: "",
    state: "",
    zip: "",
    formatted_date: "2019-03-12 09:43:00",
    day: "12",
    month: "MAR",
    year: "2019",
    time: "9:43 AM",
    latitude: "34.75793",
    longitude: "-92.267876",
    versus: true,
    multi_line: false,
    filter_name: "Soccer"
  },
  {
    id: 4,
    away_score: "",
    away_team: "Away Team Name",
    home_score: "",
    home_team: "Home Team Name",
    title: "Charity Match",
    place: "",
    address: "425 Main St, North Little Rock, AR 72114, USA",
    city_state: "",
    state: "",
    zip: "",
    formatted_date: "2019-03-12 09:43:00",
    day: "12",
    month: "MAR",
    year: "2019",
    time: "9:43 AM",
    latitude: "34.75793",
    longitude: "-92.267876",
    versus: true,
    multi_line: false,
    filter_name: "Soccer"
  }
];
const eventsPreviewContent = [
  {
    id: 1860952,
    title: '"Space, Movement and the Technological Body"',
    venue: "",
    address: "",
    city_state: "",
    state: "",
    zip: "",
    description: "",
    start_at: "2019-10-08T08:00:00.000-05:00",
    end_at: "2019-10-09T12:30:00.000-05:00",
    all_day: false,
    start: "Oct 8 at 8:00 AM",
    end: "Oct 8 at 12:30 PM",
    day: "08",
    month: "OCT",
    year: "2019",
    time: " 8:00 AM",
    filter_name: "All",
    filter_color: "#888888",
    formatted_date: "OCT 8 8:00 AM - 12:30 PM",
    cms_formatted_date: "Oct 8 to Oct 9 from 8:00 AM to 12:30 PM",
    formatted_start: "2019-10-08 08:00:00",
    formatted_end: "2019-10-09 12:30:00",
    latitude: "",
    longitude: "",
    custom_section_id: 1,
    sectionDisplayName: "Students Only"
  },
  {
    id: 3220098,
    title: "Registration, Courses at Open Campus",
    venue: "",
    address: "",
    city_state: "",
    state: "",
    zip: "",
    description: "This is the meeting where we will discuss the progress on the various tasks that we are responsible for each week",
    start_at: "2019-10-08T10:00:00.000-05:00",
    end_at: "2019-10-08T10:30:00.000-05:00",
    all_day: true,
    start: "Oct 8 at 10:00 AM",
    end: "Oct 8 at 10:30 AM",
    day: "08",
    month: "OCT",
    year: "2019",
    time: "10:00 AM",
    filter_name: "All",
    filter_color: "#888888",
    formatted_date: "OCT 8 10:00 AM - 10:30 AM",
    cms_formatted_date: "Oct 8 from 10:00 AM to 10:30 AM",
    formatted_start: "2019-10-08 10:00:00",
    formatted_end: "2019-10-08 10:30:00",
    latitude: "",
    longitude: "",
    custom_section_id: 1,
    sectionDisplayName: "Students Only"
  },
  {
    id: 2503738,
    title: "Board of Education Meeting",
    venue: "",
    address: "",
    city_state: "",
    state: "",
    zip: "",
    description: "",
    start_at: "2019-10-08T11:00:00.000-05:00",
    end_at: "2019-10-08T12:30:00.000-05:00",
    all_day: false,
    start: "Oct 10 at 11:00 AM",
    end: "Oct 10 at 12:30 PM",
    day: "08",
    month: "OCT",
    year: "2019",
    time: "11:00 AM",
    filter_name: "All",
    filter_color: "#888888",
    formatted_date: "OCT 10 11:00 AM - 12:30 PM",
    cms_formatted_date: "Oct 10 from 11:00 AM to 12:30 PM",
    formatted_start: "2019-10-08 11:00:00",
    formatted_end: "2019-10-08 12:30:00",
    latitude: "",
    longitude: "",
    custom_section_id: 1,
    sectionDisplayName: "Parent Events"
  },
  {
    id: 3220149,
    title: "Education Day",
    venue: "8SE Conf Room, 8th Floor-1-8SE Conf Room (8)",
    address: "",
    city_state: "",
    state: "",
    zip: "",
    description: "8SE Conf Room at Apptegy, Apptegy has been reserved using Robin\n\nWe decided to reduce our sprint planning meetings to once a week until things get rolling.  ",
    start_at: "2019-10-08T15:00:00.000-05:00",
    end_at: "2019-10-08T16:00:00.000-05:00",
    all_day: true,
    start: "Oct 11 at 3:00 PM",
    end: "Oct 11 at 4:00 PM",
    day: "08",
    month: "OCT",
    year: "2019",
    time: " 3:00 PM",
    filter_name: "All",
    filter_color: "#888888",
    formatted_date: "OCT 11",
    cms_formatted_date: "Oct 11 from",
    formatted_start: "2019-10-08 15:00:00",
    formatted_end: "2019-10-08 16:00:00",
    latitude: "",
    longitude: "",
    custom_section_id: 1,
    sectionDisplayName: "Parent Events"
  },
  {
    id: 2402237,
    title: "Student Art Viewing and Open Panel Discussion on the Importance of Art in Education",
    venue: "",
    address: "",
    city_state: "",
    state: "",
    zip: "",
    description: "",
    start_at: "2019-10-08T15:15:00.000-05:00",
    end_at: "2019-10-08T16:00:00.000-05:00",
    all_day: false,
    start: "Oct 16 at 3:15 PM",
    end: "Oct 16 at 4:00 PM",
    day: "08",
    month: "OCT",
    year: "2019",
    time: " 3:15 PM",
    filter_name: "All",
    filter_color: "#888888",
    formatted_date: "OCT 16 3:15 PM - 4:00 PM",
    cms_formatted_date: "Oct 16 from  3:15 PM to  4:00 PM",
    formatted_start: "2019-10-08 15:15:00",
    formatted_end: "2019-10-08 16:00:00",
    latitude: "",
    longitude: "",
    custom_section_id: 1,
    sectionDisplayName: "Students Only"
  },
  {
    id: 2503739,
    title: "Student Recital by Raul Holback",
    venue: "",
    address: "",
    city_state: "",
    state: "",
    zip: "",
    description: "",
    start_at: "2019-10-09T11:00:00.000-05:00",
    end_at: "2019-10-09T12:30:00.000-05:00",
    all_day: false,
    start: "Oct 19 at 11:00 AM",
    end: "Oct 19 at 12:30 PM",
    day: "09",
    month: "OCT",
    year: "2019",
    time: "11:00 AM",
    filter_name: "All",
    filter_color: "#888888",
    formatted_date: "OCT 19 11:00 AM - 12:30 PM",
    cms_formatted_date: "Oct 19 from 11:00 AM to 12:30 PM",
    formatted_start: "2019-10-09 11:00:00",
    formatted_end: "2019-10-09 12:30:00",
    latitude: "",
    longitude: "",
    custom_section_id: 2,
    sectionDisplayName: "Students Only"
  }
];
const liveFeedPreviewContent = [
  {
    id: 325482,
    status: `"You're A Good Man, Charlie Brown" is a fun-filled musical highlighting a day in the life of the beloved Peanuts characters by Charles Schultz.`,
    author: "School District",
    author_id: 26212,
    moderator_id: null,
    author_name: "School District",
    time_ago: "1 minute ago",
    avatar: "https://thrillshare.com/fallback/circled_default_avatar.png",
    approved: true,
    filter_name: "All",
    filter_color: "#888888",
    formatted_date: "2019-10-08 11:08:24",
    time: "2019-10-08T11:08:24.520-05:00",
    image_large: "",
    to_twitter: false,
    to_facebook: false,
    to_live_feed: true,
    to_push_notifications: false,
    detected_urls: [],
    expanded_urls: [],
    jid: null,
    live_feed_images: [
      {
        alt_text: "image news 1",
        id: 277784,
        url: "https://d2kzwze52p8717.cloudfront.net/news1.png"
      },
      {
        alt_text: "image news 2",
        id: 277785,
        url: "https://d2kzwze52p8717.cloudfront.net/gallery_01.png"
      },
      {
        alt_text: "image news 3",
        id: 277786,
        url: "https://d2kzwze52p8717.cloudfront.net/spotlight/face-2.jpg"
      },
      {
        alt_text: "image news 4",
        id: 277787,
        url: "https://d2kzwze52p8717.cloudfront.net/news3.png"
      }
    ]
  },
  {
    id: 325481,
    status: "Join us for London Elementary night at Chick Fil A Thursday evening from 5:00-8:00. A portion of sales will be donated back to our school. Invite your family and friends to come too! We look forward to seeing you there!",
    author: "School District",
    author_id: 26212,
    moderator_id: null,
    author_name: "School District",
    time_ago: "1 minute ago",
    avatar: "https://thrillshare.com/fallback/circled_default_avatar.png",
    approved: true,
    filter_name: "All",
    filter_color: "#888888",
    formatted_date: "2019-10-08 11:08:13",
    time: "2019-10-08T11:08:13.624-05:00",
    image_large: "",
    to_twitter: false,
    to_facebook: false,
    to_live_feed: true,
    to_push_notifications: false,
    detected_urls: [],
    expanded_urls: [],
    jid: null,
    live_feed_images: [
      {
        alt_text: "the gallery image",
        id: 277783,
        url: "https://d2kzwze52p8717.cloudfront.net/gallery_01.png"
      }
    ]
  },
  {
    id: 325480,
    status: "Congratulations to the members of the senior class as they prepare for graduation and life beyond high school.",
    author: "School District",
    author_id: 26212,
    moderator_id: null,
    author_name: "School District",
    time_ago: "2 minutes ago",
    avatar: "https://thrillshare.com/fallback/circled_default_avatar.png",
    approved: true,
    filter_name: "All",
    filter_color: "#888888",
    formatted_date: "2019-10-08 11:07:47",
    time: "2019-10-08T11:07:47.715-05:00",
    image_large: "",
    to_twitter: false,
    to_facebook: false,
    to_live_feed: true,
    to_push_notifications: false,
    detected_urls: [],
    expanded_urls: [],
    jid: null,
    live_feed_images: [
      {
        alt_text: "image news 1",
        id: 277784,
        url: "https://d2kzwze52p8717.cloudfront.net/news1.png"
      },
      {
        alt_text: "image news 2",
        id: 277785,
        url: "https://d2kzwze52p8717.cloudfront.net/gallery_01.png"
      },
      {
        alt_text: "image news 3",
        id: 277786,
        url: "https://d2kzwze52p8717.cloudfront.net/spotlight/face-2.jpg"
      },
      {
        alt_text: "image news 4",
        id: 277787,
        url: "https://d2kzwze52p8717.cloudfront.net/news3.png"
      },
      {
        alt_text: "image news 5",
        id: 277788,
        url: "https://d2kzwze52p8717.cloudfront.net/news4.png"
      }
    ]
  },
  {
    id: 325479,
    status: `"You're A Good Man, Charlie Brown" is a fun-filled musical highlighting a day in the life of the beloved Peanuts characters by Charles Schultz.`,
    author: "School District",
    author_id: 26212,
    moderator_id: null,
    author_name: "School District",
    time_ago: "5 minutes ago",
    avatar: "https://thrillshare.com/fallback/circled_default_avatar.png",
    approved: true,
    filter_name: "All",
    filter_color: "#888888",
    formatted_date: "2019-10-08 11:07:36",
    time: "2019-10-08T11:07:36.674-05:00",
    image_large: "",
    to_twitter: false,
    to_facebook: false,
    to_live_feed: true,
    to_push_notifications: false,
    detected_urls: [],
    expanded_urls: [],
    jid: null,
    live_feed_images: []
  },
  {
    id: 325478,
    status: "Congratulations to the senior class as they prepare for graduation and life beyond high school.",
    author: "School District",
    author_id: 26212,
    moderator_id: null,
    author_name: "School District",
    time_ago: "1 day ago",
    avatar: "https://thrillshare.com/fallback/circled_default_avatar.png",
    approved: true,
    filter_name: "All",
    filter_color: "#888888",
    formatted_date: "2019-10-08 11:06:52",
    time: "2019-10-08T11:06:52.050-05:00",
    image_large: "",
    to_twitter: false,
    to_facebook: false,
    to_live_feed: true,
    to_push_notifications: false,
    detected_urls: [],
    expanded_urls: [],
    jid: null,
    live_feed_images: []
  },
  {
    id: 325482,
    status: `"You're A Good Man, Charlie Brown" is a fun-filled musical highlighting a day in the life of the beloved Peanuts characters by Charles Schultz.`,
    author: "School District",
    author_id: 26212,
    moderator_id: null,
    author_name: "School District",
    time_ago: "2 days ago",
    avatar: "https://thrillshare.com/fallback/circled_default_avatar.png",
    approved: true,
    filter_name: "All",
    filter_color: "#888888",
    formatted_date: "2019-10-08 11:08:24",
    time: "2019-10-08T11:08:24.520-05:00",
    image_large: "",
    to_twitter: false,
    to_facebook: false,
    to_live_feed: true,
    to_push_notifications: false,
    detected_urls: [],
    expanded_urls: [],
    jid: null,
    live_feed_images: []
  },
  {
    id: 425481,
    status: "Join us for London Elementary night at Chick Fil A Thursday evening from 5:00-8:00. A portion of sales will be donated back to our school. Invite your family and friends to come too! We look forward to seeing you there!",
    author: "School District",
    author_id: 26212,
    moderator_id: null,
    author_name: "School District",
    time_ago: "1 minute ago",
    avatar: "https://thrillshare.com/fallback/circled_default_avatar.png",
    approved: true,
    filter_name: "All",
    filter_color: "#888888",
    formatted_date: "2019-10-08 11:08:13",
    time: "2019-10-08T11:08:13.624-05:00",
    image_large: "",
    to_twitter: false,
    to_facebook: false,
    to_live_feed: true,
    to_push_notifications: false,
    detected_urls: [],
    expanded_urls: [],
    jid: null,
    live_feed_images: []
  },
  {
    id: 425480,
    status: "Congratulations to the senior class as they prepare for graduation and life beyond high school.",
    author: "School District",
    author_id: 26212,
    moderator_id: null,
    author_name: "School District",
    time_ago: "2 minutes ago",
    avatar: "https://thrillshare.com/fallback/circled_default_avatar.png",
    approved: true,
    filter_name: "All",
    filter_color: "#888888",
    formatted_date: "2019-10-08 11:07:47",
    time: "2019-10-08T11:07:47.715-05:00",
    image_large: "",
    to_twitter: false,
    to_facebook: false,
    to_live_feed: true,
    to_push_notifications: false,
    detected_urls: [],
    expanded_urls: [],
    jid: null,
    live_feed_images: []
  },
  {
    id: 425479,
    status: `"You're A Good Man, Charlie Brown" is a fun-filled musical highlighting a day in the life of the beloved Peanuts characters by Charles Schultz.`,
    author: "School District",
    author_id: 26212,
    moderator_id: null,
    author_name: "School District",
    time_ago: "5 minutes ago",
    avatar: "https://thrillshare.com/fallback/circled_default_avatar.png",
    approved: true,
    filter_name: "All",
    filter_color: "#888888",
    formatted_date: "2019-10-08 11:07:36",
    time: "2019-10-08T11:07:36.674-05:00",
    image_large: "",
    to_twitter: false,
    to_facebook: false,
    to_live_feed: true,
    to_push_notifications: false,
    detected_urls: [],
    expanded_urls: [],
    jid: null,
    live_feed_images: []
  },
  {
    id: 425478,
    status: "Congratulations to the senior class as they prepare for graduation and life beyond high school.",
    author: "School District",
    author_id: 26212,
    moderator_id: null,
    author_name: "School District",
    time_ago: "1 day ago",
    avatar: "https://thrillshare.com/fallback/circled_default_avatar.png",
    approved: true,
    filter_name: "All",
    filter_color: "#888888",
    formatted_date: "2019-10-08 11:06:52",
    time: "2019-10-08T11:06:52.050-05:00",
    image_large: "",
    to_twitter: false,
    to_facebook: false,
    to_live_feed: true,
    to_push_notifications: false,
    detected_urls: [],
    expanded_urls: [],
    jid: null,
    live_feed_images: []
  },
  {
    id: 525482,
    status: `"You're A Good Man, Charlie Brown" is a fun-filled musical highlighting a day in the life of the beloved Peanuts characters by Charles Schultz.`,
    author: "School District",
    author_id: 26212,
    moderator_id: null,
    author_name: "School District",
    time_ago: "1 minute ago",
    avatar: "https://thrillshare.com/fallback/circled_default_avatar.png",
    approved: true,
    filter_name: "All",
    filter_color: "#888888",
    formatted_date: "2019-10-08 11:08:24",
    time: "2019-10-08T11:08:24.520-05:00",
    image_large: "",
    to_twitter: false,
    to_facebook: false,
    to_live_feed: true,
    to_push_notifications: false,
    detected_urls: [],
    expanded_urls: [],
    jid: null,
    live_feed_images: []
  },
  {
    id: 525481,
    status: "Join us for London Elementary night at Chick Fil A Thursday evening from 5:00-8:00. A portion of sales will be donated back to our school. Invite your family and friends to come too! We look forward to seeing you there!",
    author: "School District",
    author_id: 26212,
    moderator_id: null,
    author_name: "School District",
    time_ago: "1 minute ago",
    avatar: "https://thrillshare.com/fallback/circled_default_avatar.png",
    approved: true,
    filter_name: "All",
    filter_color: "#888888",
    formatted_date: "2019-10-08 11:08:13",
    time: "2019-10-08T11:08:13.624-05:00",
    image_large: "",
    to_twitter: false,
    to_facebook: false,
    to_live_feed: true,
    to_push_notifications: false,
    detected_urls: [],
    expanded_urls: [],
    jid: null,
    live_feed_images: []
  },
  {
    id: 525480,
    status: "Congratulations to the senior class as they prepare for graduation and life beyond high school.",
    author: "School District",
    author_id: 26212,
    moderator_id: null,
    author_name: "School District",
    time_ago: "2 minutes ago",
    avatar: "https://thrillshare.com/fallback/circled_default_avatar.png",
    approved: true,
    filter_name: "All",
    filter_color: "#888888",
    formatted_date: "2019-10-08 11:07:47",
    time: "2019-10-08T11:07:47.715-05:00",
    image_large: "",
    to_twitter: false,
    to_facebook: false,
    to_live_feed: true,
    to_push_notifications: false,
    detected_urls: [],
    expanded_urls: [],
    jid: null,
    live_feed_images: []
  },
  {
    id: 525479,
    status: `"You're A Good Man, Charlie Brown" is a fun-filled musical highlighting a day in the life of the beloved Peanuts characters by Charles Schultz.`,
    author: "School District",
    author_id: 26212,
    moderator_id: null,
    author_name: "School District",
    time_ago: "5 minutes ago",
    avatar: "https://thrillshare.com/fallback/circled_default_avatar.png",
    approved: true,
    filter_name: "All",
    filter_color: "#888888",
    formatted_date: "2019-10-08 11:07:36",
    time: "2019-10-08T11:07:36.674-05:00",
    image_large: "",
    to_twitter: false,
    to_facebook: false,
    to_live_feed: true,
    to_push_notifications: false,
    detected_urls: [],
    expanded_urls: [],
    jid: null,
    live_feed_images: []
  },
  {
    id: 525478,
    status: "Congratulations to the senior class as they prepare for graduation and life beyond high school.",
    author: "School District",
    author_id: 26212,
    moderator_id: null,
    author_name: "School District",
    time_ago: "1 day ago",
    avatar: "https://thrillshare.com/fallback/circled_default_avatar.png",
    approved: true,
    filter_name: "All",
    filter_color: "#888888",
    formatted_date: "2019-10-08 11:06:52",
    time: "2019-10-08T11:06:52.050-05:00",
    image_large: "",
    to_twitter: false,
    to_facebook: false,
    to_live_feed: true,
    to_push_notifications: false,
    detected_urls: [],
    expanded_urls: [],
    jid: null,
    live_feed_images: []
  },
  {
    id: 625482,
    status: `"You're A Good Man, Charlie Brown" is a fun-filled musical highlighting a day in the life of the beloved Peanuts characters by Charles Schultz.`,
    author: "School District",
    author_id: 26212,
    moderator_id: null,
    author_name: "School District",
    time_ago: "1 minute ago",
    avatar: "https://thrillshare.com/fallback/circled_default_avatar.png",
    approved: true,
    filter_name: "All",
    filter_color: "#888888",
    formatted_date: "2019-10-08 11:08:24",
    time: "2019-10-08T11:08:24.520-05:00",
    image_large: "",
    to_twitter: false,
    to_facebook: false,
    to_live_feed: true,
    to_push_notifications: false,
    detected_urls: [],
    expanded_urls: [],
    jid: null,
    live_feed_images: []
  },
  {
    id: 625481,
    status: "Join us for London Elementary night at Chick Fil A Thursday evening from 5:00-8:00. A portion of sales will be donated back to our school. Invite your family and friends to come too! We look forward to seeing you there!",
    author: "School District",
    author_id: 26212,
    moderator_id: null,
    author_name: "School District",
    time_ago: "1 minute ago",
    avatar: "https://thrillshare.com/fallback/circled_default_avatar.png",
    approved: true,
    filter_name: "All",
    filter_color: "#888888",
    formatted_date: "2019-10-08 11:08:13",
    time: "2019-10-08T11:08:13.624-05:00",
    image_large: "",
    to_twitter: false,
    to_facebook: false,
    to_live_feed: true,
    to_push_notifications: false,
    detected_urls: [],
    expanded_urls: [],
    jid: null,
    live_feed_images: []
  },
  {
    id: 625480,
    status: "Congratulations to the senior class as they prepare for graduation and life beyond high school.",
    author: "School District",
    author_id: 26212,
    moderator_id: null,
    author_name: "School District",
    time_ago: "2 minutes ago",
    avatar: "https://thrillshare.com/fallback/circled_default_avatar.png",
    approved: true,
    filter_name: "All",
    filter_color: "#888888",
    formatted_date: "2019-10-08 11:07:47",
    time: "2019-10-08T11:07:47.715-05:00",
    image_large: "",
    to_twitter: false,
    to_facebook: false,
    to_live_feed: true,
    to_push_notifications: false,
    detected_urls: [],
    expanded_urls: [],
    jid: null,
    live_feed_images: []
  },
  {
    id: 625479,
    status: `"You're A Good Man, Charlie Brown" is a fun-filled musical highlighting a day in the life of the beloved Peanuts characters by Charles Schultz.`,
    author: "School District",
    author_id: 26212,
    moderator_id: null,
    author_name: "School District",
    time_ago: "5 minutes ago",
    avatar: "https://thrillshare.com/fallback/circled_default_avatar.png",
    approved: true,
    filter_name: "All",
    filter_color: "#888888",
    formatted_date: "2019-10-08 11:07:36",
    time: "2019-10-08T11:07:36.674-05:00",
    image_large: "",
    to_twitter: false,
    to_facebook: false,
    to_live_feed: true,
    to_push_notifications: false,
    detected_urls: [],
    expanded_urls: [],
    jid: null,
    live_feed_images: []
  },
  {
    id: 625478,
    status: "Congratulations to the senior class as they prepare for graduation and life beyond high school.",
    author: "School District",
    author_id: 26212,
    moderator_id: null,
    author_name: "School District",
    time_ago: "1 day ago",
    avatar: "https://thrillshare.com/fallback/circled_default_avatar.png",
    approved: true,
    filter_name: "All",
    filter_color: "#888888",
    formatted_date: "2019-10-08 11:06:52",
    time: "2019-10-08T11:06:52.050-05:00",
    image_large: "",
    to_twitter: false,
    to_facebook: false,
    to_live_feed: true,
    to_push_notifications: false,
    detected_urls: [],
    expanded_urls: [],
    jid: null,
    live_feed_images: []
  },
  {
    id: 325582,
    status: `"You're A Good Man, Charlie Brown" is a fun-filled musical highlighting a day in the life of the beloved Peanuts characters by Charles Schultz.`,
    author: "School District",
    author_id: 26212,
    moderator_id: null,
    author_name: "School District",
    time_ago: "1 minute ago",
    avatar: "https://thrillshare.com/fallback/circled_default_avatar.png",
    approved: true,
    filter_name: "All",
    filter_color: "#888888",
    formatted_date: "2019-10-08 11:08:24",
    time: "2019-10-08T11:08:24.520-05:00",
    image_large: "",
    to_twitter: false,
    to_facebook: false,
    to_live_feed: true,
    to_push_notifications: false,
    detected_urls: [],
    expanded_urls: [],
    jid: null,
    live_feed_images: []
  },
  {
    id: 325581,
    status: "Join us for London Elementary night at Chick Fil A Thursday evening from 5:00-8:00. A portion of sales will be donated back to our school. Invite your family and friends to come too! We look forward to seeing you there!",
    author: "School District",
    author_id: 26212,
    moderator_id: null,
    author_name: "School District",
    time_ago: "1 minute ago",
    avatar: "https://thrillshare.com/fallback/circled_default_avatar.png",
    approved: true,
    filter_name: "All",
    filter_color: "#888888",
    formatted_date: "2019-10-08 11:08:13",
    time: "2019-10-08T11:08:13.624-05:00",
    image_large: "",
    to_twitter: false,
    to_facebook: false,
    to_live_feed: true,
    to_push_notifications: false,
    detected_urls: [],
    expanded_urls: [],
    jid: null,
    live_feed_images: []
  },
  {
    id: 325580,
    status: "Congratulations to the senior class as they prepare for graduation and life beyond high school.",
    author: "School District",
    author_id: 26212,
    moderator_id: null,
    author_name: "School District",
    time_ago: "2 minutes ago",
    avatar: "https://thrillshare.com/fallback/circled_default_avatar.png",
    approved: true,
    filter_name: "All",
    filter_color: "#888888",
    formatted_date: "2019-10-08 11:07:47",
    time: "2019-10-08T11:07:47.715-05:00",
    image_large: "",
    to_twitter: false,
    to_facebook: false,
    to_live_feed: true,
    to_push_notifications: false,
    detected_urls: [],
    expanded_urls: [],
    jid: null,
    live_feed_images: []
  },
  {
    id: 325579,
    status: `"You're A Good Man, Charlie Brown" is a fun-filled musical highlighting a day in the life of the beloved Peanuts characters by Charles Schultz.`,
    author: "School District",
    author_id: 26212,
    moderator_id: null,
    author_name: "School District",
    time_ago: "5 minutes ago",
    avatar: "https://thrillshare.com/fallback/circled_default_avatar.png",
    approved: true,
    filter_name: "All",
    filter_color: "#888888",
    formatted_date: "2019-10-08 11:07:36",
    time: "2019-10-08T11:07:36.674-05:00",
    image_large: "",
    to_twitter: false,
    to_facebook: false,
    to_live_feed: true,
    to_push_notifications: false,
    detected_urls: [],
    expanded_urls: [],
    jid: null,
    live_feed_images: []
  },
  {
    id: 325578,
    status: "Congratulations to the senior class as they prepare for graduation and life beyond high school.",
    author: "School District",
    author_id: 26212,
    moderator_id: null,
    author_name: "School District",
    time_ago: "1 day ago",
    avatar: "https://thrillshare.com/fallback/circled_default_avatar.png",
    approved: true,
    filter_name: "All",
    filter_color: "#888888",
    formatted_date: "2019-10-08 11:06:52",
    time: "2019-10-08T11:06:52.050-05:00",
    image_large: "",
    to_twitter: false,
    to_facebook: false,
    to_live_feed: true,
    to_push_notifications: false,
    detected_urls: [],
    expanded_urls: [],
    jid: null,
    live_feed_images: []
  },
  {
    id: 325582,
    status: `"You're A Good Man, Charlie Brown" is a fun-filled musical highlighting a day in the life of the beloved Peanuts characters by Charles Schultz.`,
    author: "School District",
    author_id: 26212,
    moderator_id: null,
    author_name: "School District",
    time_ago: "1 minute ago",
    avatar: "https://thrillshare.com/fallback/circled_default_avatar.png",
    approved: true,
    filter_name: "All",
    filter_color: "#888888",
    formatted_date: "2019-10-08 11:08:24",
    time: "2019-10-08T11:08:24.520-05:00",
    image_large: "",
    to_twitter: false,
    to_facebook: false,
    to_live_feed: true,
    to_push_notifications: false,
    detected_urls: [],
    expanded_urls: [],
    jid: null,
    live_feed_images: []
  },
  {
    id: 425581,
    status: "Join us for London Elementary night at Chick Fil A Thursday evening from 5:00-8:00. A portion of sales will be donated back to our school. Invite your family and friends to come too! We look forward to seeing you there!",
    author: "School District",
    author_id: 26212,
    moderator_id: null,
    author_name: "School District",
    time_ago: "1 minute ago",
    avatar: "https://thrillshare.com/fallback/circled_default_avatar.png",
    approved: true,
    filter_name: "All",
    filter_color: "#888888",
    formatted_date: "2019-10-08 11:08:13",
    time: "2019-10-08T11:08:13.624-05:00",
    image_large: "",
    to_twitter: false,
    to_facebook: false,
    to_live_feed: true,
    to_push_notifications: false,
    detected_urls: [],
    expanded_urls: [],
    jid: null,
    live_feed_images: []
  },
  {
    id: 425580,
    status: "Congratulations to the senior class as they prepare for graduation and life beyond high school.",
    author: "School District",
    author_id: 26212,
    moderator_id: null,
    author_name: "School District",
    time_ago: "2 minutes ago",
    avatar: "https://thrillshare.com/fallback/circled_default_avatar.png",
    approved: true,
    filter_name: "All",
    filter_color: "#888888",
    formatted_date: "2019-10-08 11:07:47",
    time: "2019-10-08T11:07:47.715-05:00",
    image_large: "",
    to_twitter: false,
    to_facebook: false,
    to_live_feed: true,
    to_push_notifications: false,
    detected_urls: [],
    expanded_urls: [],
    jid: null,
    live_feed_images: []
  },
  {
    id: 425579,
    status: `"You're A Good Man, Charlie Brown" is a fun-filled musical highlighting a day in the life of the beloved Peanuts characters by Charles Schultz.`,
    author: "School District",
    author_id: 26212,
    moderator_id: null,
    author_name: "School District",
    time_ago: "5 minutes ago",
    avatar: "https://thrillshare.com/fallback/circled_default_avatar.png",
    approved: true,
    filter_name: "All",
    filter_color: "#888888",
    formatted_date: "2019-10-08 11:07:36",
    time: "2019-10-08T11:07:36.674-05:00",
    image_large: "",
    to_twitter: false,
    to_facebook: false,
    to_live_feed: true,
    to_push_notifications: false,
    detected_urls: [],
    expanded_urls: [],
    jid: null,
    live_feed_images: []
  },
  {
    id: 425578,
    status: "Congratulations to the senior class as they prepare for graduation and life beyond high school.",
    author: "School District",
    author_id: 26212,
    moderator_id: null,
    author_name: "School District",
    time_ago: "1 day ago",
    avatar: "https://thrillshare.com/fallback/circled_default_avatar.png",
    approved: true,
    filter_name: "All",
    filter_color: "#888888",
    formatted_date: "2019-10-08 11:06:52",
    time: "2019-10-08T11:06:52.050-05:00",
    image_large: "",
    to_twitter: false,
    to_facebook: false,
    to_live_feed: true,
    to_push_notifications: false,
    detected_urls: [],
    expanded_urls: [],
    jid: null,
    live_feed_images: []
  },
  {
    id: 525582,
    status: `"You're A Good Man, Charlie Brown" is a fun-filled musical highlighting a day in the life of the beloved Peanuts characters by Charles Schultz.`,
    author: "School District",
    author_id: 26212,
    moderator_id: null,
    author_name: "School District",
    time_ago: "1 minute ago",
    avatar: "https://thrillshare.com/fallback/circled_default_avatar.png",
    approved: true,
    filter_name: "All",
    filter_color: "#888888",
    formatted_date: "2019-10-08 11:08:24",
    time: "2019-10-08T11:08:24.520-05:00",
    image_large: "",
    to_twitter: false,
    to_facebook: false,
    to_live_feed: true,
    to_push_notifications: false,
    detected_urls: [],
    expanded_urls: [],
    jid: null,
    live_feed_images: []
  },
  {
    id: 525581,
    status: "Join us for London Elementary night at Chick Fil A Thursday evening from 5:00-8:00. A portion of sales will be donated back to our school. Invite your family and friends to come too! We look forward to seeing you there!",
    author: "School District",
    author_id: 26212,
    moderator_id: null,
    author_name: "School District",
    time_ago: "1 minute ago",
    avatar: "https://thrillshare.com/fallback/circled_default_avatar.png",
    approved: true,
    filter_name: "All",
    filter_color: "#888888",
    formatted_date: "2019-10-08 11:08:13",
    time: "2019-10-08T11:08:13.624-05:00",
    image_large: "",
    to_twitter: false,
    to_facebook: false,
    to_live_feed: true,
    to_push_notifications: false,
    detected_urls: [],
    expanded_urls: [],
    jid: null,
    live_feed_images: []
  },
  {
    id: 525580,
    status: "Congratulations to the senior class as they prepare for graduation and life beyond high school.",
    author: "School District",
    author_id: 26212,
    moderator_id: null,
    author_name: "School District",
    time_ago: "2 minutes ago",
    avatar: "https://thrillshare.com/fallback/circled_default_avatar.png",
    approved: true,
    filter_name: "All",
    filter_color: "#888888",
    formatted_date: "2019-10-08 11:07:47",
    time: "2019-10-08T11:07:47.715-05:00",
    image_large: "",
    to_twitter: false,
    to_facebook: false,
    to_live_feed: true,
    to_push_notifications: false,
    detected_urls: [],
    expanded_urls: [],
    jid: null,
    live_feed_images: []
  },
  {
    id: 525579,
    status: `"You're A Good Man, Charlie Brown" is a fun-filled musical highlighting a day in the life of the beloved Peanuts characters by Charles Schultz.`,
    author: "School District",
    author_id: 26212,
    moderator_id: null,
    author_name: "School District",
    time_ago: "5 minutes ago",
    avatar: "https://thrillshare.com/fallback/circled_default_avatar.png",
    approved: true,
    filter_name: "All",
    filter_color: "#888888",
    formatted_date: "2019-10-08 11:07:36",
    time: "2019-10-08T11:07:36.674-05:00",
    image_large: "",
    to_twitter: false,
    to_facebook: false,
    to_live_feed: true,
    to_push_notifications: false,
    detected_urls: [],
    expanded_urls: [],
    jid: null,
    live_feed_images: []
  },
  {
    id: 525578,
    status: "Congratulations to the senior class as they prepare for graduation and life beyond high school.",
    author: "School District",
    author_id: 26212,
    moderator_id: null,
    author_name: "School District",
    time_ago: "1 day ago",
    avatar: "https://thrillshare.com/fallback/circled_default_avatar.png",
    approved: true,
    filter_name: "All",
    filter_color: "#888888",
    formatted_date: "2019-10-08 11:06:52",
    time: "2019-10-08T11:06:52.050-05:00",
    image_large: "",
    to_twitter: false,
    to_facebook: false,
    to_live_feed: true,
    to_push_notifications: false,
    detected_urls: [],
    expanded_urls: [],
    jid: null,
    live_feed_images: []
  },
  {
    id: 625582,
    status: `"You're A Good Man, Charlie Brown" is a fun-filled musical highlighting a day in the life of the beloved Peanuts characters by Charles Schultz.`,
    author: "School District",
    author_id: 26212,
    moderator_id: null,
    author_name: "School District",
    time_ago: "1 minute ago",
    avatar: "https://thrillshare.com/fallback/circled_default_avatar.png",
    approved: true,
    filter_name: "All",
    filter_color: "#888888",
    formatted_date: "2019-10-08 11:08:24",
    time: "2019-10-08T11:08:24.520-05:00",
    image_large: "",
    to_twitter: false,
    to_facebook: false,
    to_live_feed: true,
    to_push_notifications: false,
    detected_urls: [],
    expanded_urls: [],
    jid: null,
    live_feed_images: []
  },
  {
    id: 625581,
    status: "Join us for London Elementary night at Chick Fil A Thursday evening from 5:00-8:00. A portion of sales will be donated back to our school. Invite your family and friends to come too! We look forward to seeing you there!",
    author: "School District",
    author_id: 26212,
    moderator_id: null,
    author_name: "School District",
    time_ago: "1 minute ago",
    avatar: "https://thrillshare.com/fallback/circled_default_avatar.png",
    approved: true,
    filter_name: "All",
    filter_color: "#888888",
    formatted_date: "2019-10-08 11:08:13",
    time: "2019-10-08T11:08:13.624-05:00",
    image_large: "",
    to_twitter: false,
    to_facebook: false,
    to_live_feed: true,
    to_push_notifications: false,
    detected_urls: [],
    expanded_urls: [],
    jid: null,
    live_feed_images: []
  },
  {
    id: 625580,
    status: "Congratulations to the senior class as they prepare for graduation and life beyond high school.",
    author: "School District",
    author_id: 26212,
    moderator_id: null,
    author_name: "School District",
    time_ago: "2 minutes ago",
    avatar: "https://thrillshare.com/fallback/circled_default_avatar.png",
    approved: true,
    filter_name: "All",
    filter_color: "#888888",
    formatted_date: "2019-10-08 11:07:47",
    time: "2019-10-08T11:07:47.715-05:00",
    image_large: "",
    to_twitter: false,
    to_facebook: false,
    to_live_feed: true,
    to_push_notifications: false,
    detected_urls: [],
    expanded_urls: [],
    jid: null,
    live_feed_images: []
  },
  {
    id: 625579,
    status: `"You're A Good Man, Charlie Brown" is a fun-filled musical highlighting a day in the life of the beloved Peanuts characters by Charles Schultz.`,
    author: "School District",
    author_id: 26212,
    moderator_id: null,
    author_name: "School District",
    time_ago: "5 minutes ago",
    avatar: "https://thrillshare.com/fallback/circled_default_avatar.png",
    approved: true,
    filter_name: "All",
    filter_color: "#888888",
    formatted_date: "2019-10-08 11:07:36",
    time: "2019-10-08T11:07:36.674-05:00",
    image_large: "",
    to_twitter: false,
    to_facebook: false,
    to_live_feed: true,
    to_push_notifications: false,
    detected_urls: [],
    expanded_urls: [],
    jid: null,
    live_feed_images: []
  },
  {
    id: 625578,
    status: "Congratulations to the senior class as they prepare for graduation and life beyond high school.",
    author: "School District",
    author_id: 26212,
    moderator_id: null,
    author_name: "School District",
    time_ago: "1 day ago",
    avatar: "https://thrillshare.com/fallback/circled_default_avatar.png",
    approved: true,
    filter_name: "All",
    filter_color: "#888888",
    formatted_date: "2019-10-08 11:06:52",
    time: "2019-10-08T11:06:52.050-05:00",
    image_large: "",
    to_twitter: false,
    to_facebook: false,
    to_live_feed: true,
    to_push_notifications: false,
    detected_urls: [],
    expanded_urls: [],
    jid: null,
    live_feed_images: []
  }
];
const newsPreviewContent = [
  {
    id: 97311,
    jid: null,
    author_id: 26212,
    title: "Students earn recognition at Young Artist Association Competition",
    content: "<p>Several students earned recognition at the recent Young Artist Association Spring Competition and Convention. The Young Artist Association is a statewide organization of high school students.&nbsp; <br></p>",
    content_text: "Several students earned recognition at the recent Young Artist Association Spring Competition and ...",
    published_at: "2019-10-08T00:00:00.000-05:00",
    publish_date: " 8 Oct",
    day: "08",
    month: "OCT",
    year: "2019",
    time_ago: "4 minutes ago",
    author: "School District",
    filter_name: "District",
    filter_color: null,
    link: "",
    caption: "",
    author_avatar: "https://thrillshare.com/fallback/circled_default_avatar.png",
    cover_image: "https://d2kzwze52p8717.cloudfront.net/news1.png",
    approved: true,
    to_facebook: false,
    to_twitter: false,
    snippet: "Several students earned recognition at the recent Young Artist Association Spring Competition and ..."
  },
  {
    id: 97312,
    jid: null,
    author_id: 26212,
    title: "STEM student named semifinalist in US Presidential Scholars Program",
    content: "<p>Any student can reap the everyday benefits of committed work, but only a handful are commended on a national level. For these exceptional few, the U.S. Presidential Scholars Program exists to recognize their talents. <br></p>",
    content_text: "Any student can reap the everyday benefits of committed work, but only a handful are commended on a ...",
    published_at: "2019-10-09T00:00:00.000-05:00",
    publish_date: " 9 Oct",
    day: "09",
    month: "OCT",
    year: "2019",
    time_ago: "6 minutes ago",
    author: "School District",
    filter_name: "District",
    filter_color: null,
    link: "",
    caption: "",
    author_avatar: "https://thrillshare.com/fallback/circled_default_avatar.png",
    cover_image: "https://d2kzwze52p8717.cloudfront.net/news2.png",
    approved: true,
    to_facebook: false,
    to_twitter: false,
    snippet: "Any student can reap the everyday benefits of committed work, but only a handful are commended on a ..."
  },
  {
    id: 97313,
    jid: null,
    author_id: 26212,
    title: "Join us for a fun holiday fundraiser in the gymnasium on Thursday from 5:00-8:00pm",
    content: "<p>Join us for a fun holiday fundraiser in the gymnasium on Thursday from 5:00-8:00pm&nbsp; <br></p>",
    content_text: "Join us for a fun holiday fundraiser in the gymnasium on Thursday from 5:00-8:00pm ...",
    published_at: "2019-10-08T00:00:00.000-05:00",
    publish_date: " 8 Oct",
    day: "08",
    month: "OCT",
    year: "2019",
    time_ago: "30 minutes ago",
    author: "School District",
    filter_name: "District",
    filter_color: null,
    link: "",
    caption: "",
    author_avatar: "https://thrillshare.com/fallback/circled_default_avatar.png",
    cover_image: "https://d2kzwze52p8717.cloudfront.net/news3.png",
    approved: true,
    to_facebook: false,
    to_twitter: false,
    snippet: "Several students earned recognition at the recent Young Artist Association Spring Competition and ..."
  },
  {
    id: 97314,
    jid: null,
    author_id: 26212,
    title: "You're a good man, Charlie Brown is a fun-filled musical",
    content: "<p>Any student can reap the everyday benefits of committed work, but only a handful are commended on a national level. For these exceptional few, the U.S. Presidential Scholars Program exists to recognize their talents. <br></p>",
    content_text: "Any student can reap the everyday benefits of committed work, but only a handful are commended on a ...",
    published_at: "2019-10-08T00:00:00.000-05:00",
    publish_date: " 8 Oct",
    day: "08",
    month: "OCT",
    year: "2019",
    time_ago: "45 minutes ago",
    author: "School District",
    filter_name: "District",
    filter_color: null,
    link: "",
    caption: "",
    author_avatar: "https://thrillshare.com/fallback/circled_default_avatar.png",
    cover_image: "https://d2kzwze52p8717.cloudfront.net/news4.png",
    approved: true,
    to_facebook: false,
    to_twitter: false,
    snippet: "Any student can reap the everyday benefits of committed work, but only a handful are commended on a ..."
  },
  {
    id: 97315,
    jid: null,
    author_id: 26213,
    title: "Congratulations to the District eSports team on their win in the League of Legends Regional Championship!",
    content: "<p>Any student can reap the everyday benefits of committed work, but only a handful are commended on a national level. For these exceptional few, the U.S. Presidential Scholars Program exists to recognize their talents. <br></p>",
    content_text: "Any student can reap the everyday benefits of committed work, but only a handful are commended on a ...",
    published_at: "2019-10-08T00:00:00.000-05:00",
    publish_date: " 8 Oct",
    day: "08",
    month: "OCT",
    year: "2019",
    time_ago: "45 minutes ago",
    author: "School District",
    filter_name: "District",
    filter_color: null,
    link: "",
    caption: "",
    author_avatar: "https://thrillshare.com/fallback/circled_default_avatar.png",
    cover_image: "https://d2kzwze52p8717.cloudfront.net/gallery_01.png",
    approved: true,
    to_facebook: false,
    to_twitter: false,
    snippet: "Any student can reap the everyday benefits of committed work, but only a handful are commended on a ..."
  },
  {
    id: 97316,
    jid: null,
    author_id: 26214,
    title: "We'll be hosting a meet and greet for parents and teachers next Tuesday at 5:00pm",
    content: "<p>Any student can reap the everyday benefits of committed work, but only a handful are commended on a national level. For these exceptional few, the U.S. Presidential Scholars Program exists to recognize their talents. <br></p>",
    content_text: "Any student can reap the everyday benefits of committed work, but only a handful are commended on a ...",
    published_at: "2019-10-08T00:00:00.000-05:00",
    publish_date: " 8 Oct",
    day: "08",
    month: "OCT",
    year: "2019",
    time_ago: "45 minutes ago",
    author: "School District",
    filter_name: "District",
    filter_color: null,
    link: "",
    caption: "",
    author_avatar: "https://thrillshare.com/fallback/circled_default_avatar.png",
    cover_image: "https://apptegy-cms-theme-preview-images.s3.us-east-2.amazonaws.com/superintendent.jpeg",
    approved: true,
    to_facebook: false,
    to_twitter: false,
    snippet: "Any student can reap the everyday benefits of committed work, but only a handful are commended on a ..."
  }
];
const version = "M4";
const style = "light";
const bg_color = {
  hex: "#13A1C8"
};
const text_color = {
  hex: "#FFFFFF"
};
const text_hover_color = {
  hex: "#13A1C8"
};
const heading_color = {
  hex: "#fff"
};
const more_bg_color = {
  hex: "#FFFFFF"
};
const more_text_color = {
  hex: "#13A1C8"
};
const dropdown_bg_color = {
  hex: "#FFFFFF"
};
const dropdown_text_color = {
  hex: "#333333"
};
const explore_menu_text_color = {
  hex: "#FFFFFF"
};
const explore_menu_bg_color = {
  hex: "#333333"
};
const schools_menu_bg_color = {
  hex: "#333333"
};
const schools_menu_text_color = {
  hex: "#FFFFFF"
};
const icon_color = {
  hex: "#0E315C"
};
const icon_bg_color = {
  hex: "#13A1C8"
};
const icon_text_color = {
  hex: "#F31556"
};
const icon_text_hover_color = {
  hex: "#fff"
};
const navigation_icon_bg_color = {
  hex: "#0D4C8F"
};
const l2_bg_color = {
  hex: "#fff"
};
const l1_text_color = {
  hex: "#fff"
};
const l2_text_color = {
  hex: "#13A1C8"
};
const l1_text_hover_color = {
  hex: "#fff"
};
const l2_text_hover_color = {
  hex: "#13A1C8"
};
const search_icon_color = {
  hex: "#fff"
};
const translations = {
  title: "Menu"
};
const menu_titles = true;
const link_icon = "arrow-2";
const menuOptionDefaults$1 = {
  version,
  style,
  bg_color,
  text_color,
  text_hover_color,
  heading_color,
  more_bg_color,
  more_text_color,
  dropdown_bg_color,
  dropdown_text_color,
  explore_menu_text_color,
  explore_menu_bg_color,
  schools_menu_bg_color,
  schools_menu_text_color,
  icon_color,
  icon_bg_color,
  icon_text_color,
  icon_text_hover_color,
  navigation_icon_bg_color,
  l2_bg_color,
  l1_text_color,
  l2_text_color,
  l1_text_hover_color,
  l2_text_hover_color,
  search_icon_color,
  translations,
  menu_titles,
  link_icon
};
const languageDefaults$1 = [
  {
    code: "en",
    language: "English"
  },
  {
    code: "fr",
    language: "French"
  },
  {
    code: "es",
    language: "Spanish"
  }
];
const content$1 = [
  {
    snippet: "High School Graduation Rate",
    headline: "98%"
  },
  {
    snippet: "District-Wide Student to Teacher Ratio",
    headline: "20:1 "
  },
  {
    snippet: "Golden Apple Award Educators",
    headline: "90+"
  },
  {
    snippet: "Named to the AP District Honor Roll",
    headline: "4x"
  },
  {
    snippet: "Certified Staff Have Masters Degree or Higher",
    headline: "79%"
  },
  {
    snippet: "Chromebook Implementation",
    headline: "1:1"
  },
  {
    snippet: "National Blue Ribbon Schools",
    headline: "5"
  },
  {
    snippet: "AP College Credit Courses",
    headline: "40"
  }
];
const snippet$2 = true;
const headline$2 = true;
const slider$1 = true;
const stats_header$1 = "About Us";
const component_header$3 = "We mix the joy of discovery and the excitement of personal growth";
const component_header_top$3 = "This is";
const schoolStats2 = {
  content: content$1,
  snippet: snippet$2,
  headline: headline$2,
  slider: slider$1,
  stats_header: stats_header$1,
  component_header: component_header$3,
  component_header_top: component_header_top$3
};
const content = [
  {
    name: "graduation cap",
    snippet: "High School Graduation Rate",
    headline: "98%",
    icon: "<svg id='Layer_1' data-name='Layer 1' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 48 48.1'><path d='M48 30.9657C48 32.6177 46.654 33.9618 45 33.9618C43.346 33.9618 42 32.6177 42 30.9657C42 29.6647 42.839 28.5667 44 28.1528V15.7347L36.959 19.8908C36.974 19.9578 37 20.0208 37 20.0918V36.0747C37 36.6117 36.575 37.0407 36.044 37.0647C34.595 37.7947 29.741 39.9557 23 39.9557C16.259 39.9557 11.404 37.7947 9.956 37.0647C9.425 37.0407 9 36.6117 9 36.0747V20.0918C9 20.0208 9.026 19.9578 9.041 19.8908L0.491 14.8438C0.186 14.6648 0 14.3367 0 13.9837C0 13.6317 0.186 13.3037 0.491 13.1247L22.492 0.13875C22.807 -0.04625 23.195 -0.04625 23.51 0.13875L45.51 13.1247C45.913 13.1847 46 13.4688 46 13.9587V13.9808C46 13.9818 46.001 13.9827 46.001 13.9837C46.001 13.9857 46 13.9867 46 13.9878V28.1528C47.162 28.5667 48 29.6647 48 30.9657ZM35 35.3498V21.0478L23.51 27.8298C23.352 27.9217 23.177 27.9688 23.001 27.9688C22.825 27.9688 22.649 27.9217 22.492 27.8298L11 21.0468V35.3498C12.452 36.0518 16.951 37.9577 23 37.9577C29.048 37.9577 33.548 36.0518 35 35.3498ZM23.001 2.15875L2.966 13.9837L23.001 25.8098L43.035 13.9837L23.001 2.15875ZM45.419 30.0658C45.397 30.0678 45.386 30.0818 45.362 30.0818C45.224 30.0818 45.07 30.0458 44.916 29.9838C44.405 30.0288 44 30.4447 44 30.9657C44 31.5157 44.448 31.9648 45 31.9648C45.552 31.9648 46 31.5157 46 30.9657C46 30.5658 45.76 30.2248 45.419 30.0658Z'/></svg>",
    bg_color: "var(--card-bg-color)",
    color: "var(--color)"
  },
  {
    snippet: "District-Wide Student to Teacher Ratio",
    headline: "20:1 ",
    bg_image: {
      url: "https://d2kzwze52p8717.cloudfront.net/news1.png",
      alt_text: "landscape"
    }
  },
  {
    name: "trophy",
    snippet: "Certified Staff Have Masters Degree or Higher",
    headline: "79%",
    icon: "<svg id='Layer_1' data-name='Layer 1' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 48 48.1'><path d='M39 14.331V20.888C39 20.907 38.99 20.924 38.989 20.943C38.99 20.962 39 20.979 39 20.998C39 28.933 32.805 35.43 25 35.948V45.999H35C35.553 45.999 36 46.446 36 46.998C36 47.55 35.553 47.999 35 47.999H13C12.447 47.999 12 47.55 12 46.998C12 46.446 12.447 45.999 13 45.999H23V35.948C15.195 35.43 9 28.933 9 20.998C9 20.979 9.01 20.962 9.011 20.943C9.01 20.924 9 20.907 9 20.888V14.331C3.932 14.331 0 8.77705 0 3.99805C0 3.44605 0.447 2.99905 1 2.99905H9V0.998047C9 0.446047 9.447 -0.00195312 10 -0.00195312H38C38.553 -0.00195312 39 0.446047 39 0.998047V2.99905H47C47.553 2.99905 48 3.44605 48 3.99805C48 8.77705 44.068 14.331 39 14.331ZM9 4.99905H2.069C2.549 8.53205 5.46 12.332 9 12.332V4.99905ZM37 20.888V1.99905H11V20.888C11 20.907 10.99 20.924 10.989 20.943C10.99 20.962 11 20.979 11 20.998C11 28.167 16.832 33.998 24 33.998C31.168 33.998 37 28.167 37 20.998C37 20.979 37.01 20.962 37.011 20.943C37.01 20.924 37 20.907 37 20.888ZM39 4.99905V12.332C42.54 12.332 45.451 8.53205 45.931 4.99905H39ZM27 25.998H21C20.447 25.998 20 25.551 20 24.999C20 24.447 20.447 23.998 21 23.998H23V13.413L20.707 15.706C20.316 16.096 19.684 16.096 19.293 15.706C18.902 15.315 18.902 14.682 19.293 14.292L23.293 10.292C23.579 10.004 24.009 9.92005 24.383 10.075C24.757 10.23 25 10.594 25 10.999V23.998H27C27.553 23.998 28 24.447 28 24.999C28 25.551 27.553 25.998 27 25.998Z'/></svg>",
    bg_color: "var(--card-2-bg-color)",
    color: "var(--color-2)"
  },
  {
    snippet: "Chromebook Implementation",
    headline: "1:1",
    bg_image: {
      url: "https://d2kzwze52p8717.cloudfront.net/news2.png",
      alt_text: "landscape"
    }
  },
  {
    snippet: "National Blue Ribbon Schools",
    headline: "5",
    icon: "<svg id='Layer_1' data-name='Layer 1' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 48 48.1'><path d='M31.9,18.7h0c-.1-.2-.1-.3-.2-.4h0l-12-12h0c-.1-.1-.2-.1-.3-.2h-.1A.37.37,0,0,1,19,6H2A2,2,0,0,0,0,8V46a2.15,2.15,0,0,0,2,2H30a2,2,0,0,0,2-2V18.9C32,18.8,32,18.8,31.9,18.7ZM20,9.4,28.6,18H20ZM2,46V8H18V19a.94.94,0,0,0,1,1H30V46Z' transform='translate(0 0.1)'/><path d='M48,12.9a.37.37,0,0,0-.1-.3v-.1c0-.1-.1-.2-.2-.3h0L35.7.2h0c-.1-.1-.2-.1-.3-.2h-.1A.37.37,0,0,1,35-.1H18c-1.2,0-2,.6-2,1.5V2a1,1,0,0,0,2,0H34V13a.94.94,0,0,0,1,1H46V40H36a1,1,0,0,0,0,2H46a2,2,0,0,0,2-2V12.9ZM36,12V3.4L44.6,12Z' transform='translate(0 0.1)'/></svg>",
    bg_color: "var(--card-3-bg-color)",
    color: "var(--color-3)"
  },
  {
    snippet: "AP College Credit Courses",
    headline: "40",
    bg_image: {
      url: "https://d2kzwze52p8717.cloudfront.net/news3.png",
      alt_text: "landscape"
    }
  }
];
const snippet$1 = true;
const headline$1 = true;
const slider = true;
const stats_header = "About Us";
const component_header$2 = "About Us";
const component_header_top$2 = "This is";
const schoolStats3 = {
  content,
  snippet: snippet$1,
  headline: headline$1,
  slider,
  stats_header,
  component_header: component_header$2,
  component_header_top: component_header_top$2
};
const nested_content = [
  {
    top_stats: {
      headline: "17 : 1",
      snippet: "teacher to student ratio"
    },
    bottom_stats: {
      headline: "24",
      snippet: "varsity teams"
    },
    left_image: {
      url: "https://public-apptegy-assets.s3.us-east-2.amazonaws.com/apptegy-cms-theme-preview-images/students.jpeg",
      alt_text: ""
    },
    right_image: {
      url: "https://public-apptegy-assets.s3.us-east-2.amazonaws.com/apptegy-cms-theme-preview-images/graudation-gown.jpeg",
      alt_text: ""
    }
  },
  {
    top_stats: {
      headline: "450",
      snippet: "acres campus"
    },
    bottom_stats: {
      headline: "85",
      snippet: "IT courses to choose from"
    },
    left_image: {
      url: "https://public-apptegy-assets.s3.us-east-2.amazonaws.com/apptegy-cms-theme-preview-images/students-walking.jpeg",
      alt_text: ""
    },
    right_image: {
      url: "https://public-apptegy-assets.s3.us-east-2.amazonaws.com/apptegy-cms-theme-preview-images/IT.jpeg",
      alt_text: ""
    }
  },
  {
    top_stats: {
      headline: "98%",
      snippet: "college acceptance rate"
    },
    bottom_stats: {
      headline: "27",
      snippet: "students per class"
    },
    left_image: {
      url: "https://public-apptegy-assets.s3.us-east-2.amazonaws.com/apptegy-cms-theme-preview-images/reading.jpeg",
      alt_text: ""
    },
    right_image: {
      url: "https://public-apptegy-assets.s3.us-east-2.amazonaws.com/apptegy-cms-theme-preview-images/students-talking.jpeg",
      alt_text: ""
    }
  },
  {
    top_stats: {
      headline: "100+",
      snippet: "co curricular activities"
    },
    bottom_stats: {
      headline: "20+",
      snippet: "sports on offer"
    },
    left_image: {
      url: "https://public-apptegy-assets.s3.us-east-2.amazonaws.com/apptegy-cms-theme-preview-images/graduation.jpeg",
      alt_text: ""
    },
    right_image: {
      url: "https://public-apptegy-assets.s3.us-east-2.amazonaws.com/apptegy-cms-theme-preview-images/robotics.jpeg",
      alt_text: ""
    }
  }
];
const headline = true;
const snippet = true;
const component_header$1 = "Life at Mason Harbor";
const component_header_top$1 = "This is";
const schoolStats4 = {
  nested_content,
  headline,
  snippet,
  component_header: component_header$1,
  component_header_top: component_header_top$1
};
const component_header = "A Story of Passion and Purpose";
const component_header_top = "This Is";
const component_text = "<p>Our mission is to develop young men with active and creative minds, a sense of understanding and compassion for others, and the courage to act on their beliefs. We stress the total development of each child: spiritual, moral, intellectual, social, emotional, and physical.</p><p><strong>Rick Ross, Superintendent</strong></p>";
const links = [
  {
    href: "#",
    top_title: "we value",
    title: "Community",
    image: {
      url: "https://public-apptegy-assets.s3.us-east-2.amazonaws.com/apptegy-cms-theme-preview-images/community.jpeg",
      alt_text: ""
    }
  },
  {
    href: "#",
    top_title: "we value",
    title: "Creativity",
    image: {
      url: "https://public-apptegy-assets.s3.us-east-2.amazonaws.com/apptegy-cms-theme-preview-images/art.jpeg",
      alt_text: ""
    }
  },
  {
    href: "#",
    top_title: "we value",
    title: "Growth",
    target: "_self",
    icon: "<svg data-name='Layer 1' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 47.92 46.04'><path d='M47.1,1.4A2.32,2.32,0,0,0,45.3,1L24,4.7,2.6,1a2.21,2.21,0,0,0-1.9.6A2.36,2.36,0,0,0,0,3.2V40.9a3.07,3.07,0,0,0,2.3,2.8L23.8,47H24l21.6-3.3a3,3,0,0,0,2.3-2.8V3.2A1.84,1.84,0,0,0,47.1,1.4ZM32,5.3,40,4V15.1l-3.4-2.6a1.07,1.07,0,0,0-1.4.1L32,16.4ZM2,40.9V3.2c0-.1,0-.1.1-.1s.1-.1.2-.1L23,6.5V44.8L2.7,41.7A1.12,1.12,0,0,1,2,40.9Zm44,0a1.12,1.12,0,0,1-.7.8L25,44.8V6.5l5-.9V19a1,1,0,0,0,.7.9c.1,0,.2.1.3.1a.91.91,0,0,0,.8-.4l4.4-5.2,4.2,3.3a1.07,1.07,0,0,0,1.1.1,1.15,1.15,0,0,0,.6-.9V3.6L45.7,3h.2a.35.35,0,0,1,.1.2Z' transform='translate(0 -0.96)'/></svg>",
    image: {
      url: "https://public-apptegy-assets.s3.us-east-2.amazonaws.com/apptegy-cms-theme-preview-images/flower.jpeg",
      alt_text: ""
    }
  },
  {
    href: "#",
    top_title: "we value",
    title: "Innovation",
    image: {
      url: "https://public-apptegy-assets.s3.us-east-2.amazonaws.com/apptegy-cms-theme-preview-images/growth.png",
      alt_text: ""
    }
  },
  {
    href: "#",
    top_title: "we value",
    title: "Kindness",
    image: {
      url: "https://public-apptegy-assets.s3.us-east-2.amazonaws.com/apptegy-cms-theme-preview-images/friends.png",
      alt_text: ""
    }
  }
];
const schoolAbout3 = {
  component_header,
  component_header_top,
  component_text,
  links
};
const schoolHomepageDefaults = {
  alertDefaults,
  alertSeparateDefaults,
  orgMenuDefaults,
  globalSettingDefaults,
  utilityLinkDefaults,
  editableHomepageComponents,
  orgDefaults,
  siteMenuDefaults,
  staticMenuLinkDefaults,
  videoGalleryDefaults,
  menuOptionDefaults: menuOptionDefaults$1,
  languageDefaults: languageDefaults$1,
  aboutPreviewContent: {
    AboutV1: editableHomepageComponents.about.preview_id,
    AboutV2: editableHomepageComponents.about.preview_id,
    AboutV3: schoolAbout3
  },
  statsPreviewContent: {
    S1: editableHomepageComponents.stats.preview_id,
    S2: schoolStats2,
    S3: schoolStats3,
    S4: schoolStats4
  }
};
const schoolMediaPreviewContent = {
  athleticsPreviewContent,
  eventsPreviewContent,
  liveFeedPreviewContent,
  newsPreviewContent
};
function generateHomepagePreviewContent(orgType) {
  return orgType === "Municipality" ? municipalityHomepageDefaults : schoolHomepageDefaults;
}
function languageDefaults(orgType) {
  return orgType === "Municipality" ? municipalityHomepageDefaults.languageDefaults : schoolHomepageDefaults.languageDefaults;
}
function menuOptionDefaults(orgType) {
  return orgType === "Municipality" ? municipalityHomepageDefaults.menuOptionDefaults : schoolHomepageDefaults.menuOptionDefaults;
}
function generateGalleryPreviewContent(orgType) {
  return orgType === "Municipality" ? {
    videoContent: municipalityHomepageDefaults.videoGalleryDefaults,
    staticImageContent: municipalityHomepageDefaults.editableHomepageComponents.gallery
  } : {
    videoContent: schoolHomepageDefaults.videoGalleryDefaults,
    staticImageContent: schoolHomepageDefaults.editableHomepageComponents.gallery
  };
}
function generateMediaPreviewContent(orgType) {
  return orgType === "Municipality" ? municipalityMediaPreviewContent : schoolMediaPreviewContent;
}
export {
  generateGalleryPreviewContent,
  generateHomepagePreviewContent,
  generateMediaPreviewContent,
  languageDefaults,
  menuOptionDefaults,
  municipalityHomepageDefaults,
  municipalityMediaPreviewContent,
  schoolHomepageDefaults,
  schoolMediaPreviewContent
};
